/* Playforce Playbot v104 - hide internal optional extras in live catalogue responses. */
(function () {
  var storageKey = 'pfPlaybotStateV102PriceContextReset';

  function bootPlaybot() {
    var roots = document.querySelectorAll('#pf-playbot-root:not([data-pf-playbot-ready="true"])');
    for (var i = 0; i < roots.length; i += 1) {
      initPlaybot(roots[i]);
    }
  }

  function isRentalRelatedPath() {
    var path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
    return path.indexOf('/pages/rentals') !== -1 ||
      path.indexOf('/products/business-laptop-rental') !== -1 ||
      path.indexOf('/products/gaming-laptop-rental') !== -1 ||
      path.indexOf('/products/macbook-rental') !== -1 ||
      path.indexOf('/products/ipad-rental') !== -1 ||
      (path.indexOf('/products/') !== -1 && path.indexOf('rental') !== -1);
  }

  function initPlaybot(root) {
    if (!root || root.getAttribute('data-pf-playbot-ready') === 'true') return;

    if (!isRentalRelatedPath()) {
      root.parentNode && root.parentNode.removeChild(root);
      return;
    }

    root.style.display = '';
    root.setAttribute('data-pf-playbot-ready', 'true');

    // Keep Playbot outside page wrappers/forms so rental-page scripts, overflow, or stacking contexts cannot block the panel.
    if (document.body && root.parentNode !== document.body) {
      document.body.appendChild(root);
    }

    var toggle = root.querySelector('#pfPlaybotToggle');
    var launcher = root.querySelector('#pfPlaybotLauncher');
    var overlay = root.querySelector('#pfPlaybotOverlay');
    var panel = root.querySelector('#pfPlaybotPanel');
    var closeBtn = root.querySelector('#pfPlaybotClose');
    var messages = root.querySelector('#pfPlaybotMessages');
    var form = root.querySelector('#pfPlaybotForm');
    var input = root.querySelector('#pfPlaybotInput');

    if (!toggle || !launcher || !overlay || !panel || !closeBtn || !messages || !form || !input) return;

  var whatsappNumber = '6591151460';
  var shopifyContactFallbackEmail = 'sales@playforce.com.sg';
  var rentalLinks = {
    rental: '/pages/rentals#rental-packages',
    business: '/products/business-laptop-rental',
    gaming: '/products/gaming-laptop-rental',
    macbook: '/products/macbook-rental',
    ipad: '/products/ipad-rental'
  };

  var productTitle = (root.getAttribute('data-product-title') || '').trim();
  var liveState = null;
  var feedbackState = null;
  var feedbackProfile = null;
  var priceState = null;
  var confirmState = null;
  var pendingRedirectState = null;
  var chatEnded = false;
  var questionContext = null;
  function createEmptyConversationContext() {
    return {
      devices: [],
      apps: [],
      usage: '',
      lastCategory: '',
      pageDevice: '',
      customerName: '',
      device: '',
      quantity: '',
      duration: '',
      startDate: '',
      location: '',
      company: '',
      lastIntent: '',
      lastQuestion: '',
      confirmedPriceDevice: '',
      confirmedPriceProductKey: '',
      confirmedPriceDuration: '',
      activePriceQuoteKey: '',
      lastPriceProductKey: '',
      lastPriceDevice: '',
      lastPriceDuration: '',
      pendingPriceSwitchProductKey: '',
      pendingPriceSwitchDuration: ''
    };
  }

  var conversationContext = createEmptyConversationContext();
  var overallQuestionCount = 0;
  var unresolvedCount = 0;
  var playbotLeadEndpoint = 'https://script.google.com/macros/s/AKfycbyXNd1twotuDkp7p3y8yCwatwDUejhYr_o1hU7IWUyaxHxpVF8-v2KlHc5AwkfQdqpBaQ/exec';
  var playbotLeadSecret = 'playforce-playbot-2026';
  var playbotLeadEmail = 'sales@playforce.com.sg';
  var playbotSessionId = getOrCreatePlaybotSessionId();
  var playbotTranscript = [];
  var playbotLeadSentKeys = {};
  var playbotLeadSentCounts = {};
  var playbotWhatsappClicked = false;
  var playbotLogQueueKey = 'pfPlaybotMobileLogQueueV102';
  var playbotLogQueue = [];
  var playbotLogFlushTimer = null;
  var playbotWhatsappNavigationLock = false;
  var playbotLastWhatsappClickAt = 0;
  var playbotLastWhatsappClickHref = '';
  var playbotLastWhatsappClickEventId = '';
  var playbotFeedbackActionLocks = {};
  var lastWhatsappHandoffState = null;
  var lastLowConfidenceQuestion = '';
  var lastUserQuestion = '';
  var lastUserQuestions = [];
  var lastUserTopic = '';
  var lastAnswerMeta = null;
  var lastAnswerTimestamp = 0;
  var lastDissatisfactionSignal = null;
  var playbotFullMessageAuditEnabled = true;
  var playbotAnswerAuditEnabled = true;
  var typingTimer = null;
  var hasStarted = false;
  var previousBodyOverflow = '';
  var previousHtmlOverflow = '';
  var previousBodyPaddingRight = '';
  var scrollLockActive = false;
  var playbotKeyboardViewportTimer = null;
  var playbotKeyboardScrollTimers = [];

  function saveState() {
    try {
      var savedMessages = messages.cloneNode(true);
      var transientRows = savedMessages.querySelectorAll('.pf-playbot-typing');
      for (var i = 0; i < transientRows.length; i += 1) {
        transientRows[i].parentNode.removeChild(transientRows[i]);
      }
      window.sessionStorage.setItem(storageKey, JSON.stringify({
        messagesHtml: savedMessages.innerHTML,
        hasStarted: hasStarted,
        liveState: liveState,
        feedbackState: feedbackState,
        feedbackProfile: feedbackProfile,
        priceState: priceState,
        confirmState: confirmState,
        pendingRedirectState: pendingRedirectState,
        chatEnded: chatEnded,
        questionContext: questionContext,
        conversationContext: conversationContext,
        overallQuestionCount: overallQuestionCount,
        unresolvedCount: unresolvedCount,
        playbotSessionId: playbotSessionId,
        playbotTranscript: playbotTranscript,
        playbotLeadSentCounts: playbotLeadSentCounts,
        playbotWhatsappClicked: playbotWhatsappClicked,
        lastWhatsappHandoffState: lastWhatsappHandoffState,
        lastLowConfidenceQuestion: lastLowConfidenceQuestion,
        lastUserQuestion: lastUserQuestion,
        lastUserQuestions: lastUserQuestions,
        lastUserTopic: lastUserTopic,
        lastAnswerMeta: lastAnswerMeta,
        lastAnswerTimestamp: lastAnswerTimestamp,
        lastDissatisfactionSignal: lastDissatisfactionSignal,
        isOpen: root.classList.contains('is-open')
      }));
    } catch (error) {}
  }

  function restoreState() {
    try {
      var raw = window.sessionStorage.getItem(storageKey);
      if (!raw) return;
      var state = JSON.parse(raw);
      if (!state) return;
      if (state.messagesHtml) {
        messages.innerHTML = state.messagesHtml;
        hasStarted = !!state.hasStarted || true;
        liveState = state.liveState || null;
        feedbackState = state.feedbackState || null;
        feedbackProfile = state.feedbackProfile || null;
        priceState = state.priceState || null;
        confirmState = state.confirmState || null;
        pendingRedirectState = state.pendingRedirectState || null;
        chatEnded = !!state.chatEnded;
        questionContext = state.questionContext || null;
        conversationContext = state.conversationContext || conversationContext;
        overallQuestionCount = state.overallQuestionCount || 0;
        unresolvedCount = state.unresolvedCount || 0;
        playbotSessionId = state.playbotSessionId || playbotSessionId;
        playbotTranscript = Array.isArray(state.playbotTranscript) ? state.playbotTranscript : playbotTranscript;
        playbotLeadSentCounts = state.playbotLeadSentCounts || {};
        playbotWhatsappClicked = !!state.playbotWhatsappClicked;
        lastWhatsappHandoffState = state.lastWhatsappHandoffState || lastWhatsappHandoffState;
        lastLowConfidenceQuestion = state.lastLowConfidenceQuestion || lastLowConfidenceQuestion;
        lastUserQuestion = state.lastUserQuestion || lastUserQuestion;
        lastUserQuestions = Array.isArray(state.lastUserQuestions) ? state.lastUserQuestions : lastUserQuestions;
        lastUserTopic = state.lastUserTopic || lastUserTopic;
        lastAnswerMeta = state.lastAnswerMeta || lastAnswerMeta;
        lastAnswerTimestamp = state.lastAnswerTimestamp || lastAnswerTimestamp;
        lastDissatisfactionSignal = state.lastDissatisfactionSignal || lastDissatisfactionSignal;
        removeTypingIndicators();
        scrollToBottom();
      }
      if (state.isOpen) {
        window.setTimeout(function () {
          openPanel();
        }, 120);
      }
    } catch (error) {}
  }

  function lockPageScroll() {
    if (scrollLockActive) return;
    scrollLockActive = true;
    previousBodyOverflow = document.body.style.overflow || '';
    previousHtmlOverflow = document.documentElement.style.overflow || '';
    previousBodyPaddingRight = document.body.style.paddingRight || '';

    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    var currentPaddingRight = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;

    document.documentElement.classList.add('pf-playbot-scroll-lock');
    document.body.classList.add('pf-playbot-scroll-lock');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = (currentPaddingRight + scrollbarWidth) + 'px';
    }
  }

  function unlockPageScroll() {
    if (!scrollLockActive) return;
    scrollLockActive = false;
    document.documentElement.classList.remove('pf-playbot-scroll-lock');
    document.body.classList.remove('pf-playbot-scroll-lock');
    document.documentElement.style.overflow = previousHtmlOverflow;
    document.body.style.overflow = previousBodyOverflow;
    document.body.style.paddingRight = previousBodyPaddingRight;
  }

  function isPlaybotIOSLikeBrowser() {
    try {
      var ua = navigator && navigator.userAgent ? navigator.userAgent : '';
      var isiOS = /iphone|ipad|ipod/i.test(ua);
      var isIPadOSDesktopMode = /macintosh/i.test(ua) && navigator && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
      return !!(isiOS || isIPadOSDesktopMode);
    } catch (error) {
      return false;
    }
  }

  function clearPlaybotKeyboardScrollTimers() {
    for (var i = 0; i < playbotKeyboardScrollTimers.length; i += 1) {
      window.clearTimeout(playbotKeyboardScrollTimers[i]);
    }
    playbotKeyboardScrollTimers = [];
  }

  function scrollMessagesToBottomNow() {
    try {
      messages.scrollTop = messages.scrollHeight;
    } catch (error) {}
  }

  function resetPlaybotKeyboardViewport() {
    root.classList.remove('pf-playbot-keyboard-open');
    root.classList.remove('pf-playbot-input-focused');
    root.style.removeProperty('--pf-playbot-vv-height');
    root.style.removeProperty('--pf-playbot-vv-top');
    root.style.removeProperty('--pf-playbot-keyboard-height');
    clearPlaybotKeyboardScrollTimers();
  }

  function shouldManagePlaybotKeyboardViewport() {
    // Keep the visualViewport keyboard workaround strictly for iPhone and iPad Safari.
    // Android Chrome handles fixed panels more predictably; applying the iOS workaround there can collapse or close the chat.
    return !!(isPlaybotIOSLikeBrowser() && window.visualViewport);
  }

  function updatePlaybotKeyboardViewport(reason) {
    try {
      if (!root.classList.contains('is-open')) return;
      if (!shouldManagePlaybotKeyboardViewport()) {
        resetPlaybotKeyboardViewport();
        return;
      }

      var vv = window.visualViewport || null;
      var layoutHeight = window.innerHeight || document.documentElement.clientHeight || screen.height || 0;
      var vvHeight = vv && vv.height ? vv.height : layoutHeight;
      var vvTop = vv && typeof vv.offsetTop === 'number' ? vv.offsetTop : 0;
      var safeHeight = Math.max(320, Math.round(vvHeight));
      var safeTop = Math.max(0, Math.round(vvTop));
      var keyboardHeight = Math.max(0, Math.round(layoutHeight - safeHeight - safeTop));

      root.style.setProperty('--pf-playbot-vv-height', safeHeight + 'px');
      root.style.setProperty('--pf-playbot-vv-top', safeTop + 'px');
      root.style.setProperty('--pf-playbot-keyboard-height', keyboardHeight + 'px');

      var inputFocused = document.activeElement === input;
      if (inputFocused) {
        root.classList.add('pf-playbot-input-focused');
        root.classList.add('pf-playbot-keyboard-open');
        scrollMessagesToBottomNow();
      } else if (reason === 'blur' || reason === 'close') {
        resetPlaybotKeyboardViewport();
      }
    } catch (error) {}
  }

  function schedulePlaybotKeyboardViewportUpdate(reason, delay) {
    if (playbotKeyboardViewportTimer) window.clearTimeout(playbotKeyboardViewportTimer);
    playbotKeyboardViewportTimer = window.setTimeout(function () {
      updatePlaybotKeyboardViewport(reason || 'scheduled');
      scrollMessagesToBottomNow();
    }, typeof delay === 'number' ? delay : 60);
  }

  function scheduleInputVisibleAfterKeyboard(reason) {
    clearPlaybotKeyboardScrollTimers();
    updatePlaybotKeyboardViewport(reason || 'focus');
    var delays = [60, 180, 360, 620];
    for (var i = 0; i < delays.length; i += 1) {
      playbotKeyboardScrollTimers.push(window.setTimeout(function () {
        updatePlaybotKeyboardViewport(reason || 'focus');
        scrollMessagesToBottomNow();
        try {
          if (document.activeElement === input && isPlaybotIOSLikeBrowser()) {
            input.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        } catch (error) {}
      }, delays[i]));
    }
  }


  function getOrCreatePlaybotSessionId() {
    var key = 'pfPlaybotLeadSessionIdV84';
    try {
      var existing = window.sessionStorage.getItem(key);
      if (existing) return existing;
      var generated = 'pf-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      window.sessionStorage.setItem(key, generated);
      return generated;
    } catch (error) {
      return 'pf-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }
  }

  function scrubSensitiveText(text) {
    return String(text || '')
      .replace(/\b[STFGM]\d{7}[A-Z]\b/gi, '[redacted ID]')
      .replace(/\b\d{4}[\s-]?\d{4}[\s-]?\d{4}[\s-]?\d{4}\b/g, '[redacted card]')
      .replace(/\b\d{6}\s?\d{4}\b/g, '[redacted number]');
  }

  function compactText(text, maxLength) {
    var value = scrubSensitiveText(String(text || '').replace(/\s+/g, ' ').trim());
    if (!maxLength || value.length <= maxLength) return value;
    return value.slice(0, maxLength - 3) + '...';
  }


  function createPlaybotEventId() {
    return 'evt-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function safeJsonStringify(value) {
    try { return JSON.stringify(value || {}); } catch (error) { return '{}'; }
  }

  function isHighValuePlaybotReason(reason) {
    return reason === 'whatsapp_clicked' ||
      reason === 'whatsapp_handoff' ||
      reason === 'possible_bad_answer' ||
      reason === 'low_confidence_question' ||
      reason === 'low_confidence_followup' ||
      reason === 'negative_feedback' ||
      reason === 'fallback_first' ||
      reason === 'fallback_escalated';
  }

  function createHiddenPlaybotLogFrame() {
    try {
      var frameId = 'pf-playbot-log-frame';
      var existing = document.getElementById(frameId);
      if (existing) return existing;
      var iframe = document.createElement('iframe');
      iframe.id = frameId;
      iframe.name = frameId;
      iframe.title = 'Playbot logging';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.position = 'absolute';
      iframe.style.left = '-9999px';
      iframe.style.top = '-9999px';
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.opacity = '0';
      iframe.style.pointerEvents = 'none';
      document.body.appendChild(iframe);
      return iframe;
    } catch (error) {
      return null;
    }
  }

  function sendPayloadViaFormPost(payload) {
    try {
      if (!playbotLeadEndpoint || !document || !document.body) return false;
      createHiddenPlaybotLogFrame();
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = playbotLeadEndpoint;
      form.target = 'pf-playbot-log-frame';
      form.acceptCharset = 'UTF-8';
      form.style.display = 'none';

      var inputPayload = document.createElement('input');
      inputPayload.type = 'hidden';
      inputPayload.name = 'payload';
      inputPayload.value = safeJsonStringify(payload);
      form.appendChild(inputPayload);

      var inputEvent = document.createElement('input');
      inputEvent.type = 'hidden';
      inputEvent.name = 'eventId';
      inputEvent.value = payload && payload.eventId ? payload.eventId : '';
      form.appendChild(inputEvent);

      document.body.appendChild(form);
      form.submit();
      window.setTimeout(function () {
        try { if (form && form.parentNode) form.parentNode.removeChild(form); } catch (error) {}
      }, 1500);
      return true;
    } catch (error) {
      return false;
    }
  }

  function buildCompactGetPayload(payload) {
    payload = payload || {};
    return {
      secret: payload.secret || playbotLeadSecret,
      eventId: payload.eventId || createPlaybotEventId(),
      queuedAt: payload.queuedAt || new Date().toISOString(),
      reason: payload.reason || payload.eventType || 'chat_summary',
      eventType: payload.eventType || payload.reason || 'chat_summary',
      sessionId: payload.sessionId || playbotSessionId,
      pageUrl: compactText(payload.pageUrl || window.location.href, 700),
      pageTitle: compactText(payload.pageTitle || document.title || '', 300),
      intent: compactText(payload.intent || '', 160),
      device: compactText(payload.device || '', 160),
      quantity: compactText(payload.quantity || '', 80),
      duration: compactText(payload.duration || '', 120),
      startDate: compactText(payload.startDate || '', 120),
      location: compactText(payload.location || '', 200),
      company: compactText(payload.company || '', 200),
      whatsappClicked: !!payload.whatsappClicked,
      lowConfidenceQuestion: compactText(payload.lowConfidenceQuestion || '', 500),
      customerMessage: compactText(payload.customerMessage || '', 700),
      detectedTopic: compactText(payload.detectedTopic || '', 160),
      matchedAnswerId: compactText(payload.matchedAnswerId || '', 160),
      matchedAnswerTitle: compactText(payload.matchedAnswerTitle || '', 250),
      matchedCategory: compactText(payload.matchedCategory || '', 160),
      confidenceScore: payload.confidenceScore || '',
      botOutcome: compactText(payload.botOutcome || '', 160),
      dissatisfactionSignal: compactText(payload.dissatisfactionSignal || '', 160),
      previousQuestion: compactText(payload.previousQuestion || '', 500),
      previousAnswerId: compactText(payload.previousAnswerId || '', 160),
      previousAnswerTitle: compactText(payload.previousAnswerTitle || '', 250),
      summary: compactText(payload.summary || '', 1000),
      userInputTranscript: compactText(payload.userInputTranscript || payload.customerInputTranscript || '', 1800),
      transcript: compactText(payload.transcript || '', 1800),
      notifyEmail: payload.notifyEmail !== false,
      sheetOnly: !!payload.sheetOnly,
      userAgent: compactText(payload.userAgent || (navigator && navigator.userAgent ? navigator.userAgent : ''), 500)
    };
  }

  function sendPayloadViaImageGet(payload) {
    try {
      if (!playbotLeadEndpoint) return false;
      var compact = buildCompactGetPayload(payload || {});
      var json = safeJsonStringify(compact);
      if (json.length > 6500) {
        compact.userInputTranscript = compactText(compact.userInputTranscript || '', 700);
        compact.transcript = compactText(compact.transcript || '', 700);
        compact.summary = compactText(compact.summary || '', 700);
        json = safeJsonStringify(compact);
      }
      var url = playbotLeadEndpoint + (playbotLeadEndpoint.indexOf('?') === -1 ? '?' : '&') + 'payload=' + encodeURIComponent(json) + '&_ts=' + Date.now();
      var img = new Image();
      img.style.display = 'none';
      img.referrerPolicy = 'no-referrer-when-downgrade';
      img.onload = img.onerror = function () {
        window.setTimeout(function () {
          try { img.onload = img.onerror = null; } catch (error) {}
        }, 100);
      };
      img.src = url;
      return true;
    } catch (error) {
      return false;
    }
  }

  function sendPayloadViaBeacon(payload) {
    try {
      if (!navigator || typeof navigator.sendBeacon !== 'function' || !playbotLeadEndpoint) return false;
      var body = safeJsonStringify(payload);
      var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
      return !!navigator.sendBeacon(playbotLeadEndpoint, blob);
    } catch (error) {
      return false;
    }
  }

  function sendPayloadViaFetch(payload) {
    try {
      if (!window.fetch || !playbotLeadEndpoint) return false;
      window.fetch(playbotLeadEndpoint, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: safeJsonStringify(payload)
      }).catch(function () {});
      return true;
    } catch (error) {
      return false;
    }
  }

  function isWhatsappClickPlaybotReason(reason) {
    return reason === 'whatsapp_clicked';
  }

  function isSingleDeliveryPlaybotReason(reason) {
    // Use one accepted browser delivery channel for all tracking events that can trigger email or feedback logs.
    // This prevents duplicate Google Sheet rows on deployments that have not yet deduplicated by eventId.
    return isHighValuePlaybotReason(reason) ||
      reason === 'answer_given' ||
      reason === 'message_audit' ||
      reason === 'topic_clarification' ||
      reason === 'clarification' ||
      reason === 'direct_clarification' ||
      reason === 'repeated_question_recovery';
  }

  function sendPlaybotPayloadSingleBestEffort(payload, options) {
    options = options || {};
    if (!payload || !playbotLeadEndpoint) return false;

    // Use one accepted delivery channel only. This prevents duplicate Google Sheet rows
    // on WhatsApp click even if the Apps Script deployment has not been updated to dedupe by eventId.
    if (sendPayloadViaBeacon(payload)) return true;
    if (sendPayloadViaFormPost(payload)) return true;
    if (sendPayloadViaFetch(payload)) return true;
    if (sendPayloadViaImageGet(payload)) return true;
    return false;
  }

  function sendPlaybotPayloadBestEffort(payload, options) {
    options = options || {};
    if (!payload || !playbotLeadEndpoint) return false;
    var reason = payload.reason || payload.eventType || '';
    var highValue = !!options.highPriority || !!options.urgent || isHighValuePlaybotReason(reason);

    // v93: do not fire multiple browser delivery methods for the same feedback/log event.
    // Some Apps Script deployments may not dedupe by eventId, so client-side single delivery is safer.
    if (highValue || options.singleDelivery || isSingleDeliveryPlaybotReason(reason)) {
      return sendPlaybotPayloadSingleBestEffort(payload, options);
    }

    // For normal audit rows, use fetch first and only fall back if fetch is unavailable.
    // Do not send fetch + form together, as that can create duplicate rows.
    if (sendPayloadViaFetch(payload)) return true;
    if (options.formFallback !== false && sendPayloadViaFormPost(payload)) return true;
    if (options.imageFallback && sendPayloadViaImageGet(payload)) return true;
    return false;
  }

  function getPlaybotStorage(type) {
    try {
      if (type === 'local' && window.localStorage) return window.localStorage;
      if (window.sessionStorage) return window.sessionStorage;
    } catch (error) {}
    return null;
  }

  function loadPlaybotLogQueue() {
    try {
      var storage = getPlaybotStorage('local') || getPlaybotStorage('session');
      if (!storage) return [];
      var raw = storage.getItem(playbotLogQueueKey);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function savePlaybotLogQueue() {
    try {
      var storage = getPlaybotStorage('local') || getPlaybotStorage('session');
      if (!storage) return;
      storage.setItem(playbotLogQueueKey, JSON.stringify(playbotLogQueue.slice(-40)));
    } catch (error) {}
  }

  function removePlaybotLogQueueItem(id) {
    if (!id) return;
    var nextQueue = [];
    for (var i = 0; i < playbotLogQueue.length; i += 1) {
      if (playbotLogQueue[i] && playbotLogQueue[i].id !== id) nextQueue.push(playbotLogQueue[i]);
    }
    playbotLogQueue = nextQueue;
    savePlaybotLogQueue();
  }

  function trimPlaybotLogQueue() {
    if (playbotLogQueue.length > 40) {
      playbotLogQueue = playbotLogQueue.slice(playbotLogQueue.length - 40);
    }
    savePlaybotLogQueue();
  }

  function sendPlaybotLogQueueItem(item, options) {
    if (!item || !item.payload || !playbotLeadEndpoint) return false;
    options = options || {};
    var payload = item.payload;
    var reason = payload.reason || payload.eventType || '';
    var highPriority = !!item.highPriority || !!item.urgent || !!options.highPriority || !!options.urgent || isHighValuePlaybotReason(reason);

    var sent = sendPlaybotPayloadBestEffort(payload, {
      urgent: highPriority,
      highPriority: highPriority,
      singleDelivery: isSingleDeliveryPlaybotReason(reason),
      formFallback: true
    });

    if (sent) {
      // Apps Script v82 deduplicates by eventId. Remove locally once at least one channel has accepted the send.
      removePlaybotLogQueueItem(item.id);
      return true;
    }

    return false;
  }

  function flushPlaybotLogQueue(options) {
    try {
      if (!playbotLeadEndpoint) return;
      options = options || {};
      if (!playbotLogQueue || !playbotLogQueue.length) {
        playbotLogQueue = loadPlaybotLogQueue();
      }
      if (!playbotLogQueue.length) return;

      var limit = typeof options.limit === 'number' ? options.limit : 8;
      var snapshot = playbotLogQueue.slice(0, limit);
      for (var i = 0; i < snapshot.length; i += 1) {
        var item = snapshot[i];
        if (!item) continue;
        item.attempts = (item.attempts || 0) + 1;
        item.lastAttemptAt = Date.now();
        if (item.attempts > 8) {
          removePlaybotLogQueueItem(item.id);
          continue;
        }
        sendPlaybotLogQueueItem(item, options);
      }
      savePlaybotLogQueue();
    } catch (error) {}
  }

  function schedulePlaybotLogFlush(options) {
    try {
      if (playbotLogFlushTimer) window.clearTimeout(playbotLogFlushTimer);
      playbotLogFlushTimer = window.setTimeout(function () {
        playbotLogFlushTimer = null;
        flushPlaybotLogQueue(options || {});
      }, options && options.fast ? 60 : 300);
    } catch (error) {}
  }

  function queuePlaybotLeadPayload(payload, options) {
    try {
      options = options || {};
      if (!payload || !playbotLeadEndpoint) return;
      payload.eventId = payload.eventId || createPlaybotEventId();
      payload.queuedAt = payload.queuedAt || new Date().toISOString();
      payload.userAgent = navigator && navigator.userAgent ? navigator.userAgent : '';

      playbotLogQueue = loadPlaybotLogQueue();
      var reason = payload.reason || payload.eventType || '';
      var highPriority = !!options.highPriority || !!options.urgent || isHighValuePlaybotReason(reason);
      playbotLogQueue.push({
        id: payload.eventId,
        payload: payload,
        attempts: 0,
        createdAt: Date.now(),
        preferBeacon: !!options.preferBeacon,
        urgent: highPriority,
        highPriority: highPriority
      });
      trimPlaybotLogQueue();

      if (options.flushNow || highPriority) {
        // v93: queue first, then flush once. Do not direct-send and flush the same payload,
        // because that can create duplicate rows when server-side eventId dedupe is not active.
        flushPlaybotLogQueue({
          preferBeacon: !!options.preferBeacon || highPriority,
          highPriority: highPriority,
          urgent: highPriority,
          singleDelivery: isSingleDeliveryPlaybotReason(reason),
          limit: options.limit || 8
        });
      } else {
        schedulePlaybotLogFlush({ fast: !!options.urgent, preferBeacon: !!options.preferBeacon, formFallback: true });
      }
    } catch (error) {}
  }

  function recordTranscript(speaker, text) {
    var cleanText = compactText(text, 1200);
    if (!cleanText) return;
    playbotTranscript.push({
      time: new Date().toISOString(),
      speaker: speaker,
      text: cleanText
    });
    if (playbotTranscript.length > 80) {
      playbotTranscript = playbotTranscript.slice(playbotTranscript.length - 80);
    }
  }

  function getTranscriptText() {
    var lines = [];
    for (var i = 0; i < playbotTranscript.length; i += 1) {
      var item = playbotTranscript[i] || {};
      lines.push((item.speaker || 'Message') + ': ' + (item.text || ''));
    }
    return lines.join('\n');
  }

  function getUserInputTranscriptText() {
    var lines = [];
    for (var i = 0; i < playbotTranscript.length; i += 1) {
      var item = playbotTranscript[i] || {};
      if ((item.speaker || '').toLowerCase() !== 'customer') continue;
      var text = item.text || '';
      if (!text) continue;
      lines.push('Customer: ' + text);
    }
    return lines.join('\n');
  }

  function getLeadContext(extra) {
    var source = extra && extra.handoff ? extra.handoff : (lastWhatsappHandoffState || liveState || {});
    return {
      intent: (extra && extra.intent) || source.flow || conversationContext.lastIntent || conversationContext.lastCategory || '',
      device: (extra && extra.device) || source.device || conversationContext.device || (conversationContext.devices && conversationContext.devices[0]) || '',
      quantity: (extra && extra.quantity) || source.quantity || conversationContext.quantity || '',
      duration: (extra && extra.duration) || source.duration || conversationContext.duration || '',
      startDate: (extra && extra.startDate) || source.startDate || conversationContext.startDate || '',
      location: (extra && extra.location) || source.location || conversationContext.location || '',
      company: (extra && extra.company) || source.company || conversationContext.company || '',
      customerName: (extra && extra.customerName) || source.name || conversationContext.customerName || ''
    };
  }

  function getPlaybotAuditMeta(extra) {
    extra = extra || {};
    var answerMatch = extra.answerMatch || null;
    var second = answerMatch && answerMatch.second ? answerMatch.second : null;
    return {
      customerMessage: compactText(extra.query || extra.customerMessage || '', 1200),
      detectedTopic: compactText(extra.detectedTopic || extra.currentTopic || '', 200),
      matchedAnswerId: compactText(extra.matchedAnswerId || (answerMatch && answerMatch.answer && answerMatch.answer.id) || '', 200),
      matchedAnswerTitle: compactText(extra.matchedAnswerTitle || (answerMatch && answerMatch.answer && answerMatch.answer.title) || '', 400),
      matchedCategory: compactText(extra.matchedCategory || (answerMatch && answerMatch.answer && answerMatch.answer.category) || '', 200),
      confidenceScore: typeof extra.confidenceScore === 'number' ? extra.confidenceScore : (answerMatch && typeof answerMatch.bestScore === 'number' ? answerMatch.bestScore : ''),
      secondAnswerId: compactText(extra.secondAnswerId || (second && second.item && second.item.id) || '', 200),
      secondAnswerTitle: compactText(extra.secondAnswerTitle || (second && second.item && second.item.title) || '', 400),
      secondScore: typeof extra.secondScore === 'number' ? extra.secondScore : (second && typeof second.score === 'number' ? second.score : ''),
      botOutcome: compactText(extra.botOutcome || extra.responseType || '', 200),
      previousQuestion: compactText(extra.previousQuestion || '', 1200),
      previousAnswerId: compactText(extra.previousAnswerId || '', 200),
      previousAnswerTitle: compactText(extra.previousAnswerTitle || '', 400),
      signal: compactText(extra.signal || '', 200)
    };
  }

  function buildPlaybotLeadPayload(reason, extra) {
    var ctx = getLeadContext(extra || {});
    var lowConfidence = (extra && extra.lowConfidenceQuestion) || lastLowConfidenceQuestion || '';
    var summaryParts = [];
    if (ctx.customerName) summaryParts.push('Name: ' + ctx.customerName);
    if (ctx.company) summaryParts.push('Company: ' + ctx.company);
    if (ctx.device) summaryParts.push('Device: ' + ctx.device);
    if (ctx.quantity) summaryParts.push('Quantity: ' + ctx.quantity);
    if (ctx.duration) summaryParts.push('Duration: ' + ctx.duration);
    if (ctx.startDate) summaryParts.push('Start date: ' + ctx.startDate);
    if (ctx.location) summaryParts.push('Location: ' + ctx.location);
    if (extra && extra.query) summaryParts.push('Customer question: ' + extra.query);
    if (extra && extra.signal) summaryParts.push('Signal: ' + extra.signal);
    if (extra && extra.previousQuestion) summaryParts.push('Previous question: ' + extra.previousQuestion);
    if (extra && extra.previousAnswerId) summaryParts.push('Previous answer ID: ' + extra.previousAnswerId);
    if (extra && extra.previousAnswerTitle) summaryParts.push('Previous answer: ' + extra.previousAnswerTitle);
    if (extra && extra.currentTopic) summaryParts.push('Current detected topic: ' + extra.currentTopic);

    return {
      secret: playbotLeadSecret,
      emailTo: playbotLeadEmail,
      reason: reason || 'chat_summary',
      sessionId: playbotSessionId,
      pageUrl: window.location.href,
      pageTitle: document.title || '',
      intent: ctx.intent || (extra && extra.type) || '',
      device: ctx.device || '',
      quantity: ctx.quantity || '',
      duration: ctx.duration || '',
      startDate: ctx.startDate || '',
      location: ctx.location || '',
      company: ctx.company || '',
      whatsappClicked: !!(extra && extra.whatsappClicked),
      lowConfidenceQuestion: lowConfidence,
      notifyEmail: !(extra && extra.notifyEmail === false),
      sheetOnly: !!(extra && extra.sheetOnly),
      eventType: (extra && extra.eventType) || reason || 'chat_summary',
      eventId: (extra && extra.eventId) || '',
      customerMessage: getPlaybotAuditMeta(extra).customerMessage,
      detectedTopic: getPlaybotAuditMeta(extra).detectedTopic,
      matchedAnswerId: getPlaybotAuditMeta(extra).matchedAnswerId,
      matchedAnswerTitle: getPlaybotAuditMeta(extra).matchedAnswerTitle,
      matchedCategory: getPlaybotAuditMeta(extra).matchedCategory,
      confidenceScore: getPlaybotAuditMeta(extra).confidenceScore,
      secondAnswerId: getPlaybotAuditMeta(extra).secondAnswerId,
      secondAnswerTitle: getPlaybotAuditMeta(extra).secondAnswerTitle,
      secondScore: getPlaybotAuditMeta(extra).secondScore,
      botOutcome: getPlaybotAuditMeta(extra).botOutcome,
      previousQuestion: getPlaybotAuditMeta(extra).previousQuestion,
      previousAnswerId: getPlaybotAuditMeta(extra).previousAnswerId,
      previousAnswerTitle: getPlaybotAuditMeta(extra).previousAnswerTitle,
      dissatisfactionSignal: getPlaybotAuditMeta(extra).signal,
      summary: compactText((extra && extra.summary) || summaryParts.join('\n') || 'Playbot chat activity captured.', 3000),
      userInputTranscript: compactText(getUserInputTranscriptText(), 18000),
      transcript: compactText(getTranscriptText(), 18000)
    };
  }

  function sendPlaybotLead(reason, extra) {
    try {
      if (!playbotLeadEndpoint) return;
      extra = extra || {};

      var normalisedReason = reason || 'chat_summary';
      var allowRepeat = !!extra.allowRepeat;
      var maxPerReason = typeof extra.maxPerReason === 'number' ? extra.maxPerReason : 3;
      var keySource = extra.query || extra.lowConfidenceQuestion || extra.summary || extra.type || '';
      var key = normalisedReason + '|' + compactText(keySource, 160);

      if (extra.skipDedup) {
        // Sheet-only audit events may intentionally repeat within one session.
      } else if (allowRepeat) {
        playbotLeadSentCounts[normalisedReason] = playbotLeadSentCounts[normalisedReason] || 0;
        if (playbotLeadSentCounts[normalisedReason] >= maxPerReason) return;
        playbotLeadSentCounts[normalisedReason] += 1;
      } else {
        if (playbotLeadSentKeys[key]) return;
        playbotLeadSentKeys[key] = true;
      }

      var payload = buildPlaybotLeadPayload(normalisedReason, extra);
      queuePlaybotLeadPayload(payload, {
        urgent: !!extra.urgent,
        preferBeacon: !!extra.preferBeacon,
        flushNow: extra.flushNow !== false,
        limit: extra.limit || 8
      });
      saveState();
    } catch (error) {}
  }

  var categories = [
    'Rental Price',
    'Availability and Urgent Rental',
    'Device Selection',
    'Rental Period',
    'Delivery & Return',
    'Security Deposit',
    'Security Deposit and Device Care',
    'Required Documents',
    'Accessories and Device Condition',
    'Software Compatibility',
    'Corporate and Bulk Rental',
    'Damage and Late Return',
    'Cancellation and Changes'
  ];

  var qaBank = [
    {
      id: 'rental_process_overview',
      category: 'Rental Process',
      title: 'How does rental work?',
      phrases: ['How does rental work?', 'How to rent?', 'How do I rent?', 'How does it work?', 'What is the rental process?', 'Show me the rental process', 'What are the rental steps?', 'How do I place an order?', 'Can I order online?', 'Can I order by WhatsApp?', 'What happens after payment?', 'When is my rental confirmed?', 'How do I receive the device?', 'How do I return the device?', 'Will you deliver and collect?', 'Do you collect back the device?'],
      keywords: ['rental process', 'rental steps', 'how to rent', 'how does rental work', 'order online', 'whatsapp order', 'after payment', 'confirmed', 'deliver', 'collect', 'return collection'],
      answer: 'Here’s how Playforce rental works:\n\n1. Choose your rental device.\n2. Order online or WhatsApp us for help.\n3. Submit the required documents for verification.\n4. Make payment to confirm the rental.\n5. Playforce delivers the device to you.\n6. Playforce collects it back when the rental ends.\n\nRental is confirmed only after payment is completed.',
      actions: ['rent_device_flow', 'price_flow', 'view_rental', 'live_agent', 'main_menu']
    },
    {
      id: 'exact_brand_model',
      category: 'Device Selection',
      title: 'Can I choose the exact laptop brand or model?',
      phrases: [
        'Can I choose the exact laptop brand or model?',
        'Can I choose brand?',
        'Can choose model?',
        'Brand can choose?',
        'Can I choose exact Windows laptop?',
        'Can I choose exact laptop?',
        'Can I choose specific laptop?',
        'Can I choose specific model?',
        'Can I choose the laptop model?',
        'Can I request a specific brand?',
        'Can I request a specific model?',
        'Can I request Lenovo?',
        'Can I request Dell?',
        'Can I request HP?',
        'Can I request Asus?',
        'Can I request Acer?',
        'Can I request Microsoft?',
        'Can I request Razer?',
        'Can I choose Lenovo laptop?',
        'Can I choose Dell laptop?',
        'Can I choose HP laptop?',
        'Can I choose Asus laptop?',
        'Can I choose Acer laptop?',
        'Can I choose Microsoft laptop?',
        'Can I choose Razer laptop?',
        'I want Dell laptop',
        'I want Lenovo laptop',
        'I want HP laptop',
        'I want Asus laptop',
        'I want Acer laptop',
        'I want Microsoft laptop',
        'I want Razer laptop',
        'Dell preferred',
        'Lenovo preferred',
        'HP preferred',
        'Asus preferred',
        'Acer preferred',
        'Microsoft preferred',
        'Razer preferred',
        'Got Dell?',
        'Got Lenovo?',
        'Got HP?',
        'Got Asus?',
        'Got Acer?',
        'Got Microsoft?',
        'Got Razer?',
        'Do you have Dell?',
        'Do you have Lenovo?',
        'Do you have HP?',
        'Do you have Asus?',
        'Do you have Acer?',
        'Do you have Microsoft?',
        'Do you have Razer?',
        'What brand will I get?',
        'What brands do you have?',
        'What laptop brands do you have?',
        'What brands and models of laptop do you have?',
        'What models of laptop do you have?',
        'What laptop models do you have?',
        'What brand laptop can I rent?',
        'What laptop brand available?',
        'What model laptop available?',
        'Which laptop brands are available?',
        'Which laptop models are available?',
        'Are Windows laptop brands guaranteed?',
        'Is the laptop same as photo?'
      ],
      keywords: [
        'brand', 'brands', 'model', 'models', 'specific brand', 'specific model', 'exact brand', 'exact model', 'preferred brand', 'brand preference', 'model preference',
        'choose brand', 'choose model', 'request brand', 'request model', 'what brand', 'what brands', 'what model', 'what models', 'brands available', 'models available',
        'acer', 'asus', 'dell', 'lenovo', 'hp', 'microsoft', 'surface', 'razer', 'apple', 'macbook',
        'exact', 'choose', 'request', 'prefer', 'preferred', 'available', 'windows laptop', 'business laptop', 'gaming laptop'
      ],
      answer: "For Windows laptop rentals, devices are allocated based on the specifications selected and current availability.\n\nOur laptop fleet may include brands such as Apple, Acer, Asus, Dell, Lenovo, HP, Microsoft, Razer and others.\n\nIf you have a preferred brand or model, you may add it under “Additional Remarks” during booking. Where available, our team will try to assign it for you.\n\nFor MacBook rentals, you may choose from the available MacBook options shown on the rental page.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'reference_images',
      category: 'Device Selection',
      title: 'Are the product images the actual rental device?',
      phrases: ['Is the photo the actual laptop?', 'Will I receive the exact laptop shown?', 'Is the image for reference only?', 'Does the device look exactly like the picture?', 'Is the picture the actual unit?', 'Product image actual?'],
      keywords: ['photo', 'image', 'picture', 'actual', 'reference', 'illustration'],
      answer: "Product images are for illustration only.\n\nThe actual rental device will be based on the specifications selected and current availability.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'macbook_selectable',
      category: 'Device Selection',
      title: 'Can I choose a MacBook model?',
      phrases: ['Can I choose MacBook Air M1?', 'Can I choose M2?', 'Can I select MacBook Pro?', 'Are MacBook models confirmed?', 'For MacBook can choose exact type?', 'Can choose MacBook model?'],
      keywords: ['macbook', 'm1', 'm2', 'm3', 'm4', 'air', 'pro', 'select'],
      answer: "Yes. For MacBook rentals, you may choose from the available MacBook options shown on the rental page, such as MacBook Air, MacBook Pro, and other available models.",
      actions: ['view_macbook', 'live_agent']
    },
    {
      id: 'specs_match',
      category: 'Device Selection',
      title: 'Will the laptop match the specifications selected?',
      phrases: ['Will I get the specs I selected?', 'Is i5 confirmed?', 'Is 16GB RAM confirmed?', 'Will I get the selected GPU?', 'Will the laptop match my booking?', 'Will specs be same?'],
      keywords: ['spec', 'specs', 'i5', 'i7', 'ram', 'memory', 'gpu', 'selected', 'confirmed'],
      answer: "Yes. The device provided will match the specifications selected during booking, subject to availability and rental confirmation.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'which_device',
      category: 'Device Selection',
      title: 'Which rental device should I choose?',
      phrases: ['Which laptop should I rent?', 'Not sure which laptop to choose', 'Business or gaming laptop better?', 'Should I rent MacBook or Windows?', 'Which device is suitable for me?', 'Help me choose laptop'],
      keywords: ['which', 'choose', 'suitable', 'recommend', 'business', 'gaming', 'macbook', 'ipad'],
      answer: "Here’s a quick guide:\n\n• Business Laptop — office, school, training, exam, and general productivity.\n• Gaming Laptop — Adobe and design work, video editing, gaming, coding, and heavier Windows use.\n• MacBook — macOS users, creative work, coding, school, and business use.\n• iPad — events, registration, forms, presentations, and portable use.",
      actions: ['view_business', 'view_gaming', 'view_macbook', 'view_ipad', 'live_agent']
    },
    {
      id: 'custom_duration',
      category: 'Rental Period',
      title: 'Can I choose a custom rental duration?',
      phrases: ['Can I choose exact dates?', 'Can I rent for custom period?', 'Can rent 1.5 months?', 'Can rent 45 days?', 'Can rent 7 weeks?', 'Why only fixed periods?', 'Can choose custom duration?'],
      keywords: ['custom', 'duration', 'period', 'exact', 'dates', '1.5', '45', 'weeks'],
      answer: "Custom rental periods are not available for standard online rental at the moment.\n\nPlease choose from the available rental periods shown on the rental page. For corporate, bulk, or long-term rental enquiries, WhatsApp us to check if an arrangement is possible.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'seven_weeks',
      category: 'Rental Period',
      title: 'Can I rent for 7 weeks instead of 2 months?',
      phrases: ['Can I rent 7 weeks?', 'I need 7 weeks only', 'Can I pay for 7 weeks?', 'Why must choose 2 months?', 'Can I rent from 4 July to 21 August?', '7 weeks instead of 2 months'],
      keywords: ['7', 'seven', 'weeks', '2 months', 'two months'],
      answer: "7-week rental is not available as a standard online rental period unless it is shown on the rental page.\n\nPlease choose the closest available period, usually 2 Month. For corporate, bulk, or long-term rental enquiries, WhatsApp us to check if a custom arrangement is possible.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'available_periods',
      category: 'Rental Period',
      title: 'What rental periods are available?',
      phrases: ['What duration can I rent?', 'Can rent how long?', 'What rental periods do you offer?', 'Do you have 2 days?', 'Do you have 1 month?', 'What are the rental options?'],
      keywords: ['duration', 'periods', '2 day', '3 day', '5 day', 'week', 'month'],
      answer: "Available rental periods are shown on each rental product page.\n\nAvailable rental periods depend on the selected device and will be shown on the rental page. Common rental periods include 2 Day, 3 Day, 5 Day, 1 Week, 2 Week, 1 Month, and 2 Month. Gaming Laptop, Business Laptop, and MacBook rental also support 3 Month where shown on the rental page.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'extension',
      category: 'Rental Period',
      title: 'Can I extend my rental instead?',
      phrases: ['Can extend?', 'Can I rent longer after booking?', 'Can I extend later?', 'What if I need more days?', 'Can I extend before return?', 'Extend rental', 'Can I extend my rental instead?', 'What should I do if I need the device for more days?', 'Need more days', 'Can keep longer?', 'Can use longer?', 'Can extend one more day?', 'Not ready to return'],
      keywords: ['extend', 'extension', 'rental extension', 'longer', 'more days', 'keep longer', 'use longer', 'need more days', 'one more day', 'not ready to return'],
      answer: "Rental extension may be possible, subject to availability.\n\nPlease contact Playforce before the rental ends to request an extension. Additional rental charges apply.\n\nIf the device is returned late without an approved extension, the late return fee is $100 per day per device.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'early_return',
      category: 'Rental Period',
      title: 'Can I return the device early?',
      phrases: ['Can return early?', 'Can I return earlier?', 'Can I return the device earlier?', 'What if I finish using earlier?', 'Can I end rental early?', 'If I return earlier can refund?', 'Got rebate for early return?', 'Any refund if return early?'],
      keywords: ['early', 'return', 'refund', 'rebate', 'terminate'],
      answer: "You may return the device earlier.\n\nThere is no refund or rebate for early return, as rental charges are based on the confirmed rental period.",
      actions: ['live_agent']
    },
    {
      id: 'check_price',
      category: 'Rental Price',
      title: 'How do I check the rental price?',
      phrases: ['How much to rent?', 'What is the rental price?', 'Rental fee how much?', 'How much for laptop rental?', 'Where to see price?', 'How to check price?', 'Rental how much?', 'How much ah?', 'Price how?', 'How much rental?', 'Rate how much?', 'Can quote?'],
      keywords: ['price', 'pricing', 'how much', 'rental fee', 'cost', 'rate'],
      answer: "Rental pricing is shown on the rental page.\n\nYou can also ask Playbot by including the device and rental duration, for example: “MacBook Air M1 for 1 Month how much?”\n\nFinal pricing will be confirmed at checkout.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'quotation',
      category: 'Rental Price',
      title: 'Can I get a quotation?',
      phrases: ['Can send quote?', 'Can quote me?', 'I need quotation', 'Can I get company quote?', 'Can you quote for bulk rental?', 'Send quotation'],
      keywords: ['quote', 'quotation', 'company quote', 'bulk quote'],
      answer: "For standard rental, pricing is available on the rental page. Playbot can also check the price when you include the device and rental duration.\n\nFor corporate, bulk, or long-term rental enquiries, WhatsApp us for an official quotation.",
      actions: ['live_agent']
    },
    {
      id: 'bulk_pricing',
      category: 'Rental Price',
      title: 'Do you offer bulk rental pricing?',
      phrases: ['Got bulk discount?', 'Can quote for 2 units?', 'Can quote for 5 units?', 'Can quote for 10 units?', 'Company rental price?', 'Corporate rental rate?', 'Long-term rental quote?', 'Bulk rental price', 'Company rental can?', 'Bulk can?', '2 units can?', '10 units can?', 'Corporate quote can?', 'Need multiple devices'],
      keywords: ['bulk', 'corporate', 'company', 'long term', 'long-term', '2 units', '10 units', 'multiple devices', 'discount'],
      answer: "Yes. Playforce supports multiple-device rental from 2 units and above.\n\nThis is suitable for individuals, companies, schools, events, roadshows, training, exams, and short-term projects.\n\nPlease share your name, company name if any, device type, quantity, start date, rental duration, and delivery location. Playforce will check availability and advise the suitable rental arrangement.\n\nOfficial quotation and invoice can be provided where required.",
      actions: ['live_agent']
    },
    {
      id: 'payment_confirmation',
      category: 'Rental Price',
      title: 'Is the price confirmed after I select the options?',
      phrases: ['Is price confirmed?', 'Will price change?', 'Is booking confirmed after selection?', 'Is reservation confirmed?', 'When is rental confirmed?', 'When confirm booking?'],
      keywords: ['confirmed', 'payment', 'reservation', 'booking', 'pay'],
      answer: "Rental reservation is confirmed only after payment is completed.\n\nPricing and availability may change before payment confirmation.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'payment_delivery_confirmation',
      category: 'Rental Confidence and Common Concerns',
      title: 'Will I receive the laptop after payment?',
      phrases: ['Will I get the laptop after paying?', 'Will I get the laptop after payment?', 'After payment will I receive the laptop?', 'Once I pay will you deliver?', 'Will I receive the device after payment?', 'Will you really send the laptop after I pay?', 'After paying will I get it?', 'If I pay will I get the device?'],
      keywords: ['after payment', 'after paying', 'once i pay', 'will i get', 'will i receive', 'deliver after payment', 'payment verified'],
      answer: "Yes. Once payment and the required documents are received and verified, Playforce will proceed with the rental arrangement for the selected delivery slot.\n\nIf there is any issue with the selected device or timing, our team will contact you to advise the available options before proceeding.",
      actions: ['view_rental', 'live_agent', 'main_menu']
    },
    {
      id: 'price_objection',
      category: 'Rental Price',
      title: 'Is there a cheaper rental option?',
      phrases: ['Rental price too high', 'Too expensive', 'Any cheaper option?', 'Got cheaper?', 'Can lower price?', 'Any discount?', 'Budget option?', 'Cheapest laptop rental?', 'Price is high'],
      keywords: ['too expensive', 'price too high', 'cheaper', 'budget', 'discount', 'lower price', 'cheapest'],
      answer: "I understand. Rental cost depends on the selected device tier and rental duration.\n\nFor a lower cash commitment, you may consider a Business Laptop or a lower gaming tier if it suits your usage. If you share what you need the device for and how long you need it, I can suggest a more cost-effective option.",
      actions: ['rental_product', 'price_flow', 'live_agent', 'main_menu']
    },
    {
      id: 'delivery_free',
      category: 'Delivery & Return',
      title: 'Is delivery free?',
      phrases: ['Delivery free?', 'Any delivery charge?', 'Is delivery included?', 'Need pay delivery?', 'Is return included?', 'Free delivery?', 'Got delivery?', 'Delivery got charge?', 'Free delivery ah?', 'Send to me can?'],
      keywords: ['delivery', 'free', 'charge', 'included', 'return'],
      answer: "Delivery and return collection are arranged by Playforce.\n\nDelivery and return charges, if applicable, will be shown during booking or confirmed by Playforce before the rental is confirmed.\n\nAdditional charges may apply for urgent delivery, priority delivery, weekend arrangements, MBS or special locations, different return location, or return timing changes.",
      actions: ['main_menu']
    },
    {
      id: 'self_collect',
      category: 'Delivery & Return',
      title: 'Can I self-collect?',
      phrases: ['Can self collect?', 'Can I pick up myself?', 'Can collect from your shop?', 'Can I arrange own collection?', 'Where to collect?', 'Self collection available?', 'Self collect can?', 'Can ownself collect?', 'Can collect myself?'],
      keywords: ['self collect', 'self-collect', 'collect myself', 'ownself collect', 'pickup myself', 'pick up myself', 'pickup from shop', 'pick up from shop', 'shop'],
      answer: "Self-collection is not available at the moment.\n\nFor rentals, delivery will be arranged by Playforce.",
      actions: ['main_menu']
    },
    {
      id: 'self_return',
      category: 'Delivery & Return',
      title: 'Can I self-return?',
      phrases: ['Can self return?', 'Can I return myself?', 'Can I drop off?', 'Can I send back myself?', 'Where to return?', 'Self return available?'],
      keywords: ['self return', 'self-return', 'drop off', 'send back'],
      answer: "Self-return is not available at the moment.\n\nFor rentals, return collection will be arranged by Playforce.",
      actions: ['main_menu']
    },
    {
      id: 'return_collection_fee',
      category: 'Delivery & Return',
      title: 'Is return collection free?',
      phrases: ['Is return collection free?', 'Is collection free?', 'Is returning free?', 'Is collection back free?', 'Return collection got charge?', 'Need pay return collection?', 'Is pickup after rental included?', 'Collect back free?', 'Return free?'],
      keywords: ['return collection', 'collection free', 'returning free', 'collect back', 'pickup after rental', 'return included', 'return charge'],
      answer: "Delivery and return collection are arranged by Playforce.\n\nDelivery and return charges, if applicable, will be shown during booking or confirmed by Playforce before the rental is confirmed.\n\nAdditional charges may apply for urgent delivery, priority delivery, weekend arrangements, MBS or special locations, different return location, or return timing changes.",
      actions: ['view_rental', 'main_menu']
    },
    {
      id: 'deliver_tomorrow',
      category: 'Delivery & Return',
      title: 'Can you deliver tomorrow?',
      phrases: ['Can deliver tomorrow?', 'Tomorrow available?', 'Can I get it next day?', 'Need laptop tomorrow', 'Can deliver urgently?', 'Next day delivery', 'Tomorrow can?', 'Tomorrow delivery can?', 'Need tomorrow can?'],
      keywords: ['tomorrow', 'next day', 'urgent', 'deliver tomorrow'],
      answer: "Please select your rental start date on the rental page to view the available delivery slots.\n\nAvailable timings and any applicable charges will be shown during booking.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'delivery_timing',
      category: 'Delivery & Return',
      title: 'Can I choose delivery timing?',
      phrases: ['Can choose timing?', 'What delivery slots available?', 'Can deliver morning?', 'Can deliver evening?', 'Can I choose time slot?', 'Delivery slot?'],
      keywords: ['timing', 'slot', 'morning', 'evening', 'delivery time'],
      answer: "Yes. Available delivery slots will be shown during the rental booking process after you select your rental start date.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'urgent_delivery_charges',
      category: 'Delivery & Return',
      title: 'Are there urgent delivery charges?',
      phrases: ['Any urgent fee?', 'Need urgent delivery', 'Why got extra charge?', 'What is priority delivery?', 'What is urgent charge?', 'Priority delivery charge?', 'Urgent can?', 'ASAP can?', 'Need now can?', 'Rush rental can?'],
      keywords: ['urgent', 'priority', 'extra charge', '8am', '11am', '1pm'],
      answer: "Urgent or priority delivery charges may apply depending on the rental date and delivery timing.\n\n• Priority Delivery 8am–10am: +$30\n• Restricted next-day Priority Urgent 11am–1pm: +$80\n• Restricted next-day Standard Urgent 1pm–3pm: +$50\n\nApplicable charges will be shown during booking.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'different_return_location',
      category: 'Delivery & Return',
      title: 'Can I return from another location?',
      phrases: ['Can return at different location?', 'Delivery one place return another?', 'Can collect from another address?', 'Return address different can?', 'Different return location charge?'],
      keywords: ['different location', 'another location', 'return address', 'different address'],
      answer: "Return from a different location may be arranged with an additional $15 charge.\n\nPlease WhatsApp us before confirming your rental.",
      actions: ['live_agent']
    },
    {
      id: 'security_deposit_required',
      category: 'Security Deposit',
      title: 'Is there a security deposit?',
      phrases: ['Need deposit?', 'Got security deposit?', 'Why need deposit?', 'Is deposit required?', 'Deposit compulsory?', 'Is there deposit?'],
      keywords: ['deposit', 'security deposit', 'required', 'compulsory'],
      answer: "Yes. A refundable security deposit is required for rental.\n\nThe deposit amount is shown on the rental page based on the selected device.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'deposit_refundable',
      category: 'Security Deposit',
      title: 'Is the security deposit refundable?',
      phrases: ['Deposit refundable?', 'Will I get deposit back?', 'When refund deposit?', 'How long to refund?', 'Is it fully refundable?', 'Refundable deposit?', 'Deposit return when?', 'Deposit can get back?', 'Refund deposit when?', 'Security deposit return how?'],
      keywords: ['deposit', 'refundable', 'refund', 'get back', '3 business days'],
      answer: "Yes. The security deposit is refundable within 3 business days after return.\n\nThis is subject to device condition, late return, and rental terms.",
      actions: ['main_menu']
    },
    {
      id: 'deposit_waived',
      category: 'Security Deposit',
      title: 'Can the deposit be waived?',
      phrases: ['Can waive deposit?', 'Can no need deposit?', 'Can reduce deposit?', 'Deposit can discount?', 'Existing customer can waive?', 'Can waive security deposit?', 'Can waive deposit?', 'Deposit can waive?', 'No deposit can?'],
      keywords: ['waive', 'waived', 'reduce', 'discount', 'no need deposit'],
      answer: "No. The security deposit cannot be waived.",
      actions: ['live_agent']
    },
    {
      id: 'deposit_offset',
      category: 'Security Deposit',
      title: 'Can I use the deposit to offset the rental fee?',
      phrases: ['Can use deposit to pay rental?', 'Can offset rental with deposit?', 'Can deduct from deposit?', 'Can deposit cover rental fee?', 'Can use deposit as payment?'],
      keywords: ['offset', 'deduct', 'cover rental', 'deposit payment'],
      answer: "No. The security deposit cannot be used to offset rental fees.\n\nRental fee and security deposit are separate.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'deposit_amount',
      category: 'Security Deposit',
      title: 'How much is the deposit?',
      phrases: ['Deposit how much?', 'What is the security deposit?', 'How much to pay upfront?', 'Deposit amount?', 'Is deposit different for each device?'],
      keywords: ['deposit amount', 'how much deposit', 'upfront'],
      answer: "The security deposit amount depends on the selected rental device.\n\nIt will be shown on the rental page during booking.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'required_documents',
      category: 'Required Documents',
      title: 'What documents are required for rental?',
      phrases: ['Need what documents?', 'What do I need to submit?', 'Need NRIC?', 'Need proof of address?', 'What documents for individual rental?', 'Required documents?', 'Need NRIC?', 'Need what doc?', 'Need document?', 'Need proof address?'],
      keywords: ['document', 'documents', 'nric', 'proof of address', 'submit'],
      answer: "For individual rental, NRIC front and back and proof of address are required.\n\nProof of address should show your full name and residential address clearly, and should be dated within the latest 2 months.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'why_documents',
      category: 'Required Documents',
      title: 'Why do I need to provide documents?',
      phrases: ['Why need NRIC?', 'Why need proof of address?', 'Why need documents?', 'Is document required?', 'Why so many documents?'],
      keywords: ['why', 'nric', 'proof address', 'verification', 'documents'],
      answer: "Documents are required for rental verification and to confirm the renter responsible for the device.\n\nFor individual rental, NRIC front and back and proof of address are required. For company rental, ACRA and name card may be required.\n\nPlayforce uses the submitted documents for rental verification purposes.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'proof_of_address',
      category: 'Required Documents',
      title: 'What is accepted as proof of address?',
      phrases: ['What proof of address can use?', 'Can use bank statement?', 'Can use utility bill?', 'Can use telco bill?', 'What address proof accepted?', 'Proof of address examples?'],
      keywords: ['proof of address', 'bank statement', 'utility bill', 'telco', 'address proof'],
      answer: "Accepted proof of address examples include utility bill, telco or broadband bill, bank or credit-card statement, CPF statement, IRAS Notice of Assessment or other government letter, tenancy or rental agreement, or property tax or ownership document.\n\nThe document should show your full name and residential address clearly, and should be dated within the latest 2 months.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'company_documents',
      category: 'Required Documents',
      title: 'Do companies need documents?',
      phrases: ['What documents for company rental?', 'Company rental need what?', 'Need ACRA?', 'Need name card?', 'Corporate rental documents?', 'Company documents?'],
      keywords: ['company', 'corporate', 'acra', 'name card', 'documents'],
      answer: "For company rental, ACRA and name card may be required.\n\nPlease WhatsApp us so our team can advise based on the company, quantity, duration, and delivery requirements.",
      actions: ['live_agent']
    },
    {
      id: 'apps_included',
      category: 'Software Compatibility',
      title: 'Are applications included?',
      phrases: ['Got apps?', 'Apps included?', 'Software included?', 'Does it come with programs?', 'Are applications provided?', 'Applications included?'],
      keywords: ['apps', 'applications', 'software', 'programs', 'included'],
      answer: "Applications are not provided unless stated.\n\nMicrosoft Office is included for Business Laptop rental. For Gaming Laptop and MacBook rental, Microsoft Office may be available as a chargeable optional extra where shown.\n\nCustomers may install their own compatible software during the rental period.",
      actions: ['main_menu']
    },
    {
      id: 'microsoft_office',
      category: 'Software Compatibility',
      title: 'Does the laptop come with Microsoft Office?',
      phrases: ['Got Microsoft Office?', 'Got Word and Excel?', 'Office included?', 'Need pay for Office?', 'Does it include PowerPoint?', 'Do your laptops have Office?', 'Got Office?', 'Got Word?', 'Got Excel?', 'Office have or not?'],
      keywords: ['microsoft office', 'office', 'word', 'excel', 'powerpoint', 'outlook'],
      answer: "Microsoft Office is included for Business Laptop rental.\n\nFor Gaming Laptop and MacBook rental, Microsoft Office may be available as a chargeable optional extra where shown.\n\nFor iPad rental, please use supported iPadOS Microsoft apps with your own account if required.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'install_software',
      category: 'Software Compatibility',
      title: 'Can I install my own software?',
      phrases: ['Can install own apps?', 'Can install my software?', 'Can I download programs?', 'Can install company software?', 'Can install Adobe?', 'Can install apps?'],
      keywords: ['install', 'download', 'own software', 'company software', 'apps'],
      answer: "Yes, you may install your own software during the rental period where compatible.\n\nApplications, accounts, licences, and setup are the customer’s responsibility unless stated.",
      actions: ['main_menu']
    },
    {
      id: 'adobe_apps',
      category: 'Software Compatibility',
      title: 'Can the laptop run Adobe apps?',
      phrases: ['Can use Adobe?', 'Can run Photoshop?', 'Can run Illustrator?', 'Can run Premiere Pro?', 'Suitable for design work?', 'Can do video editing?'],
      keywords: ['adobe', 'photoshop', 'illustrator', 'premiere', 'design', 'video editing'],
      answer: "For common Adobe or design use, Business Laptop may be suitable depending on the selected specifications.\n\nFor heavier design work, large files, Premiere Pro, or video editing, Gaming Laptop or a suitable MacBook is recommended.",
      actions: ['main_menu']
    },
    {
      id: 'coding_apps',
      category: 'Software Compatibility',
      title: 'Can the laptop run Python, Visual Studio, or coding apps?',
      phrases: ['Can use Python?', 'Can use Visual Studio?', 'Can use VS Code?', 'Suitable for coding?', 'Can do programming?', 'Can use coding apps?'],
      keywords: ['python', 'visual studio', 'vs code', 'coding', 'programming', 'developer'],
      answer: "For coding, Python, Visual Studio, or VS Code, Business Laptop i7 or Ryzen 7, Gaming Laptop, or a suitable MacBook is recommended.\n\nFor heavier projects, 16GB RAM or higher is recommended where available.",
      actions: ['main_menu']
    },
    {
      id: 'docker_sql',
      category: 'Software Compatibility',
      title: 'Can the laptop run Docker or SQL?',
      phrases: ['Can run Docker?', 'Can use SQL?', 'Can run database tools?', 'Is 16GB enough for Docker?', 'Suitable for backend development?', 'Can run databases?'],
      keywords: ['docker', 'sql', 'database', 'backend', '16gb', 'containers'],
      answer: "For Docker, SQL, database tools, local servers, or heavier development stacks, Business Laptop i7 or Ryzen 7, Gaming Laptop, or a suitable MacBook is recommended.\n\n16GB RAM or higher is generally recommended for smoother performance.",
      actions: ['main_menu']
    },
    {
      id: 'ai_apps',
      category: 'Software Compatibility',
      title: 'Can the laptop run AI apps?',
      phrases: ['Can run AI app?', 'Can use ChatGPT app?', 'Can run local AI?', 'Can use application-based AI tools?', 'Can use cloud AI tools?', 'AI apps suitable?'],
      keywords: ['ai', 'chatgpt', 'copilot', 'gemini', 'local ai', 'cloud ai'],
      answer: "Cloud-assisted AI apps are generally less demanding and should be suitable for common use.\n\nFor heavier local AI tools, larger files, or more demanding workloads, choose a higher-spec laptop such as Business Laptop i7 or Ryzen 7, Gaming Laptop, or a suitable MacBook.",
      actions: ['main_menu']
    },
    {
      id: 'software_support',
      category: 'Software Compatibility',
      title: 'Do you provide software support?',
      phrases: ['Can help install software?', 'Can help troubleshoot apps?', 'Do you support my software?', 'Can you help set up programs?', 'What if my software cannot run?', 'Software support?'],
      keywords: ['software support', 'troubleshoot', 'setup', 'set up', 'help install'],
      answer: "Playforce can help guide you on a suitable rental device based on your software, game, or usage needs.\n\nPerformance may depend on the software version, settings, workload, game updates, and internet connection.\n\nIf you are unsure, WhatsApp us before ordering so our team can recommend a suitable rental device.\n\nUpgrade may be possible, subject to availability and additional fees. Rental charges are based on the confirmed rental period.",
      actions: ['rental_product', 'game_recommendation', 'live_agent', 'main_menu']
    },
    {
      id: 'business_i5_compatibility',
      category: 'Software Compatibility',
      title: 'What can Business Laptop i5 or Ryzen 5 handle?',
      phrases: ['What can business laptop i5 handle?', 'Business i5 compatibility?', 'Business laptop Ryzen 5 suitable for what?', 'What apps can i5 run?', 'What apps can Ryzen 5 run?', 'Business laptop i5 can run what?', 'Non grey out compatibility items?'],
      keywords: ['business', 'i5', 'ryzen 5', 'compatibility', 'suitable', 'apps', 'grey', 'greyed', 'handle'],
      answer: "Business Laptop i5 or Ryzen 5 is suitable for general use such as Microsoft Office, browsing, video calls, cloud-assisted AI apps, common productivity apps, light design work, and exam browsers.\n\nFor coding, Docker, SQL, Ubuntu or Custom OS, or heavier multitasking, Business Laptop i7 or Ryzen 7 or higher is recommended.",
      actions: ['main_menu']
    },
    {
      id: 'business_i7_compatibility',
      category: 'Software Compatibility',
      title: 'What can Business Laptop i7 or Ryzen 7 handle?',
      phrases: ['Business i7 compatibility?', 'Business laptop i7 can run what?', 'Ryzen 7 business laptop suitable for what?', 'Can i7 business laptop run coding?', 'Can Ryzen 7 run Docker?'],
      keywords: ['business', 'i7', 'ryzen 7', 'compatibility', 'coding', 'docker', 'sql', 'visual studio'],
      answer: "Business Laptop i7 or Ryzen 7 is suitable for general productivity, multitasking, coding, Visual Studio or VS Code, Docker, SQL and database tools, Ubuntu or Custom OS, and heavier business use.\n\nFor video editing, gaming, graphics-heavy Adobe work, or demanding GPU-based workloads, Gaming Laptop may still be more suitable.",
      actions: ['main_menu']
    },
    {
      id: 'device_compatibility_comparison',
      category: 'Software Compatibility',
      title: 'How do the rental categories compare for app compatibility?',
      phrases: ['What is the difference between i5 and i7?', 'Compare i5 and i7 compatibility', 'i5 vs i7 for apps', 'i5 vs macbook pro m1 pro', 'MacBook vs business laptop compatibility', 'Gaming laptop vs MacBook compatibility', 'Which device is better for Docker?', 'Which device is better for Adobe?', 'Which device is better for coding?'],
      keywords: ['compare', 'comparison', 'difference', 'i5', 'i7', 'macbook', 'gaming', 'business', 'compatibility', 'apps', 'docker', 'coding', 'adobe'],
      answer: "General guide:\n\n• Business Laptop i5 or Ryzen 5 — Office, browsing, video calls, cloud-assisted AI apps, common productivity work, light design work, and exam browsers.\n• Business Laptop i7 or Ryzen 7 — multitasking, coding, Visual Studio or VS Code, Docker, SQL and database tools, Ubuntu or Custom OS, and heavier business use.\n• Gaming Laptop — strongest Windows option for Adobe, video editing, gaming, graphics work, application-based AI apps, coding, Docker, SQL, and external-display use.\n• MacBook — macOS users, Office, browsing, video calls, Adobe and design apps, coding, Docker, SQL, and exam browsers. For heavier workloads, choose a 16GB MacBook or higher where available.",
      actions: ['main_menu']
    },
    {
      id: 'business_laptop_overview',
      category: 'Device Selection',
      title: 'What is Business Laptop rental suitable for?',
      phrases: ['What is business laptop rental suitable for?', 'Business laptop suitable for what?', 'Can I use business laptop for office?', 'Business laptop rental use case', 'What can business laptop do?'],
      keywords: ['business laptop', 'office', 'school', 'general', 'suitable', 'use case'],
      answer: "Business Laptop rental is suitable for office work, school use, Microsoft Office, web browsing, video calls, and common productivity tasks.\n\nFor coding, Docker, SQL, or heavier multitasking, choose Business Laptop i7 or Ryzen 7 or higher where available.",
      actions: ['main_menu']
    },
    {
      id: 'business_i5_i7_difference',
      category: 'Software Compatibility',
      title: 'What is the difference between i5 or Ryzen 5 and i7 or Ryzen 7?',
      phrases: ['What is the difference between i5 and i7?', 'i5 vs i7 for rental', 'i5 vs i7 app compatibility', 'Ryzen 5 vs Ryzen 7 rental', 'Should I choose i5 or i7?', 'Business i5 or i7 better?'],
      keywords: ['i5', 'i7', 'ryzen 5', 'ryzen 7', 'difference', 'compare', 'compatibility'],
      answer: "Business Laptop i5 or Ryzen 5 is suitable for lighter general use such as Office, browsing, video calls, cloud-assisted AI apps, common productivity work, light design work, and exam browsers.\n\nBusiness Laptop i7 or Ryzen 7 is better for multitasking, coding, Visual Studio or VS Code, Docker, SQL and database tools, Ubuntu or Custom OS, and heavier business use.\n\nFor video editing, gaming, graphics-heavy Adobe work, or demanding AI workloads, Gaming Laptop may still be more suitable.",
      actions: ['main_menu']
    },
    {
      id: 'gaming_laptop_overview',
      category: 'Device Selection',
      title: 'What is Gaming Laptop rental suitable for?',
      phrases: ['What is gaming laptop rental suitable for?', 'Gaming laptop suitable for what?', 'Can gaming laptop be used for work?', 'Gaming laptop rental use case', 'What can gaming laptop run?'],
      keywords: ['gaming laptop', 'suitable', 'work', 'adobe', 'coding', 'gpu', 'rtx', 'gtx'],
      answer: "Gaming Laptop rental is suitable for gaming, Adobe and design work, video editing, graphics workloads, coding, Visual Studio or VS Code, Docker, SQL tools, external-display use, and heavier application-based AI apps.\n\nActual performance depends on the selected GPU tier and workload.",
      actions: ['main_menu']
    },
    {
      id: 'gaming_gpu_options',
      category: 'Device Selection',
      title: 'Which Gaming Laptop GPU options are available?',
      phrases: ['Which GPU is available?', 'What GPU do gaming laptops have?', 'Do you have RTX?', 'Do you have GTX?', 'Gaming laptop GPU options', 'RTX rental laptop available?'],
      keywords: ['gpu', 'graphics', 'gtx', 'rtx', '3050', '3060', '4050', '4060', '4070', '5050', '5080'],
      answer: "Gaming Laptop rental is arranged by GPU tier, such as GTX and RTX series options where available. Exact brand or model selection is not available.\n\nGeneral guide:\n• GTX or RTX 2060 or RTX 3050 — common gaming, basic GPU acceleration, general Adobe and design use, and light-to-moderate editing.\n• RTX 3060, RTX 4050, or RTX 5050 — smoother gaming, Adobe work, video editing, and heavier multitasking.\n• RTX 3070, RTX 3080, RTX 4060, or RTX 4070 — heavier creative workloads, larger projects, higher graphics needs, or demanding GPU-based work.\n• RTX 5080 — strongest available tier for very demanding gaming, high graphics settings, heavier GPU workloads, rendering, and creator use where available.\n\nChoose a higher GPU tier if your work depends heavily on CUDA or GPU acceleration, VRAM, 3D, rendering, or video editing.",
      actions: ['main_menu']
    },
    {
      id: 'gaming_adobe_video',
      category: 'Software Compatibility',
      title: 'Can Gaming Laptop handle video editing and creative apps?',
      phrases: ['Can gaming laptop run Adobe?', 'Can gaming laptop run Premiere Pro?', 'Gaming laptop for video editing?', 'Gaming laptop for Photoshop?', 'Gaming laptop for Illustrator?'],
      keywords: ['gaming', 'adobe', 'premiere', 'video editing', 'photoshop', 'illustrator', 'design'],
      answer: "Yes. Gaming Laptop rental is generally suitable for Adobe, design apps, and video editing.\n\nFor Premiere Pro, large files, or heavier edits, choose a higher GPU tier where available. Applications are not provided unless stated.",
      actions: ['main_menu']
    },
    {
      id: 'gaming_development_ai',
      category: 'Software Compatibility',
      title: 'Can Gaming Laptop run coding, Docker, SQL, or AI apps?',
      phrases: ['Can gaming laptop run Docker?', 'Can gaming laptop run SQL?', 'Can gaming laptop run Python?', 'Can gaming laptop run Visual Studio?', 'Can gaming laptop run AI apps?', 'Gaming laptop for coding?'],
      keywords: ['gaming', 'docker', 'sql', 'python', 'visual studio', 'coding', 'ai'],
      answer: "Yes. Gaming Laptop rental is generally suitable for coding, Visual Studio or VS Code, Docker, SQL and database tools, and heavier application-based AI apps.\n\nActual performance depends on the selected GPU tier and workload.",
      actions: ['main_menu']
    },
    {
      id: 'macbook_overview',
      category: 'Device Selection',
      title: 'What is MacBook rental suitable for?',
      phrases: ['What is MacBook rental suitable for?', 'MacBook suitable for what?', 'Can MacBook be used for coding?', 'Can MacBook be used for Adobe?', 'MacBook rental use case'],
      keywords: ['macbook', 'suitable', 'coding', 'adobe', 'docker', 'office', 'macos'],
      answer: "MacBook rental is suitable for macOS users, Office, browsing, video calls, Adobe and design apps, coding, Docker, SQL tools, and exam browsers.\n\nFor heavier workloads, a 16GB MacBook or higher is recommended, such as MacBook Pro M1 Pro and above. Ubuntu or Custom OS installation is not recommended for MacBook rentals.",
      actions: ['main_menu']
    },
    {
      id: 'macbook_air_8gb_heavy_apps',
      category: 'Software Compatibility',
      title: 'Can MacBook Air M1 or M2 handle Docker or heavier apps?',
      phrases: ['Can MacBook Air M1 handle Docker?', 'Can MacBook Air M2 handle Docker?', 'Can MacBook Air M1 run coding?', 'Can MacBook Air M1 run SQL?', 'Is MacBook Air M1 8GB enough?', 'Can 8GB MacBook run Docker?'],
      keywords: ['macbook air', 'm1', 'm2', '8gb', 'docker', 'coding', 'sql', 'heavy'],
      answer: "MacBook Air M1 or M2 is suitable for common macOS use, Office, browsing, video calls, lighter coding, and common app use.\n\nFor Docker, SQL, multiple development tools, large Adobe files, local AI, or heavier multitasking, a 16GB MacBook or higher is recommended.",
      actions: ['main_menu']
    },
    {
      id: 'macbook_exam_lockdown',
      category: 'Software Compatibility',
      title: 'Can MacBook run Exam Browser or LockDown?',
      phrases: ['Can MacBook run LockDown?', 'Can MacBook Air M1 handle LockDown?', 'Can MacBook run exam browser?', 'MacBook for school exam?', 'Respondus LockDown on MacBook?', 'Can use for exam?', 'MacBook exam can?', 'Lockdown can or not?'],
      keywords: ['macbook', 'lockdown', 'exam browser', 'respondus', 'safe exam', 'exam'],
      answer: "MacBook rental is suitable for common online exam browsers and school assessment platforms.\n\nPlease check that your school or exam provider supports macOS and the selected MacBook model before booking.",
      actions: ['main_menu']
    },
    {
      id: 'macbook_memory_options',
      category: 'Device Selection',
      title: 'Which MacBook options have 16GB or higher?',
      phrases: ['Which MacBook has 16GB?', 'MacBook 16GB rental?', 'Which MacBook is better for heavy work?', 'MacBook Pro M1 Pro memory?', 'MacBook Air M1 memory?'],
      keywords: ['macbook', '16gb', 'memory', 'ram', 'm1 pro', 'm2 pro', 'heavy'],
      answer: "For heavier workloads such as Docker, coding, Adobe, SQL, local AI, or heavy multitasking, choose a 16GB MacBook or higher where available.\n\nMacBook Pro M1 Pro and above is usually a better choice for heavier professional use.",
      actions: ['main_menu']
    },
    {
      id: 'macbook_ubuntu_custom_os',
      category: 'Software Compatibility',
      title: 'Can MacBook install Ubuntu or Custom OS?',
      phrases: ['Can MacBook install Ubuntu?', 'Can MacBook run Linux?', 'Can MacBook use custom OS?', 'Ubuntu on MacBook rental?', 'Can dual boot MacBook?'],
      keywords: ['macbook', 'ubuntu', 'linux', 'custom os', 'dual boot'],
      answer: "Ubuntu or Custom OS installation is not recommended for MacBook rentals.\n\nThe device must be returned with the original macOS intact. If Ubuntu or custom OS is required, choose a suitable Windows laptop instead.",
      actions: ['main_menu']
    },
    {
      id: 'ipad_overview',
      category: 'Device Selection',
      title: 'What is iPad rental suitable for?',
      phrases: ['What is iPad rental suitable for?', 'iPad suitable for what?', 'Can iPad be used for event?', 'iPad rental use case', 'What can iPad rental do?'],
      keywords: ['ipad', 'suitable', 'event', 'registration', 'presentation', 'portable'],
      answer: "iPad rental is suitable for portable use, events, registration, presentations, browsing, supported iPad apps, and simple on-site workflows.\n\niPad is not recommended for desktop laptop software such as Docker, Visual Studio, SQL tools, Ubuntu, or full desktop Adobe workflows.",
      actions: ['main_menu']
    },
    {
      id: 'ipad_event_registration',
      category: 'Device Selection',
      title: 'Is iPad suitable for events or registration?',
      phrases: ['Is iPad suitable for event?', 'Can use iPad for registration?', 'iPad for event check in?', 'iPad for presentation?', 'iPad for roadshow?'],
      keywords: ['ipad', 'event', 'registration', 'check in', 'presentation', 'roadshow'],
      answer: "Yes. iPad rental is suitable for events, registration, check-in, presentations, forms, browsing, and portable on-site use.\n\nPlease ensure the apps or web platforms you need are supported on iPadOS.",
      actions: ['main_menu']
    },
    {
      id: 'ipad_optional_extras',
      category: 'Device Selection',
      title: 'Does iPad come with Apple Pencil or Cellular?',
      phrases: ['Does iPad come with Apple Pencil?', 'Is Apple Pencil included?', 'Can add Apple Pencil?', 'Does iPad have cellular?', 'Can rent iPad with cellular?'],
      keywords: ['ipad', 'apple pencil', 'pencil', 'cellular', 'optional extras'],
      answer: "Apple Pencil and Cellular may be available as chargeable optional extras on the iPad rental page.\n\nPlease select them during booking if required.",
      actions: ['main_menu']
    },
    {
      id: 'ipad_desktop_apps',
      category: 'Software Compatibility',
      title: 'Can iPad run laptop software like Docker or Adobe?',
      phrases: ['Can iPad run Docker?', 'Can iPad run Visual Studio?', 'Can iPad run SQL?', 'Can iPad run Adobe?', 'Can iPad run laptop software?', 'Can iPad install desktop apps?'],
      keywords: ['ipad', 'docker', 'visual studio', 'sql', 'adobe', 'desktop apps', 'laptop software'],
      answer: "iPad is not recommended for desktop laptop software such as Docker, Visual Studio, SQL tools, Ubuntu, or full desktop Adobe workflows.\n\nChoose a Windows laptop or MacBook if you need desktop software compatibility.",
      actions: ['main_menu']
    },
    {
      id: 'ipad_exam_browser',
      category: 'Software Compatibility',
      title: 'Can iPad be used for exam browser?',
      phrases: ['Can iPad use exam browser?', 'Can iPad run LockDown?', 'iPad for exam?', 'Respondus on iPad?', 'Safe exam browser on iPad?'],
      keywords: ['ipad', 'exam', 'lockdown', 'respondus', 'safe exam browser'],
      answer: "iPad may only be suitable if your school or exam provider supports iPadOS for the exam browser.\n\nPlease check your school or exam platform requirements before booking. If unsure, a Windows Business Laptop is usually a safer choice.",
      actions: ['main_menu']
    },
    {
      id: 'minimum_rental_period',
      category: 'Rental Period',
      title: 'What is the minimum rental period?',
      phrases: ['What is the minimum rental period?', 'Minimum rental how long?', 'Can rent 1 day?', 'Can I rent for one day?', 'One day rental available?', 'Minimum duration?'],
      keywords: ['minimum', '1 day', 'one day', 'duration', 'period'],
      answer: "Available rental periods depend on the selected device and will be shown on the rental page. Please select from the rental periods shown during booking.",
      actions: ['view_rental', 'main_menu']
    },
    {
      id: 'next_day_after_7pm',
      category: 'Delivery & Return',
      title: 'What if I book after 7pm for next-day delivery?',
      phrases: ['What if I book after 7pm for tomorrow?', 'After 7pm can deliver tomorrow?', 'Next day cutoff time?', 'Can I get next-day delivery after 7pm?', 'Book tonight deliver tomorrow?'],
      keywords: ['after 7pm', '7pm', 'next day', 'tomorrow', 'cutoff', 'delivery'],
      answer: "For next-day rental bookings made after 7pm, earlier next-day slots may be restricted.\n\nThe earliest standard slot is usually 3pm–5pm, subject to availability.\n\nUrgent next-day slots may be available at extra charge:\n• 11am–1pm Priority Urgent: +$80\n• 1pm–3pm Standard Urgent: +$50",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'weekend_surcharge',
      category: 'Delivery & Return',
      title: 'Is there a weekend surcharge?',
      phrases: ['Is there weekend surcharge?', 'Weekend delivery charge?', 'Saturday delivery charge?', 'Sunday delivery charge?', 'Weekend rental extra charge?'],
      keywords: ['weekend', 'saturday', 'sunday', 'surcharge', 'charge'],
      answer: "Weekend arrangements may have an additional $50 surcharge where applicable.\n\nAny applicable charge will be shown during booking or confirmed by Playforce before the rental is confirmed.",
      actions: ['view_rental', 'main_menu']
    },
    {
      id: 'mbs_surcharge',
      category: 'Delivery & Return',
      title: 'Is there an MBS delivery surcharge?',
      phrases: ['Is there MBS surcharge?', 'Marina Bay Sands delivery charge?', 'Deliver to MBS extra charge?', 'MBS rental delivery?'],
      keywords: ['mbs', 'marina bay sands', 'surcharge', 'delivery'],
      answer: "MBS or Marina Bay Sands delivery may have an additional $30 surcharge where applicable.\n\nPlease contact us before confirming if your delivery or return location is at MBS.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'return_extension_charges',
      category: 'Delivery & Return',
      title: 'Can I change the return collection timing on the same day?',
      phrases: ['Can extend return timing?', 'Return timing charge?', 'Can collect later on the same day?', 'Can change return collection time?', 'Return slot change?', 'Same day return timing change?'],
      keywords: ['return timing', 'return slot', 'collection timing', 'same day return', 'same return date', '1pm', '3pm', '5pm'],
      answer: "Return timing change means changing the collection time on the same return date. This is different from returning after the rental end date.\n\nIf the device is returned after the rental end date without an approved rental extension, the late return fee is $100 per day per device.\n\nFor same-day return timing changes, available options and charges will be shown during booking or confirmed by Playforce.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'foreigner_documents',
      category: 'Required Documents',
      title: 'What documents are required for foreigners or short-stay visitors?',
      phrases: ['What documents for foreigners?', 'Foreigner rental documents?', 'Can use passport?', 'Short stay proof of address?', 'Hotel booking can use as address?', 'Tourist can rent?'],
      keywords: ['foreigner', 'foreigners', 'passport', 'short stay', 'hotel', 'serviced apartment', 'tourist'],
      answer: "For foreigners or short-stay visitors, passport and local stay or address proof may be required.\n\nHotel or serviced apartment booking confirmation or invoice should show the guest name, full Singapore address, check-in and check-out dates, and hotel or operator details.\n\nIf staying with a friend or relative, a signed accommodation letter and host address proof may be required.",
      actions: ['view_rental', 'live_agent']
    },
    {
      id: 'payment_options',
      category: 'Rental Price',
      title: 'What payment options are accepted?',
      phrases: ['What payment options are accepted?', 'Can pay by PayNow?', 'Can pay credit card?', 'Can use Grab?', 'Can use Atome?', 'Payment method?', 'How to pay?', 'PayNow checkout only?', 'Can use card?'],
      keywords: ['payment', 'paynow', 'credit card', 'card', 'grab', 'atome', 'pay', 'checkout'],
      answer: "Rental checkout is strictly via PayNow checkout.\n\nPlease use PayNow checkout to complete payment. Orders paid through unsupported payment methods may not be processed.",
      actions: ['main_menu']
    },
    {
      id: 'overseas_use',
      category: 'Cancellation and Changes',
      title: 'Can I bring the rental device overseas?',
      phrases: ['Can bring overseas?', 'Can bring laptop overseas?', 'Can use outside Singapore?', 'Can bring to Malaysia?', 'Overseas use allowed?', 'Can travel with rental laptop?'],
      keywords: ['overseas', 'outside singapore', 'malaysia', 'travel', 'bring overseas'],
      answer: "Yes, rental devices may be brought overseas.\n\nCustomers remain responsible for the device throughout the rental period and must return it according to the confirmed rental terms.",
      actions: ['main_menu']
    },
    {
      id: 'data_wipe',
      category: 'Cancellation and Changes',
      title: 'Will the device be formatted after return?',
      phrases: ['Will data be wiped?', 'Will device be formatted?', 'Do you reset laptop after return?', 'What happens to my data?', 'Should I remove personal data?', 'Will you clear my data?'],
      keywords: ['data', 'wipe', 'wiped', 'format', 'formatted', 'reset', 'personal data'],
      answer: "Before returning the device, customers are encouraged to back up and remove their personal files.\n\nPlayforce will format the laptop once it is returned and prepare it for the next rental.\n\nFor MacBook and iPad, please ensure Find My is turned off and Apple ID or iCloud is signed out before return.",
      actions: ['main_menu']
    },
    {
      id: 'trust_rental_confidence',
      category: 'Rental Confidence and Common Concerns',
      title: 'Is it safe to rent from Playforce?',
      phrases: ['Is it safe to rent from Playforce?', 'Can I trust Playforce?', 'Is Playforce legit?', 'Is Playforce legitimate?', 'Is this legit?', 'Is this real?', 'Is your company real?', 'Can trust or not?', 'Is rental safe?', 'How do I know I will receive the laptop?', 'How do I know you will deliver?', 'Will you really deliver?', 'Will I receive the device after confirmation?', 'What happens after I order?', 'What happens after confirmation?', 'Are you a local company?', 'Are you a Singapore company?', 'Are you registered?', 'What is your UEN?', 'Do you have experience?', 'Who have you worked with?', 'What companies rent from you?', 'Do organisations rent from you?', 'Is this a scam?', 'Safe to order online?'],
      keywords: ['trust', 'legit', 'legitimate', 'real', 'safe', 'scam', 'uen', 'registered', 'local', 'singapore', 'experience', 'company', 'organisation', 'organization', 'receive', 'deliver', 'after order', 'after confirmation'],
      answer: "Playforce is a local Singapore rental provider since 2016.\n\nOur UEN is 53341959W. We have assisted both individuals and local organisations, including Arts House, Breitling South East Asia, NoonTalk Media, Event Kaki, Epic Media Production, Embassy of Peru, MINDEF Singapore, PlayFACTO School, MCI Group Asia Pacific, and many more.\n\nAfter your rental is confirmed, Playforce will prepare the device and arrange delivery based on the confirmed rental details.\n\nIf you would like to verify details before ordering, you may WhatsApp us and our team will assist.",
      actions: ['rental_steps', 'rent_device_flow', 'view_rental', 'live_agent', 'main_menu']
    },
    {
      id: 'software_game_cannot_run',
      category: 'Rental Confidence and Common Concerns',
      title: 'What if my software or game cannot run?',
      phrases: ['What if my software or game cannot run?', 'What if my software cannot run?', 'What if my app cannot run?', 'What if the program cannot run?', 'What if game cannot run?', 'What if cannot play the game?', 'What if laptop too slow?', 'What if laptop not powerful enough?', 'What if not compatible?', 'Software not compatible', 'App not compatible', 'Game not compatible', 'Will the laptop run my app?', 'Will the laptop run my software?', 'Can run my company software?', 'Can run my school software?', 'Can run exam browser?', 'Can run lockdown browser?', 'Can run Adobe?', 'Can run Photoshop?', 'Can run Illustrator?', 'Can run Premiere Pro?', 'Can run AutoCAD?', 'Can run Revit?', 'Can run SketchUp?', 'Can run SolidWorks?', 'Can run Python?', 'Can run Visual Studio?', 'Can run Docker?', 'Can run SQL?', 'Can run VPN?', 'Can install driver?', 'Can run printer driver?', 'Can run trading software?', 'Can run accounting software?', 'Can run POS system?', 'Can run Zoom?', 'Can run Teams?', 'Can run Roblox?', 'Can run Dota 2?', 'Can run Valorant?', 'Can run Fortnite?', 'Can change if cannot run?', 'Can upgrade if cannot run?', 'Can exchange if software cannot run?', 'Can refund if cannot run?'],
      keywords: ['software', 'app', 'application', 'program', 'game', 'compatible', 'compatibility', 'cannot run', 'too slow', 'lag', 'performance', 'upgrade', 'exchange', 'refund', 'adobe', 'coding', 'docker', 'exam', 'browser', 'vpn', 'driver'],
      answer: "Playforce can help guide you on a suitable rental device based on your software, game, or usage needs.\n\nPerformance may depend on the software version, settings, workload, game updates, and internet connection.\n\nIf you are unsure, WhatsApp us before ordering so our team can recommend a suitable rental device.\n\nUpgrade may be possible, subject to availability and additional fees. Rental charges are based on the confirmed rental period.",
      actions: ['rental_product', 'game_recommendation', 'rental_software', 'live_agent', 'main_menu']
    },
    {
      id: 'pre_rental_testing',
      category: 'Rental Confidence and Common Concerns',
      title: 'Can I test the device before renting?',
      phrases: ['Can I test the device before renting?', 'Can test first?', 'Can try first?', 'Can test before rent?', 'Can try before rent?', 'Can test before paying?', 'Can test before confirming?', 'Can test my software first?', 'Can test my game first?', 'Can test exam browser first?', 'Can test company software first?', 'Can view the laptop first?', 'Can inspect before renting?', 'Can check device before rent?', 'Got trial?', 'Trial rental?', 'Demo unit available?', 'Can test before delivery?', 'Can test after delivery?', 'What if after delivery cannot use?', 'Can cancel after testing?', 'Can refund after testing?'],
      keywords: ['test', 'try', 'trial', 'demo', 'inspect', 'view first', 'before rent', 'before paying', 'before confirming', 'after delivery', 'cancel after testing', 'refund after testing'],
      answer: "Pre-rental testing is not available for standard rental.\n\nBefore booking, customers are encouraged to ensure the selected rental device meets the minimum requirements of their required app, software, game, or platform.\n\nIf you are unsure which device to choose, WhatsApp us with your usage requirements before ordering. Our team can help recommend a suitable rental device.",
      actions: ['rental_product', 'rental_software', 'game_recommendation', 'live_agent', 'main_menu']
    },
    {
      id: 'missed_delivery_return',
      category: 'Rental Confidence and Common Concerns',
      title: 'What if I miss delivery or return collection?',
      phrases: ['What if I miss delivery or return collection?', 'What if nobody is home?', 'What if no one is around?', 'What if no one available?', 'What if I miss delivery?', 'What if I miss collection?', 'Missed delivery', 'Missed collection', 'Miss return collection', 'Cannot receive delivery', 'Cannot return device', 'Courier cannot reach me', 'Driver cannot reach me', 'I am not home', 'I will not be home', 'Can someone else receive?', 'Can my friend receive?', 'Can my family receive?', 'Can my staff receive?', 'Can colleague receive?', 'Can someone else return?', 'Can my friend return?', 'Can my staff return?', 'Can my family return?', 'Change delivery timing', 'Change return timing', 'Change delivery address', 'Change return address', 'Redelivery fee', 'Redelivery charge'],
      keywords: ['miss delivery', 'miss collection', 'nobody home', 'not around', 'not available', 'redelivery', 'someone else', 'receive', 'return', 'handover', 'change timing', 'change address', 'courier', 'driver'],
      answer: "Please ensure someone is available during the confirmed delivery or return collection slot.\n\nSomeone else may receive or return the device on your behalf, but they should be aware of the handover arrangement.\n\nIf delivery is missed, redelivery fees may apply. Playforce will contact you to rearrange the delivery.\n\nIf return collection is missed, please contact Playforce directly to arrange return collection.",
      actions: ['live_agent', 'rental_terms', 'main_menu']
    },
    {
      id: 'device_expectations',
      category: 'Rental Confidence and Common Concerns',
      title: 'What should I expect when I receive the device?',
      phrases: ['What should I expect when I receive the device?', 'Will the laptop be new?', 'Is the laptop new?', 'Is it brand new?', 'Is the device new?', 'Used laptop or new laptop?', 'Pre-owned laptop?', 'Second hand laptop?', 'Will there be scratches?', 'Got scratches or not?', 'Got dents or not?', 'Will it look old?', 'Device condition?', 'Laptop condition?', 'Rental device condition?', 'Is the laptop clean?', 'Do you clean the laptop?', 'Is it checked before delivery?', 'Do you check before sending?', 'Will it be working?', 'Will charger be included?', 'Does it come with charger?', 'Does it come with mouse?', 'Does it come with bag?', 'What is included?', 'Will cosmetic marks be recorded?', 'Existing scratches', 'Existing dents', 'Existing cosmetic marks', 'Will I be charged for old scratches?'],
      keywords: ['new', 'used', 'pre-owned', 'second hand', 'scratches', 'dents', 'condition', 'clean', 'checked', 'working', 'charger', 'mouse', 'bag', 'included', 'existing marks', 'cosmetic'],
      answer: "Rental devices are pre-owned and may have minor cosmetic signs of use.\n\nBefore delivery, Playforce checks, cleans, and prepares the device. Existing cosmetic marks are documented before the device is delivered out, and customers are not charged for those documented marks.\n\nIncluded accessories depend on the rental device type:\n• Windows Laptop: charger, mouse, and bag\n• MacBook: charger and bag\n• iPad: charger and bag",
      actions: ['view_rental', 'main_menu']
    },
    {
      id: 'data_after_return',
      category: 'Rental Confidence and Common Concerns',
      title: 'What happens to my data after return?',
      phrases: ['What happens to my data after return?', 'What happens to my data?', 'Will you delete my data?', 'Will my files be deleted?', 'Will laptop be formatted?', 'Do you format laptop?', 'Do you wipe laptop?', 'Should I delete my files?', 'Should I remove my files?', 'Should I log out?', 'Do I need to log out?', 'What about my accounts?', 'What about my passwords?', 'Is my data safe?', 'Data privacy', 'Personal files', 'Company files', 'School files', 'Browser history', 'Saved password', 'iCloud login', 'Apple ID', 'Find My', 'Find My Mac', 'Find My iPad', 'Can leave my files?', 'Do I need to backup?', 'Backup before return', 'Remove account before return', 'Factory reset'],
      keywords: ['data', 'files', 'delete', 'format', 'wipe', 'reset', 'personal', 'privacy', 'backup', 'log out', 'accounts', 'password', 'icloud', 'apple id', 'find my'],
      answer: "Before returning the device, customers are encouraged to back up and remove their personal files.\n\nPlayforce will format the laptop once it is returned and prepare it for the next rental.\n\nFor MacBook and iPad, please ensure Find My is turned off and Apple ID or iCloud is signed out before return.",
      actions: ['main_menu']
    },
    {
      id: 'install_apps_admin',
      category: 'Rental Confidence and Common Concerns',
      title: 'Can I install apps or use admin access?',
      phrases: ['Can I install apps or use admin access?', 'Can install apps?', 'Can install software?', 'Can install program?', 'Can download apps?', 'Can download software?', 'Can install my own software?', 'Can install company software?', 'Can install school software?', 'Can install exam browser?', 'Can install lockdown browser?', 'Can install safe exam browser?', 'Can install Adobe?', 'Can install Photoshop?', 'Can install Illustrator?', 'Can install Premiere Pro?', 'Can install AutoCAD?', 'Can install Revit?', 'Can install SketchUp?', 'Can install SolidWorks?', 'Can install Python?', 'Can install Visual Studio?', 'Can install VS Code?', 'Can install Docker?', 'Can install SQL?', 'Can install VPN?', 'Can install driver?', 'Can install printer driver?', 'Can install Wacom driver?', 'Can install tablet driver?', 'Can install game?', 'Can install Steam?', 'Can install Epic Games?', 'Can use admin?', 'Admin access?', 'Administrator access?', 'Need admin rights?', 'Do I have admin rights?', 'Can change settings?', 'Can update Windows?', 'Can install Windows update?', 'Can connect printer?', 'Can connect external monitor?'],
      keywords: ['install', 'download', 'apps', 'software', 'program', 'admin', 'administrator', 'admin rights', 'driver', 'vpn', 'printer', 'exam browser', 'game', 'steam', 'epic games', 'settings'],
      answer: "Yes. You may install your own apps and software during the rental period.\n\nAdmin access is provided by default. Please ensure you have the required account, licence, installer, and setup details for your software.\n\nPlayforce will format the laptop once it is returned.",
      actions: ['main_menu']
    },
    {
      id: 'internet_connectivity',
      category: 'Rental Confidence and Common Concerns',
      title: 'Does the rental include internet?',
      phrases: ['Does the rental include internet?', 'Got internet?', 'Got WiFi?', 'WiFi included?', 'Does it come with WiFi?', 'Does laptop come with internet?', 'Does iPad come with internet?', 'Does MacBook come with internet?', 'Got SIM card?', 'SIM card included?', 'Got data?', 'Mobile data included?', 'Cellular included?', 'Hotspot included?', 'Need my own internet?', 'Need own WiFi?', 'Can provide WiFi?', 'Can provide data?', 'Can provide SIM?', 'Can use hotspot?', 'Can connect to WiFi?', 'Can use venue WiFi?', 'Can use office WiFi?', 'Can use home WiFi?', 'Can use school WiFi?', 'iPad cellular', 'iPad data', 'iPad SIM', 'Laptop data', 'Internet dongle', 'Router rental', 'Hotspot rental'],
      keywords: ['internet', 'wifi', 'wi-fi', 'sim', 'data', 'mobile data', 'cellular', 'hotspot', 'dongle', 'router', 'own internet'],
      answer: "Internet connection, SIM card, and mobile data are not included.\n\nRental devices can connect to your own WiFi, hotspot, office network, school network, or venue WiFi where available.\n\nFor iPad rental, WiFi is the default option. Cellular may be available as an optional extra where shown.",
      actions: ['view_ipad', 'main_menu']
    },
    {
      id: 'multiple_device_rental',
      category: 'Rental Confidence and Common Concerns',
      title: 'I need multiple devices. How should I proceed?',
      phrases: ['I need multiple devices. How should I proceed?', 'Need multiple devices', 'Need many devices', 'Need 2 laptops', 'Need 3 laptops', 'Need 5 laptops', 'Need 10 laptops', 'Need 20 laptops', 'Need 2 MacBooks', 'Need 2 iPads', 'Need few laptops', 'Need several laptops', 'Bulk laptop rental', 'Bulk rental', 'Multiple laptop rental', 'Multiple device rental', 'Corporate rental', 'Company rental', 'Office rental', 'School rental', 'Class rental', 'Training rental', 'Event rental', 'Roadshow rental', 'Seminar rental', 'Workshop rental', 'Exam rental', 'Conference rental', 'Registration iPad', 'iPads for registration', 'Need laptops for staff', 'Need laptops for students', 'Need laptops for onboarding', 'Need quotation for multiple laptops', 'Can quote for 2 units', 'Can quote for 5 units', 'Can issue invoice'],
      keywords: ['multiple', 'many', 'few', 'several', '2 laptops', '2 units', 'bulk', 'corporate', 'company', 'school', 'event', 'roadshow', 'training', 'exam', 'quotation', 'invoice', 'staff', 'students', 'registration'],
      answer: "Yes. Playforce supports multiple-device rental from 2 units and above.\n\nThis is suitable for individuals, companies, schools, events, roadshows, training, exams, and short-term projects.\n\nPlease share your name, company name if any, device type, quantity, start date, rental duration, and delivery location. Playforce will check availability and advise the suitable rental arrangement.\n\nOfficial quotation and invoice can be provided where required.",
      actions: ['corporate_flow', 'live_agent', 'main_menu']
    },
    {
      id: 'someone_else_handover',
      category: 'Rental Confidence and Common Concerns',
      title: 'Can someone else receive or return the device?',
      phrases: ['Can someone else receive or return the device?', 'Can someone else receive?', 'Can someone else return?', 'Can my friend receive?', 'Can my family receive?', 'Can my staff receive?', 'Can my colleague receive?', 'Can my helper receive?', 'Can my wife receive?', 'Can my husband receive?', 'Can my parent receive?', 'Can another person receive?', 'Can another person return?', 'Can company staff receive?', 'Can employee receive?', 'Can student receive?', 'Can someone collect on my behalf?', 'Can someone return on my behalf?', 'Can I rent for someone else?', 'Can I rent for my friend?', 'Can I rent for my child?', 'Can I rent for my staff?', 'Can I rent under company?', 'Whose documents are needed?', 'Who is responsible for the rental?', 'Can use another person documents?', 'Can use someone else NRIC?'],
      keywords: ['someone else', 'friend', 'family', 'staff', 'colleague', 'helper', 'parent', 'receive', 'return', 'collect', 'on my behalf', 'rent for someone', 'child', 'student', 'documents', 'nric', 'responsible'],
      answer: "Yes. Someone else may receive or return the device on your behalf, but they should be aware of the handover arrangement.\n\nThe renter remains responsible for the rental device and will be the main point of contact.\n\nRental verification is based on the confirmed rental details and submitted documents. Please do not use another person’s NRIC or documents unless that person is the renter responsible for the rental.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'deposit_deductions',
      category: 'Security Deposit and Device Care',
      title: 'Will I be charged or have my deposit deducted?',
      phrases: ['Will I be charged or have my deposit deducted?', 'Will you deduct money?', 'Will you minus money?', 'Will minus deposit?', 'Will deduct deposit?', 'Will cut deposit?', 'Will forfeit deposit?', 'Will I lose my deposit?', 'Deposit kena deduct?', 'Deposit kena minus?', 'Need compensate?', 'Need pay compensation?', 'Will you charge me?', 'What can affect my security deposit?', 'What causes deposit deductions?', 'What will cause deductions in security deposit?'],
      keywords: ['deduct', 'deduction', 'minus', 'charge', 'charged', 'deposit', 'security deposit', 'forfeit', 'lose deposit', 'compensate', 'compensation', 'pay extra'],
      answer: "Playforce does not deduct or expect compensation for slight cosmetic scratches from normal careful use.\n\nPlayforce also does not charge for existing cosmetic defects that were already documented before the device was delivered out.\n\nDeposit deductions or charges may apply for customer-caused damage, missing accessories, obvious dents, cracked parts, liquid damage, fall damage, or if the device is lost or stolen.\n\nFor internal device faults such as keyboard issue, display issue, motherboard issue, or other hardware faults, Playforce will generally handle it as long as the issue was not caused by customer damage.\n\nPlease inform Playforce immediately if you notice any issue. Do not attempt self-repair or third-party repair.",
      actions: ['security_device_care', 'live_agent', 'main_menu']
    },
    {
      id: 'small_cosmetic_scratches',
      category: 'Security Deposit and Device Care',
      title: 'Will I be charged for small scratches?',
      phrases: ['Will I be charged for small scratches?', 'Will you deduct for scratches?', 'Will you minus for scratches?', 'What if got small scratch?', 'What if slight scratch?', 'Normal scratches charge?', 'Cosmetic scratches deduct deposit?', 'Small scratch need pay?', 'Will scratches affect deposit?'],
      keywords: ['scratch', 'scratches', 'cosmetic', 'slight scratch', 'small scratch', 'normal use', 'deduct', 'minus', 'charge'],
      answer: "Playforce does not deduct or expect compensation for slight cosmetic scratches from normal careful use.\n\nDeductions mainly apply for customer-caused damage, such as obvious dents, cracked parts, liquid damage, fall damage, missing accessories, lost device, or stolen device.",
      actions: ['security_device_care', 'live_agent', 'main_menu']
    },
    {
      id: 'existing_cosmetic_marks',
      category: 'Security Deposit and Device Care',
      title: 'What if there are existing cosmetic marks?',
      phrases: ['What if there are existing cosmetic marks?', 'What if already scratched?', 'What if already got scratch?', 'Existing scratches will charge?', 'Existing cosmetic defects charge?', 'Existing cosmetic mark deduct?', 'Device came with scratches', 'Laptop already has scratches', 'Will I pay for existing defects?'],
      keywords: ['existing', 'already', 'documented', 'cosmetic', 'marks', 'defects', 'scratches', 'charge', 'deduct'],
      answer: "You will not be charged for existing cosmetic defects that were already documented before the device was delivered out.\n\nExisting cosmetic marks are documented before delivery, so customers are not charged for those documented marks.",
      actions: ['security_device_care', 'live_agent', 'main_menu']
    },
    {
      id: 'damage_payment_amount',
      category: 'Security Deposit and Device Care',
      title: 'How much do I need to pay if there is damage?',
      phrases: ['How much do I need to pay if there is damage?', 'Damage need pay how much?', 'How much need to pay if damaged?', 'How much compensation?', 'How much will you deduct?', 'How much will you minus?', 'Repair cost how much?', 'Do I need to pay extra if damaged?', 'Damage charge how much?'],
      keywords: ['how much', 'pay', 'damage', 'damaged', 'compensation', 'deduct', 'minus', 'repair cost', 'replacement cost', 'pay extra'],
      answer: "The amount depends on the type and extent of the issue.\n\nFor slight cosmetic scratches from normal careful use, Playforce does not usually deduct or expect compensation.\n\nFor existing cosmetic defects already documented before delivery, Playforce does not charge the customer.\n\nFor customer-caused damage, missing accessories, lost device, or stolen device, charges may be based on repair or replacement cost. The final amount can only be confirmed after checking the returned device.",
      actions: ['security_device_care', 'live_agent', 'main_menu']
    },
    {
      id: 'late_return',
      category: 'Damage and Late Return',
      title: 'How much is the late return fee?',
      phrases: ['How much is the late return fee?', 'Late return how?', 'What if I return late?', 'Late fee?', 'Return late charge?', 'Overdue rental charge?', 'What is late return fee?', 'How much to pay for late return?', 'How much if I return late?', 'Need pay if late?', 'Fine for late return?', 'What if I cannot return the device on time?', 'Cannot return today', 'Can return tomorrow?', 'Return after rental end', 'Return after due date'],
      keywords: ['late return', 'return late', 'overdue', 'late fee', 'late charge', 'late penalty', 'cannot return today', 'return tomorrow', 'return next day', 'miss return', 'missed collection', 'forgot to return', 'after due date', 'after rental end'],
      answer: "The late return fee is $100 per day per device.\n\nIf you need the device for a longer period, please contact Playforce before the rental ends to request a rental extension. Extension is subject to availability and additional rental charges.\n\nIf the return is already late, or you missed the return collection, please contact Playforce immediately so our team can advise the next step.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'device_damaged',
      category: 'Security Deposit and Device Care',
      title: 'What if the device is accidentally damaged?',
      phrases: ['What if laptop damaged?', 'What if screen cracked?', 'What if device damaged?', 'What if I dropped the laptop?', 'What if water spilled?', 'What if liquid damage?', 'What if dented?', 'What if cracked?', 'Accidental damage charge?', 'Will deduct deposit if damaged?', 'Device damaged'],
      keywords: ['damage', 'damaged', 'screen crack', 'repair', 'replacement', 'deduct deposit', 'water damage', 'liquid damage', 'drop', 'fall', 'dent', 'crack'],
      answer: "Please inform Playforce immediately if the rental device is accidentally damaged.\n\nCustomer-caused damage may be chargeable based on repair or replacement cost. This may include obvious dents, cracked parts, liquid damage, fall damage, or missing accessories.\n\nSlight cosmetic scratches from normal careful use are generally accepted and Playforce does not usually deduct or expect compensation for them.",
      actions: ['security_device_care', 'live_agent', 'main_menu']
    },
    {
      id: 'device_lost',
      category: 'Security Deposit and Device Care',
      title: 'What if the device is lost or stolen?',
      phrases: ['What if lost?', 'What if stolen?', 'Lost laptop how?', 'Device missing?', 'What if cannot return?', 'Device stolen', 'What if device is lost or stolen?', 'Laptop stolen how?'],
      keywords: ['lost', 'stolen', 'missing', 'cannot return'],
      answer: "Please inform Playforce immediately if the rental device is lost or stolen.\n\nThe customer may be responsible for the replacement cost of the device and any missing accessories, subject to assessment and rental terms.",
      actions: ['security_device_care', 'live_agent', 'main_menu']
    },
    {
      id: 'inspect_receipt',
      category: 'Security Deposit and Device Care',
      title: 'What should I do if something happens?',
      phrases: ['Need check when receive?', 'What if already scratched?', 'What if there is existing damage?', 'Should I report issue?', 'Device got problem when delivered', 'Existing damage?', 'What should I do if something happens?', 'What should I do if I notice an issue?'],
      keywords: ['check', 'receipt', 'receive', 'scratch', 'existing damage', 'report issue', 'notice issue', 'something happens'],
      answer: "Please contact Playforce immediately once you notice any issue.\n\nDo not attempt self-repair or third-party repair. Our team will check and advise the next step.\n\nPlayforce does not charge for existing cosmetic defects that were already documented before the device was delivered out.",
      actions: ['security_device_care', 'live_agent', 'main_menu']
    },
    {
      id: 'cancel_rental',
      category: 'Cancellation and Changes',
      title: 'Can I cancel my rental?',
      phrases: ['Can cancel?', 'Cancellation policy?', 'What if I do not need anymore?', 'Can I cancel after booking?', 'Can refund if cancel?', 'Cancel rental'],
      keywords: ['cancel', 'cancellation', 'refund', 'do not need'],
      answer: "Cancellation policy:\n\n• 50% cancellation charge applies once the rental is confirmed.\n• 100% cancellation charge applies if cancelled 1 day before the rental start date or on the rental start date.\n\nPlease contact Playforce as early as possible if you need to cancel your rental booking.",
      actions: ['main_menu']
    },
    {
      id: 'change_date',
      category: 'Cancellation and Changes',
      title: 'Can I change my rental date?',
      phrases: ['Can change date?', 'Can postpone rental?', 'Can change start date?', 'Can change delivery date?', 'Can amend booking?', 'Change rental date'],
      keywords: ['change date', 'postpone', 'start date', 'delivery date', 'amend'],
      answer: "Rental date changes are subject to availability. Please contact Playforce before your rental starts.\n\nIf we are not informed in time, or if changes cannot be arranged due to time or operational constraints, the rental will proceed based on the original confirmed schedule.",
      actions: ['main_menu']
    },

    {
      id: 'availability_stock',
      category: 'Availability and Urgent Rental',
      title: 'How do I check device availability?',
      phrases: ['Got stock?', 'Is it available?', 'Available tomorrow?', 'Do you have stock?', 'Can confirm availability?', 'Can reserve?', 'Still available?', 'Laptop have?', 'Got laptop anot?', 'Need 10 laptops tomorrow'],
      keywords: ['availability', 'available', 'stock', 'got stock', 'reserve', 'tomorrow', 'quantity', 'units'],
      answer: "Availability depends on the selected device, quantity, rental start date, and rental duration.\n\nShare these details and our team can check availability for you.",
      actions: ['live_agent', 'view_rental', 'main_menu']
    },
    {
      id: 'same_day_urgent_rental',
      category: 'Availability and Urgent Rental',
      title: 'Can I rent urgently or today?',
      phrases: ['Can rent today?', 'Need laptop today', 'Can deliver today?', 'Need now', 'Need ASAP', 'Urgent rental', 'Same day rental', 'Can get laptop immediately?', 'Rush rental can?'],
      keywords: ['urgent', 'today', 'same day', 'asap', 'immediate', 'now', 'rush'],
      answer: "Urgent rental may be possible depending on device availability and delivery timing.\n\nPlease share the device, quantity, rental start date, rental duration, and delivery location so our team can check quickly.",
      actions: ['live_agent', 'view_rental', 'main_menu']
    },
    {
      id: 'invoice_receipt',
      category: 'Corporate and Bulk Rental',
      title: 'Can Playforce issue quotation, invoice, or receipt?',
      phrases: ['Can issue invoice?', 'Can provide official receipt?', 'Can company pay?', 'Can use company name?', 'Can send quotation with company details?', 'Official quotation?', 'Company invoice?', 'Can issue quote?'],
      keywords: ['invoice', 'receipt', 'quotation', 'quote', 'company name', 'official', 'billing'],
      answer: "Yes. Playforce is registered locally and can issue official quotations and invoices for company rental enquiries.\n\nPlease WhatsApp us with your company name, device type, quantity, rental start date, and rental duration.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'accessories_included',
      category: 'Accessories and Device Condition',
      title: 'What accessories are included?',
      phrases: ['Does laptop come with charger?', 'Got charger?', 'Got mouse?', 'Got bag?', 'Got laptop bag?', 'Got HDMI?', 'Got adapter?', 'Does MacBook come with charger?', 'Does iPad come with charger?', 'Accessories included?'],
      keywords: ['charger', 'mouse', 'bag', 'laptop bag', 'hdmi', 'adapter', 'accessories', 'power adapter'],
      answer: "Included accessories:\n\n• Windows Laptop — charger, mouse, and bag.\n• MacBook — charger and bag.\n• iPad — charger and bag.\n\nOther accessories are only included if stated or selected as optional extras where available.",
      actions: ['view_rental', 'main_menu']
    },
    {
      id: 'device_condition',
      category: 'Accessories and Device Condition',
      title: 'Are rental devices new or used?',
      phrases: ['Is the laptop new?', 'Is it used?', 'Any scratches?', 'Is it clean?', 'Are devices clean?', 'Device condition?', 'Used laptop?', 'Pre-owned rental unit?'],
      keywords: ['new', 'used', 'pre-owned', 'condition', 'scratches', 'clean', 'cosmetic'],
      answer: "Rental devices are pre-owned and may have minor cosmetic signs of use.\n\nBefore delivery, Playforce checks, cleans, and prepares the device. Existing cosmetic marks are documented before the device is delivered out, and customers are not charged for those documented marks.\n\nIncluded accessories depend on the rental device type:\n• Windows Laptop: charger, mouse, and bag\n• MacBook: charger and bag\n• iPad: charger and bag",
      actions: ['main_menu']
    },
    {
      id: 'battery_condition',
      category: 'Accessories and Device Condition',
      title: 'How is the battery condition?',
      phrases: ['Battery health?', 'Battery condition?', 'How long can battery last?', 'Battery life good?', 'Laptop battery can last how long?', 'MacBook battery health?'],
      keywords: ['battery', 'battery health', 'battery life', 'last how long'],
      answer: "Battery performance may vary because rental devices are pre-owned units.\n\nDevices are checked before delivery, but battery life depends on usage, settings, workload, and device model.",
      actions: ['main_menu']
    },
    {
      id: 'faulty_device_replacement',
      category: 'Security Deposit and Device Care',
      title: 'What if the device has a fault?',
      phrases: ['What if laptop spoil during rental?', 'Can exchange?', 'Can replace?', 'What if cannot turn on?', 'Device faulty', 'Laptop faulty', 'Laptop not working', 'Can get replacement?', 'What if the device has a fault?', 'What if keyboard issue?', 'What if display issue?', 'What if motherboard issue?', 'Keyboard spoil during rental', 'Screen issue during rental'],
      keywords: ['faulty', 'spoil', 'spoiled', 'spoilt', 'not working', 'cannot turn on', 'exchange', 'replace', 'replacement', 'keyboard', 'display', 'screen', 'motherboard', 'hardware fault'],
      answer: "Internal hardware faults are generally handled by Playforce as long as they are not caused by customer damage.\n\nThis may include keyboard issue, display issue, motherboard issue, or other device faults.\n\nPlease contact Playforce immediately so our team can check and assist. A replacement may be arranged where needed, subject to assessment and availability. Do not attempt self-repair or third-party repair.",
      actions: ['security_device_care', 'live_agent', 'main_menu']
    },
    {
      id: 'charger_issue',
      category: 'Damage and Late Return',
      title: 'What if the charger or accessory is missing or damaged?',
      phrases: ['Charger spoil', 'Charger faulty', 'Lost charger', 'Missing charger', 'Mouse missing', 'Bag missing', 'Adapter damaged'],
      keywords: ['charger', 'adapter', 'accessory', 'missing', 'lost', 'faulty', 'damaged', 'mouse', 'bag'],
      answer: "Please contact Playforce immediately if there is an issue with the charger or included accessory.\n\nMissing or damaged accessories may be chargeable based on replacement cost.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'admin_access_accounts',
      category: 'Software Compatibility',
      title: 'Can I install software or use my own accounts?',
      phrases: ['Do I have admin access?', 'Can I install company apps?', 'Can install VPN?', 'Can install Zoom?', 'Can use my own Apple ID?', 'Can login Microsoft account?', 'Can use own account?'],
      keywords: ['admin', 'install', 'company apps', 'vpn', 'zoom', 'apple id', 'microsoft account', 'own account', 'login'],
      answer: "Yes. You may install your own apps and software during the rental period.\n\nAdmin access is provided by default. Please ensure you have the required account, licence, installer, and setup details for your software.\n\nPlayforce will format the laptop once it is returned.",
      actions: ['main_menu']
    },
    {
      id: 'internet_data_sim',
      category: 'Software Compatibility',
      title: 'Does the rental include internet?',
      phrases: ['Does it come with internet?', 'Got SIM card?', 'Is WiFi included?', 'iPad cellular got data?', 'Data plan included?', 'Need internet with iPad', 'Does rental include internet?', 'Got WiFi?', 'Got mobile data?', 'Can use hotspot?', 'Can connect to WiFi?', 'Internet dongle?', 'Router rental?', 'Hotspot rental?'],
      keywords: ['internet', 'wifi', 'wi-fi', 'sim', 'data', 'data plan', 'cellular', 'hotspot', 'dongle', 'router'],
      answer: "Internet connection, SIM card, and mobile data are not included.\n\nRental devices can connect to your own WiFi, hotspot, office network, school network, or venue WiFi where available.\n\nFor iPad rental, WiFi is the default option. Cellular may be available as an optional extra where shown.",
      actions: ['view_ipad', 'main_menu']
    },
    {
      id: 'delivery_coverage',
      category: 'Delivery & Return',
      title: 'Where can Playforce deliver?',
      phrases: ['Can deliver to my house?', 'Can deliver to office?', 'Can deliver to hotel?', 'Can deliver to school?', 'Can deliver to event venue?', 'Islandwide delivery?', 'Can deliver to condo?'],
      keywords: ['house', 'office', 'hotel', 'school', 'event venue', 'condo', 'islandwide', 'delivery location'],
      answer: "Delivery can be arranged islandwide in Singapore to residential, office, school, hotel, condo, or event locations.\n\nSpecial locations or arrangements may be subject to an additional $30 fee where applicable.",
      actions: ['view_rental', 'live_agent', 'main_menu']
    },
    {
      id: 'reserve_without_payment',
      category: 'Rental Price',
      title: 'Can I reserve without payment?',
      phrases: ['Can reserve without payment?', 'Can hold first?', 'Can book first pay later?', 'Can confirm without payment?', 'Reserve laptop first?'],
      keywords: ['reserve', 'hold', 'book first', 'pay later', 'without payment'],
      answer: "Rental reservation is confirmed only after payment is completed.\n\nAvailability may change before payment confirmation.",
      actions: ['view_rental', 'live_agent', 'main_menu']
    },
    {
      id: 'rent_without_documents',
      category: 'Required Documents',
      title: 'Can I rent without documents?',
      phrases: ['Can rent without documents?', 'No NRIC can rent?', 'No proof of address can?', 'Can skip documents?', 'Documents not available'],
      keywords: ['without documents', 'no nric', 'no proof', 'skip documents', 'documents not available'],
      answer: "Required rental documents must be submitted for verification.\n\nRental may not proceed if the required documents are incomplete or not accepted.",
      actions: ['view_rental', 'live_agent', 'main_menu']
    },
    {
      id: 'event_roadshow_rental',
      category: 'Corporate and Bulk Rental',
      title: 'Can I rent devices for events, roadshows, training, or exams?',
      phrases: ['Need iPads for event', 'Need laptops for training', 'Need laptops for exam', 'Need devices for roadshow', 'Event rental', 'Roadshow rental', 'Training laptop rental', 'Exam laptop rental'],
      keywords: ['event', 'roadshow', 'training', 'exam', 'check in', 'registration', 'venue', 'bulk'],
      answer: "Yes. Playforce supports rentals for events, roadshows, training, exams, registration, and corporate use.\n\nPlease share the device type, quantity, venue, rental start date, rental duration, delivery timing, and return arrangement so our team can assist.",
      actions: ['live_agent', 'view_rental', 'main_menu']
    },
    {
      id: 'available_rental_devices',
      category: 'Device Selection',
      title: 'What devices does Playforce have for rent?',
      phrases: ['What devices does Playforce have for rent?', 'What devices can I rent?', 'What do you rent?', 'What laptops do you have?', 'What rental devices are available?', 'What device options do you have?', 'What products can rent?', 'Do you rent MacBook?', 'Do you rent iPad?', 'Do you rent gaming laptop?', 'What laptops can I rent?', 'What can I rent from Playforce?'],
      keywords: ['devices', 'what devices', 'what do you rent', 'rental devices', 'device options', 'products', 'business laptop', 'gaming laptop', 'macbook', 'ipad'],
      answer: "Playforce offers these rental categories:\n\n• Business Laptop — office, school, training, exam, and general productivity.\n• Gaming Laptop — gaming, Adobe and design work, video editing, coding, GPU workloads, and heavier Windows use.\n• MacBook — macOS users, creative work, coding, business use, and school use.\n• iPad — events, registration, check-in, presentations, forms, and portable use.\n\nExact models and specifications depend on the selected category and availability.",
      actions: ['rent_device_flow', 'price_flow', 'view_rental', 'main_menu']
    },
    {
      id: 'change_upgrade_device',
      category: 'Cancellation and Changes',
      title: 'Can I change or upgrade to another rental device halfway?',
      phrases: ['Can upgrade halfway?', 'Can change laptop halfway?', 'Can change to another model?', 'Can swap laptop?', 'Can upgrade to better laptop?', 'Can change from business to gaming?', 'Can change from MacBook Air to MacBook Pro?', 'Can top up for better laptop?', 'Can switch device during rental?', 'Can I upgrade laptop to another model halfway during rental?', 'Can I swap device during rental?'],
      keywords: ['upgrade', 'change laptop', 'change model', 'swap', 'switch device', 'top up', 'halfway', 'during rental', 'better laptop'],
      answer: "Changing or upgrading to another rental device during the rental period may be possible, subject to availability and approval.\n\nAdditional charges may apply, such as rental price difference and delivery and collection charges. Please WhatsApp us before making any change request.",
      actions: ['live_agent', 'price_flow', 'view_rental', 'main_menu']
    },
    {
      id: 'missed_return_collection',
      category: 'Damage and Late Return',
      title: 'What happens if I miss the return collection?',
      phrases: ['What if I miss return collection?', 'I missed collection', 'Missed collection', 'Miss return', 'Not around for return', 'Cannot return at arranged time', 'Missed return timing', 'What if courier comes and I am not there?', 'Forgot to return', 'Cannot return today'],
      keywords: ['miss return', 'missed collection', 'miss collection', 'not around', 'cannot return', 'arranged time', 'return timing', 'courier', 'forgot return'],
      answer: "Please contact Playforce directly to arrange return collection if you missed the confirmed return collection.\n\nIf the device is not returned on time, the late return fee is $100 per day per device.\n\nIf you still need the device for more days, request a rental extension with Playforce as early as possible. Extension is subject to availability and additional rental charges.",
      actions: ['live_agent', 'rental_terms', 'main_menu']
    },
    {
      id: 'authorised_receiver',
      category: 'Delivery & Return',
      title: 'Can someone else receive or return the rental device?',
      phrases: ['Can someone else receive the laptop?', 'Can my colleague receive?', 'Can my family receive?', 'Can someone else return?', 'Can another person handover?', 'Authorised person for delivery'],
      keywords: ['someone else', 'colleague', 'family', 'authorised', 'authorized', 'receive', 'handover', 'return for me'],
      answer: "Yes. Someone else may receive or return the device on your behalf, but they should be aware of the handover arrangement.\n\nThe renter remains responsible for the rental device and will be the main point of contact.\n\nRental verification is based on the confirmed rental details and submitted documents. Please do not use another person’s NRIC or documents unless that person is the renter responsible for the rental.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'windows_version_request',
      category: 'Software Compatibility',
      title: 'Can I request Windows 10 or Windows 11?',
      phrases: ['Can I choose Windows 10?', 'Can I request Windows 11?', 'Windows 10 available?', 'Windows 11 available?', 'Can change OS version?', 'What Windows version?'],
      keywords: ['windows 10', 'windows 11', 'os version', 'operating system', 'windows version'],
      answer: "Windows laptops are generally provided with the operating system stated on the rental page.\n\nIf you require a specific Windows version, please WhatsApp us before booking so our team can check if it can be arranged.",
      actions: ['live_agent', 'view_business', 'view_gaming', 'main_menu']
    },
    {
      id: 'technical_setup_support',
      category: 'Software Compatibility',
      title: 'Does Playforce provide technical setup or software support?',
      phrases: ['Do you provide technical setup?', 'Can help setup software?', 'Can help install company software?', 'Can help setup VPN?', 'Can help troubleshoot apps?', 'Do you provide IT support?', 'Can help configure laptop?'],
      keywords: ['technical setup', 'software support', 'setup software', 'install company software', 'vpn', 'troubleshoot', 'it support', 'configure'],
      answer: "Playforce does not provide software setup or troubleshooting support for third-party applications.\n\nCustomers are responsible for software accounts, licences, VPN access, and setup. Please ensure your software is compatible with the selected device specifications.",
      actions: ['main_menu']
    },
    {
      id: 'clean_formatted_before_delivery',
      category: 'Accessories and Device Condition',
      title: 'Will the rental device be clean and formatted before delivery?',
      phrases: ['Is the laptop formatted?', 'Is it reset before delivery?', 'Is the laptop clean before delivery?', 'Can request clean laptop?', 'Will you format the laptop before delivery?'],
      keywords: ['formatted', 'format', 'reset before delivery', 'clean before delivery', 'clean laptop'],
      answer: "Yes. Rental devices are checked, reset where applicable, and thoroughly cleaned before delivery so they are ready for rental use.",
      actions: ['main_menu']
    },
    {
      id: 'lost_accessories',
      category: 'Damage and Late Return',
      title: 'What if I lose the charger, bag, mouse, or accessory?',
      phrases: ['What if I lose the charger?', 'Lost laptop bag', 'Lost mouse', 'Lost accessory', 'Missing bag', 'Missing mouse', 'Missing charger', 'Lose charger how?'],
      keywords: ['lost charger', 'lost bag', 'lost mouse', 'lost accessory', 'missing charger', 'missing bag', 'missing mouse'],
      answer: "Missing or damaged accessories may be chargeable based on replacement cost.\n\nPlease inform Playforce as soon as possible if any included charger, mouse, bag, or accessory is lost or damaged.",
      actions: ['live_agent', 'main_menu']
    },

    {
      id: 'gaming_game_recommendation',
      category: 'Device Selection',
      title: 'Which gaming laptop should I rent for my game?',
      phrases: ['Which gaming laptop should I rent for my game?', 'Which laptop for my game?', 'Recommend laptop for game', 'Can gaming laptop run popular games?', 'Which device for Dota 2?', 'Which device for Valorant?', 'Which laptop for Fortnite?', 'Can gaming laptop run Roblox?', 'Can it run Minecraft?', 'Need laptop for gaming event'],
      keywords: ['game recommendation', 'which laptop for game', 'recommend gaming laptop', 'popular games', 'dota', 'valorant', 'fortnite', 'roblox', 'minecraft', 'fps', 'graphics'],
      answer: "Tell me the game you want to play and I’ll suggest a suitable gaming laptop tier.\n\nYou can ask things like:\n“Which laptop for Dota 2?”\n“Can it run Valorant?”\n“I need laptops for Roblox event.”\n\nPlaybot recommends by rental tier, not exact brand or model, because final devices depend on availability.",
      actions: ['view_gaming', 'rent_device_flow', 'live_agent']
    },
    {
      id: 'gaming_higher_fps',
      category: 'Device Selection',
      title: 'I want higher FPS. Which gaming laptop should I choose?',
      phrases: ['I want higher FPS', 'Which laptop for high FPS?', 'Need smooth FPS', 'Need 144 FPS', 'Need high refresh gaming', 'Gaming laptop for better FPS'],
      keywords: ['higher fps', 'high fps', 'smooth fps', '144 fps', 'high refresh', 'gaming'],
      answer: "For higher FPS, choose a Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050 as a safer starting point.\n\nFor heavier games, better graphics, or external high-refresh monitor use, choose a High-Performance Gaming Laptop such as RTX 3070, RTX 3080, RTX 4060, or RTX 4070 where available.\n\nFor the strongest available gaming tier, choose RTX 5080 where available.\n\nActual performance depends on game settings, game updates, and internet connection.",
      actions: ['view_gaming', 'price_flow', 'rent_device_flow']
    },
    {
      id: 'gaming_better_graphics',
      category: 'Device Selection',
      title: 'I want better graphics. Which gaming laptop should I choose?',
      phrases: ['I want better graphics', 'Which laptop for better graphics?', 'Need high graphics', 'Need ultra graphics', 'Need best gaming laptop', 'Gaming laptop for better quality'],
      keywords: ['better graphics', 'high graphics', 'ultra', 'best gaming', 'quality settings', 'epic settings'],
      answer: "For better graphics, choose a High-Performance Gaming Laptop such as RTX 3070, RTX 3080, RTX 4060, or RTX 4070 where available.\n\nFor very demanding users who want the strongest available rental option, choose the Best Available Gaming Laptop such as RTX 5080 where available.\n\nActual performance depends on game settings, game updates, and internet connection.",
      actions: ['view_gaming', 'price_flow', 'rent_device_flow']
    },
    {
      id: 'mobile_games_on_laptop',
      category: 'Device Selection',
      title: 'Can I play mobile games on a laptop?',
      phrases: ['Can I play mobile games on laptop?', 'Can play PUBG Mobile on laptop?', 'Can play Mobile Legends on laptop?', 'Can use emulator?', 'Can gaming laptop run mobile games?'],
      keywords: ['mobile games', 'pubg mobile', 'mobile legends', 'free fire', 'emulator', 'ipad'],
      answer: "Some games are mainly mobile games.\n\nFor normal mobile play, iPad rental may be more suitable. If you need to run a mobile game on a Windows laptop through an emulator, please check with Playforce first because emulator compatibility and performance may vary.\n\nPerformance may depend on emulator settings, game updates, account requirements, and internet connection.",
      actions: ['view_ipad', 'view_gaming', 'live_agent']
    },
    {
      id: 'gaming_event_rental',
      category: 'Corporate and Bulk Rental',
      title: 'Can I rent gaming laptops for an event?',
      phrases: ['Can I rent gaming laptops for event?', 'Need gaming laptops for event', 'Need laptops for Roblox event', 'Need gaming PCs for tournament', 'Gaming event rental', 'Need multiple gaming laptops'],
      keywords: ['gaming event', 'tournament', 'event', 'multiple gaming laptops', 'roblox event', 'bulk gaming'],
      answer: "Yes. For gaming events, tournaments, training, or roadshows, please share the game, number of units, rental date, duration, venue, and whether you need normal smooth play, higher FPS, or better graphics.\n\nPlayforce can then recommend a suitable gaming laptop tier and check availability. Exact brand or model depends on available rental stock.",
      actions: ['live_agent', 'view_gaming', 'rent_device_flow']
    },

    {
      id: 'document_usage_privacy',
      category: 'Required Documents',
      title: 'How will my documents be used?',
      phrases: ['How will my documents be used?', 'What do you do with my NRIC?', 'Why do you need my NRIC?', 'Why do you need proof of address?', 'Is it safe to submit documents?', 'Will my documents be kept?', 'How do you use my documents?', 'Why must submit documents?', 'Why need documents?', 'Why need verification?', 'Document privacy', 'NRIC privacy', 'Can I verify before submitting documents?', 'I am worried about submitting NRIC'],
      keywords: ['documents', 'document use', 'nric', 'proof of address', 'verification', 'privacy', 'safe', 'submit', 'responsible renter', 'how used'],
      answer: "Documents are used for rental verification and to confirm the renter responsible for the device.\n\nFor individual rental, NRIC front and back and proof of address are required. For company rental, ACRA and name card may be required.\n\nIf you have concerns about document submission, please WhatsApp us before ordering and our team will assist.",
      actions: ['required_documents', 'live_agent', 'main_menu']
    },
    {
      id: 'device_unavailable_after_order',
      category: 'Availability and Urgent Rental',
      title: 'What if the device is unavailable after I order?',
      phrases: ['What if the device is unavailable after I order?', 'What if no stock after payment?', 'What if the laptop is not available?', 'What if selected device unavailable?', 'What if the model is unavailable?', 'What if no device after checkout?', 'What if stock changes?', 'What if availability changes?', 'What if out of stock after order?', 'Will you contact me if unavailable?', 'What happens if cannot fulfil rental?', 'What if you cannot provide the device?'],
      keywords: ['unavailable', 'no stock', 'out of stock', 'stock changes', 'availability changes', 'after order', 'after payment', 'cannot fulfil', 'selected device'],
      answer: "Rental confirmation is subject to payment, verification, and device availability.\n\nIf the selected device is unavailable, Playforce will contact you to advise the available options.",
      actions: ['live_agent', 'view_rental', 'main_menu']
    },
    {
      id: 'upfront_payment_deposit',
      category: 'Rental Price',
      title: 'Do I need to pay rental fee and deposit upfront?',
      phrases: ['Do I need to pay rental fee and deposit upfront?', 'Do I pay deposit upfront?', 'Need pay deposit first?', 'Need pay rental fee first?', 'Need pay both rental and deposit?', 'How much do I need to pay upfront?', 'What do I pay during checkout?', 'Is deposit paid together?', 'Is rental fee paid upfront?', 'When do I pay the security deposit?', 'When do I pay rental fee?', 'Total payable includes deposit?', 'Do I need to pay full amount?'],
      keywords: ['upfront', 'pay first', 'deposit upfront', 'rental fee upfront', 'total payable', 'checkout', 'security deposit', 'full amount', 'pay both'],
      answer: "Yes. The rental fee and refundable security deposit are payable upfront during checkout.\n\nThe security deposit is refundable after return, subject to device condition, accessories returned, late return, and rental terms.",
      actions: ['price_flow', 'view_rental', 'live_agent', 'main_menu']
    },
    {
      id: 'find_my_not_off',
      category: 'Cancellation and Changes',
      title: 'What happens if I forget to turn off Find My?',
      phrases: ['What happens if I forget to turn off Find My?', 'Forgot to turn off Find My', 'Find My still on', 'Find My enabled', 'Forgot to sign out Apple ID', 'Forgot to sign out iCloud', 'Apple ID still logged in', 'iCloud still signed in', 'Cannot remove Find My', 'Need to turn off Find My?', 'Need to sign out iCloud?', 'Need to sign out Apple ID?', 'What if iPad still linked to Apple ID?', 'What if MacBook still linked to iCloud?'],
      keywords: ['find my', 'apple id', 'icloud', 'sign out', 'signed out', 'enabled', 'still on', 'macbook', 'ipad', 'forget'],
      answer: "For MacBook and iPad, please ensure Find My is turned off and Apple ID or iCloud is signed out before return.\n\nIf Find My is still enabled, return processing may be delayed until it is removed.",
      actions: ['live_agent', 'main_menu']
    },
    {
      id: 'delivery_return_timing_change',
      category: 'Delivery & Return',
      title: 'Can I request a specific delivery or return slot after ordering?',
      phrases: ['Can I request a specific delivery or return slot after ordering?', 'Can I change delivery timing after order?', 'Can I change return timing after order?', 'Can I change delivery slot?', 'Can I change return slot?', 'Can I request delivery time?', 'Can I request return time?', 'Can change delivery after confirmed?', 'Can change collection after confirmed?', 'Can change address after order?', 'Can change return address?', 'Can choose specific delivery time?', 'Can choose specific collection time?', 'Need to reschedule delivery', 'Need to reschedule return'],
      keywords: ['change timing', 'delivery timing', 'return timing', 'delivery slot', 'return slot', 'reschedule', 'specific time', 'after order', 'after confirmed', 'change address'],
      answer: "Please contact Playforce to check and advise on any delivery or return timing changes.\n\nChanges are subject to arrangement availability and may have applicable fees depending on the request.",
      actions: ['live_agent', 'main_menu']
    },
  ];

  function shouldShowLiveAgentForAnswer(item) {
    if (!item) return false;
    var highIntentIds = [
      'check_price', 'quotation', 'bulk_pricing', 'payment_confirmation', 'deliver_tomorrow',
      'urgent_delivery_charges', 'different_return_location', 'availability_stock', 'same_day_urgent_rental',
      'invoice_receipt', 'event_roadshow_rental', 'delivery_coverage', 'reserve_without_payment',
      'trust_rental_confidence', 'software_game_cannot_run', 'pre_rental_testing', 'missed_delivery_return', 'device_expectations', 'data_after_return', 'install_apps_admin', 'internet_connectivity', 'multiple_device_rental', 'someone_else_handover', 'deposit_deductions', 'small_cosmetic_scratches', 'existing_cosmetic_marks', 'damage_payment_amount', 'faulty_device_replacement', 'charger_issue', 'device_damaged', 'device_lost', 'late_return', 'change_upgrade_device', 'missed_return_collection', 'lost_accessories', 'available_rental_devices', 'gaming_game_recommendation', 'gaming_higher_fps', 'gaming_better_graphics', 'mobile_games_on_laptop', 'gaming_event_rental', 'document_usage_privacy', 'device_unavailable_after_order', 'upfront_payment_deposit', 'find_my_not_off', 'delivery_return_timing_change'
    ];
    return highIntentIds.indexOf(item.id) !== -1 ||
      item.category === 'Rental Price' ||
      item.category === 'Availability and Urgent Rental' ||
      item.category === 'Corporate and Bulk Rental';
  }

  function getAnswerActions(item) {
    // v43 circular design: after an answer, route the customer to the next most useful step,
    // instead of ending every branch at Main menu.
    var actions = getCircularAnswerActions(item);
    if (shouldShowLiveAgentForAnswer(item) && actions.indexOf('live_agent') === -1) {
      actions.splice(Math.min(1, actions.length), 0, 'live_agent');
    }
    if (actions.indexOf('main_menu') === -1) actions.push('main_menu');
    return uniqueActions(actions);
  }

  function updateQuestionContext(item) {
    if (!item) return false;

    overallQuestionCount += 1;

    if (!questionContext || questionContext.category !== item.category) {
      questionContext = { category: item.category, count: 1 };
    } else {
      questionContext.count += 1;
    }

    var reachedSameCategoryLimit = questionContext.count >= 2;
    var reachedOverallLimit = overallQuestionCount >= 3;

    if (reachedSameCategoryLimit || reachedOverallLimit) {
      // Reset after prompting so the rating check does not keep appearing repeatedly.
      questionContext = null;
      overallQuestionCount = 0;
      saveState();
      return true;
    }

    saveState();
    return false;
  }

  function resetQuestionContext() {
    questionContext = null;
    overallQuestionCount = 0;
    saveState();
  }

  function isResetRequest(text) {
    var q = normalise(text);
    return /\b(reset|restart|clear chat|clear conversation|start over|start again|refresh chat)\b/.test(q);
  }

  function isEndChatRequest(text) {
    var q = normalise(text);
    return /\b(end chat|end conversation|close chat|stop chat|finish chat|terminate chat|bye|goodbye)\b/.test(q);
  }

  function isAvailableDevicesQuestion(text) {
    var q = normalise(text);
    return /\b(what devices|which devices|what laptops|which laptops|what products|device options|rental devices|what do you rent|what can i rent|devices does playforce have|laptops do you have)\b/.test(q) ||
      (/\b(playforce|you)\b/.test(q) && /\b(rent|have|offer|available)\b/.test(q) && /\b(devices|laptops|macbook|ipad|products|options)\b/.test(q));
  }

  function isDeviceUpgradeQuestion(text) {
    var q = normalise(text);
    return /\b(upgrade|change|swap|switch|top up)\b/.test(q) &&
      /\b(laptop|device|macbook|ipad|model|better|business|gaming|halfway|during rent|during rental)\b/.test(q);
  }

  function isFaultyDeviceQuestion(text) {
    var q = normalise(text);
    return /\b(what if|if|during rental|during rent|cannot turn on|not working|faulty|broken|blue screen|black screen|hang|crash)\b/.test(q) &&
      /\b(laptop|device|macbook|ipad|charger|screen|keyboard|battery|it)\b/.test(q) &&
      /\b(faulty|broken|not working|cannot turn on|blue screen|black screen|hang|crash|issue|problem)\b/.test(q);
  }

  function isAccessoryLostQuestion(text) {
    var q = normalise(text);
    return /\b(lost|missing|lose)\b/.test(q) && /\b(charger|bag|mouse|adapter|accessory)\b/.test(q);
  }

  function isCorporateEnquiry(text) {
    var q = normalise(text);
    var quantityText = detectQuantityFromText(q);
    var quantityNumber = parseInt(quantityText, 10) || 0;
    var hasDevice = /\b(laptop|laptops|device|devices|notebook|notebooks|macbook|macbooks|ipad|ipads|tablet|tablets|business|gaming|windows)\b/.test(q);
    var hasBulkQuantity = quantityNumber >= 2 && hasDevice;
    var hasCorporateWord = /\b(corporate|company|b2b|bulk|long term|long-term|organisation|organization|enterprise|event|roadshow|training|exam)\b/.test(q);
    var hasRentalContext = /\b(rent|rental|enquiry|inquiry|quote|quotation|request|laptop|laptops|macbook|macbooks|ipad|ipads|device|devices|units|billing|invoice|receipt|need|want|require)\b/.test(q);
    return hasBulkQuantity || (hasCorporateWord && hasRentalContext);
  }

  function isInvoiceReceiptQuestion(text) {
    var q = normalise(text);
    return /\b(invoice|receipt|quotation|quote|billing|company name)\b/.test(q) &&
      /\b(can|issue|provide|official|company|quotation|quote|invoice|receipt|billing)\b/.test(q);
  }

  function isCustomRentalEnquiry(text) {
    var q = normalise(text);
    return /\b(custom|customised|customized|special arrangement|special request|flexible period|custom enquiry|custom inquiry|custom quote|custom quotation)\b/.test(q) &&
      /\b(rent|rental|enquiry|inquiry|quote|quotation|request|period|duration|laptop|macbook|ipad|device)\b/.test(q);
  }

  function isUrgentRentalRequest(text) {
    var q = normalise(text);
    return /\b(urgent|immediate|immediately|asap|same day|today|tomorrow|next day|now|rush|last minute|last-minute)\b/.test(q) &&
      /\b(rent|rental|deliver|delivery|device|laptop|macbook|ipad|need|request)\b/.test(q);
  }

  function isAvailabilityQuestion(text) {
    var q = normalise(text);
    return /\b(available|stock|availability|got stock|still have|reserve|hold)\b/.test(q) &&
      /\b(laptop|device|macbook|ipad|business|gaming|units|today|tomorrow|rent|rental|need|available)\b/.test(q);
  }

  function isEventRentalQuestion(text) {
    var q = normalise(text);
    return /\b(event|roadshow|training|exam|registration|check in|school|venue)\b/.test(q) &&
      /\b(rent|rental|device|laptop|macbook|ipad|units|bulk|need)\b/.test(q);
  }


  function isRentalProcessQuestion(text) {
    var q = normalise(text);
    if (!q) return false;

    // Broad rental-process intent. This should answer orientation questions, not start collection immediately.
    var processPhrases = /\b(how does rental work|how rental works|how does it work|how to rent|how do i rent|how to order|how do i order|rental process|rent process|rental steps|rent steps|show me the rental process|show rental process|what are the steps|what is the process|place order|place an order|order online|order by whatsapp|order through whatsapp|whatsapp to order|whatsapp order|after i order|after payment|after pay|what happens after payment|what happens after i pay|when is my rental confirmed|when confirm rental|how do i receive|how will i receive|how do i return|how to return|will you deliver and collect|deliver and collect|delivery and collection|do you collect back|pick up when rental ends|collect when rental ends|return collection)\b/.test(q);

    var deviceRentalHowTo = /\b(how to rent|how do i rent|how to order|how do i order)\b/.test(q) &&
      /\b(laptop|macbook|ipad|device|business laptop|gaming laptop)\b/.test(q);

    var deliveryReturnProcess = /\b(deliver|delivery|collect|collection|pick up|pickup|return)\b/.test(q) &&
      /\b(process|steps|how|work|works|arrange|when rental ends|rental ends)\b/.test(q);

    return processPhrases || deviceRentalHowTo || deliveryReturnProcess;
  }

  function isRentalStartRequest(text) {
    var q = normalise(text);
    var hasDevice = /\b(laptop|device|macbook|ipad|tablet|business laptop|gaming laptop|windows laptop)\b/.test(q);
    var hasRentalIntent = /\b(i want to rent|want to rent|need to rent|can rent|looking to rent|looking for rent|rent|lease|leasing|hire|borrow)\b/.test(q);
    var hasNeedDeviceIntent = /\b(need|want|looking for|looking to get|require)\b/.test(q) && hasDevice;
    var isPurePolicyQuestion = v87IsPolicyOrFaqQuestion(q) || /\b(price|how much|cost|quote|fee|deposit|document|nric|deliver|delivery|return|cancel|damage|late|overseas|software|compatible|run|support)\b/.test(q);

    return v87HasRentalStarter(q) && hasDevice && !isPurePolicyQuestion ||
      ((hasRentalIntent || hasNeedDeviceIntent) && hasDevice && !isPurePolicyQuestion);
  }


  /* v90 Brand and Model Preference Router
     Brand/model preference should be treated as a specific device-selection question,
     not as a generic rental entry. */

  function v90IsBrandModelPreference(text) {
    var q = normalise(text || '');
    if (!q) return false;
    var hasKnownBrand = /\b(acer|asus|dell|lenovo|hp|hewlett packard|microsoft|surface|razer|razer blade|apple)\b/.test(q);
    var hasBrandModelWord = /\b(brand|brands|model|models|exact model|exact brand|specific model|specific brand|laptop brand|laptop model)\b/.test(q);
    var hasChoiceWord = /\b(choose|chose|select|pick|request|prefer|preferred|preference|want|looking for|need|got|have|available|assign|allocation)\b/.test(q);
    var hasLaptopDevice = /\b(laptop|notebook|windows laptop|business laptop|gaming laptop|macbook|computer|pc)\b/.test(q);

    if (hasBrandModelWord && (hasChoiceWord || hasLaptopDevice || /\b(what|which|do you|can i|can we)\b/.test(q))) return true;
    if (hasKnownBrand && hasLaptopDevice && hasChoiceWord) return true;
    if (hasKnownBrand && /\b(got|have|available|choose|request|prefer|want)\b/.test(q)) return true;
    if (/\b(what brands do you have|what laptop brands|what brands and models|what models of laptop|which laptop brands|which laptop models)\b/.test(q)) return true;
    return false;
  }

  function v90BrandModelScoreBoost(text) {
    var q = normalise(text || '');
    if (!q) return 0;
    var score = 0;
    if (v90IsBrandModelPreference(q)) score += 170;
    if (/\b(acer|asus|dell|lenovo|hp|hewlett packard|microsoft|surface|razer|razer blade|apple)\b/.test(q)) score += 50;
    if (/\b(brand|brands|model|models|specific|exact|preferred|preference)\b/.test(q)) score += 45;
    if (/\b(choose|select|pick|request|prefer|want|got|have|available)\b/.test(q)) score += 25;
    return score;
  }

  /* v100 Intent Priority Cleanup
     These rules sit above broad FAQ scoring and price-flow collection.
     They prevent broad terms such as rental, device, collection, payment, or price
     from overriding a clearer customer intent. */

  function v100GameKeys(items) {
    var keys = [];
    if (!items || !items.length) return keys;
    for (var i = 0; i < items.length; i += 1) {
      if (items[i] && items[i].key && keys.indexOf(items[i].key) === -1) keys.push(items[i].key);
    }
    return keys;
  }

  function v100HasNewGameEntity(currentText, previousText) {
    var current = v100GameKeys(findGameRecommendations(currentText || ''));
    var previous = v100GameKeys(findGameRecommendations(previousText || ''));
    if (!current.length) return false;
    for (var i = 0; i < current.length; i += 1) {
      if (previous.indexOf(current[i]) === -1) return true;
    }
    return current.length > previous.length;
  }

  function v100IsGenericRentalOnly(text) {
    var q = normalise(text || '');
    if (!q) return false;
    if (/^(rental|rent|lease|leasing|hire|borrow|rental enquiry|rental inquiry)$/.test(q)) return true;
    if (/^(i want rental|want rental|need rental|looking for rental)$/.test(q)) return true;
    return false;
  }

  function v100IsDeviceConditionQuestion(text) {
    var q = normalise(text || '');
    if (!q) return false;
    var hasDevice = /\b(rental device|rental laptop|device|devices|laptop|laptops|macbook|ipad|unit|units)\b/.test(q);
    var hasCondition = /\b(preowned|pre-owned|used|second hand|new|brand new|condition|clean|cleaned|sanitary|format|formatted|reset|scratch|scratches|cosmetic|dents|checked|working)\b/.test(q);
    return hasDevice && hasCondition && !/\b(price|how much|cost|deposit|refund|deduct|minus|late|return late|delivery free|surcharge)\b/.test(q);
  }

  function v100DeviceConditionIntentId(text) {
    var q = normalise(text || '');
    if (/\b(clean|cleaned|format|formatted|reset|ready before delivery|before delivery)\b/.test(q)) return 'clean_formatted_before_delivery';
    return 'device_condition';
  }

  function v100IsPaymentDeliveryConfirmationQuestion(text) {
    var q = normalise(text || '');
    if (!q) return false;
    if (/\b(refund|deposit refund|get deposit|return deposit|price|how much|payment method|paynow|credit card)\b/.test(q)) return false;
    var hasPaymentCue = /\b(after payment|after paying|once i pay|if i pay|after i pay|when i pay|payment completed|payment verified|paid already|after checkout)\b/.test(q);
    var hasReceiveCue = /\b(will i get|will i receive|do i get|receive the|get the|deliver|delivery|send|arrange|confirmed)\b/.test(q);
    var hasDevice = /\b(laptop|device|macbook|ipad|unit|order|rental|get it)\b/.test(q);
    return (hasPaymentCue && (hasReceiveCue || hasDevice)) || (/\b(will i get|will i receive)\b/.test(q) && /\b(after payment|after paying|after i pay|once i pay|payment)\b/.test(q));
  }

  function v100IsReturnCollectionFeeQuestion(text) {
    var q = normalise(text || '');
    if (!q) return false;
    if (/\b(self collect|self-collect|collect myself|ownself collect|pick up myself|pickup myself|collect from shop|your shop|store|office)\b/.test(q)) return false;
    var hasFee = /\b(free|charge|charges|fee|fees|cost|pay|included|how much)\b/.test(q);
    var hasReturnCollection = /\b(return collection|collection free|is collection free|returning free|is returning free|collect back|collection back|pickup after rental|pick up after rental|return included|return charge|return free)\b/.test(q);
    return hasFee && hasReturnCollection;
  }

  function v100FeePolicyIntentId(text) {
    var q = normalise(text || '');
    if (!q) return '';
    if (/\b(weekend|saturday|sunday)\b/.test(q) && /\b(surcharge|charge|fee|cost|how much|fixed|fix|extra)\b/.test(q)) return 'weekend_surcharge';
    if (/\b(mbs|marina bay sands)\b/.test(q) && /\b(surcharge|charge|fee|cost|delivery|return|how much|extra)\b/.test(q)) return 'mbs_surcharge';
    if (/\b(urgent|priority|same day|asap|rush|today|tomorrow)\b/.test(q) && /\b(delivery|deliver|charge|fee|surcharge|cost|how much|extra)\b/.test(q)) return 'urgent_delivery_charges';
    if (/\b(return extension|return timing|return slot|collect later|collection timing|same day return)\b/.test(q) && /\b(charge|fee|cost|how much|extend|extension|change)\b/.test(q)) return 'return_extension_charges';
    if (/\b(late return|return late|overdue|forgot return|cannot return today|return tomorrow)\b/.test(q) && /\b(charge|fee|cost|how much|pay|penalty|fine)\b/.test(q)) return 'late_return';
    if (/\b(different return location|different location|another location|another address|different address)\b/.test(q) && /\b(charge|fee|cost|how much|return|collection)\b/.test(q)) return 'different_return_location';
    return '';
  }

  function v100IsPriceObjection(text) {
    var q = normalise(text || '');
    if (!q) return false;
    return /\b(too expensive|price too high|rental price too high|cost too high|very expensive|cheaper option|got cheaper|any cheaper|budget option|lower price|discount|cheapest)\b/.test(q);
  }

  function v100IsDeviceRecommendationQuestion(text) {
    var q = normalise(text || '');
    if (!q) return false;
    if (findGameRecommendations(q).length) return false;
    var hasAdvice = /\b(advise|advice|recommend|suggest|which laptop|which device|what laptop|what device|help me choose|not sure which|suitable for me|should i get|should i rent|best laptop|best device)\b/.test(q);
    var hasDevice = /\b(laptop|device|macbook|ipad|business laptop|gaming laptop|windows laptop|computer|pc)\b/.test(q);
    return hasAdvice && hasDevice;
  }

  function showV100DeviceRecommendationPrompt() {
    conversationContext.lastIntent = 'device_recommendation_usage';
    saveState();
    setLastAnswerMeta('v100_device_recommendation_prompt', 'Device recommendation usage prompt', 'Device Selection', 'clarification');
    replyBot('Sure. I can help recommend a suitable rental device. What will you mainly use it for?', function () {
      addPlaybotCard('Choose your main usage',
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-recommend-usage="office">Office, school or general use</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-recommend-usage="exam">Exam browser</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-recommend-usage="adobe">Adobe and design</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-recommend-usage="video">Video editing</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-recommend-usage="coding">Coding or programming</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-recommend-usage="gaming">Gaming</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-recommend-usage="event">Event or registration</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-recommend-usage="unsure">Not sure</button>'
      );
      addActionRow(['price_flow', 'live_agent', 'main_menu']);
    });
  }

  function showV100UsageRecommendation(usage) {
    var u = normalise(usage || '');
    var answer = '';
    var actions = ['price_flow', 'view_rental', 'live_agent', 'main_menu'];
    if (u === 'office') {
      answer = 'For office, school, training, exam preparation, web browsing, Microsoft Office, Zoom, and general productivity, Business Laptop i5 or Ryzen 5 is usually suitable.\n\nChoose Business Laptop i7 or Ryzen 7 if you need heavier multitasking, coding, Docker, SQL, or more demanding business apps.';
      conversationContext.device = 'Business Laptop';
      actions = ['view_business', 'price_flow', 'rent_device_flow', 'live_agent', 'main_menu'];
    } else if (u === 'exam') {
      answer = 'For exam browser use, Business Laptop is usually the safest starting point for Windows-based exams.\n\nPlease still check your school or exam provider’s device and operating-system requirements before booking.';
      conversationContext.device = 'Business Laptop';
      actions = ['view_business', 'price_flow', 'live_agent', 'main_menu'];
    } else if (u === 'adobe' || u === 'video') {
      answer = 'For Adobe, design work, or video editing, Gaming Laptop or a suitable MacBook is usually recommended.\n\nChoose Gaming Laptop for heavier Windows GPU workloads. Choose MacBook if you specifically need macOS or Mac-based creative workflows.';
      actions = ['view_gaming', 'view_macbook', 'price_flow', 'live_agent', 'main_menu'];
    } else if (u === 'coding') {
      answer = 'For coding or programming, Business Laptop i7 or Ryzen 7 is usually a good Windows option.\n\nFor Docker, SQL, heavier development tools, or GPU-related workloads, consider Gaming Laptop or a suitable MacBook with enough memory.';
      actions = ['view_business', 'view_gaming', 'view_macbook', 'price_flow', 'live_agent', 'main_menu'];
    } else if (u === 'gaming') {
      answer = 'For gaming, Gaming Laptop is recommended. Tell me the game you want to play and I’ll suggest a suitable GPU tier, such as Entry Gaming, Performance, or High-Performance Gaming Laptop.';
      conversationContext.device = 'Gaming Laptop';
      actions = ['game_recommendation', 'view_gaming', 'price_flow', 'live_agent', 'main_menu'];
    } else if (u === 'event') {
      answer = 'For events, registration, check-in, forms, presentations, or portable workflows, iPad rental is often suitable.\n\nFor Windows software, browser-based training, or multiple laptop workstations, Business Laptop rental may be better.';
      actions = ['view_ipad', 'view_business', 'price_flow', 'live_agent', 'main_menu'];
    } else {
      answer = 'No problem. A safe starting point is Business Laptop for general use, MacBook for macOS users, Gaming Laptop for games or heavier workloads, and iPad for events or portable use.\n\nShare your usage, quantity, rental duration, and start date if you want a more specific recommendation.';
      actions = ['view_business', 'view_gaming', 'view_macbook', 'view_ipad', 'live_agent', 'main_menu'];
    }
    if (u === 'office' || u === 'exam') conversationContext.recommendedPriceProductKey = 'business';
    else if (u === 'gaming') conversationContext.recommendedPriceProductKey = 'gaming';
    else if (u === 'event') conversationContext.recommendedPriceProductKey = 'ipad';
    else conversationContext.recommendedPriceProductKey = '';
    conversationContext.lastIntent = 'device_recommendation';
    saveState();
    setLastAnswerMeta('v100_device_recommendation_' + (u || 'unsure'), 'Device recommendation by usage', 'Device Selection', 'answered');
    replyBot(answer, function () { addActionRow(actions); });
  }

  /* v101 Price Context Safety
     Recommendation examples should not become confirmed pricing selections.
     The bot may remember advice context, but exact pricing must require a clear selected model/tier. */

  function v101IsAdvisoryMemoryIntent(intent) {
    intent = String(intent || '');
    return /^(gaming_game_recommendation|gaming_higher_fps|gaming_better_graphics|mobile_games_on_laptop|gaming_event_rental|which_device|available_rental_devices|device_recommendation|v100_device_recommendation_prompt)/.test(intent);
  }

  function v101CountPriceableGamingModels(text) {
    var q = normalise(text || '');
    var matches = q.match(/(gtx\s*1650|rtx\s*2060|rtx\s*3050|rtx\s*3060|rtx\s*4050|rtx\s*4060|rtx\s*4070|1650|2060|3050|3060|4050|4060|4070)/g);
    return matches ? matches.length : 0;
  }

  function v101ShouldStoreDeviceFromMemory(text, intent) {
    var q = normalise(text || '');
    if (v101IsAdvisoryMemoryIntent(intent)) return false;
    if (/\b(such as|for example|where available|recommended category|general guide|choose a performance|choose high-performance|safer starting point)\b/.test(q) && v101CountPriceableGamingModels(q) >= 2) return false;
    return true;
  }

  function v101IsGenericPriceRequest(text) {
    var q = normalise(text || '');
    if (!q) return false;
    if (getCanonicalDeviceLabelFromText(q)) return false;
    if (/\b(32gb|32 gb|memory upgrade|ram upgrade)\b/.test(q)) return false;
    return /^(how much|how much to rent|how much rental|rental price|price|pricing|cost|cost to rent|rental fee|rate|rates|quote|check price|check rental price)$/.test(q);
  }

  function v101CanUseStoredPriceContext(text) {
    var q = normalise(text || '');
    if (!q) return false;
    if (getCanonicalDeviceLabelFromText(q)) return true;
    if (v101IsGenericPriceRequest(q)) return false;
    if (v102IsDeviceSwitchPriceQuestion(q)) return false;
    if (conversationContext && conversationContext.confirmedPriceDevice && /\b(same|this|that|it|for same|same one|same laptop|same device)\b/.test(q)) return true;
    if (conversationContext && conversationContext.confirmedPriceDevice && /\b(1 day|2 day|3 day|5 day|1 week|2 week|1 month|2 month|3 month)\b/.test(q)) return true;
    return false;
  }

  function v101IsShortCleanFollowUp(text) {
    var q = normalise(text || '');
    if (!/^(clean|cleaned|is clean|clean before delivery|device clean|rental device clean)$/.test(q)) return false;
    var lastId = lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '';
    return /^(device_condition|device_expectations|clean_formatted_before_delivery)$/.test(lastId) || /\b(preowned|pre-owned|used|condition|clean)\b/.test(normalise(lastUserQuestion || ''));
  }

  function v101IsBroadAdviceRequest(text) {
    var q = normalise(text || '');
    return /^(advise me|advice|need advice|can advise|can you advise|recommend me|recommend|suggest|suggest me|help me choose|not sure|not sure which)$/.test(q);
  }

  function v101Is32gbMemoryPriceQuestion(text) {
    var q = normalise(text || '');
    return /\b(32gb|32 gb|32gb ram|32 gb ram|32gb memory|32 gb memory|memory upgrade|ram upgrade)\b/.test(q) && /\b(how much|price|cost|fee|charge|add on|addon|optional extra|extra)\b/.test(q);
  }

  function showV101MemoryAddonAnswer() {
    setLastAnswerMeta('v101_32gb_memory_addon', '32GB memory optional extra', 'Rental Price', 'answered');
    fetchVariantById('47939116859579').then(function (variant) {
      var cents = variantPriceCents(variant);
      var priceText = cents !== null ? formatSgd(cents) : 'shown during booking';
      replyBot('32GB memory is an optional extra for Gaming Laptop rental where available.\n\nThe 32GB memory add-on is ' + priceText + '.\n\nIt is not an iPad add-on. To estimate the full rental total, tell me the gaming laptop GPU tier and rental duration, for example: “RTX 3050 1 Week with 32GB memory”.', function () {
        addActionRow(['view_gaming', 'price_flow', 'live_agent', 'main_menu']);
      });
    }).catch(function () {
      replyBot('32GB memory is an optional extra for Gaming Laptop rental where available.\n\nThe add-on price will be shown during booking. To estimate the full rental total, tell me the gaming laptop GPU tier and rental duration, for example: “RTX 3050 1 Week with 32GB memory”.', function () {
        addActionRow(['view_gaming', 'price_flow', 'live_agent', 'main_menu']);
      });
    });
  }


  /* v102 Price Context Reset and Live Catalogue Discovery
     Exact price quotes now require an active, confirmed price selection. Older quotes are kept only as reference,
     and switching device family clears the old price model before asking for the new model/tier. */

  function v102GetRentalPriceProductByKey(key) {
    key = String(key || '');
    for (var i = 0; i < rentalPriceProducts.length; i += 1) {
      if (rentalPriceProducts[i].key === key) return rentalPriceProducts[i];
    }
    return null;
  }

  function v102ClearConfirmedPriceContext(reason) {
    if (!conversationContext) return;
    conversationContext.confirmedPriceDevice = '';
    conversationContext.confirmedPriceProductKey = '';
    conversationContext.confirmedPriceDuration = '';
    conversationContext.activePriceQuoteKey = '';
    conversationContext.pendingPriceSwitchProductKey = '';
    conversationContext.pendingPriceSwitchDuration = '';
    if (reason) conversationContext.lastPriceResetReason = reason;
  }

  function v102MarkConfirmedPriceContext(request) {
    if (!conversationContext || !request || !request.product || !request.model || !request.period) return;
    conversationContext.device = request.model.label || request.product.label || '';
    conversationContext.duration = request.period.label || '';
    conversationContext.confirmedPriceDevice = request.model.label || '';
    conversationContext.confirmedPriceProductKey = request.product.key || '';
    conversationContext.confirmedPriceDuration = request.period.label || '';
    conversationContext.lastPriceProductKey = request.product.key || '';
    conversationContext.lastPriceDevice = request.model.label || '';
    conversationContext.lastPriceDuration = request.period.label || '';
    conversationContext.activePriceQuoteKey = [request.product.key || '', request.model.key || request.model.label || '', request.period.key || request.period.label || ''].join('|');
    conversationContext.lastIntent = 'price';
  }

  function v102IsDeviceSwitchPriceQuestion(text) {
    var q = normalise(text || '');
    if (!q) return false;
    var hasSwitchCue = /\b(how about|what about|instead|switch to|change to|compare|for)\b/.test(q);
    var hasPriceCue = /\b(how much|price|cost|fee|rate|quote|rental)\b/.test(q);
    var oldKey = conversationContext && (conversationContext.confirmedPriceProductKey || conversationContext.lastPriceProductKey || '');
    var product = detectRentalPriceProduct(q);
    if (!product || !oldKey || product.key === oldKey) return false;
    return hasSwitchCue || hasPriceCue || /^\s*(macbook|business laptop|gaming laptop|ipad)\s*$/.test(q);
  }

  function v102HandlePriceDeviceSwitch(text) {
    if (!v102IsDeviceSwitchPriceQuestion(text)) return false;
    var product = detectRentalPriceProduct(text);
    if (!product) return false;
    var existingDuration = (conversationContext && (conversationContext.confirmedPriceDuration || conversationContext.lastPriceDuration || conversationContext.duration)) || '';
    var period = detectRentalPeriod(text) || (existingDuration ? detectRentalPeriod(existingDuration) : null);
    var seed = 'price ' + product.label + (period && period.label ? ' ' + period.label : '');
    v102ClearConfirmedPriceContext('device_switch_to_' + product.key);
    conversationContext.device = product.label;
    conversationContext.pendingPriceSwitchProductKey = product.key;
    conversationContext.pendingPriceSwitchDuration = period && period.label ? period.label : '';
    priceState = { raw: seed };
    showRentalPriceEstimate(seed);
    trackPlaybotEvent('topic_switch', { query: text, from: 'previous_price_quote', to: product.key, botOutcome: 'v102_price_device_switch' });
    return true;
  }

  function v102InferProductFromPage() {
    var path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
    if (path.indexOf('/products/gaming-laptop-rental') !== -1) return v102GetRentalPriceProductByKey('gaming');
    if (path.indexOf('/products/business-laptop-rental') !== -1) return v102GetRentalPriceProductByKey('business');
    if (path.indexOf('/products/macbook-rental') !== -1) return v102GetRentalPriceProductByKey('macbook');
    if (path.indexOf('/products/ipad-rental') !== -1) return v102GetRentalPriceProductByKey('ipad');
    return null;
  }

  function v102InferLiveCatalogueProduct(text) {
    var q = normalise(text || '');
    var product = detectRentalPriceProduct(q);
    if (product) return product;
    if (/\b(gpu|graphics|graphic card|rtx|gtx)\b/.test(q)) return v102GetRentalPriceProductByKey('gaming');
    if (/\b(processor|cpu|i5|i7|ryzen|ultra)\b/.test(q)) return v102GetRentalPriceProductByKey('business');
    return v102InferProductFromPage();
  }

  function v102IsLiveCatalogueQuestion(text) {
    var q = normalise(text || '');
    if (!q) return false;
    var asksForOptions = /\b(what|which|show|list|available|have|got|do you have|options?|option)\b/.test(q);
    var optionTopic = /\b(gpu|graphics|graphic card|processor|cpu|specs|specification|optional extras|optional extra|add ons|addons|add-on|add on|rental period|rental periods|duration|durations|business laptop options?|macbook options?|ipad options?|gaming laptop options?)\b/.test(q);
    if (asksForOptions && optionTopic) return true;
    if (/\b(what gpu|which gpu|gpu options|graphics options|what processor|processor options|what optional extras|optional extras available|what rental periods|rental period available|what business laptop option|business laptop options available|what macbook option|macbook options available|what ipad option|ipad options available)\b/.test(q)) return true;
    return false;
  }

  function v102PushUnique(list, value) {
    value = String(value || '').trim();
    if (!value) return;
    if (list.indexOf(value) === -1) list.push(value);
  }

  function v103PushBusinessProcessorPair(out, text, value) {
    if (!out || !text) return;
    var label = '';
    if (value === 5 && /\bultra\s*5\b/.test(text) && /\bryzen\s*5\b/.test(text)) label = 'Ultra 5 / Ryzen 5 (New)';
    if (value === 7 && /\bultra\s*7\b/.test(text) && /\bryzen\s*7\b/.test(text)) label = 'Ultra 7 / Ryzen 7 (New)';
    if (label) v102PushUnique(out.processors, label);
  }

  function v103SortOptionLabels(list) {
    var order = {
      'Business Laptop i5 or Ryzen 5': 10,
      'Business Laptop i7 or Ryzen 7': 20,
      'Ultra 5 / Ryzen 5 (New)': 30,
      'Ultra 7 / Ryzen 7 (New)': 40
    };
    return (list || []).slice().sort(function (a, b) {
      var ai = typeof order[a] === 'number' ? order[a] : 999;
      var bi = typeof order[b] === 'number' ? order[b] : 999;
      if (ai !== bi) return ai - bi;
      return String(a).localeCompare(String(b));
    });
  }

  function v102ExtractLiveCatalogue(product, shopifyProduct) {
    var variants = shopifyProduct && shopifyProduct.variants ? shopifyProduct.variants : [];
    var out = { graphics: [], processors: [], periods: [], extras: [] };
    for (var i = 0; i < variants.length; i += 1) {
      var raw = [variants[i].title, variants[i].name, variants[i].public_title, variants[i].option1, variants[i].option2, variants[i].option3, variants[i].sku].join(' ');
      var text = priceNormalise(raw);
      var gpuRegex = /\b(rtx|gtx)\s*([0-9]{4,5})\b/g;
      var gm;
      while ((gm = gpuRegex.exec(text))) v102PushUnique(out.graphics, gm[1].toUpperCase() + ' ' + gm[2]);

      if (product && product.key === 'business') {
        v103PushBusinessProcessorPair(out, text, 5);
        v103PushBusinessProcessorPair(out, text, 7);
      }

      var processorRegex = /\b(core\s*)?(ultra\s*[579]|i[3579]|ryzen\s*[3579])\b/g;
      var pm;
      while ((pm = processorRegex.exec(text))) {
        var label = pm[2].replace(/\s+/g, ' ').trim();
        label = label.replace(/^i([3579])$/, 'Intel i$1').replace(/^ultra/i, 'Intel Ultra').replace(/^ryzen/i, 'Ryzen');
        if (product && product.key === 'business' && /^Ryzen [57]$/i.test(label) && /\bnew\b/.test(text)) {
          // Keep Ryzen 5/7 (New) paired with the matching Ultra option instead of showing a vague duplicate.
          continue;
        }
        v102PushUnique(out.processors, label);
      }

      for (var r = 0; r < rentalPeriodConfigs.length; r += 1) {
        for (var t = 0; t < rentalPeriodConfigs[r].terms.length; t += 1) {
          if (termInText(text, rentalPeriodConfigs[r].terms[t])) v102PushUnique(out.periods, rentalPeriodConfigs[r].label);
        }
      }
      var dynamicPeriodRegex = /\b([1-9]|1[0-2])\s*(day|days|week|weeks|month|months|mth|mths)\b/g;
      var dm;
      while ((dm = dynamicPeriodRegex.exec(text))) {
        var unit = /^day/.test(dm[2]) ? 'Day' : (/^week/.test(dm[2]) ? 'Week' : 'Month');
        v102PushUnique(out.periods, parseInt(dm[1], 10) + ' ' + unit);
      }

      if (/\b(optional|extra|addon|add on|add-on|office|32gb|32 gb|cellular|pencil|urgent|delivery|return extension)\b/.test(text)) {
        var cleanLabel = String(variants[i].public_title || variants[i].title || variants[i].name || '').replace(/\s+/g, ' ').trim();
        if (cleanLabel && cleanLabel.length <= 80) v102PushUnique(out.extras, cleanLabel);
      }
    }

    if (product && product.models && product.key === 'business') {
      for (var m = product.models.length - 1; m >= 0; m -= 1) {
        var modelLabel = product.models[m].label || '';
        if (/Ultra 5 \/ Ryzen 5/.test(modelLabel)) v102PushUnique(out.processors, 'Ultra 5 / Ryzen 5 (New)');
        else if (/Ultra 7 \/ Ryzen 7/.test(modelLabel)) v102PushUnique(out.processors, 'Ultra 7 / Ryzen 7 (New)');
        else if (/i5 or Ryzen 5/.test(modelLabel)) v102PushUnique(out.processors, 'Business Laptop i5 or Ryzen 5');
        else if (/i7 or Ryzen 7/.test(modelLabel)) v102PushUnique(out.processors, 'Business Laptop i7 or Ryzen 7');
      }
      out.processors = v103SortOptionLabels(out.processors);
    }

    for (var e = 0; e < rentalPriceExtraConfigs.length; e += 1) {
      var cfg = rentalPriceExtraConfigs[e];
      if (cfg.productKeys && cfg.productKeys.length && product && cfg.productKeys.indexOf(product.key) === -1) continue;
      v102PushUnique(out.extras, cfg.label);
    }

    return out;
  }

  function showV102LiveCatalogueAnswer(text) {
    var product = v102InferLiveCatalogueProduct(text);
    if (!product) {
      replyBot('Sure. Which rental category would you like me to check live options for?', function () {
        addPriceChipRow([
          { label: 'Business Laptop', value: 'Business Laptop' },
          { label: 'Gaming Laptop', value: 'Gaming Laptop' },
          { label: 'MacBook', value: 'MacBook' },
          { label: 'iPad', value: 'iPad' }
        ]);
        addActionRow(['live_agent', 'main_menu']);
      });
      return true;
    }

    addTypingIndicator();
    fetchRentalProduct(product).then(function (shopifyProduct) {
      removeTypingIndicators();
      var info = v102ExtractLiveCatalogue(product, shopifyProduct);
      var q = normalise(text || '');
      var lines = ['Based on the current ' + product.label + ' rental page, Playbot can read the live website variants where available.'];
      if (/\b(gpu|graphics|graphic card|rtx|gtx)\b/.test(q)) {
        lines.push('', 'Graphics / GPU options found:');
        lines.push(info.graphics.length ? '• ' + info.graphics.join('\n• ') : '• I could not detect GPU names from the current variant titles. Please check the rental page or WhatsApp us.');
      } else if (/\b(processor|cpu|i5|i7|ryzen|ultra)\b/.test(q)) {
        lines.push('', 'Processor options found:');
        lines.push(info.processors.length ? '• ' + info.processors.join('\n• ') : '• I could not detect processor names from the current variant titles. Please check the rental page or WhatsApp us.');
      } else if (/\b(optional extras|optional extra|add ons|addons|add-on|add on|extras)\b/.test(q)) {
        lines.push('', 'Optional extras, delivery charges, return extensions, and location surcharges may depend on the selected device, timing, rental date, and checkout options.');
        lines.push('Any applicable add-on or charge will be shown during booking, or confirmed by Playforce before the rental is confirmed.');
      } else if (/\b(rental period|rental periods|duration|durations)\b/.test(q)) {
        lines.push('', 'Rental periods found:');
        lines.push(info.periods.length ? '• ' + info.periods.join('\n• ') : '• I could not detect rental periods from the current variant titles.');
      } else {
        if (product && product.key === 'business') {
          lines.push('', 'Business Laptop options found:');
          lines.push(info.processors.length ? '• ' + info.processors.join('\n• ') : '• I could not detect Business Laptop processor options from the current variant titles.');
        } else {
          lines.push('', 'Detected options:', '• Graphics: ' + (info.graphics.length ? info.graphics.join(', ') : 'Not detected'), '• Processors: ' + (info.processors.length ? info.processors.join(', ') : 'Not detected'), '• Rental periods: ' + (info.periods.length ? info.periods.join(', ') : 'Not detected'));
        }
      }
      lines.push('', 'For exact pricing, tell me the specific model/tier and rental duration, for example: “RTX 4070 1 Week price” or “Ultra 7 3 Month price”.');
      setLastAnswerMeta('v102_live_catalogue', 'Live Shopify rental option discovery', 'Device and Pricing', 'answered');
      addBotMessage(lines.join('\n'));
      addActionRow([product.viewAction || 'view_rental', 'price_flow', 'live_agent', 'main_menu']);
      saveState();
    }).catch(function () {
      removeTypingIndicators();
      replyBot('I could not read the live rental page options at the moment. Please check the rental page or WhatsApp us for the latest options.', function () {
        addActionRow([product.viewAction || 'view_rental', 'live_agent', 'main_menu']);
      });
    });
    return true;
  }

  function v103DetectStandaloneCatalogueEntity(text) {
    var q = normalise(text || '');
    if (!q) return null;
    var gpu = q.match(/\b(rtx|gtx)\s*([0-9]{4,5})\b/);
    if (gpu) return { product: v102GetRentalPriceProductByKey('gaming'), label: gpu[1].toUpperCase() + ' ' + gpu[2], type: 'graphics', terms: [gpu[1] + ' ' + gpu[2], gpu[1] + gpu[2], gpu[2]] };
    var businessPair5 = /\bultra\s*5\b/.test(q) || /\bryzen\s*5\s*new\b/.test(q);
    var businessPair7 = /\bultra\s*7\b/.test(q) || /\bryzen\s*7\s*new\b/.test(q);
    if (businessPair7) return { product: v102GetRentalPriceProductByKey('business'), label: 'Ultra 7 / Ryzen 7 (New)', type: 'processor', terms: ['ultra 7', 'ryzen 7 new', 'ultra 7 ryzen 7 new'] };
    if (businessPair5) return { product: v102GetRentalPriceProductByKey('business'), label: 'Ultra 5 / Ryzen 5 (New)', type: 'processor', terms: ['ultra 5', 'ryzen 5 new', 'ultra 5 ryzen 5 new'] };
    return null;
  }

  function v103CatalogueHasEntity(info, entity) {
    if (!info || !entity) return false;
    var list = entity.type === 'graphics' ? info.graphics : info.processors;
    var target = priceNormalise(entity.label);
    for (var i = 0; i < (list || []).length; i += 1) {
      if (priceNormalise(list[i]) === target || priceNormalise(list[i]).indexOf(target) !== -1 || target.indexOf(priceNormalise(list[i])) !== -1) return true;
    }
    return false;
  }

  function v103MaybeHandleStandaloneCatalogueEntity(text) {
    var entity = v103DetectStandaloneCatalogueEntity(text);
    if (!entity || !entity.product) return false;
    var q = normalise(text || '');
    var hasPriceOrPeriod = /\b(price|pricing|cost|fee|rate|how much|estimate|quote|pay|total)\b/.test(q) || !!detectRentalPeriod(q);
    if (hasPriceOrPeriod) return false;

    addTypingIndicator();
    fetchRentalProduct(entity.product).then(function (shopifyProduct) {
      removeTypingIndicators();
      var info = v102ExtractLiveCatalogue(entity.product, shopifyProduct);
      var found = v103CatalogueHasEntity(info, entity);
      if (found) {
        replyBot(entity.label + ' is detected on the current ' + entity.product.label + ' rental options. What rental duration would you like to check?', function () {
          priceState = { raw: entity.product.label + ' ' + entity.label };
          addPriceChipRow(getAvailablePeriodChipItems(entity.product));
          addActionRow(['price_flow', 'live_agent', 'main_menu']);
        });
      } else {
        var lines = [entity.label + ' is not detected from the current ' + entity.product.label + ' rental page options.'];
        if (entity.type === 'graphics' && info.graphics.length) {
          lines.push('', 'GPU options currently detected:', '• ' + info.graphics.join('\n• '));
        } else if (entity.type === 'processor' && info.processors.length) {
          lines.push('', 'Business Laptop options currently detected:', '• ' + info.processors.join('\n• '));
        }
        lines.push('', 'You may WhatsApp us if you want us to check a specific upcoming or newly added option.');
        addBotMessage(lines.join('\n'));
        addActionRow([entity.product.viewAction || 'view_rental', 'price_flow', 'live_agent', 'main_menu']);
      }
      saveState();
    }).catch(function () {
      removeTypingIndicators();
      replyBot('I could not read the current rental page options at the moment. Please check the rental page or WhatsApp us for the latest options.', function () {
        addActionRow([entity.product.viewAction || 'view_rental', 'live_agent', 'main_menu']);
      });
    });
    return true;
  }


  /* v105 Recommendation-to-Price Refinement
     When a customer asks for price immediately after a recommendation, keep only the recommended product category
     and ask for the exact model/tier. Do not quote a specific model unless the user explicitly selected it. */

  function v105ProductFromKey(key) {
    return v102GetRentalPriceProductByKey(key || '');
  }

  function v105ProductFromDeviceLabel(label) {
    var q = normalise(label || '');
    if (!q) return null;
    if (/^gaming laptop$/.test(q) || /^gaming$/.test(q)) return v105ProductFromKey('gaming');
    if (/^business laptop$/.test(q) || /^windows business laptop$/.test(q) || /^windows laptop$/.test(q)) return v105ProductFromKey('business');
    if (/^macbook$/.test(q) || /^macbook air$/.test(q) || /^macbook pro$/.test(q)) return v105ProductFromKey('macbook');
    if (/^ipad$/.test(q) || /^tablet$/.test(q)) return v105ProductFromKey('ipad');
    return null;
  }

  function v105ProductFromAnswerMeta() {
    var id = lastAnswerMeta && lastAnswerMeta.answerId ? String(lastAnswerMeta.answerId) : '';
    if (!id) return null;
    if (/^(gaming_game_recommendation|gaming_higher_fps|gaming_better_graphics|gaming_event_rental|v100_device_recommendation_gaming|v87_rental_entry_gaming)$/.test(id)) return v105ProductFromKey('gaming');
    if (/^(v100_device_recommendation_office|v100_device_recommendation_exam|v87_rental_entry_business|business_laptop_overview)$/.test(id)) return v105ProductFromKey('business');
    if (/^(v87_rental_entry_macbook|macbook_overview|macbook_selectable)$/.test(id)) return v105ProductFromKey('macbook');
    if (/^(v87_rental_entry_ipad|ipad_overview|v100_device_recommendation_event)$/.test(id)) return v105ProductFromKey('ipad');
    return null;
  }

  function v105HasActiveMainMenuReset() {
    return !!(conversationContext && conversationContext.lastPriceResetReason === 'main_menu');
  }

  function v105GetContextualPriceProduct() {
    if (!conversationContext) return null;
    if (conversationContext.confirmedPriceDevice) return null;

    var fromRecommendedKey = conversationContext.recommendedPriceProductKey ? v105ProductFromKey(conversationContext.recommendedPriceProductKey) : null;
    if (fromRecommendedKey) return fromRecommendedKey;

    var fromMeta = v105ProductFromAnswerMeta();
    if (fromMeta) return fromMeta;

    if (v105HasActiveMainMenuReset()) return null;

    var fromDevice = v105ProductFromDeviceLabel(conversationContext.device || '');
    if (fromDevice) return fromDevice;

    return null;
  }

  function v105BuildContextualPriceSeed(product, text) {
    var seed = 'price ' + (product && product.label ? product.label : '');
    var duration = detectRentalPeriod(text || '') || null;
    if (!duration && conversationContext && conversationContext.duration && !conversationContext.confirmedPriceDevice) {
      duration = detectRentalPeriod(conversationContext.duration);
    }
    if (duration && isRentalPeriodAllowedForProduct(duration, product)) seed += ' ' + duration.label;
    return seed;
  }

  function v105ShowContextualPricePrompt(product, sourceText, source) {
    if (!product) return false;
    resetQuestionContext();
    liveState = null;
    feedbackState = null;
    confirmState = null;
    chatEnded = false;
    v102ClearConfirmedPriceContext('v105_contextual_price_' + (source || 'typed'));
    conversationContext.device = product.label;
    conversationContext.lastIntent = 'price';
    conversationContext.lastPriceProductKey = product.key || '';
    conversationContext.recommendedPriceProductKey = product.key || '';
    saveState();
    var seed = v105BuildContextualPriceSeed(product, sourceText || '');
    priceState = { raw: seed };
    showRentalPriceEstimate(seed);
    trackPlaybotEvent('contextual_price_prompt', { query: sourceText || '', product: product.key || '', botOutcome: 'v105_recommendation_to_price' });
    return true;
  }

  function v105MaybeHandleContextualGenericPriceRequest(text) {
    if (!v101IsGenericPriceRequest(text)) return false;
    var product = v105GetContextualPriceProduct();
    if (!product) return false;
    return v105ShowContextualPricePrompt(product, text, 'typed_generic_price');
  }

  function v105MaybeStartContextualPriceFlowFromAction() {
    var product = v105GetContextualPriceProduct();
    if (!product) return false;
    return v105ShowContextualPricePrompt(product, 'Check rental price', 'button');
  }

  function maybeHandleV100PriorityIntent(text) {
    var q = normalise(text || '');
    if (!q) return false;

    if (v101IsShortCleanFollowUp(q)) {
      showAnswer(findIntentById('clean_formatted_before_delivery'));
      return true;
    }

    if (v101Is32gbMemoryPriceQuestion(q)) {
      showV101MemoryAddonAnswer();
      return true;
    }

    if (v101IsBroadAdviceRequest(q)) {
      showV100DeviceRecommendationPrompt();
      return true;
    }

    if (v100IsGenericRentalOnly(q)) {
      showV87DeviceCategoryOptions(q);
      return true;
    }

    if (v100IsDeviceConditionQuestion(q)) {
      showAnswer(findIntentById(v100DeviceConditionIntentId(q)) || findIntentById('device_condition'));
      return true;
    }

    if (v100IsPaymentDeliveryConfirmationQuestion(q)) {
      showAnswer(findIntentById('payment_delivery_confirmation'));
      return true;
    }

    if (v100IsReturnCollectionFeeQuestion(q)) {
      showAnswer(findIntentById('return_collection_fee'));
      return true;
    }

    var feeIntent = v100FeePolicyIntentId(q);
    if (feeIntent) {
      showAnswer(findIntentById(feeIntent));
      return true;
    }

    if (v100IsPriceObjection(q)) {
      showAnswer(findIntentById('price_objection'));
      return true;
    }

    if (v100IsDeviceRecommendationQuestion(q)) {
      showV100DeviceRecommendationPrompt();
      return true;
    }

    return false;
  }

  /* v87 Rental Entry Router
     High-intent rental-start phrases must be handled before FAQ scoring.
     Examples: "I want to lease a laptop", "I want to rent a device", "rent an iPad".
     Broad device terms open guided device choices. Specific device terms show available tiers/models. */

  function v87HasRentalStarter(text) {
    var q = normalise(text || '');
    if (!q) return false;
    return /\b(i want to rent|want to rent|i need to rent|need to rent|looking to rent|looking for rental|looking for a rental|looking for rent|want rental|need rental|rent a|rent an|rent the|rent laptop|rent device|rent ipad|rent macbook|lease a|lease an|lease laptop|lease device|lease ipad|lease macbook|hire a|hire an|hire laptop|borrow a|borrow an|borrow laptop|do you rent|can i rent|can rent|i want to lease|want to lease|need to lease|rental enquiry|rental inquiry)\b/.test(q) ||
      (/\b(rent|rental|lease|leasing|hire|borrow)\b/.test(q) && /\b(laptop|device|macbook|ipad|tablet|business laptop|windows laptop|gaming laptop)\b/.test(q));
  }

  function v87IsPolicyOrFaqQuestion(text) {
    var q = normalise(text || '');
    if (!q) return false;

    // These are policy/support questions even though they may contain "rent".
    if (v90IsBrandModelPreference(q)) return true;
    if (v100IsDeviceConditionQuestion(q) || v100IsPaymentDeliveryConfirmationQuestion(q) || v100IsReturnCollectionFeeQuestion(q) || v100IsPriceObjection(q) || v100FeePolicyIntentId(q)) return true;
    if (/\b(without documents|without document|no nric|skip documents|no proof|deposit|deduct|minus|refund deposit|waive|offset|late return|return late|return earlier|early return|damage|damaged|scratch|lost|stolen|software|compatible|can run|support|admin access|internet|wifi|sim card|mobile data|delivery charge|deliver charge|missed delivery|missed collection|self collect|self return|scam|trust|preowned|pre-owned|used|second hand|clean|cleaned|condition|too expensive|cheaper|budget|discount)\b/.test(q)) return true;

    // Reservation/hold wording should stay as payment-confirmation FAQ unless a clear device-start phrase appears.
    if (/\b(reserve|hold|book first|pay later|without payment|before payment)\b/.test(q) && !/\b(i want to rent|want to rent|need to rent|rent a|rent an|lease a|lease an)\b/.test(q)) return true;

    // Process questions should answer the rental process, not open product selection.
    if (/\b(how does rental work|rental process|rental steps|how to rent|how do i rent|how to order|how do i order)\b/.test(q) && !/\b(i want to rent|want to rent|need to rent|rent a|rent an|lease a|lease an)\b/.test(q)) return true;

    return false;
  }

  function v87DetectRentalEntryDevice(text) {
    var q = normalise(text || '');
    if (!q) return '';

    // Specific model/tier first.
    var canonical = getCanonicalDeviceLabelFromText(q);
    if (canonical) {
      if (/^ipad/i.test(canonical)) return 'ipad';
      if (/^macbook/i.test(canonical)) return 'macbook';
      if (/^gaming/i.test(canonical)) return 'gaming';
      if (/^business/i.test(canonical)) return 'business';
    }

    if (/\b(ipad|i pad|tablet)\b/.test(q)) return 'ipad';
    if (/\b(macbook|mac book|mba|mbp|mac laptop|m1|m2|m3|m4|m5)\b/.test(q)) return 'macbook';
    if (/\b(gaming laptop|gaming notebook|rtx|gtx|gpu|game laptop|laptop for gaming)\b/.test(q)) return 'gaming';
    if (/\b(business laptop|windows laptop|office laptop|work laptop|normal laptop|school laptop|exam laptop|i5 laptop|i7 laptop|ryzen laptop)\b/.test(q)) return 'business';

    if (/\b(laptop|notebook|computer|pc)\b/.test(q)) return 'laptop';
    if (/\b(device|devices|equipment|machine|machines)\b/.test(q)) return 'device';
    return '';
  }

  function v87AnalyzeRentalEntry(text) {
    var q = normalise(text || '');
    if (!q || !v87HasRentalStarter(q)) return null;
    if (v87IsPolicyOrFaqQuestion(q)) return null;

    var device = v87DetectRentalEntryDevice(q) || 'device';
    var hasPrice = /\b(how much|price|pricing|cost|fee|rate|quote|quotation|total|payable)\b/.test(q);
    var canonical = getCanonicalDeviceLabelFromText(q);

    return {
      isRentalEntry: true,
      deviceType: device,
      canonicalDevice: canonical || '',
      wantsPrice: hasPrice,
      quantity: detectQuantityFromText(q) || '',
      duration: detectDurationFromText(q) || '',
      startDate: detectStartDateFromText(q) || ''
    };
  }

  function v87RentalEntryButton(label, value) {
    return '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-rental-entry-value="' + escapeHtml(value || label) + '">' + escapeHtml(label) + '</button>';
  }

  function v87ActionButton(label, action) {
    return '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="' + escapeHtml(action) + '">' + escapeHtml(label) + '</button>';
  }

  function v87PriceButton(label, value) {
    return '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-price-value="' + escapeHtml(value || label) + '">' + escapeHtml(label) + '</button>';
  }

  function v87IntentButton(label, intent) {
    return '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-intent="' + escapeHtml(intent) + '">' + escapeHtml(label) + '</button>';
  }

  function v87AddEntryCards(cards) {
    var wrap = document.createElement('div');
    wrap.className = 'pf-playbot-card-grid pf-playbot-card-grid-compact';
    var html = '';
    for (var i = 0; i < cards.length; i += 1) {
      html += '<div class="pf-playbot-card">' +
        '<div class="pf-playbot-card-title">' + escapeHtml(cards[i].title || '') + '</div>' +
        '<div class="pf-playbot-card-list">' + (cards[i].buttons || '') + '</div>' +
      '</div>';
    }
    wrap.innerHTML = html;
    messages.appendChild(wrap);
    scrollToBottom();
  }

  function showV87LaptopCategoryOptions(text) {
    conversationContext.device = '';
    conversationContext.lastIntent = 'rental_entry_laptop';
    saveState();
    setLastAnswerMeta('v87_rental_entry_laptop', 'Rental entry laptop selection', 'Rental Entry', 'clarification');
    replyBot('Sure. Are you looking for a Windows Business Laptop, MacBook, or Gaming Laptop?', function () {
      v87AddEntryCards([
        {
          title: 'Laptop rental options',
          buttons:
            v87ActionButton('Windows business laptop', 'v87_rent_business') +
            v87ActionButton('MacBook', 'v87_rent_macbook') +
            v87ActionButton('Gaming laptop', 'v87_rent_gaming') +
            v87ActionButton('Not sure, help me choose', 'rental_product')
        }
      ]);
      addActionRow(['price_flow', 'live_agent', 'main_menu']);
    });
  }

  function showV87DeviceCategoryOptions(text) {
    conversationContext.device = '';
    conversationContext.recommendedPriceProductKey = '';
    conversationContext.lastIntent = 'rental_entry_device';
    saveState();
    setLastAnswerMeta('v87_rental_entry_device', 'Rental entry device selection', 'Rental Entry', 'clarification');
    replyBot('Sure. What type of device are you looking to rent?', function () {
      v87AddEntryCards([
        {
          title: 'Device categories',
          buttons:
            v87ActionButton('Business laptop', 'v87_rent_business') +
            v87ActionButton('Gaming laptop', 'v87_rent_gaming') +
            v87ActionButton('MacBook', 'v87_rent_macbook') +
            v87ActionButton('iPad', 'v87_rent_ipad') +
            v87ActionButton('Not sure, help me choose', 'rental_product')
        }
      ]);
      addActionRow(['price_flow', 'live_agent', 'main_menu']);
    });
  }

  function showV87BusinessRentalOptions(sourceText) {
    conversationContext.device = getCanonicalDeviceLabelFromText(sourceText || '') || 'Business Laptop';
    conversationContext.recommendedPriceProductKey = 'business';
    conversationContext.lastIntent = 'rental_entry_business';
    saveState();
    setLastAnswerMeta('v87_rental_entry_business', 'Business laptop rental options', 'Rental Entry', 'answered');
    replyBot('Sure. Playforce has Windows Business Laptop rental options for office, school, training, exams, and general productivity.', function () {
      v87AddEntryCards([
        {
          title: 'Business laptop options',
          buttons:
            v87RentalEntryButton('Business laptop i5 or Ryzen 5', 'Business Laptop i5 or Ryzen 5') +
            v87RentalEntryButton('Business laptop i7 or Ryzen 7', 'Business Laptop i7 or Ryzen 7') +
            v87RentalEntryButton('Ultra 5 / Ryzen 5 (New)', 'Business Laptop Ultra 5 / Ryzen 5 (New)') +
            v87RentalEntryButton('Ultra 7 / Ryzen 7 (New)', 'Business Laptop Ultra 7 / Ryzen 7 (New)') +
            v87PriceButton('Check business laptop price', 'Business Laptop') +
            v87ActionButton('View business rental page', 'view_business')
        }
      ]);
      addActionRow(['rent_device_flow', 'live_agent', 'main_menu']);
    });
  }

  function showV87GamingRentalOptions(sourceText) {
    conversationContext.device = getCanonicalDeviceLabelFromText(sourceText || '') || 'Gaming Laptop';
    conversationContext.recommendedPriceProductKey = 'gaming';
    conversationContext.lastIntent = 'rental_entry_gaming';
    saveState();
    setLastAnswerMeta('v87_rental_entry_gaming', 'Gaming laptop rental options', 'Rental Entry', 'answered');
    replyBot('Sure. Playforce has Gaming Laptop rental by GPU tier. Exact brand or model depends on availability.', function () {
      v87AddEntryCards([
        {
          title: 'Gaming laptop tiers',
          buttons:
            v87RentalEntryButton('Entry gaming: GTX 1650 or RTX 3050', 'Gaming Laptop GTX 1650 or RTX 3050') +
            v87RentalEntryButton('Performance: RTX 3060, RTX 4050 or RTX 5050', 'Gaming Laptop RTX 3060 RTX 4050 RTX 5050') +
            v87RentalEntryButton('High-performance: RTX 3070, RTX 3080, RTX 4060 or RTX 4070', 'Gaming Laptop RTX 3070 RTX 3080 RTX 4060 RTX 4070') +
            v87RentalEntryButton('Best available: RTX 5080', 'Gaming Laptop RTX 5080') +
            v87IntentButton('Recommend by game', 'gaming_game_recommendation') +
            v87PriceButton('Check gaming laptop price', 'Gaming Laptop') +
            v87ActionButton('View gaming rental page', 'view_gaming')
        }
      ]);
      addActionRow(['rent_device_flow', 'live_agent', 'main_menu']);
    });
  }

  function showV87MacbookRentalOptions(sourceText) {
    conversationContext.device = getCanonicalDeviceLabelFromText(sourceText || '') || 'MacBook';
    conversationContext.recommendedPriceProductKey = 'macbook';
    conversationContext.lastIntent = 'rental_entry_macbook';
    saveState();
    setLastAnswerMeta('v87_rental_entry_macbook', 'MacBook rental options', 'Rental Entry', 'answered');
    replyBot('Sure. Playforce has MacBook rental options including MacBook Air and MacBook Pro tiers.', function () {
      v87AddEntryCards([
        {
          title: 'MacBook Air',
          buttons:
            v87RentalEntryButton('MacBook Air M1', 'MacBook Air M1') +
            v87RentalEntryButton('MacBook Air M2', 'MacBook Air M2') +
            v87RentalEntryButton('MacBook Air M4', 'MacBook Air M4') +
            v87PriceButton('Check MacBook Air price', 'MacBook Air')
        },
        {
          title: 'MacBook Pro',
          buttons:
            v87RentalEntryButton('MacBook Pro M1', 'MacBook Pro M1') +
            v87RentalEntryButton('MacBook Pro M1 Pro', 'MacBook Pro M1 Pro') +
            v87RentalEntryButton('MacBook Pro M2 Pro', 'MacBook Pro M2 Pro') +
            v87RentalEntryButton('MacBook Pro M3 Pro', 'MacBook Pro M3 Pro') +
            v87RentalEntryButton('MacBook Pro M4 Pro', 'MacBook Pro M4 Pro') +
            v87PriceButton('Check MacBook Pro price', 'MacBook Pro') +
            v87ActionButton('View MacBook rental page', 'view_macbook')
        }
      ]);
      addActionRow(['rent_device_flow', 'live_agent', 'main_menu']);
    });
  }

  function showV87IpadRentalOptions(sourceText) {
    conversationContext.device = getCanonicalDeviceLabelFromText(sourceText || '') || 'iPad';
    conversationContext.recommendedPriceProductKey = 'ipad';
    conversationContext.lastIntent = 'rental_entry_ipad';
    saveState();
    setLastAnswerMeta('v87_rental_entry_ipad', 'iPad rental options', 'Rental Entry', 'answered');
    replyBot('Sure. Playforce has these iPad rental options. You can choose a model, or tell me your quantity, rental duration, and start date.', function () {
      v87AddEntryCards([
        {
          title: 'iPad models',
          buttons:
            v87RentalEntryButton('iPad 8th gen', 'iPad 8th Gen') +
            v87RentalEntryButton('iPad 9th gen', 'iPad 9th Gen') +
            v87RentalEntryButton('iPad 10th gen', 'iPad 10th Gen') +
            v87RentalEntryButton('iPad Air 5th gen', 'iPad Air 5th Gen') +
            v87RentalEntryButton('iPad Pro M1', 'iPad Pro M1') +
            v87RentalEntryButton('iPad Pro M2', 'iPad Pro M2') +
            v87PriceButton('Check iPad price', 'iPad') +
            v87ActionButton('View iPad rental page', 'view_ipad')
        }
      ]);
      addActionRow(['rent_device_flow', 'live_agent', 'main_menu']);
    });
  }

  function showV87RentalEntryForText(text) {
    var analysis = v87AnalyzeRentalEntry(text);
    if (!analysis) return false;

    updateConversationMemory(text || 'Rental enquiry', 'rental_entry');
    trackPlaybotEvent('rental_entry_router', {
      query: text,
      deviceType: analysis.deviceType || '',
      canonicalDevice: analysis.canonicalDevice || '',
      quantity: analysis.quantity || '',
      duration: analysis.duration || '',
      startDate: analysis.startDate || '',
      botOutcome: 'rental_entry_detected'
    });

    if (analysis.wantsPrice && (analysis.canonicalDevice || analysis.deviceType !== 'device' && analysis.deviceType !== 'laptop')) {
      showRentalPriceEstimate(applyMemoryToText(text));
      return true;
    }

    if (analysis.deviceType === 'business') {
      showV87BusinessRentalOptions(text);
      return true;
    }
    if (analysis.deviceType === 'gaming') {
      showV87GamingRentalOptions(text);
      return true;
    }
    if (analysis.deviceType === 'macbook') {
      showV87MacbookRentalOptions(text);
      return true;
    }
    if (analysis.deviceType === 'ipad') {
      showV87IpadRentalOptions(text);
      return true;
    }
    if (analysis.deviceType === 'laptop') {
      showV87LaptopCategoryOptions(text);
      return true;
    }

    showV87DeviceCategoryOptions(text);
    return true;
  }

  function startV87RentalEntryValue(value) {
    var device = String(value || '').trim();
    if (!device) return false;
    conversationContext.device = device;
    conversationContext.lastIntent = 'rental_entry_selected_device';
    saveState();
    setLastAnswerMeta('v87_rental_entry_selected_device', 'Selected rental device from entry router', 'Rental Entry', 'answered');
    replyBot('Great. I’ll note this as: ' + device + '.\n\nTo help with rental, please share your quantity, rental start date, and rental duration. You can also check price or WhatsApp us below.', function () {
      addActionRow(['price_flow', 'rent_device_flow', 'live_agent', 'main_menu']);
    });
    return true;
  }


  function isLiveAgentRequest(text) {
    var q = normalise(text);
    return /\b(agent|human|staff|person|whatsapp|wa|contact|someone|playforce team|sales)\b/.test(q) && /\b(speak|talk|connect|chat|assist|help|contact|whatsapp|wa|ask)\b/.test(q);
  }

  function isFeedbackRequest(text) {
    var q = normalise(text);
    return /\b(feedback|feedbacks|review|suggestion|suggestions|complain|complaint|complaints|unhappy)\b/.test(q);
  }

  function isGreeting(text) {
    var q = normalise(text);
    return /^(hi|hello|hey|good morning|good afternoon|good evening)$/i.test(q);
  }

  function isPoliteAcknowledgement(text) {
    var q = normalise(text);
    if (!q) return false;

    // Only treat short standalone acknowledgements as a polite close.
    // Messages like "ok can I rent a MacBook" should continue through normal intent detection.
    return /^(thanks|thank you|thank u|thx|ty|ok thanks|okay thanks|ok thank you|okay thank you|noted thanks|alright thanks|sure thanks|thanks a lot|thanks alot|thank you very much|got it|ok got it|okay got it|understood|noted|okay|ok|alright|cool|great|nice)$/i.test(q);
  }

  function isSimpleAcknowledgement(text) {
    var q = normalise(text);
    return /^(got it|ok got it|okay got it|understood|noted|okay|ok|alright|cool|great|nice)$/i.test(q);
  }

  function getPoliteAcknowledgementReply(text) {
    if (isSimpleAcknowledgement(text)) {
      return 'Got it. You can continue asking here anytime.';
    }
    return 'You’re welcome. 😊\n\nIf you need anything else, you can continue asking here, start a rental enquiry, or WhatsApp us for assistance.';
  }

  function isGenericHelpRequest(text) {
    var q = normalise(text);
    return /^(help|need help|i need help|i need your help|need assistance|i need assistance|need assist|i need assist|need support|i need support|require assistance|require help|assistance needed|support please|can you help|can help|can you assist|can assist|assist me|help me)$/i.test(q);
  }

  function isFrustration(text) {
    var q = normalise(text);
    return /\b(not answering|not helpful|not useful|not clear|wrong answer|answering wisely|wisely|useless|bad answer|cannot answer)\b/.test(q);
  }

  function isTrustQuestion(text) {
    var q = normalise(text);
    return /\b(playforce|rental|you|this)\b/.test(q) && /\b(good|trust|trusted|trustworthy|reliable|legit|legitimate|scam|safe|review|reviews|uen|registered)\b/.test(q);
  }

  function isScamConcern(text) {
    var q = normalise(text);
    return /\b(scam|scammer|fake|fraud|fraudulent)\b/.test(q);
  }

  function isSameDayDeliveryQuestion(text) {
    var q = normalise(text);
    return /\b(today|same day|now|asap|immediate|immediately)\b/.test(q) && /\b(deliver|delivery|rent|rental|device|laptop|macbook|ipad)\b/.test(q);
  }

  function isDamageStatement(text) {
    var q = normalise(text);
    return /\b(damage|damaged|spoil|spoiled|spoilt|crack|cracked|broke|broken|screen|keyboard)\b/.test(q) && /\b(laptop|device|macbook|ipad|rental|it|screen|keyboard)\b/.test(q);
  }

  function isLostStatement(text) {
    var q = normalise(text);
    if (isLateReturnConcern(q)) return false;
    return /\b(lost|stolen|missing)\b/.test(q) && /\b(laptop|device|macbook|ipad|rental|it)\b/.test(q);
  }

  function isLateReturnConcern(text) {
    var q = normalise(text);
    if (!q) return false;
    return /\b(late return|return late|overdue|late fee|late charge|late penalty|late fine|miss return|missed return|miss collection|missed collection|forgot return|forgot to return|cannot return today|cant return today|return tomorrow|return next day|return after due date|after due date|after rental end|past return date|fine for late return|charge for late return)\b/.test(q) ||
      (/\b(late|overdue)\b/.test(q) && /\b(return|rental|fee|charge|pay|penalty|fine)\b/.test(q)) ||
      (/\b(how much|need pay|need to pay|pay|charge|fee|fine|penalty)\b/.test(q) && /\b(late|overdue)\b/.test(q) && /\b(return|rental)\b/.test(q));
  }

  function isEarlyReturnConcern(text) {
    var q = normalise(text);
    if (!q) return false;
    if (/\b(late|overdue|after due date|after rental end|missed collection|miss collection)\b/.test(q)) return false;
    return /\b(early return|return early|return earlier|return before end|return before rental end|finish earlier|finish using earlier|end rental early|return ahead|return in advance|return sooner)\b/.test(q) ||
      (/\b(return|end rental|finish)\b/.test(q) && /\b(early|earlier|sooner|before end|before rental end)\b/.test(q));
  }

  function isRentalExtensionConcern(text) {
    var q = normalise(text);
    if (!q) return false;
    if (/\b(return timing|return slot|collection timing|same day return timing|same return date)\b/.test(q)) return false;
    return /\b(extend rental|rental extension|extend one more day|extend a few days|keep longer|use longer|need more days|need the device longer|not ready to return|can extend instead|extend instead|extend before return)\b/.test(q) ||
      (/\b(extend|extension)\b/.test(q) && /\b(rental|rent|device|laptop|macbook|ipad|more days|longer)\b/.test(q));
  }


  function isDepositDeductionConcern(text) {
    var q = normalise(text);
    if (!q) return false;
    var directDeduction = /\b(deduct|deduction|minus|cut deposit|forfeit|lose my deposit|lose deposit|charged|charge me|compensate|compensation|pay extra)\b/.test(q) ||
      q.indexOf('deposit kena deduct') !== -1 ||
      q.indexOf('deposit kena minus') !== -1 ||
      q.indexOf('will you deduct') !== -1 ||
      q.indexOf('will you minus') !== -1;
    var deviceCareContext = /\b(deposit|security deposit|scratch|cosmetic|defect|mark|dent|damage|damaged|fault|faulty|spoil|spoiled|spoilt|keyboard|display|screen|motherboard|water|liquid|drop|dropped|fall|crack|broken|lost|stolen|missing|accessory|charger|mouse|bag)\b/.test(q);
    return directDeduction && deviceCareContext;
  }

  function isExistingCosmeticDefectConcern(text) {
    var q = normalise(text);
    return /\b(existing|already|before delivery|documented)\b/.test(q) && /\b(cosmetic|scratch|scratches|defect|defects|mark|marks|damage)\b/.test(q);
  }

  function isSmallScratchConcern(text) {
    var q = normalise(text);
    return /\b(small scratch|slight scratch|cosmetic scratch|minor scratch|scratch|scratches)\b/.test(q) && !/\b(crack|cracked|dent|dented|water|liquid|drop|dropped|fall)\b/.test(q);
  }

  function isDamagePaymentAmountConcern(text) {
    var q = normalise(text);
    return /\b(how much|need pay|need to pay|pay extra|compensation|repair cost|replacement cost)\b/.test(q) && /\b(damage|damaged|deduct|minus|scratch|crack|dent|water|liquid|lost|stolen|missing)\b/.test(q);
  }

  function applyPlaybotLanguageSynonyms(text) {
    var q = ' ' + String(text || '') + ' ';

    // Common customer shorthand and abbreviations.
    q = q.replace(/\bmac\s+book\b/g, ' macbook ');
    q = q.replace(/\bmba\b/g, ' macbook air ');
    q = q.replace(/\bmbp\b/g, ' macbook pro ');
    q = q.replace(/\bmb\b/g, ' macbook ');

    // Device wording variations.
    q = q.replace(/\bnotebook\b/g, ' laptop ');
    q = q.replace(/\bcomputer\b/g, ' laptop ');
    q = q.replace(/\bpc\b/g, ' laptop ');
    q = q.replace(/\blappy\b/g, ' laptop ');
    q = q.replace(/\btablet\b/g, ' ipad ');
    q = q.replace(/\bwindows\s+notebook\b/g, ' windows laptop ');
    q = q.replace(/\boffice\s+laptop\b/g, ' business laptop ');
    q = q.replace(/\bnormal\s+laptop\b/g, ' business laptop ');
    q = q.replace(/\bwork\s+laptop\b/g, ' business laptop ');
    q = q.replace(/\bhigh\s+performance\s+laptop\b/g, ' gaming laptop ');
    q = q.replace(/\bgpu\s+laptop\b/g, ' gaming laptop ');
    q = q.replace(/\brtx\s+laptop\b/g, ' gaming laptop ');

    // Rental intent variations. Treat lease/borrow/hire/book as rental intent for this assistant.
    q = q.replace(/\b(rentals|rental|renting|rented)\b/g, ' rent ');
    q = q.replace(/\b(lease|leases|leasing|leased)\b/g, ' rent ');
    q = q.replace(/\b(borrow|borrows|borrowing|borrowed)\b/g, ' rent ');
    q = q.replace(/\b(hire|hires|hiring|hired)\b/g, ' rent ');
    q = q.replace(/\b(book|books|booking|booked|reserve|reserves|reserved|reservation)\b/g, ' rent ');

    // Availability and urgency wording.
    q = q.replace(/\bgot\s+stock\b/g, ' available stock ');
    q = q.replace(/\bstill\s+have\b/g, ' available stock ');
    q = q.replace(/\bhave\s+stock\b/g, ' available stock ');
    q = q.replace(/\bavailable\b/g, ' available ');
    q = q.replace(/\basap\b/g, ' urgent ');
    q = q.replace(/\bimmediate\b/g, ' urgent ');
    q = q.replace(/\bimmediately\b/g, ' urgent ');
    q = q.replace(/\brush\b/g, ' urgent ');

    // Singapore-style / casual variations.
    q = q.replace(/\banot\b/g, ' or not ');
    q = q.replace(/\bah\b/g, ' ');
    q = q.replace(/\bwanna\b/g, ' want to ');
    q = q.replace(/\bwan\s+to\b/g, ' want to ');
    q = q.replace(/\bneed\s+rent\b/g, ' need to rent ');
    q = q.replace(/\bwant\s+rent\b/g, ' want to rent ');
    q = q.replace(/\bcan\s+rent\b/g, ' can rent ');

    // Commercial wording variations.
    q = q.replace(/\bquotations\b/g, ' quote ');
    q = q.replace(/\bquotation\b/g, ' quote ');
    q = q.replace(/\binvoices\b/g, ' invoice ');
    q = q.replace(/\breceipts\b/g, ' receipt ');
    q = q.replace(/\brates\b/g, ' rate ');
    q = q.replace(/\bfees\b/g, ' fee ');
    q = q.replace(/\bcosts\b/g, ' cost ');

    // Fault / change wording variations.
    q = q.replace(/\bspoilt\b/g, ' faulty ');
    q = q.replace(/\bspoil\b/g, ' faulty ');
    q = q.replace(/\bspoiled\b/g, ' faulty ');
    q = q.replace(/\bcannot\s+on\b/g, ' cannot turn on ');
    q = q.replace(/\bcant\s+on\b/g, ' cannot turn on ');
    q = q.replace(/\bswap\b/g, ' change ');
    q = q.replace(/\bswitch\b/g, ' change ');
    q = q.replace(/\btop\s*up\b/g, ' top up ');

    return q.replace(/\s+/g, ' ').trim();
  }

  function normalise(text) {
    var cleaned = String(text || '')
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9$+\s.-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return applyPlaybotLanguageSynonyms(cleaned);
  }

  function priceNormalise(text) {
    return normalise(text).replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
  }

  var rentalPriceProductCache = {};
  var rentalPriceVariantCache = {};

  var rentalPriceExtraConfigs = [
    { key: 'ms_office', label: 'Microsoft Office optional extra', terms: ['ms office', 'microsoft office', 'office', 'word', 'excel', 'powerpoint'], productKeys: ['gaming', 'macbook'], variantId: '47939117285563' },
    { key: 'gaming_32gb', label: '32GB RAM optional extra', terms: ['32gb', '32 gb', '32gb ram', '32 gb ram', 'ram upgrade', 'memory upgrade'], productKeys: ['gaming'], variantId: '47939116859579' },
    { key: 'ipad_cellular', label: 'Cellular optional extra', terms: ['cellular', 'sim card', 'sim', 'mobile data', 'data plan'], productKeys: ['ipad'], variantId: '47943498989755' },
    { key: 'ipad_pencil', label: 'Apple Pencil optional extra', terms: ['apple pencil', 'pencil', 'stylus'], productKeys: ['ipad'], variantId: '47943499776187' },
    { key: 'priority_delivery', label: 'Priority Delivery 8am–10am', terms: ['priority delivery', '8am 10am', '8 10am', '8am to 10am', '8-10am', '8 to 10'], fixedCents: 3000 },
    { key: 'priority_urgent', label: 'Priority Urgent Charge 11am–1pm', terms: ['priority urgent', '11am 1pm', '11 1pm', '11am to 1pm', '11-1pm'], variantId: '47943772995771' },
    { key: 'standard_urgent', label: 'Standard Urgent Charge 1pm–3pm', terms: ['standard urgent', '1pm 3pm', '1 3pm', '1pm to 3pm', '1-3pm'], variantId: '47943771488443' },
    { key: 'standard_return_extension', label: 'Standard Return Extension 1pm–3pm', terms: ['standard return extension', 'return extension 1pm 3pm', 'return 1pm 3pm', 'return 1-3pm'], variantId: '47943792853179' },
    { key: 'priority_return_extension', label: 'Priority Return Extension 3pm–5pm', terms: ['priority return extension', 'return extension 3pm 5pm', 'return 3pm 5pm', 'return 3-5pm'], variantId: '47943796097211' },
    { key: 'weekend_surcharge', label: 'Weekend surcharge', terms: ['weekend', 'saturday', 'sunday'], fixedCents: 5000 },
    { key: 'different_return_location', label: 'Different return location', terms: ['different return location', 'different return address', 'return another location', 'return another address'], fixedCents: 1500 },
    { key: 'mbs_surcharge', label: 'MBS or Marina Bay Sands surcharge', terms: ['mbs', 'marina bay sands'], fixedCents: 3000 }
  ];

  var rentalPriceIncludedNoteConfigs = [
    { key: 'business_office', label: 'Microsoft Office is included for Business Laptop rental.', terms: ['ms office', 'microsoft office', 'office', 'word', 'excel', 'powerpoint'], productKeys: ['business'] }
  ];

  var rentalPeriodConfigs = [
    { key: '3_month', label: '3 Month', terms: ['3 month', '3 months', '3 mth', '3 mths', 'three month', 'three months'] },
    { key: '2_month', label: '2 Month', terms: ['2 month', '2 months', '2 mth', '2 mths', 'two month', 'two months'] },
    { key: '1_month', label: '1 Month', terms: ['1 month', '1 months', '1 mth', 'one month', 'one months', 'a month', 'monthly'] },
    { key: '2_week', label: '2 Week', terms: ['2 week', '2 weeks', '2 wk', '2 wks', 'two week', 'two weeks'] },
    { key: '1_week', label: '1 Week', terms: ['1 week', '1 weeks', '1 wk', 'one week', 'one weeks', 'weekly'] },
    { key: '5_day', label: '5 Day', terms: ['5 day', '5 days', 'five day', 'five days'] },
    { key: '3_day', label: '3 Day', terms: ['3 day', '3 days', 'three day', 'three days'] },
    { key: '2_day', label: '2 Day', terms: ['2 day', '2 days', 'two day', 'two days'] },
    { key: '1_day', label: '1 Day', terms: ['1 day', '1 days', 'one day', 'one days', 'daily'] }
  ];

  var rentalPriceProducts = [
    {
      key: 'macbook',
      label: 'MacBook',
      handle: 'macbook-rental',
      viewAction: 'view_macbook',
      pageUrl: rentalLinks.macbook,
      deviceTerms: ['macbook', 'mac book', 'mba', 'mbp', 'imac'],
      modelPrompt: 'Could you tell me which MacBook or iMac model you need before advising the pricing? For example: MacBook Air M1, MacBook Air M4, MacBook Pro M5 Pro, MacBook Pro M3 Max, or iMac M1.',
      models: [
        { key: 'imac_m1', label: 'iMac M1', terms: ['imac m1', 'm1 imac', 'imac'], depositVariantId: '48220729606331' },
        { key: 'macbook_pro_m5_pro', label: 'MacBook Pro M5 Pro', terms: ['macbook pro m5 pro', 'mbp m5 pro', 'm5 pro macbook pro'], depositVariantId: '48220744155323' },
        { key: 'macbook_pro_m3_max', label: 'MacBook Pro M3 Max', terms: ['macbook pro m3 max', 'mbp m3 max', 'm3 max macbook pro'], depositVariantId: '48000175931579' },
        { key: 'macbook_pro_m4_pro', label: 'MacBook Pro M4 Pro', terms: ['macbook pro m4 pro', 'mbp m4 pro', 'm4 pro macbook pro'], depositVariantId: '47939193307323' },
        { key: 'macbook_pro_m3_pro', label: 'MacBook Pro M3 Pro', terms: ['macbook pro m3 pro', 'mbp m3 pro', 'm3 pro macbook pro'], depositVariantId: '47939192258747' },
        { key: 'macbook_pro_m2_pro', label: 'MacBook Pro M2 Pro', terms: ['macbook pro m2 pro', 'mbp m2 pro', 'm2 pro macbook pro'], depositVariantId: '47939191931067' },
        { key: 'macbook_pro_m1_pro', label: 'MacBook Pro M1 Pro', terms: ['macbook pro m1 pro', 'mbp m1 pro', 'm1 pro macbook pro'], depositVariantId: '47939190161595' },
        { key: 'macbook_air_m5', label: 'MacBook Air M5', terms: ['macbook air m5', 'mba m5', 'air m5'], depositVariantId: '47939187671227' },
        { key: 'macbook_air_m4', label: 'MacBook Air M4', terms: ['macbook air m4', 'mba m4', 'air m4'], depositVariantId: '47939187671227' },
        { key: 'macbook_air_m3', label: 'MacBook Air M3', terms: ['macbook air m3', 'mba m3', 'air m3'] },
        { key: 'macbook_air_m2', label: 'MacBook Air M2', terms: ['macbook air m2', 'mba m2', 'air m2'], depositVariantId: '47939187605691' },
        { key: 'macbook_air_m1', label: 'MacBook Air M1', terms: ['macbook air m1', 'mba m1', 'air m1'], depositVariantId: '47939187343547' },
        { key: 'macbook_pro_m5', label: 'MacBook Pro M5', terms: ['macbook pro m5', 'mbp m5', 'm5 macbook pro'] },
        { key: 'macbook_pro_m4', label: 'MacBook Pro M4', terms: ['macbook pro m4', 'mbp m4', 'm4 macbook pro'] },
        { key: 'macbook_pro_m3', label: 'MacBook Pro M3', terms: ['macbook pro m3', 'mbp m3', 'm3 macbook pro'] },
        { key: 'macbook_pro_m2', label: 'MacBook Pro M2', terms: ['macbook pro m2', 'mbp m2', 'pro m2', 'm2 macbook pro'], depositVariantId: '47939189276859' },
        { key: 'macbook_pro_m1', label: 'MacBook Pro M1', terms: ['macbook pro m1', 'mbp m1', 'pro m1', 'm1 macbook pro'], depositVariantId: '47939188719803' }
      ]
    },
    {
      key: 'business',
      label: 'Business Laptop',
      handle: 'business-laptop-rental',
      viewAction: 'view_business',
      pageUrl: rentalLinks.business,
      deviceTerms: ['business laptop', 'business', 'office laptop', 'windows laptop', 'laptop', 'i5', 'i7', 'i9', 'ryzen 5', 'ryzen 7', 'ryzen 9', 'ultra 5', 'ultra 7', 'ultra 9', 'core ultra'],
      modelPrompt: 'Could you tell me which Business Laptop specification you need before advising the pricing? For example: i5 or Ryzen 5, i7 or Ryzen 7, Ultra 5 / Ryzen 5 (New), or Ultra 7 / Ryzen 7 (New).',
      models: [
        { key: 'business_ultra_7_ryzen_7_new', label: 'Business Laptop Ultra 7 / Ryzen 7 (New)', terms: ['business laptop ultra 7 ryzen 7 new', 'ultra 7 ryzen 7 new', 'ultra 7 ryzen 7', 'ultra 7', 'intel ultra 7', 'core ultra 7', 'ryzen 7 new'], depositVariantId: '48111444099259' },
        { key: 'business_ultra_5_ryzen_5_new', label: 'Business Laptop Ultra 5 / Ryzen 5 (New)', terms: ['business laptop ultra 5 ryzen 5 new', 'ultra 5 ryzen 5 new', 'ultra 5 ryzen 5', 'ultra 5', 'intel ultra 5', 'core ultra 5', 'ryzen 5 new'], depositVariantId: '48111443509435' },
        { key: 'business_i7', label: 'Business Laptop i7 or Ryzen 7', terms: ['business laptop i7', 'business i7', 'i7', 'ryzen 7', 'r7'] },
        { key: 'business_i5', label: 'Business Laptop i5 or Ryzen 5', terms: ['business laptop i5', 'business i5', 'i5', 'ryzen 5', 'r5'] }
      ]
    },
    {
      key: 'gaming',
      label: 'Gaming Laptop',
      handle: 'gaming-laptop-rental',
      viewAction: 'view_gaming',
      pageUrl: rentalLinks.gaming,
      deviceTerms: ['gaming laptop', 'gaming', 'gpu', 'gtx', 'rtx'],
      modelPrompt: 'Could you tell me which Gaming Laptop GPU tier you need before advising the pricing? For example: GTX 1650, RTX 3050, RTX 4050, RTX 5050, RTX 4060, RTX 4070, or RTX 5080.',
      models: [
        { key: 'rtx5080', label: 'Gaming Laptop RTX 5080', terms: ['rtx 5080', '5080'], depositVariantId: '48221763272891' },
        { key: 'rtx5050', label: 'Gaming Laptop RTX 5050', terms: ['rtx 5050', '5050'], depositVariantId: '48205548290235' },
        { key: 'rtx4070', label: 'Gaming Laptop RTX 4070', terms: ['rtx 4070', '4070'], depositVariantId: '47939106078907' },
        { key: 'rtx4060', label: 'Gaming Laptop RTX 4060', terms: ['rtx 4060', '4060'], depositVariantId: '47939105980603' },
        { key: 'rtx4050', label: 'Gaming Laptop RTX 4050', terms: ['rtx 4050', '4050'], depositVariantId: '47939105030331' },
        { key: 'rtx3060', label: 'Gaming Laptop RTX 3060', terms: ['rtx 3060', '3060'], depositVariantId: '47939100672187' },
        { key: 'rtx3050', label: 'Gaming Laptop RTX 3050', terms: ['rtx 3050', '3050'], depositVariantId: '47939100672187' },
        { key: 'rtx2060', label: 'Gaming Laptop RTX 2060', terms: ['rtx 2060', '2060'], depositVariantId: '47939100672187' },
        { key: 'gtx1650', label: 'Gaming Laptop GTX 1650', terms: ['gtx 1650', '1650'], depositVariantId: '47939100672187' }
      ]
    },
    {
      key: 'ipad',
      label: 'iPad',
      handle: 'ipad-rental',
      viewAction: 'view_ipad',
      pageUrl: rentalLinks.ipad,
      deviceTerms: ['ipad', 'ipad air', 'ipad pro', 'tablet'],
      modelPrompt: 'Could you tell me which iPad model you need before advising the pricing? For example: iPad 8th, iPad 8th Cellular, iPad 11th, iPad Air M4, iPad Pro M1, or iPad Pro M2 Cellular.',
      models: [
        { key: 'ipad_pro_m2_cellular', label: 'iPad Pro M2 Cellular', terms: ['ipad pro m2 cellular', 'pro m2 cellular'], depositVariantId: '48199710212283' },
        { key: 'ipad_pro_m2', label: 'iPad Pro M2', terms: ['ipad pro m2', 'pro m2'], depositVariantId: '47940843143355' },
        { key: 'ipad_pro_m1_cellular', label: 'iPad Pro M1 Cellular', terms: ['ipad pro m1 cellular', 'pro m1 cellular'], depositVariantId: '48199710081211' },
        { key: 'ipad_pro_m1', label: 'iPad Pro M1', terms: ['ipad pro m1', 'pro m1'], depositVariantId: '47940838621371' },
        { key: 'ipad_air_m4_cellular', label: 'iPad Air M4 Cellular', terms: ['ipad air m4 cellular', 'air m4 cellular'], depositVariantId: '48221655466171' },
        { key: 'ipad_air_m4', label: 'iPad Air M4', terms: ['ipad air m4', 'air m4'], depositVariantId: '48221653827771' },
        { key: 'ipad_11th_cellular', label: 'iPad 11th Cellular', terms: ['ipad 11th cellular', 'ipad 11 cellular', '11th cellular', '11th gen cellular', '11th generation cellular'], depositVariantId: '48221681189051' },
        { key: 'ipad_11th', label: 'iPad 11th', terms: ['ipad 11th', 'ipad 11', '11th gen', '11th generation'], depositVariantId: '48221678796987' },
        { key: 'ipad_10th_cellular', label: 'iPad 10th Cellular', terms: ['ipad 10th cellular', 'ipad 10 cellular', '10th cellular', '10th gen cellular', '10th generation cellular'], depositVariantId: '48199708999867' },
        { key: 'ipad_10th', label: 'iPad 10th', terms: ['ipad 10th', 'ipad 10', '10th gen', '10th generation'], depositVariantId: '48011984797883' },
        { key: 'ipad_9th_cellular', label: 'iPad 9th Cellular', terms: ['ipad 9th cellular', 'ipad 9 cellular', '9th cellular', '9th gen cellular', '9th generation cellular'], depositVariantId: '48199708967099' },
        { key: 'ipad_9th', label: 'iPad 9th', terms: ['ipad 9th', 'ipad 9', '9th gen', '9th generation'], depositVariantId: '47940834984123' },
        { key: 'ipad_8th_cellular', label: 'iPad 8th Cellular', terms: ['ipad 8th cellular', 'ipad 8 cellular', '8th cellular', '8th gen cellular', '8th generation cellular'], depositVariantId: '48199708836027' },
        { key: 'ipad_8th', label: 'iPad 8th', terms: ['ipad 8th', 'ipad 8', '8th gen', '8th generation'], depositVariantId: '48012018843835' },
        { key: 'ipad_air_5th', label: 'iPad Air 5th', terms: ['ipad air 5th', 'ipad air 5', 'air 5th', 'air 5'], depositVariantId: '47940837474491' }
      ]
    }
  ];

  function termInText(text, term) {
    var q = priceNormalise(text);
    var t = priceNormalise(term);
    if (!q || !t) return false;
    return (' ' + q + ' ').indexOf(' ' + t + ' ') !== -1;
  }

  function detectRentalPeriod(text) {
    var q = priceNormalise(text);
    for (var i = 0; i < rentalPeriodConfigs.length; i += 1) {
      var period = rentalPeriodConfigs[i];
      for (var j = 0; j < period.terms.length; j += 1) {
        if (termInText(q, period.terms[j])) return period;
      }
    }
    var dynamicMonth = q.match(/\b([4-9]|1[0-2])\s*(month|months|mth|mths)\b/);
    if (dynamicMonth) {
      var months = parseInt(dynamicMonth[1], 10);
      return {
        key: months + '_month_dynamic',
        label: months + ' Month',
        terms: [months + ' month', months + ' months', months + ' mth', months + ' mths']
      };
    }

    return null;
  }

  function supportsThreeMonthRental(productOrKey) {
    var key = '';
    if (typeof productOrKey === 'string') key = productOrKey;
    else if (productOrKey && productOrKey.key) key = productOrKey.key;
    return key === 'macbook' || key === 'business' || key === 'gaming';
  }

  function isRentalPeriodAllowedForProduct(period, product) {
    if (!period || !period.key) return true;
    if (period.key !== '3_month') return true;
    return supportsThreeMonthRental(product);
  }

  function getAvailablePeriodChipItems(productOrKey) {
    var items = [
      { label: '1 Day', value: '1 Day' },
      { label: '2 Day', value: '2 Day' },
      { label: '3 Day', value: '3 Day' },
      { label: '5 Day', value: '5 Day' },
      { label: '1 Week', value: '1 Week' },
      { label: '2 Week', value: '2 Week' },
      { label: '1 Month', value: '1 Month' },
      { label: '2 Month', value: '2 Month' }
    ];

    if (supportsThreeMonthRental(productOrKey)) {
      items.push({ label: '3 Month', value: '3 Month' });
    }

    return items;
  }

  function parseDurationNumber(value) {
    if (!value) return null;
    if (/^\d+$/.test(value)) return parseInt(value, 10);
    return wordNumberToInt(value);
  }

  function detectUnsupportedRentalDuration(text) {
    var q = priceNormalise(text || '');
    if (!q) return null;

    // If it already matches a supported online rental period, it is not unsupported.
    if (detectRentalPeriod(q)) return null;

    var match = q.match(/\b(\d{1,2}|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|fourteen|fifteen|twenty|thirty|forty|forty five|fifty)\s*(days?|weeks?|months?|mths?|wks?)\b/);
    if (!match) return null;

    var value = parseDurationNumber(match[1]);
    if (!value) return null;

    var unitRaw = match[2];
    var unit = /^day/.test(unitRaw) ? 'Day' : (/^week|^wk/.test(unitRaw) ? 'Week' : 'Month');

    return {
      value: value,
      unit: unit,
      label: value + ' ' + unit + (value > 1 ? 's' : '')
    };
  }

  function buildUnsupportedDurationMessage(unsupported) {
    var label = unsupported && unsupported.label ? unsupported.label : 'That rental duration';
    return label + ' is not available as a standard online rental period. Please choose one of the available rental durations before I advise the pricing.';
  }

  function seedPriceStateForDurationCorrection(originalQuestion) {
    var seedText = String(originalQuestion || '') + ' ' + (conversationContext.device || '') + ' ' + (conversationContext.lastQuestion || '');
    var product = detectRentalPriceProduct(seedText);
    var model = product ? detectRentalPriceModel(seedText, product) : null;
    var raw = 'price';

    if (model && model.label) {
      raw += ' ' + model.label;
    } else if (conversationContext.device) {
      raw += ' ' + conversationContext.device;
    } else if (product && product.label) {
      raw += ' ' + product.label;
    }

    priceState = { raw: raw };
  }

  function showUnsupportedDurationPrompt(unsupported, originalQuestion) {
    seedPriceStateForDurationCorrection(originalQuestion);
    replyBot(buildUnsupportedDurationMessage(unsupported), function () {
      addPriceChipRow(getAvailablePeriodChipItems());
      addActionRow(['live_agent', 'main_menu']);
      input.focus();
    });
  }

  function detectRentalPriceProduct(text) {
    var q = priceNormalise(text);
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < rentalPriceProducts.length; i += 1) {
      var product = rentalPriceProducts[i];
      var score = 0;
      for (var j = 0; j < product.deviceTerms.length; j += 1) {
        if (termInText(q, product.deviceTerms[j])) score += product.deviceTerms[j].length;
      }
      if (score > bestScore) {
        bestScore = score;
        best = product;
      }
    }

    return bestScore > 0 ? best : null;
  }

  function detectRentalPriceModel(text, product) {
    if (!product || !product.models) return null;
    var q = priceNormalise(text);
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < product.models.length; i += 1) {
      var model = product.models[i];
      var score = 0;
      for (var j = 0; j < model.terms.length; j += 1) {
        var term = priceNormalise(model.terms[j]);
        if (termInText(q, term)) score += term.length;
      }
      if (score > bestScore) {
        bestScore = score;
        best = model;
      }
    }

    if (bestScore > 0) return best;

    return detectDynamicRentalPriceModel(q, product);
  }

  function detectDynamicRentalPriceModel(text, product) {
    var q = priceNormalise(text || '');
    if (!product || !q) return null;

    if (product.key === 'gaming') {
      var gpu = q.match(/\b(rtx|gtx)\s*([0-9]{4,5})\b/);
      if (gpu) {
        var series = gpu[1].toUpperCase();
        var number = gpu[2];
        return {
          key: (series + number).toLowerCase(),
          label: 'Gaming Laptop ' + series + ' ' + number,
          terms: [series.toLowerCase() + ' ' + number, series.toLowerCase() + number, number]
        };
      }
    }

    if (product.key === 'business') {
      if (/\b(ultra\s*7|intel\s*ultra\s*7|core\s*ultra\s*7|ryzen\s*7\s*new|ultra\s*7\s*ryzen\s*7\s*new)\b/.test(q)) {
        return { key: 'business_ultra_7_ryzen_7_new', label: 'Business Laptop Ultra 7 / Ryzen 7 (New)', terms: ['ultra 7', 'intel ultra 7', 'core ultra 7', 'ryzen 7 new', 'ultra 7 ryzen 7 new'] };
      }
      if (/\b(ultra\s*5|intel\s*ultra\s*5|core\s*ultra\s*5|ryzen\s*5\s*new|ultra\s*5\s*ryzen\s*5\s*new)\b/.test(q)) {
        return { key: 'business_ultra_5_ryzen_5_new', label: 'Business Laptop Ultra 5 / Ryzen 5 (New)', terms: ['ultra 5', 'intel ultra 5', 'core ultra 5', 'ryzen 5 new', 'ultra 5 ryzen 5 new'] };
      }
      var ultra = q.match(/\b(ultra)\s*([579])\b/);
      if (ultra) {
        return {
          key: 'business_ultra_' + ultra[2],
          label: 'Business Laptop Ultra ' + ultra[2],
          terms: ['ultra ' + ultra[2], 'intel ultra ' + ultra[2], 'core ultra ' + ultra[2], 'business laptop ultra ' + ultra[2]]
        };
      }
      var intel = q.match(/\b(i[3579])\b/);
      var ryzen = q.match(/\b(ryzen\s*[3579]|r[3579])\b/);
      if (intel || ryzen) {
        var label = intel ? intel[1].toUpperCase().replace('I', 'i') : ryzen[1].replace(/\s+/g, ' ').toUpperCase().replace('RYZEN', 'Ryzen').replace(/^R([3579])$/, 'Ryzen $1');
        return {
          key: 'business_' + priceNormalise(label).replace(/\s+/g, '_'),
          label: 'Business Laptop ' + label,
          terms: [priceNormalise(label), priceNormalise('business laptop ' + label)]
        };
      }
    }

    if (product.key === 'macbook') {
      var mac = q.match(/\b(macbook\s*)?(air|pro)?\s*(m[1-9])\s*(max|pro)?\b/);
      if (mac && mac[3]) {
        var family = mac[2] ? (mac[2].charAt(0).toUpperCase() + mac[2].slice(1)) : 'MacBook';
        var chip = mac[3].toUpperCase();
        var suffix = mac[4] ? ' ' + mac[4].charAt(0).toUpperCase() + mac[4].slice(1) : '';
        var label = family === 'MacBook' ? ('MacBook ' + chip + suffix) : ('MacBook ' + family + ' ' + chip + suffix);
        return { key: priceNormalise(label).replace(/\s+/g, '_'), label: label, terms: [priceNormalise(label), priceNormalise(chip + suffix), priceNormalise((mac[2] || '') + ' ' + chip + suffix)] };
      }
    }

    return null;
  }

  function detectRentalPriceExtras(text, product) {
    var q = priceNormalise(text);
    var extras = [];
    var seen = {};

    function productAllowed(config) {
      if (!config.productKeys || !config.productKeys.length) return true;
      if (!product) return true;
      return config.productKeys.indexOf(product.key) !== -1;
    }

    for (var i = 0; i < rentalPriceExtraConfigs.length; i += 1) {
      var config = rentalPriceExtraConfigs[i];
      if (!productAllowed(config)) continue;
      for (var j = 0; j < config.terms.length; j += 1) {
        if (termInText(q, config.terms[j])) {
          if (!seen[config.key]) {
            extras.push(config);
            seen[config.key] = true;
          }
          break;
        }
      }
    }

    return extras;
  }

  function detectRentalPriceIncludedNotes(text, product) {
    var q = priceNormalise(text);
    var notes = [];
    var seen = {};
    if (!product) return notes;

    for (var i = 0; i < rentalPriceIncludedNoteConfigs.length; i += 1) {
      var config = rentalPriceIncludedNoteConfigs[i];
      if (config.productKeys && config.productKeys.length && config.productKeys.indexOf(product.key) === -1) continue;
      for (var j = 0; j < config.terms.length; j += 1) {
        if (termInText(q, config.terms[j])) {
          if (!seen[config.key]) {
            notes.push(config.label);
            seen[config.key] = true;
          }
          break;
        }
      }
    }

    return notes;
  }

  function parseRentalPriceRequest(text) {
    var product = detectRentalPriceProduct(text);
    return {
      raw: text,
      product: product,
      model: product ? detectRentalPriceModel(text, product) : null,
      period: detectRentalPeriod(text),
      extras: detectRentalPriceExtras(text, product),
      includedNotes: detectRentalPriceIncludedNotes(text, product)
    };
  }

  function isRentalPriceEstimateQuestion(text) {
    var q = priceNormalise(text);
    var hasPriceWord = /\b(price|pricing|cost|fee|rate|how much|estimate|estimated|pay|total|payable|quote)\b/.test(q);
    var hasRentalWord = /\b(rent|lease|borrow|hire|book)\b/.test(q);
    var hasProduct = !!detectRentalPriceProduct(q);
    var hasGenericDevice = /\b(laptop|device|notebook|ipad|tablet|macbook|business laptop|gaming laptop)\b/.test(q);
    var hasPeriod = !!detectRentalPeriod(q);
    var isBulk = /\b(bulk|corporate|company|companies|quote for)\b/.test(q);
    return hasPriceWord && (hasProduct || hasGenericDevice || (hasRentalWord && hasPeriod)) && (hasRentalWord || hasPeriod) && !isBulk;
  }

  function fetchRentalProduct(product) {
    // Price source of truth: read live Shopify product JSON where available.
    // This keeps rental fees aligned with current product variants instead of relying only on static text.
    if (!product) return Promise.reject(new Error('Missing product'));
    if (rentalPriceProductCache[product.key]) return Promise.resolve(rentalPriceProductCache[product.key]);

    return fetch('/products/' + product.handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product price unavailable');
        return response.json();
      })
      .then(function (data) {
        rentalPriceProductCache[product.key] = data;
        return data;
      });
  }

  function fetchVariantById(variantId) {
    if (!variantId) return Promise.resolve(null);
    if (rentalPriceVariantCache[variantId]) return Promise.resolve(rentalPriceVariantCache[variantId]);

    return fetch('/variants/' + variantId + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Variant price unavailable');
        return response.json();
      })
      .then(function (data) {
        rentalPriceVariantCache[variantId] = data;
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function resolveRentalPriceExtras(extras) {
    extras = extras || [];
    var tasks = [];

    for (var i = 0; i < extras.length; i += 1) {
      (function (config) {
        if (typeof config.fixedCents === 'number') {
          tasks.push(Promise.resolve({ config: config, cents: config.fixedCents }));
          return;
        }

        tasks.push(fetchVariantById(config.variantId).then(function (variant) {
          return { config: config, cents: variantPriceCents(variant) };
        }));
      }(extras[i]));
    }

    return Promise.all(tasks);
  }

  function variantText(variant) {
    if (!variant) return '';
    return priceNormalise([
      variant.title,
      variant.name,
      variant.public_title,
      variant.option1,
      variant.option2,
      variant.option3,
      variant.sku
    ].join(' '));
  }

  function variantPriceCents(variant) {
    if (!variant) return null;
    var price = variant.price;
    if (typeof price === 'string') price = parseInt(price, 10);
    return isNaN(price) ? null : price;
  }

  function formatSgd(cents) {
    if (cents === null || typeof cents === 'undefined') return 'Not available';
    var amount = cents / 100;
    return 'S$' + amount.toLocaleString('en-SG', {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function matchRentalVariant(shopifyProduct, request) {
    var variants = shopifyProduct && shopifyProduct.variants ? shopifyProduct.variants : [];
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < variants.length; i += 1) {
      var variant = variants[i];
      var hay = variantText(variant);
      var score = 0;

      if (request.model) {
        for (var j = 0; j < request.model.terms.length; j += 1) {
          if (termInText(hay, request.model.terms[j])) score += 70 + priceNormalise(request.model.terms[j]).length;
        }
      }

      if (request.period) {
        for (var k = 0; k < request.period.terms.length; k += 1) {
          if (termInText(hay, request.period.terms[k])) score += 80 + priceNormalise(request.period.terms[k]).length;
        }
      }

      if (variant.available === false) score -= 15;

      if (score > bestScore) {
        bestScore = score;
        best = variant;
      }
    }

    return bestScore >= 120 ? best : null;
  }

  function getRentalPriceMissingPrompt(request) {
    if (!request.product) {
      return 'Which device would you like to check the rental price for? For example: MacBook, Business Laptop, Gaming Laptop, or iPad.';
    }

    if (!request.model) {
      return request.product.modelPrompt;
    }

    if (!request.period) {
      if (supportsThreeMonthRental(request.product)) {
        return 'What’s the rental duration needed? For example: 2 Day, 1 Week, 1 Month, 2 Month, or 3 Month.';
      }
      return 'What’s the rental duration needed? For example: 2 Day, 1 Week, 1 Month, or 2 Month.';
    }

    if (!isRentalPeriodAllowedForProduct(request.period, request.product)) {
      return request.period.label + ' rental is currently available for Gaming Laptop, Business Laptop, and MacBook rental. For iPad long-term rental, WhatsApp us to check the available options.';
    }

    return '';
  }

  function buildRentalPriceEstimateText(request, rentalVariant, depositVariant, extraItems) {
    var rentalCents = variantPriceCents(rentalVariant);
    var depositCents = variantPriceCents(depositVariant);
    var extrasCents = 0;
    var hasUnknownExtra = false;
    var title = request.model.label + ' — ' + request.period.label;
    extraItems = extraItems || [];

    var lines = [
      title,
      '',
      'Rental fee: ' + formatSgd(rentalCents)
    ];

    if (extraItems.length) {
      lines.push('');
      lines.push('Selected add-ons and charges:');
      for (var i = 0; i < extraItems.length; i += 1) {
        var item = extraItems[i];
        if (item.cents === null || typeof item.cents === 'undefined') {
          hasUnknownExtra = true;
          lines.push('• ' + item.config.label + ': Shown at checkout');
        } else {
          extrasCents += item.cents;
          lines.push('• ' + item.config.label + ': ' + formatSgd(item.cents));
        }
      }
    }

    if (request.includedNotes && request.includedNotes.length) {
      lines.push('');
      for (var n = 0; n < request.includedNotes.length; n += 1) {
        lines.push('Note: ' + request.includedNotes[n]);
      }
    }

    lines.push('');

    if (depositCents !== null) {
      var totalCents = rentalCents !== null && !hasUnknownExtra ? rentalCents + depositCents + extrasCents : null;
      lines.push('Refundable security deposit: ' + formatSgd(depositCents));
      lines.push('Total payable at checkout: ' + (totalCents !== null ? formatSgd(totalCents) : 'Rental fee + refundable security deposit + selected add-ons and charges shown at checkout'));
    } else {
      lines.push('Refundable security deposit: Shown at checkout');
      lines.push('Total payable at checkout: Rental fee + applicable refundable security deposit + selected add-ons and charges');
    }

    lines.push('');
    lines.push('Final amount is confirmed at checkout.');
    lines.push('Optional extras, urgent delivery, weekend surcharge, return timing changes, or special arrangements may apply if selected.');

    return lines.join('\n');
  }

  function resolveRentalPriceEstimate(request) {
    return fetchRentalProduct(request.product).then(function (shopifyProduct) {
      var rentalVariant = matchRentalVariant(shopifyProduct, request);
      if (!rentalVariant) {
        return request.model.label + ' — ' + request.period.label + '\n\nI could not match this combination to a live website variant.\n\nPlease check the rental page for the latest price and available options. Final amount is confirmed at checkout.';
      }

      var depositVariantId = request.model.depositVariantId || '';
      return Promise.all([
        fetchVariantById(depositVariantId),
        resolveRentalPriceExtras(request.extras)
      ]).then(function (results) {
        return buildRentalPriceEstimateText(request, rentalVariant, results[0], results[1]);
      });
    });
  }

  function showRentalPriceEstimate(query) {
    var unsupportedDuration = detectUnsupportedRentalDuration(query);
    if (unsupportedDuration) {
      updateConversationMemory(query || '', 'price');
      showUnsupportedDurationPrompt(unsupportedDuration, query);
      return;
    }

    updateConversationMemory(query || '', 'price');
    var request = parseRentalPriceRequest(query);
    if (request.product) conversationContext.device = (request.model && request.model.label) ? request.model.label : request.product.label;
    if (request.period) conversationContext.duration = request.period.label;
    var missingPrompt = getRentalPriceMissingPrompt(request);

    if (missingPrompt) {
      priceState = { raw: query };
      replyBot(missingPrompt, function () {
        if (!request.product) {
          addPriceChipRow([
            { label: 'Business Laptop', value: 'Business Laptop' },
            { label: 'Gaming Laptop', value: 'Gaming Laptop' },
            { label: 'MacBook', value: 'MacBook' },
            { label: 'iPad', value: 'iPad' }
          ]);
        } else if (!request.model) {
          addPriceChipRow(getPriceModelChipItems(request.product));
        } else if (!request.period) {
          addPriceChipRow(getAvailablePeriodChipItems(request.product));
        }
        addActionRow(['live_agent', 'main_menu']);
      });
      return;
    }

    priceState = null;
    v102MarkConfirmedPriceContext(request);
    unresolvedCount = 0;
    var shouldAskForRating = updateQuestionContext({ category: 'Rental Price' });

    addTypingIndicator();
    resolveRentalPriceEstimate(request)
      .then(function (answer) {
        removeTypingIndicators();
        addBotMessage(answer);
        addActionRow([request.product.viewAction || 'view_rental', 'live_agent', 'main_menu']);
        if (shouldAskForRating) {
          replyBot('Did this answer your question?', function () {
            addActionRow(['thumbs_up', 'thumbs_down']);
          });
        }
        saveState();
      })
      .catch(function () {
        removeTypingIndicators();
        addBotMessage('I’m unable to read the current website price at the moment.\n\nPlease check the rental page for the latest price and final checkout amount.');
        addActionRow(['view_rental', 'live_agent', 'main_menu']);
        saveState();
      });
  }

  function processPriceInput(text) {
    var unsupportedDuration = detectUnsupportedRentalDuration(text);
    if (unsupportedDuration) {
      showUnsupportedDurationPrompt(unsupportedDuration, text);
      return;
    }

    var existingRaw = (priceState && priceState.raw) ? priceState.raw : '';
    var incomingProduct = detectRentalPriceProduct(text);
    var incomingDevice = getCanonicalDeviceLabelFromText(text);
    if (!incomingProduct && incomingDevice) incomingProduct = detectRentalPriceProduct(incomingDevice);

    var existingProduct = detectRentalPriceProduct(existingRaw);
    var incomingModel = incomingProduct ? detectRentalPriceModel(text, incomingProduct) : null;
    var existingModel = existingProduct ? detectRentalPriceModel(existingRaw, existingProduct) : null;
    var q = normalise(text || '');
    var hasPriceWord = /\b(how much|price|cost|fee|rate|total|payable|quote)\b/.test(q);

    var shouldStartFresh = false;
    var carryExistingPeriod = null;
    if (incomingProduct && existingProduct && incomingProduct.key !== existingProduct.key) {
      shouldStartFresh = true;
      carryExistingPeriod = detectRentalPeriod(existingRaw);
      v102ClearConfirmedPriceContext('price_state_product_switch');
    }
    if (incomingModel && existingModel && incomingModel.key !== existingModel.key) {
      shouldStartFresh = true;
      v102ClearConfirmedPriceContext('price_state_model_switch');
    }
    if (incomingProduct && hasPriceWord) {
      shouldStartFresh = true;
    }

    var combined = shouldStartFresh ? text : (existingRaw + ' ' + text);
    if (shouldStartFresh && carryExistingPeriod && !detectRentalPeriod(combined)) {
      combined += ' ' + carryExistingPeriod.label;
    }
    priceState = { raw: combined };
    showRentalPriceEstimate(combined);
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function scrollToBottom() {
    window.setTimeout(function () {
      messages.scrollTop = messages.scrollHeight;
      saveState();
    }, 30);
  }

  function addBotMessage(text) {
    text = String(text || '').trim();
    if (!text) {
      text = 'Sorry, I did not catch that clearly. Are you looking for help choosing a device, checking price, checking availability, or rental FAQs?';
    }
    recordTranscript('Playbot', text);
    removeTypingIndicators();
    var row = document.createElement('div');
    row.className = 'pf-playbot-row pf-playbot-row-bot';
    row.innerHTML = '<div class="pf-playbot-avatar" aria-hidden="true">💬</div><div class="pf-playbot-bubble">' + escapeHtml(text) + '</div>';
    messages.appendChild(row);
    scrollToBottom();
  }

  function addTypingIndicator() {
    removeTypingIndicators();
    var row = document.createElement('div');
    row.className = 'pf-playbot-row pf-playbot-row-bot pf-playbot-typing';
    row.innerHTML = '<div class="pf-playbot-avatar" aria-hidden="true">💬</div><div class="pf-playbot-bubble"><span class="pf-playbot-typing-dots" aria-label="Playbot is typing"><span></span><span></span><span></span></span></div>';
    messages.appendChild(row);
    scrollToBottom();
  }

  function removeTypingIndicators() {
    var rows = messages.querySelectorAll('.pf-playbot-typing');
    for (var i = 0; i < rows.length; i += 1) {
      if (rows[i].parentNode) rows[i].parentNode.removeChild(rows[i]);
    }
  }

  function replyBot(text, callback) {
    if (typingTimer) window.clearTimeout(typingTimer);
    addTypingIndicator();
    typingTimer = window.setTimeout(function () {
      removeTypingIndicators();
      addBotMessage(text);
      if (typeof callback === 'function') callback();
      saveState();
    }, 480);
  }

  function addUserMessage(text) {
    recordTranscript('Customer', text);
    var row = document.createElement('div');
    row.className = 'pf-playbot-row pf-playbot-row-user';
    row.innerHTML = '<div class="pf-playbot-bubble">' + escapeHtml(text) + '</div>';
    messages.appendChild(row);
    scrollToBottom();
  }

  function addChipRow(items, title) {
    if (!items || !items.length) return;
    var card = document.createElement('div');
    card.className = 'pf-playbot-card-grid pf-playbot-card-grid-compact';
    var html = '<div class="pf-playbot-card">' +
      (title ? '<div class="pf-playbot-card-title">' + escapeHtml(title) + '</div>' : '') +
      '<div class="pf-playbot-card-list">';
    for (var i = 0; i < items.length; i += 1) {
      html += '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-intent="' + escapeHtml(items[i].id) + '">' + escapeHtml(items[i].label || items[i].title) + '</button>';
    }
    html += '</div></div>';
    card.innerHTML = html;
    messages.appendChild(card);
    scrollToBottom();
  }

  function addActionRow(actions) {
    if (!actions || !actions.length) return;
    var row = document.createElement('div');
    row.className = 'pf-playbot-action-row';
    var html = '';
    for (var i = 0; i < actions.length; i += 1) {
      html += actionButtonHtml(actions[i]);
    }
    row.innerHTML = html;
    messages.appendChild(row);
    scrollToBottom();
  }

  function actionButtonHtml(action) {
    var labels = {
      view_rental: 'View rental page',
      view_business: 'View business rental page',
      view_gaming: 'View gaming rental page',
      view_macbook: 'View MacBook rental page',
      view_ipad: 'View iPad rental page',
      compatibility: 'View compatibility guide',
      live_agent: 'WhatsApp us',
      feedback: 'Submit feedback',
      main_menu: 'Main menu',
      back_main: 'Back',
      back_product: 'Back',
      continue_chat: 'Continue chatting',
      thumbs_up: '<span class="pf-playbot-rating-content"><span class="pf-playbot-rating-icon">👍🏻</span><span class="pf-playbot-rating-label">Yes</span></span>',
      thumbs_down: '<span class="pf-playbot-rating-content"><span class="pf-playbot-rating-icon">👎🏻</span><span class="pf-playbot-rating-label">No</span></span>',
      rent_device_flow: 'Start rental enquiry',
      price_flow: 'Check rental price',
      availability_flow: 'Request availability check',
      rental_related: 'Delivery, deposit & documents',
      rental_product: 'Help me choose a device',
      rental_software: 'Software & app compatibility',
      rental_tnc: 'Rental terms',
      corporate_flow: 'Corporate and bulk rental',
      start_corporate_enquiry: 'Start corporate enquiry',
      contact_menu: 'Contact Playforce',
      rental_faq: 'Rental FAQs',
      rental_confidence_concerns: 'Rental confidence and common concerns',
      security_device_care: 'Security deposit and device care',
      start_availability_enquiry: 'Start availability request',
      product_business_questions: 'Business laptop rental questions',
      product_gaming_questions: 'Gaming laptop rental questions',
      game_recommendation: 'Game recommendation',
      product_macbook_questions: 'MacBook rental questions',
      product_ipad_questions: 'iPad rental questions',
      rental_steps: 'How does rental work?',
      rental_terms: 'Rental terms',
      payment_options: 'Payment options',
      issue_flow: 'Report device issue',
      confirm_reset: 'Yes, reset',
      cancel_reset: 'No, continue',
      confirm_end: 'Yes, end chat',
      cancel_end: 'No, continue',
      confirm_view_page: 'Yes, open page',
      cancel_view_page: 'No, stay here'
    };

    var actionClasses = {
      live_agent: 'pf-playbot-btn-whatsapp',
      feedback: 'pf-playbot-btn-feedback',
      main_menu: 'pf-playbot-btn-main',
      back_main: 'pf-playbot-btn-back',
      back_product: 'pf-playbot-btn-back',
      continue_chat: 'pf-playbot-btn-continue',
      rent_device_flow: 'pf-playbot-btn-start-rental',
      price_flow: 'pf-playbot-btn-check-price',
      availability_flow: 'pf-playbot-btn-availability',
      start_availability_enquiry: 'pf-playbot-btn-availability',
      corporate_flow: 'pf-playbot-btn-corporate',
      start_corporate_enquiry: 'pf-playbot-btn-corporate',
      rental_product: 'pf-playbot-btn-choose-device',
      rental_faq: 'pf-playbot-btn-faq',
      rental_confidence_concerns: 'pf-playbot-btn-faq',
      security_device_care: 'pf-playbot-btn-faq',
      game_recommendation: 'pf-playbot-btn-choose-device',
      rental_terms: 'pf-playbot-btn-terms',
      payment_options: 'pf-playbot-btn-payment',
      issue_flow: 'pf-playbot-btn-issue',
      compatibility: 'pf-playbot-btn-compatibility',
      confirm_reset: 'pf-playbot-btn-reset',
      cancel_reset: 'pf-playbot-btn-reset',
      confirm_end: 'pf-playbot-btn-end',
      cancel_end: 'pf-playbot-btn-end',
      confirm_view_page: 'pf-playbot-btn-confirm',
      cancel_view_page: 'pf-playbot-btn-confirm'
    };

    function linkButton(actionName, extraClass, ariaLabel) {
      var className = 'pf-playbot-link-btn' + (extraClass ? ' ' + extraClass : '');
      var aria = ariaLabel ? ' aria-label="' + ariaLabel + '"' : '';
      return '<button type="button" class="' + className + '" data-pf-playbot-action="' + actionName + '"' + aria + '>' + labels[actionName] + '</button>';
    }

    if (action === 'live_agent' || action === 'feedback' || action === 'main_menu' || action === 'back_main' || action === 'back_product' || action === 'continue_chat') {
      return linkButton(action, actionClasses[action]);
    }
    if (action === 'thumbs_up' || action === 'thumbs_down') {
      return '<button type="button" class="pf-playbot-link-btn pf-playbot-rating-btn" data-pf-playbot-action="' + action + '" aria-label="' + (action === 'thumbs_up' ? 'Helpful' : 'Not helpful') + '">' + labels[action] + '</button>';
    }
    if (action === 'rent_device_flow' || action === 'price_flow' || action === 'availability_flow' || action === 'start_availability_enquiry' || action === 'corporate_flow' || action === 'start_corporate_enquiry' || action === 'rental_product' || action === 'rental_faq' || action === 'rental_confidence_concerns' || action === 'security_device_care' || action === 'rental_terms' || action === 'issue_flow') {
      return linkButton(action, actionClasses[action]);
    }
    if (action === 'rental_related' || action === 'rental_confidence_concerns' || action === 'security_device_care' || action === 'game_recommendation' || action === 'rental_software' || action === 'rental_tnc' || action === 'contact_menu' || action === 'product_business_questions' || action === 'product_gaming_questions' || action === 'product_macbook_questions' || action === 'product_ipad_questions' || action === 'rental_steps' || action === 'payment_options') {
      return '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="' + action + '">' + labels[action] + '</button>';
    }
    if (action === 'confirm_reset' || action === 'cancel_reset' || action === 'confirm_end' || action === 'cancel_end' || action === 'confirm_view_page' || action === 'cancel_view_page') {
      return linkButton(action, actionClasses[action]);
    }
    if (action === 'compatibility') {
      return linkButton(action, actionClasses[action]);
    }
    var viewClass = 'pf-playbot-btn-view-rental';
    if (action === 'view_business') { viewClass = 'pf-playbot-btn-view-business'; }
    if (action === 'view_gaming') { viewClass = 'pf-playbot-btn-view-gaming'; }
    if (action === 'view_macbook') { viewClass = 'pf-playbot-btn-view-macbook'; }
    if (action === 'view_ipad') { viewClass = 'pf-playbot-btn-view-ipad'; }
    if (action === 'view_rental' || action === 'view_business' || action === 'view_gaming' || action === 'view_macbook' || action === 'view_ipad') {
      return linkButton(action, viewClass, labels[action]);
    }
    return '';
  }

  function showAnswer(item) {
    if (!item) return;
    unresolvedCount = 0;
    if (item) {
      conversationContext.lastCategory = item.category || '';
      conversationContext.lastIntent = item.id || conversationContext.lastIntent || '';
      updateConversationMemory((item.title || '') + ' ' + (item.answer || ''), item.id || item.category || 'answer');
      setLastAnswerMeta(item.id || '', item.title || '', item.category || '', 'answered');
      if (playbotAnswerAuditEnabled && lastUserQuestion) {
        sendPlaybotLead('answer_given', {
          query: lastUserQuestion,
          customerMessage: lastUserQuestion,
          matchedAnswerId: item.id || '',
          matchedAnswerTitle: item.title || '',
          matchedCategory: item.category || '',
          botOutcome: 'answered',
          eventType: 'answer_given',
          summary: 'Playbot answered a customer typed question.',
          notifyEmail: false,
          sheetOnly: true,
          allowRepeat: true,
          maxPerReason: 120,
          skipDedup: true,
          flushNow: true,
          urgent: false,
          formFallback: true
        });
      }
    }
    var shouldAskForRating = updateQuestionContext(item);
    replyBot(item.answer, function () {
      addActionRow(getAnswerActions(item));
      if (shouldAskForRating) {
        replyBot('Did this answer your question?', function () {
          addActionRow(['thumbs_up', 'thumbs_down']);
        });
      }
    });
  }

  function showMainMenu() {
    liveState = null;
    feedbackState = null;
    pendingRedirectState = null;
    priceState = null;
    v102ClearConfirmedPriceContext('main_menu');
    if (conversationContext) conversationContext.recommendedPriceProductKey = '';
    unresolvedCount = 0;
    resetQuestionContext();

    replyBot('Hello, I’m Playbot. Choose a service below, or type your rental question anytime.', function () {
      var cards = document.createElement('div');
      cards.className = 'pf-playbot-card-grid pf-playbot-main-menu-grid';
      cards.innerHTML =
        '<div class="pf-playbot-card pf-playbot-menu-card">' +
          '<div class="pf-playbot-card-title">Recommended services</div>' +
          '<div class="pf-playbot-card-list">' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_steps">How does rental work?</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rent_device_flow">Start rental enquiry</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="price_flow">Check rental price</button>' +
          '</div>' +
        '</div>' +
        '<div class="pf-playbot-card pf-playbot-menu-card">' +
          '<div class="pf-playbot-card-title">Device and pricing</div>' +
          '<div class="pf-playbot-card-list">' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_product">Help me choose a device</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="view_rental">View rental page</button>' +
          '</div>' +
        '</div>' +
        '<div class="pf-playbot-card pf-playbot-menu-card">' +
          '<div class="pf-playbot-card-title">Business rental</div>' +
          '<div class="pf-playbot-card-list">' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="corporate_flow">Corporate and bulk rental</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-intent="invoice_receipt">Quotation and invoice</button>' +
          '</div>' +
        '</div>' +
        '<div class="pf-playbot-card pf-playbot-menu-card">' +
          '<div class="pf-playbot-card-title">Help and support</div>' +
          '<div class="pf-playbot-card-list">' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_faq">Rental FAQs</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="contact_menu">Contact Playforce</button>' +
          '</div>' +
        '</div>' +
        '';
      messages.appendChild(cards);
      var privacyNote = document.createElement('div');
      privacyNote.className = 'pf-playbot-privacy-note';
      privacyNote.textContent = 'Playbot may keep a chat summary to help our team follow up on rental enquiries and improve support.';
      messages.appendChild(privacyNote);
      scrollToBottom();
    });
  }

  function showRentalFaqMenu() {
    replyBot('Sure. Which rental FAQ would you like to check?', function () {
      var cards = document.createElement('div');
      cards.className = 'pf-playbot-card-grid';
      cards.innerHTML =
        '<div class="pf-playbot-card">' +
          '<div class="pf-playbot-card-title">Rental FAQs</div>' +
          '<div class="pf-playbot-card-list">' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_steps">How does rental work?</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_confidence_concerns">Rental Confidence and Common Concerns</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_related">Delivery, deposit &amp; documents</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="security_device_care">Security Deposit and Device Care</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-category="Accessories and Device Condition">Accessories &amp; device condition</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_software">Software compatibility</button>' +
            '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_tnc">Rental terms &amp; changes</button>' +
          '</div>' +
        '</div>';
      messages.appendChild(cards);
      addActionRow(['back_main', 'main_menu']);
      scrollToBottom();
    });
  }

  function showAvailabilityHub() {
    replyBot('I can help prepare an availability request for our team to confirm. You can also check a few common availability questions first.', function () {
      addPlaybotCard('Availability and urgent rental',
        intentButtonHtml('availability_stock', 'How availability is confirmed') +
        intentButtonHtml('device_unavailable_after_order', 'What if the device is unavailable after I order?') +
        intentButtonHtml('same_day_urgent_rental', 'Same-day and urgent rental') +
        intentButtonHtml('deliver_tomorrow', 'Next-day delivery') +
        intentButtonHtml('delivery_timing', 'Delivery timing') +
        intentButtonHtml('delivery_return_timing_change', 'Can I request a specific delivery or return slot after ordering?') +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="start_availability_enquiry">Start availability request</button>'
      );
      addActionRow(['back_main', 'main_menu']);
    });
  }

  function showCorporateBulkHub() {
    replyBot('Sure — here are common corporate and bulk rental questions. You can choose a topic first, or start an enquiry when you’re ready.', function () {
      addPlaybotCard('Corporate and bulk rental',
        intentButtonHtml('bulk_pricing', 'Bulk and long-term rental') +
        intentButtonHtml('invoice_receipt', 'Quotation and invoice') +
        intentButtonHtml('company_documents', 'Company documents') +
        intentButtonHtml('event_roadshow_rental', 'Event, training and roadshow rental') +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="start_corporate_enquiry">Start corporate enquiry</button>'
      );
      addActionRow(['back_main', 'main_menu']);
    });
  }


  function showRentalConfidenceConcernsHub() {
    replyBot('Here are common customer concerns before and during rental. You can also type your own question anytime.', function () {
      addPlaybotCard('Rental Confidence and Common Concerns',
        intentButtonHtml('trust_rental_confidence', 'Is it safe to rent from Playforce?') +
        intentButtonHtml('software_game_cannot_run', 'What if my software or game cannot run?') +
        intentButtonHtml('pre_rental_testing', 'Can I test the device before renting?') +
        intentButtonHtml('missed_delivery_return', 'What if I miss delivery or return collection?') +
        intentButtonHtml('device_expectations', 'What should I expect when I receive the device?') +
        intentButtonHtml('data_after_return', 'What happens to my data after return?') +
        intentButtonHtml('find_my_not_off', 'What if I forget to turn off Find My?') +
        intentButtonHtml('install_apps_admin', 'Can I install apps or use admin access?') +
        intentButtonHtml('internet_connectivity', 'Does the rental include internet?') +
        intentButtonHtml('multiple_device_rental', 'I need multiple devices. How should I proceed?') +
        intentButtonHtml('someone_else_handover', 'Can someone else receive or return the device?')
      );
      addActionRow(['rental_faq', 'live_agent', 'main_menu']);
    });
  }

  function showSecurityDeviceCareHub() {
    replyBot('Here are the most common questions about deposit, deductions, and device care. You can also type your own question anytime.', function () {
      addPlaybotCard('Security Deposit and Device Care',
        intentButtonHtml('deposit_deductions', 'Will I be charged or have my deposit deducted?') +
        intentButtonHtml('small_cosmetic_scratches', 'Will I be charged for small scratches?') +
        intentButtonHtml('existing_cosmetic_marks', 'What if there are existing cosmetic marks?') +
        intentButtonHtml('faulty_device_replacement', 'What if the device has a fault?') +
        intentButtonHtml('device_damaged', 'What if the device is accidentally damaged?') +
        intentButtonHtml('device_lost', 'What if the device is lost or stolen?') +
        intentButtonHtml('damage_payment_amount', 'How much do I need to pay if there is damage?') +
        intentButtonHtml('inspect_receipt', 'What should I do if something happens?')
      );
      addActionRow(['live_agent', 'back_main', 'main_menu']);
    });
  }

  function showRentalSteps() {
    replyBot('Here’s how Playforce rental works:\n\n1. Choose your rental device.\nSelect the laptop, MacBook, iPad, or rental device you need.\n\n2. Order online or WhatsApp us for help.\nYou may place the order online, or WhatsApp us if you need help choosing a device, checking availability, or arranging a corporate rental.\n\n3. Submit the required documents.\nDocuments are required for rental verification and to confirm the renter responsible for the device.\n\nFor individual rental, NRIC front and back and proof of address are required. For company rental, ACRA and name card may be required.\n\nPlayforce uses the submitted documents for rental verification purposes. For individual rental, NRIC front and back and proof of address are required. For company rental, ACRA and name card may be required.\n\n4. Make payment to confirm the rental.\nRental is confirmed only after payment is completed.\n\n5. Delivery to your location.\nPlayforce will arrange delivery to your address.\n\n6. Return collection.\nWhen the rental period ends, Playforce will arrange return collection from you.', function () {
      addActionRow(['rent_device_flow', 'price_flow', 'view_rental', 'live_agent', 'main_menu']);
    });
  }

  function showRentalTerms() {
    replyBot('Key rental terms:\n\n• Rental is confirmed only after PayNow checkout is completed.\n• Online rental follows the available rental periods shown on the rental page.\n• Security deposit is refundable within 3 business days after return, subject to device condition, late return, and rental terms.\n• Late return is charged at $100 per day per device.\n• Early return does not come with refund or rebate.\n• Cancellation charges may apply once rental is confirmed. 100% cancellation charge applies if cancelled 1 day before the start date or on the start date.\n• Customer-caused damage, missing accessories, lost device, or stolen device may be chargeable based on repair or replacement cost. Slight cosmetic scratches from normal careful use, and existing cosmetic defects documented before delivery, are not usually chargeable.\n• Devices will be formatted and reset after return.', function () {
      addActionRow(['rent_device_flow', 'live_agent', 'main_menu']);
    });
  }

  function showPaymentOptions() {
    replyBot('Payment options:\n\n• Rental checkout is strictly via PayNow checkout.\n• Please use PayNow checkout to complete payment. Orders paid through unsupported payment methods may not be processed.', function () {
      addActionRow(['rent_device_flow', 'price_flow', 'main_menu']);
    });
  }

  function addPlaybotCard(title, html) {
    var cards = document.createElement('div');
    cards.className = 'pf-playbot-card-grid';
    cards.innerHTML =
      '<div class="pf-playbot-card">' +
        '<div class="pf-playbot-card-title">' + escapeHtml(title) + '</div>' +
        '<div class="pf-playbot-card-list">' + html + '</div>' +
      '</div>';
    messages.appendChild(cards);
    scrollToBottom();
  }

  function showRentalRelatedCategories() {
    replyBot('What would you like to check?', function () {
      addPlaybotCard('Delivery, deposit & documents',
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_steps">How does rental work?</button>' +
        categoryButtonHtml('Rental Price', 'Rental Fees') +
        intentButtonHtml('upfront_payment_deposit', 'Do I need to pay rental fee and deposit upfront?') +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="payment_options">Payment Options</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="availability_flow">Availability and urgent rental</button>' +
        categoryButtonHtml('Rental Period', 'Rental Period') +
        categoryButtonHtml('Delivery & Return', 'Delivery & Return') +
        categoryButtonHtml('Security Deposit', 'Security Deposit') +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="security_device_care">Security Deposit and Device Care</button>' +
        categoryButtonHtml('Required Documents', 'Required Documents') +
        intentButtonHtml('document_usage_privacy', 'How will my documents be used?') +
        categoryButtonHtml('Accessories and Device Condition', 'Accessories and Device Condition')
      );
      addActionRow(['back_main', 'main_menu']);
    });
  }

  function showRentalProductCategories() {
    replyBot('Which rental product are you checking? I’ll show a few common questions first. You can also type your own question anytime.', function () {
      addPlaybotCard('Product help',
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="product_business_questions">Business Laptop</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="product_gaming_questions">Gaming Laptop</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="product_macbook_questions">MacBook</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="product_ipad_questions">iPad</button>' +
        intentButtonHtml('which_device', 'Not sure which to choose')
      );
      addActionRow(['price_flow', 'rent_device_flow', 'back_main', 'main_menu']);
    });
  }


  function showProductQuestionSet(title, intro, ids, nextActions) {
    var html = '';
    for (var i = 0; i < ids.length; i += 1) {
      var item = findIntentById(ids[i]);
      if (item) {
        html += intentButtonHtml(item.id, item.title || item.id);
      }
    }
    if (!html) {
      replyBot('Sorry, I could not load these questions. Please type your question or contact Playforce for assistance.', function () {
        addActionRow(['live_agent', 'back_product', 'main_menu']);
      });
      return;
    }
    replyBot(intro, function () {
      addPlaybotCard(title, html);
      addActionRow(nextActions || ['price_flow', 'rent_device_flow', 'back_product', 'main_menu']);
    });
  }

  function showBusinessLaptopQuestions() {
    conversationContext.device = conversationContext.device || 'Business Laptop';
    showProductQuestionSet(
      'Business Laptop',
      'Here are the most common Business Laptop questions. You can also type your own question, such as “Can Business i7 run Docker?”.',
      [
        'business_laptop_overview',
        'business_i5_i7_difference',
        'microsoft_office',
        'accessories_included',
        'exact_brand_model',
        'check_price'
      ],
      ['price_flow', 'view_business', 'rent_device_flow', 'back_product', 'main_menu']
    );
  }

  function showGamingLaptopQuestions() {
    conversationContext.device = conversationContext.device || 'Gaming Laptop';
    replyBot('Gaming laptop rental. Choose a topic below, or type your own question such as “Which laptop for Dota 2?”.', function () {
      addPlaybotCard('Gaming Laptop',
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="game_recommendation">Game Recommendation</button>' +
        intentButtonHtml('gaming_laptop_overview', 'What is Gaming Laptop rental suitable for?') +
        intentButtonHtml('gaming_gpu_options', 'Which Gaming Laptop GPU options are available?') +
        intentButtonHtml('gaming_higher_fps', 'I want higher FPS. Which laptop should I choose?') +
        intentButtonHtml('mobile_games_on_laptop', 'Can I play mobile games on a laptop?') +
        intentButtonHtml('gaming_event_rental', 'Can I rent gaming laptops for an event?')
      );
      addActionRow(['price_flow', 'view_gaming', 'rent_device_flow', 'back_product', 'main_menu']);
    });
  }


  var gameRecommendationData = [
    {
      key: 'roblox', name: 'Roblox', aliases: ['roblox'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'Roblox is generally suitable for entry gaming use. For events with many units, Playforce should check stock and delivery planning first.',
      upgrade: 'For larger Roblox events, higher graphics settings, recording, streaming, or smoother play, choose a Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050.'
    },
    {
      key: 'candy_crush', name: 'Candy Crush Saga', aliases: ['candy crush saga', 'candy crush'], rank: 0, tier: 'iPad rental or Business Laptop', device: 'iPad rental or Business Laptop', mode: 'mobile',
      why: 'Candy Crush Saga is mainly a casual mobile game, so a gaming laptop is usually not necessary.',
      upgrade: 'Choose iPad rental for normal mobile play. Choose Business Laptop only if you need a browser or Windows setup.'
    },
    {
      key: 'minecraft', name: 'Minecraft', aliases: ['minecraft'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'Minecraft is usually suitable on entry gaming laptops for normal play.',
      upgrade: 'For shaders, heavy mods, servers, recording, or better graphics, choose Performance or High-Performance Gaming Laptop.'
    },
    {
      key: 'pubg_mobile', name: 'PUBG Mobile', aliases: ['pubg mobile'], rank: 0, tier: 'iPad rental for mobile play', device: 'iPad rental', mode: 'mobile',
      why: 'PUBG Mobile is mainly a mobile game.',
      upgrade: 'For normal mobile play, iPad rental may be more suitable. If you need Windows emulator use, check with Playforce first because emulator compatibility and performance may vary.'
    },
    {
      key: 'free_fire', name: 'Garena Free Fire', aliases: ['garena free fire', 'free fire'], rank: 0, tier: 'iPad rental for mobile play', device: 'iPad rental', mode: 'mobile',
      why: 'Garena Free Fire is mainly a mobile game.',
      upgrade: 'For normal mobile play, iPad rental may be more suitable. If you need Windows emulator use, check with Playforce first because emulator compatibility and performance may vary.'
    },
    {
      key: 'fortnite', name: 'Fortnite', aliases: ['fortnite'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Fortnite can run on lighter settings, but a performance gaming tier is safer for smoother gameplay.',
      upgrade: 'For better graphics, Epic quality settings, or higher FPS, choose High-Performance Gaming Laptop such as RTX 3070, RTX 4060, or RTX 4070 where available.'
    },
    {
      key: 'league_of_legends', name: 'League of Legends', aliases: ['league of legends', 'league', 'lol'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'League of Legends is generally suitable for entry gaming use.',
      upgrade: 'For higher FPS or external high-refresh monitor use, choose Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050.'
    },
    {
      key: 'call_of_duty', name: 'Call of Duty Warzone', aliases: ['call of duty warzone', 'warzone', 'call of duty', 'cod', 'black ops'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Call of Duty titles are more demanding than lighter esports games, so a performance gaming tier is the safer starting point.',
      upgrade: 'For higher FPS or better graphics, choose High-Performance Gaming Laptop such as RTX 3070, RTX 4060, RTX 4070, or better where available.'
    },
    {
      key: 'gta', name: 'Grand Theft Auto V and GTA Online', aliases: ['grand theft auto v', 'gta online', 'gta 5', 'gta v', 'gta', 'fivem', 'five m'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'GTA V and GTA Online are better suited to a performance gaming tier for smoother play.',
      upgrade: 'For FiveM, mods, recording, streaming, or higher graphics settings, choose High-Performance Gaming Laptop.'
    },
    {
      key: 'counter_strike_2', name: 'Counter-Strike 2', aliases: ['counter strike 2', 'counter-strike 2', 'cs2', 'counter strike'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'Counter-Strike 2 can be played casually on an entry gaming tier, but competitive players usually care about stable higher FPS.',
      upgrade: 'For higher FPS and smoother competitive play, choose Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050.'
    },
    {
      key: 'dota_2', name: 'Dota 2', aliases: ['dota 2', 'dota2', 'dota'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'Dota 2 is generally not as demanding as newer AAA games, so this tier is usually suitable for normal play.',
      upgrade: 'For higher FPS, smoother team fights, or external high-refresh monitor use, choose Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050.'
    },
    {
      key: 'apex_legends', name: 'Apex Legends', aliases: ['apex legends', 'apex'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Apex Legends is a fast shooter, so a performance gaming tier is recommended for smoother gameplay.',
      upgrade: 'For higher FPS or better graphics, choose High-Performance Gaming Laptop.'
    },
    {
      key: 'mobile_legends', name: 'Mobile Legends: Bang Bang', aliases: ['mobile legends bang bang', 'mobile legends', 'mlbb'], rank: 0, tier: 'iPad rental for mobile play', device: 'iPad rental', mode: 'mobile',
      why: 'Mobile Legends is mainly a mobile game.',
      upgrade: 'For normal mobile play, iPad rental may be more suitable. If you need Windows emulator use, check with Playforce first because emulator compatibility and performance may vary.'
    },
    {
      key: 'valorant', name: 'Valorant', aliases: ['valorant'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'Valorant is generally suitable on entry gaming laptops for normal play.',
      upgrade: 'If you want higher FPS or plan to use a high-refresh monitor, choose Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050.'
    },
    {
      key: 'ea_sports_fc', name: 'EA SPORTS FC', aliases: ['ea sports fc 26', 'ea sports fc', 'fc 26', 'fifa'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'EA SPORTS FC is better suited to a performance gaming tier for smoother gameplay.',
      upgrade: 'For better graphics or smoother match performance, choose High-Performance Gaming Laptop where available.'
    },
    {
      key: 'palworld', name: 'Palworld', aliases: ['palworld'], rank: 3, tier: 'High-Performance Gaming Laptop', device: 'RTX 3070, RTX 3080, RTX 4060, or RTX 4070', mode: 'pc',
      why: 'Palworld is more demanding than lighter esports titles, especially with larger worlds or multiplayer use.',
      upgrade: 'For the strongest available graphics and performance, choose RTX 5080 where available.'
    },
    {
      key: 'marvel_rivals', name: 'Marvel Rivals', aliases: ['marvel rivals'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Marvel Rivals is better suited to a performance gaming tier for smoother gameplay.',
      upgrade: 'For better graphics or higher FPS, choose High-Performance Gaming Laptop such as RTX 3070, RTX 4060, or RTX 4070 where available.'
    },
    {
      key: 'overwatch_2', name: 'Overwatch 2', aliases: ['overwatch 2', 'overwatch'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Overwatch 2 is a fast-paced shooter, so a performance gaming tier is recommended for smoother FPS.',
      upgrade: 'For higher FPS, better graphics, or external high-refresh monitor use, choose High-Performance Gaming Laptop.'
    },
    {
      key: 'genshin', name: 'Genshin Impact', aliases: ['genshin impact', 'genshin'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'Genshin Impact is usually suitable for entry gaming use at normal settings.',
      upgrade: 'For smoother visuals or better graphics, choose Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050.'
    },
    {
      key: 'honkai', name: 'Honkai: Star Rail', aliases: ['honkai star rail', 'honkai'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'Honkai: Star Rail is usually suitable for entry gaming use at normal settings.',
      upgrade: 'For smoother visuals or better graphics, choose Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050.'
    },
    {
      key: 'helldivers_2', name: 'Helldivers 2', aliases: ['helldivers 2', 'helldivers'], rank: 3, tier: 'High-Performance Gaming Laptop', device: 'RTX 3070, RTX 3080, RTX 4060, or RTX 4070', mode: 'pc',
      why: 'Helldivers 2 is a demanding newer title, so a high-performance gaming tier is recommended.',
      upgrade: 'For the strongest available graphics and performance, choose RTX 5080 where available.'
    },
    {
      key: 'rocket_league', name: 'Rocket League', aliases: ['rocket league'], rank: 1, tier: 'Entry Gaming Laptop', device: 'GTX 1650 or RTX 3050', mode: 'pc',
      why: 'Rocket League is usually suitable on an entry gaming tier for normal play.',
      upgrade: 'For higher FPS or external high-refresh monitor use, choose Performance Gaming Laptop such as RTX 3060, RTX 4050, or RTX 5050.'
    },
    {
      key: 'pubg_battlegrounds', name: 'PUBG: BATTLEGROUNDS', aliases: ['pubg battlegrounds', 'pubg pc', 'playerunknown battlegrounds', 'playerunknowns battlegrounds', 'pubg'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'PUBG: BATTLEGROUNDS benefits from a performance gaming tier for smoother gameplay and more stable FPS.',
      upgrade: 'For higher FPS, better graphics, or high-refresh monitor use, choose High-Performance Gaming Laptop such as RTX 3070, RTX 4060, or RTX 4070 where available.'
    },
    {
      key: 'delta_force', name: 'Delta Force', aliases: ['delta force'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Delta Force is better suited to a performance gaming tier for smoother large-map multiplayer gameplay.',
      upgrade: 'For higher FPS, better graphics, or high-refresh monitor use, choose High-Performance Gaming Laptop.'
    },
    {
      key: 'rainbow_six_siege', name: 'Rainbow Six Siege', aliases: ['rainbow six siege', 'rainbow 6 siege', 'r6 siege', 'r6s'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Rainbow Six Siege is competitive and benefits from a performance gaming tier for stable higher FPS.',
      upgrade: 'For higher-refresh competitive play or better graphics, choose High-Performance Gaming Laptop.'
    },
    {
      key: 'warframe', name: 'Warframe', aliases: ['warframe'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Warframe is well suited to a performance gaming tier for smoother combat and higher graphics settings.',
      upgrade: 'For higher FPS or better graphics, choose High-Performance Gaming Laptop where available.'
    },
    {
      key: 'dead_by_daylight', name: 'Dead by Daylight', aliases: ['dead by daylight', 'dbd'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'Dead by Daylight is better suited to a performance gaming tier for smooth multiplayer gameplay.',
      upgrade: 'For higher graphics settings or additional performance headroom, choose High-Performance Gaming Laptop.'
    },
    {
      key: 'war_thunder', name: 'War Thunder', aliases: ['war thunder'], rank: 2, tier: 'Performance Gaming Laptop', device: 'RTX 3060, RTX 4050, or RTX 5050', mode: 'pc',
      why: 'War Thunder benefits from a performance gaming tier for smoother large battles and higher graphics settings.',
      upgrade: 'For higher FPS, better graphics, or high-resolution external displays, choose High-Performance Gaming Laptop.'
    },
    {
      key: 'rust', name: 'Rust', aliases: ['rust game', 'rust'], rank: 3, tier: 'High-Performance Gaming Laptop', device: 'RTX 3070, RTX 3080, RTX 4060, or RTX 4070', mode: 'pc',
      why: 'Rust can be demanding in larger servers and busy areas, so a high-performance gaming tier is recommended.',
      upgrade: 'For the strongest available graphics and performance headroom, choose RTX 5080 where available.'
    },
    {
      key: 'battlefield_6', name: 'Battlefield 6', aliases: ['battlefield 6', 'bf6'], rank: 3, tier: 'High-Performance Gaming Laptop', device: 'RTX 3070, RTX 3080, RTX 4060, or RTX 4070', mode: 'pc',
      why: 'Battlefield 6 is a demanding large-scale shooter, so a high-performance gaming tier is recommended.',
      upgrade: 'For very high settings, higher FPS, or additional performance headroom, choose RTX 5080 where available.'
    },
    {
      key: 'forza_horizon_6', name: 'Forza Horizon 6', aliases: ['forza horizon 6', 'forza 6', 'fh6'], rank: 3, tier: 'High-Performance Gaming Laptop', device: 'RTX 3070, RTX 3080, RTX 4060, or RTX 4070', mode: 'pc',
      why: 'Forza Horizon 6 benefits from a high-performance gaming tier for higher graphics settings and smooth open-world driving.',
      upgrade: 'For very high settings, higher resolution, or additional graphics headroom, choose RTX 5080 where available.'
    },
    {
      key: 'path_of_exile_2', name: 'Path of Exile 2', aliases: ['path of exile 2', 'poe 2', 'poe2'], rank: 3, tier: 'High-Performance Gaming Laptop', device: 'RTX 3070, RTX 3080, RTX 4060, or RTX 4070', mode: 'pc',
      why: 'Path of Exile 2 can become demanding during effects-heavy combat, so a high-performance gaming tier is recommended.',
      upgrade: 'For stronger graphics and smoother performance during heavier scenes, choose RTX 5080 where available.'
    },
    {
      key: 'elden_ring', name: 'Elden Ring', aliases: ['elden ring'], rank: 3, tier: 'High-Performance Gaming Laptop', device: 'RTX 3070, RTX 3080, RTX 4060, or RTX 4070', mode: 'pc',
      why: 'Elden Ring is better suited to a high-performance gaming tier for higher graphics settings and smoother gameplay.',
      upgrade: 'For higher resolution, maximum graphics headroom, or demanding visual settings, choose RTX 5080 where available.'
    },
    {
      key: 'cyberpunk_2077', name: 'Cyberpunk 2077', aliases: ['cyberpunk 2077', 'cyberpunk'], rank: 4, tier: 'Best Available Gaming Laptop', device: 'RTX 5080 where available', mode: 'pc',
      why: 'Cyberpunk 2077 is graphically demanding, especially at higher settings or with ray tracing, so the strongest available gaming tier is recommended.',
      upgrade: 'RTX 5080 is the preferred Playforce recommendation where available when the customer wants very high graphics settings or maximum performance headroom.'
    },
    {
      key: 'monster_hunter_wilds', name: 'Monster Hunter Wilds', aliases: ['monster hunter wilds', 'mh wilds'], rank: 4, tier: 'Best Available Gaming Laptop', device: 'RTX 5080 where available', mode: 'pc',
      why: 'Monster Hunter Wilds is a demanding modern title, so the strongest available gaming tier is recommended for better graphics and performance headroom.',
      upgrade: 'RTX 5080 is the preferred Playforce recommendation where available for customers prioritising higher graphics settings and smoother performance.'
    }
  ];

  function escapeRegExp(text) {
    return String(text || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function gameAliasMatches(q, alias) {
    var term = normalise(alias || '');
    if (!term) return false;
    var pattern = new RegExp('(^|\\s)' + escapeRegExp(term).replace(/\\s+/g, '\\s+') + '(?=\\s|$)');
    return pattern.test(q);
  }

  function findGameRecommendations(text) {
    var q = normalise(text || '');
    var matches = [];
    for (var i = 0; i < gameRecommendationData.length; i += 1) {
      var item = gameRecommendationData[i];
      for (var j = 0; j < item.aliases.length; j += 1) {
        if (gameAliasMatches(q, item.aliases[j])) {
          matches.push(item);
          break;
        }
      }
    }
    return matches;
  }

  function isGameRecommendationQuestion(text) {
    var q = normalise(text || '');
    if (!q) return false;
    if (findGameRecommendations(q).length) return /\b(which|recommend|suitable|can run|run|play|fps|graphics|game|gaming|laptop|device|event|rent|rental|need)\b/.test(q) || q.length <= 30;
    return /\b(game recommendation|recommend by game|which gaming laptop|which laptop for my game|can gaming laptop run popular games|popular games|higher fps|better graphics)\b/.test(q);
  }

  function hasHighFpsIntent(text) {
    var q = normalise(text || '');
    return /\b(high fps|higher fps|smooth fps|144hz|144 hz|165hz|165 hz|240hz|240 hz|high refresh|competitive)\b/.test(q);
  }

  function hasBetterGraphicsIntent(text) {
    var q = normalise(text || '');
    return /\b(better graphics|high graphics|ultra|epic quality|max settings|higher settings|best graphics|beautiful graphics)\b/.test(q);
  }

  function hasGamingEventIntent(text) {
    var q = normalise(text || '');
    return /\b(event|tournament|roadshow|training|school|class|bootcamp|lan|competition|multiple units|bulk)\b/.test(q) || !!detectQuantityFromText(q);
  }

  function getTierNameByRank(rank) {
    if (rank >= 4) return 'Best Available Gaming Laptop';
    if (rank >= 3) return 'High-Performance Gaming Laptop';
    if (rank >= 2) return 'Performance Gaming Laptop';
    if (rank >= 1) return 'Entry Gaming Laptop';
    return 'iPad rental or Business Laptop';
  }

  function getTierDeviceByRank(rank) {
    if (rank >= 4) return 'RTX 5080 where available';
    if (rank >= 3) return 'RTX 3070, RTX 3080, RTX 4060, or RTX 4070';
    if (rank >= 2) return 'RTX 3060, RTX 4050, or RTX 5050';
    if (rank >= 1) return 'GTX 1650 or RTX 3050';
    return 'iPad rental or Business Laptop';
  }

  function buildGeneralGameRecommendationReply() {
    return 'Tell me the game you want to play and I’ll suggest a suitable rental tier.\n\nGeneral guide:\n\n• Entry Gaming Laptop — GTX 1650 or RTX 3050. Suitable for Roblox, Minecraft, League of Legends, Counter-Strike 2, Dota 2, Valorant, Genshin Impact, Honkai: Star Rail, Rocket League, and lighter esports titles.\n\n• Performance Gaming Laptop — RTX 3060, RTX 4050, or RTX 5050. Suitable for Fortnite, Apex Legends, Overwatch 2, EA SPORTS FC, GTA Online / FiveM, Call of Duty Warzone, Marvel Rivals, PUBG: BATTLEGROUNDS, Delta Force, Rainbow Six Siege, Warframe, Dead by Daylight, War Thunder, and smoother FPS.\n\n• High-Performance Gaming Laptop — RTX 3070, RTX 3080, RTX 4060, or RTX 4070. Suitable for Palworld, Helldivers 2, Rust, Battlefield 6, Forza Horizon 6, Path of Exile 2, Elden Ring, heavier games, better graphics, higher FPS, mods, and larger worlds.\n\n• Best Available Gaming Laptop — RTX 5080 where available. Recommended for Cyberpunk 2077, Monster Hunter Wilds, very high graphics settings, higher FPS headroom, streaming, rendering, or demanding GPU workloads.\n\nFor mobile games such as PUBG Mobile, Free Fire, Mobile Legends, or Candy Crush, iPad rental may be more suitable for normal mobile play. Windows emulator use should be checked with Playforce first.';
  }

  function buildSingleGameRecommendationReply(game, rawText) {
    var rank = game.rank;
    if (hasBetterGraphicsIntent(rawText) && rank > 0 && rank < 3) rank += 1;
    if (hasHighFpsIntent(rawText) && rank > 0 && rank < 2) rank = 2;

    if (game.mode === 'mobile') {
      return 'For ' + game.name + ', ' + game.tier + ' is usually more suitable.\n\nWhy: ' + game.why + '\n\n' + game.upgrade + '\n\nIf you need this for an event or many units, share the quantity, rental date, duration, and venue so Playforce can check availability.\n\nActual experience may depend on the app version, account requirements, internet connection, and final device availability.';
    }

    var tier = getTierNameByRank(rank);
    var device = getTierDeviceByRank(rank);
    var reply = 'For ' + game.name + ', we recommend ' + tier + ', such as ' + device + '.\n\nWhy: ' + game.why + '\n\n' + game.upgrade;

    if (hasGamingEventIntent(rawText)) {
      reply += '\n\nFor gaming events or multiple units, please share the number of units, rental date, duration, venue, and whether you need normal smooth play, higher FPS, or better graphics.';
    }

    reply += '\n\nActual performance depends on game settings, game updates, and internet connection.';
    return reply;
  }

  function buildMultiGameRecommendationReply(games, rawText) {
    var heaviest = games[0];
    for (var i = 1; i < games.length; i += 1) {
      if (games[i].rank > heaviest.rank) heaviest = games[i];
    }

    var gameNames = [];
    for (var j = 0; j < games.length; j += 1) gameNames.push(games[j].name);

    if (heaviest.rank <= 0) {
      return 'For ' + gameNames.join(', ') + ', these are mainly mobile or light casual games.\n\nFor normal mobile play, iPad rental may be more suitable. If you need Windows emulator use, please check with Playforce first because emulator compatibility and performance may vary.\n\nFor events or many units, share the quantity, rental date, duration, and venue so Playforce can check availability.';
    }

    var rank = heaviest.rank;
    if (hasBetterGraphicsIntent(rawText) && rank < 3) rank += 1;
    if (hasHighFpsIntent(rawText) && rank < 2) rank = 2;

    var reply = 'For ' + gameNames.join(', ') + ', we recommend choosing based on the heaviest game: ' + heaviest.name + '.\n\nRecommended tier: ' + getTierNameByRank(rank) + ', such as ' + getTierDeviceByRank(rank) + '.\n\nLighter games in your list may run on a lower tier, but choosing for the heaviest game is safer.';

    if (hasGamingEventIntent(rawText)) {
      reply += '\n\nFor gaming events or multiple units, please share the number of units, rental date, duration, venue, and whether you need normal smooth play, higher FPS, or better graphics.';
    }

    reply += '\n\nActual performance depends on game settings, game updates, and internet connection.';
    return reply;
  }

  function showGameRecommendationForText(text) {
    var games = findGameRecommendations(text);
    var reply = '';

    conversationContext.device = 'Gaming Laptop';
    conversationContext.recommendedPriceProductKey = 'gaming';
    conversationContext.lastIntent = 'game_recommendation';

    if (!games.length) {
      reply = buildGeneralGameRecommendationReply();
      replyBot(reply, function () {
        addActionRow(['view_gaming', 'price_flow', 'rent_device_flow', 'main_menu']);
      });
      return true;
    }

    if (games.length === 1) {
      reply = buildSingleGameRecommendationReply(games[0], text);
    } else {
      reply = buildMultiGameRecommendationReply(games, text);
    }

    replyBot(reply, function () {
      var hasOnlyMobile = true;
      for (var i = 0; i < games.length; i += 1) {
        if (games[i].rank > 0) hasOnlyMobile = false;
      }
      addActionRow(hasOnlyMobile ? ['view_ipad', 'view_gaming', 'live_agent', 'main_menu'] : ['view_gaming', 'price_flow', 'rent_device_flow', 'live_agent', 'main_menu']);
    });
    return true;
  }

  function showGameRecommendationHub() {
    conversationContext.device = 'Gaming Laptop';
    conversationContext.recommendedPriceProductKey = 'gaming';
    replyBot('Tell me the game you want to play and I’ll suggest a suitable gaming laptop tier. You can also choose a common question below.', function () {
      addPlaybotCard('Game Recommendation',
        intentButtonHtml('gaming_game_recommendation', 'Which gaming laptop should I rent for my game?') +
        intentButtonHtml('gaming_higher_fps', 'I want higher FPS. Which laptop should I choose?') +
        intentButtonHtml('gaming_better_graphics', 'I want better graphics. Which laptop should I choose?') +
        intentButtonHtml('mobile_games_on_laptop', 'Can I play mobile games on a laptop?') +
        intentButtonHtml('gaming_event_rental', 'Can I rent gaming laptops for an event?')
      );
      addActionRow(['view_gaming', 'price_flow', 'rent_device_flow', 'back_product', 'main_menu']);
      input.focus();
    });
  }

  function showMacbookQuestions() {
    conversationContext.device = conversationContext.device || 'MacBook';
    showProductQuestionSet(
      'MacBook',
      'Here are the most common MacBook questions. You can also type your own question, such as “Can MacBook Air M1 run Docker?”.',
      [
        'macbook_overview',
        'macbook_selectable',
        'macbook_air_8gb_heavy_apps',
        'macbook_memory_options',
        'microsoft_office',
        'check_price'
      ],
      ['price_flow', 'view_macbook', 'rent_device_flow', 'back_product', 'main_menu']
    );
  }

  function showIpadQuestions() {
    conversationContext.device = conversationContext.device || 'iPad';
    showProductQuestionSet(
      'iPad',
      'Here are the most common iPad questions. You can also type your own question, such as “Can iPad be used for event registration?”.',
      [
        'ipad_overview',
        'ipad_event_registration',
        'ipad_optional_extras',
        'ipad_desktop_apps',
        'check_price',
        'available_periods'
      ],
      ['price_flow', 'view_ipad', 'rent_device_flow', 'back_product', 'main_menu']
    );
  }


  function handleProductQuestionAction(action, event) {
    if (action === 'product_business_questions') {
      if (event && event.preventDefault) event.preventDefault();
      if (event && event.stopPropagation) event.stopPropagation();
      addUserMessage('Business Laptop Rental Questions');
      showBusinessLaptopQuestions();
      return true;
    }
    if (action === 'product_gaming_questions') {
      if (event && event.preventDefault) event.preventDefault();
      if (event && event.stopPropagation) event.stopPropagation();
      addUserMessage('Gaming Laptop Rental Questions');
      showGamingLaptopQuestions();
      return true;
    }
    if (action === 'product_macbook_questions') {
      if (event && event.preventDefault) event.preventDefault();
      if (event && event.stopPropagation) event.stopPropagation();
      addUserMessage('MacBook Rental Questions');
      showMacbookQuestions();
      return true;
    }
    if (action === 'product_ipad_questions') {
      if (event && event.preventDefault) event.preventDefault();
      if (event && event.stopPropagation) event.stopPropagation();
      addUserMessage('iPad Rental Questions');
      showIpadQuestions();
      return true;
    }
    return false;
  }

  window.pfPlaybotProductQuestionClick = function (event, action) {
    if (event && event.__pfPlaybotHandled) return false;
    var currentRoot = document.getElementById('pf-playbot-root');
    if (currentRoot && currentRoot !== root) return true;
    if (event) event.__pfPlaybotHandled = true;
    return handleProductQuestionAction(action, event) ? false : true;
  };

  function showSoftwareCompatibilityCategories() {
    replyBot('Tell me the device and app if you need a specific answer, such as “Can MacBook Air M1 run Docker?”\n\nOr choose a topic below.', function () {
      addPlaybotCard('Software & app compatibility',
        intentButtonHtml('device_compatibility_comparison', 'Compare App Compatibility') +
        intentButtonHtml('business_i5_i7_difference', 'i5 or Ryzen 5 vs i7 or Ryzen 7') +
        intentButtonHtml('macbook_air_8gb_heavy_apps', 'MacBook Air M1 or M2 for Docker or heavy apps') +
        intentButtonHtml('macbook_exam_lockdown', 'MacBook Exam Browser or LockDown') +
        intentButtonHtml('gaming_development_ai', 'Gaming Laptop for coding, Docker and AI') +
        intentButtonHtml('ipad_desktop_apps', 'iPad for laptop software')
      );
      addActionRow(['back_main', 'main_menu']);
    });
  }

  function showRentalTncCategories() {
    replyBot('Which rental term would you like to check?', function () {
      addPlaybotCard('Rental terms & changes',
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rental_terms">Rental T&amp;C Summary</button>' +
        intentButtonHtml('cancel_rental', 'Cancellation policy') +
        intentButtonHtml('change_date', 'Change rental date') +
        intentButtonHtml('extension', 'Extend rental or need more days') +
        intentButtonHtml('early_return', 'Early return') +
        intentButtonHtml('late_return', 'Late return fee') +
        intentButtonHtml('missed_return_collection', 'Missed return collection') +
        intentButtonHtml('device_damaged', 'Device damaged') +
        intentButtonHtml('device_lost', 'Device lost or stolen') +
        intentButtonHtml('overseas_use', 'Can I bring the device overseas?') +
        intentButtonHtml('data_wipe', 'Will the device be formatted after return?')
      );
      addActionRow(['back_main', 'main_menu']);
    });
  }

  function showContactCategories() {
    replyBot('What would you like help with?', function () {
      addPlaybotCard('Contact Playforce',
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="rent_device_flow">Rental enquiry</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="price_flow">Price and quotation</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="availability_flow">Availability and urgent rental</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="corporate_flow">Corporate and bulk rental</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="issue_flow">Existing order or device issue</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="live_agent">Other question</button>' +
        '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="feedback">Submit Feedback</button>'
      );
      addActionRow(['back_main', 'main_menu']);
    });
  }

  function categoryButtonHtml(category, label) {
    return '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-category="' + escapeHtml(category) + '">' + escapeHtml(label || category) + '</button>';
  }

  function intentButtonHtml(id, label) {
    return '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-intent="' + escapeHtml(id) + '">' + escapeHtml(label) + '</button>';
  }

  function showCategory(category) {
    var items = [];
    for (var i = 0; i < qaBank.length; i += 1) {
      if (qaBank[i].category === category) items.push(qaBank[i]);
    }
    replyBot(category + ': please select one of the questions below.', function () {
      addChipRow(items, category);
      addActionRow(['back_main', 'main_menu']);
    });
  }

  function findIntentById(id) {
    for (var i = 0; i < qaBank.length; i += 1) {
      if (qaBank[i].id === id) return qaBank[i];
    }
    return null;
  }

  function scoreIntent(query, item) {
    var q = normalise(query);
    if (!q) return 0;
    var score = 0;
    var allPhrases = (item.phrases || []).concat([item.title || '']);
    for (var i = 0; i < allPhrases.length; i += 1) {
      var p = normalise(allPhrases[i]);
      if (!p) continue;
      if (q === p) score += 100;
      if (q.length >= 5 && (p.indexOf(q) !== -1 || q.indexOf(p) !== -1)) score += Math.min(45, p.length / 2);
    }

    var stopTokens = { i:1, me:1, my:1, you:1, your:1, need:1, help:1, can:1, a:1, an:1, the:1, is:1, are:1, do:1, does:1, to:1, for:1, with:1, and:1, or:1, hi:1, hello:1, yes:1, no:1, good:1 };
    var qTokens = q.split(' ');
    var keywords = item.keywords || [];
    var keywordText = normalise(keywords.join(' '));
    for (var j = 0; j < qTokens.length; j += 1) {
      var token = qTokens[j];
      if (token.length < 3 || stopTokens[token]) continue;
      for (var k = 0; k < keywords.length; k += 1) {
        var kw = normalise(keywords[k]);
        if (!kw) continue;
        if (kw === token) score += 16;
        else if (token.length >= 5 && kw.indexOf(token) !== -1) score += 10;
      }
      if (token.length >= 5 && keywordText.indexOf(token) !== -1) score += 6;
    }

    if (item.id === 'deposit_refundable' && q.indexOf('deposit') !== -1 && (q.indexOf('refund') !== -1 || q.indexOf('refundable') !== -1 || q.indexOf('get back') !== -1)) score += 60;
    if (item.id === 'early_return' && (isEarlyReturnConcern(q) || (q.indexOf('early') !== -1 && (q.indexOf('return') !== -1 || q.indexOf('refund') !== -1 || q.indexOf('rebate') !== -1)))) score += 120;
    if (item.id === 'self_collect' && /\b(self collect|self-collect|collect myself|ownself collect|pickup myself|pick up myself|pickup from shop|pick up from shop|collect from (your )?shop)\b/.test(q)) score += 95;
    if (item.id === 'self_return' && q.indexOf('self') !== -1 && q.indexOf('return') !== -1) score += 45;
    if (item.id === 'microsoft_office' && q.indexOf('office') !== -1) score += 45;
    if (item.id === 'seven_weeks' && (q.indexOf('7 week') !== -1 || q.indexOf('seven week') !== -1)) score += 65;
    if (item.id === 'exact_brand_model') {
      score += v90BrandModelScoreBoost(q);
      if (/\b(borrow|rent|rental|lease|hire)\b/.test(q) && /\b(play|game|gaming)\b/.test(q) && !v90IsBrandModelPreference(q)) score -= 90;
    }
    if (item.id === 'payment_options' && (q.indexOf('paynow') !== -1 || q.indexOf('payment') !== -1 || q.indexOf('credit card') !== -1 || q.indexOf('grab') !== -1 || q.indexOf('atome') !== -1 || q.indexOf('how to pay') !== -1)) score += 70;
    if (item.id === 'payment_delivery_confirmation' && /\b(will i get|will i receive|after payment|after paying|once i pay|if i pay|payment verified|deliver after payment)\b/.test(q) && /\b(laptop|device|macbook|ipad|deliver|receive|get it|get the)\b/.test(q)) score += 180;
    if (item.id === 'price_objection' && /\b(too expensive|price too high|rental price too high|cheaper|budget|discount|lower price|cheapest)\b/.test(q)) score += 165;
    if (item.id === 'return_collection_fee' && /\b(collection free|return collection|returning free|collect back|pickup after rental|return included|return charge|return free)\b/.test(q)) score += 155;
    if (item.id === 'required_documents' && (q.indexOf('nric') !== -1 || q.indexOf('document') !== -1 || q.indexOf('doc') !== -1)) score += 45;
    if (item.id === 'delivery_free' && (q.indexOf('got delivery') !== -1 || q.indexOf('delivery free') !== -1 || q.indexOf('send to me') !== -1)) score += 50;
    if (item.id === 'deposit_waived' && (q.indexOf('waive') !== -1 && q.indexOf('deposit') !== -1)) score += 55;
    if (item.id === 'minimum_rental_period' && (q.indexOf('minimum') !== -1 || q.indexOf('1 day') !== -1 || q.indexOf('one day') !== -1)) score += 55;
    if (item.id === 'next_day_after_7pm' && (q.indexOf('7pm') !== -1 || q.indexOf('after 7') !== -1) && (q.indexOf('tomorrow') !== -1 || q.indexOf('next day') !== -1)) score += 70;
    if (item.id === 'weekend_surcharge' && (q.indexOf('weekend') !== -1 || q.indexOf('saturday') !== -1 || q.indexOf('sunday') !== -1)) score += 55;
    if (item.id === 'mbs_surcharge' && (q.indexOf('mbs') !== -1 || q.indexOf('marina bay sands') !== -1)) score += 70;
    if (item.id === 'return_extension_charges' && q.indexOf('return') !== -1 && (q.indexOf('return timing') !== -1 || q.indexOf('return slot') !== -1 || q.indexOf('collection timing') !== -1 || q.indexOf('same day return') !== -1 || q.indexOf('1pm') !== -1 || q.indexOf('3pm') !== -1 || q.indexOf('5pm') !== -1)) score += 60;
    if (item.id === 'return_extension_charges' && isLateReturnConcern(q)) score -= 120;
    if (item.id === 'late_return' && isLateReturnConcern(q)) score += 170;
    if (item.id === 'extension' && isRentalExtensionConcern(q)) score += 140;
    if (item.id === 'missed_return_collection' && (q.indexOf('miss return') !== -1 || q.indexOf('missed collection') !== -1 || q.indexOf('miss collection') !== -1 || q.indexOf('forgot return') !== -1 || q.indexOf('not around') !== -1 || q.indexOf('courier') !== -1)) score += 125;
    if (item.id === 'foreigner_documents' && (q.indexOf('foreigner') !== -1 || q.indexOf('passport') !== -1 || q.indexOf('hotel') !== -1 || q.indexOf('tourist') !== -1)) score += 60;
    if (item.id === 'availability_stock' && (q.indexOf('available') !== -1 || q.indexOf('stock') !== -1 || q.indexOf('reserve') !== -1)) score += 80;
    if (item.id === 'same_day_urgent_rental' && (q.indexOf('urgent') !== -1 || q.indexOf('today') !== -1 || q.indexOf('same day') !== -1 || q.indexOf('now') !== -1)) score += 80;
    if (item.id === 'invoice_receipt' && (q.indexOf('invoice') !== -1 || q.indexOf('receipt') !== -1 || q.indexOf('quote') !== -1 || q.indexOf('billing') !== -1)) score += 75;
    if (item.id === 'accessories_included' && (q.indexOf('charger') !== -1 || q.indexOf('mouse') !== -1 || q.indexOf('bag') !== -1 || q.indexOf('accessor') !== -1)) score += 75;
    if (item.id === 'device_condition' && (q.indexOf('used') !== -1 || q.indexOf('preowned') !== -1 || q.indexOf('pre-owned') !== -1 || q.indexOf('second hand') !== -1 || q.indexOf('new') !== -1 || q.indexOf('condition') !== -1 || q.indexOf('scratch') !== -1 || q.indexOf('cosmetic') !== -1)) score += 125;
    if (item.id === 'battery_condition' && q.indexOf('battery') !== -1) score += 75;
    if (item.id === 'faulty_device_replacement' && (q.indexOf('faulty') !== -1 || q.indexOf('not working') !== -1 || q.indexOf('replace') !== -1 || q.indexOf('exchange') !== -1)) score += 80;
    if (item.id === 'internet_data_sim' && (q.indexOf('internet') !== -1 || q.indexOf('sim') !== -1 || q.indexOf('data') !== -1 || q.indexOf('wifi') !== -1)) score += 75;
    if (item.id === 'delivery_coverage' && (q.indexOf('hotel') !== -1 || q.indexOf('office') !== -1 || q.indexOf('school') !== -1 || q.indexOf('venue') !== -1 || q.indexOf('islandwide') !== -1)) score += 70;
    if (item.id === 'reserve_without_payment' && (q.indexOf('reserve') !== -1 || q.indexOf('hold') !== -1) && q.indexOf('payment') !== -1) score += 75;
    if (item.id === 'rent_without_documents' && (q.indexOf('without document') !== -1 || q.indexOf('no nric') !== -1 || q.indexOf('no proof') !== -1)) score += 75;
    if (item.id === 'event_roadshow_rental' && (q.indexOf('event') !== -1 || q.indexOf('roadshow') !== -1 || q.indexOf('training') !== -1 || q.indexOf('exam') !== -1)) score += 75;
    if (item.id === 'available_rental_devices' && ((q.indexOf('what devices') !== -1 || q.indexOf('what laptops') !== -1 || q.indexOf('what do you rent') !== -1 || q.indexOf('device options') !== -1 || q.indexOf('rental devices') !== -1) || (q.indexOf('playforce') !== -1 && q.indexOf('rent') !== -1 && (q.indexOf('devices') !== -1 || q.indexOf('laptops') !== -1)))) score += 95;
    if (item.id === 'change_upgrade_device' && (q.indexOf('upgrade') !== -1 || q.indexOf('change') !== -1 || q.indexOf('swap') !== -1 || q.indexOf('switch') !== -1 || q.indexOf('top up') !== -1) && (q.indexOf('model') !== -1 || q.indexOf('laptop') !== -1 || q.indexOf('device') !== -1 || q.indexOf('halfway') !== -1 || q.indexOf('during') !== -1)) score += 95;
    if (item.id === 'faulty_device_replacement' && (q.indexOf('faulty') !== -1 || q.indexOf('not working') !== -1 || q.indexOf('cannot turn on') !== -1 || q.indexOf('blue screen') !== -1 || q.indexOf('black screen') !== -1 || q.indexOf('hang') !== -1 || q.indexOf('crash') !== -1)) score += 95;
    if (item.id === 'missed_return_collection' && ((q.indexOf('miss') !== -1 || q.indexOf('not around') !== -1 || q.indexOf('cannot return') !== -1) && (q.indexOf('return') !== -1 || q.indexOf('collection') !== -1 || q.indexOf('courier') !== -1))) score += 90;
    if (item.id === 'authorised_receiver' && (q.indexOf('someone else') !== -1 || q.indexOf('colleague') !== -1 || q.indexOf('family') !== -1 || q.indexOf('authorised') !== -1 || q.indexOf('authorized') !== -1) && (q.indexOf('receive') !== -1 || q.indexOf('return') !== -1 || q.indexOf('handover') !== -1)) score += 85;
    if (item.id === 'windows_version_request' && (q.indexOf('windows 10') !== -1 || q.indexOf('windows 11') !== -1 || q.indexOf('windows version') !== -1 || q.indexOf('os version') !== -1)) score += 90;
    if (item.id === 'technical_setup_support' && ((q.indexOf('setup') !== -1 || q.indexOf('troubleshoot') !== -1 || q.indexOf('configure') !== -1 || q.indexOf('it support') !== -1) && (q.indexOf('software') !== -1 || q.indexOf('vpn') !== -1 || q.indexOf('apps') !== -1 || q.indexOf('laptop') !== -1))) score += 85;
    if (item.id === 'clean_formatted_before_delivery' && ((q.indexOf('format') !== -1 || q.indexOf('reset') !== -1 || q.indexOf('clean') !== -1 || q.indexOf('cleaned') !== -1) && (q.indexOf('before delivery') !== -1 || q.indexOf('laptop') !== -1 || q.indexOf('device') !== -1 || q.indexOf('rental') !== -1))) score += 145;
    if (item.id === 'lost_accessories' && (q.indexOf('lost') !== -1 || q.indexOf('missing') !== -1 || q.indexOf('lose') !== -1) && (q.indexOf('charger') !== -1 || q.indexOf('bag') !== -1 || q.indexOf('mouse') !== -1 || q.indexOf('adapter') !== -1 || q.indexOf('accessory') !== -1)) score += 90;

    if (item.id === 'gaming_game_recommendation' && (q.indexOf('game recommendation') !== -1 || q.indexOf('which laptop for') !== -1 || q.indexOf('which device for') !== -1 || q.indexOf('recommend') !== -1 || q.indexOf('popular games') !== -1 || findGameRecommendations(q).length)) score += 120;
    if (item.id === 'gaming_higher_fps' && (q.indexOf('high fps') !== -1 || q.indexOf('higher fps') !== -1 || q.indexOf('smooth fps') !== -1 || q.indexOf('144') !== -1 || q.indexOf('high refresh') !== -1)) score += 110;
    if (item.id === 'gaming_better_graphics' && (q.indexOf('better graphics') !== -1 || q.indexOf('high graphics') !== -1 || q.indexOf('ultra') !== -1 || q.indexOf('epic quality') !== -1 || q.indexOf('max settings') !== -1)) score += 110;
    if (item.id === 'mobile_games_on_laptop' && (q.indexOf('mobile game') !== -1 || q.indexOf('emulator') !== -1 || q.indexOf('pubg mobile') !== -1 || q.indexOf('mobile legends') !== -1 || q.indexOf('free fire') !== -1)) score += 115;
    if (item.id === 'gaming_event_rental' && ((q.indexOf('gaming') !== -1 || q.indexOf('game') !== -1 || findGameRecommendations(q).length) && (q.indexOf('event') !== -1 || q.indexOf('tournament') !== -1 || q.indexOf('multiple') !== -1 || q.indexOf('bulk') !== -1 || detectQuantityFromText(q)))) score += 110;

    if (item.id === 'deposit_deductions' && (
      /\b(deduct|deduction|minus|cut|forfeit|lose deposit|lose my deposit|charged|charge|compensate|compensation|pay extra)\b/.test(q) ||
      q.indexOf('deposit kena deduct') !== -1 ||
      q.indexOf('deposit kena minus') !== -1 ||
      q.indexOf('will you deduct') !== -1 ||
      q.indexOf('will you minus') !== -1 ||
      q.indexOf('what can affect my security deposit') !== -1 ||
      q.indexOf('cause deductions') !== -1
    )) score += 120;
    if (item.id === 'small_cosmetic_scratches' && (q.indexOf('scratch') !== -1 || q.indexOf('scratches') !== -1 || q.indexOf('cosmetic scratch') !== -1 || q.indexOf('small scratch') !== -1 || q.indexOf('slight scratch') !== -1)) score += 105;
    if (item.id === 'existing_cosmetic_marks' && ((q.indexOf('existing') !== -1 || q.indexOf('already') !== -1 || q.indexOf('before delivery') !== -1 || q.indexOf('documented') !== -1) && (q.indexOf('scratch') !== -1 || q.indexOf('cosmetic') !== -1 || q.indexOf('defect') !== -1 || q.indexOf('mark') !== -1 || q.indexOf('damage') !== -1))) score += 115;
    if (item.id === 'damage_payment_amount' && (q.indexOf('how much') !== -1 || q.indexOf('how much need') !== -1 || q.indexOf('need to pay') !== -1 || q.indexOf('need pay') !== -1 || q.indexOf('pay extra') !== -1) && (q.indexOf('damage') !== -1 || q.indexOf('damaged') !== -1 || q.indexOf('repair') !== -1 || q.indexOf('deduct') !== -1 || q.indexOf('minus') !== -1 || q.indexOf('compensation') !== -1)) score += 115;

    if (item.id === 'document_usage_privacy' && ((q.indexOf('how') !== -1 || q.indexOf('why') !== -1 || q.indexOf('safe') !== -1 || q.indexOf('privacy') !== -1 || q.indexOf('use') !== -1) && (q.indexOf('document') !== -1 || q.indexOf('nric') !== -1 || q.indexOf('proof of address') !== -1))) score += 135;
    if (item.id === 'device_unavailable_after_order' && ((q.indexOf('unavailable') !== -1 || q.indexOf('no stock') !== -1 || q.indexOf('out of stock') !== -1 || q.indexOf('stock change') !== -1 || q.indexOf('availability change') !== -1 || q.indexOf('cannot fulfil') !== -1) && (q.indexOf('after') !== -1 || q.indexOf('order') !== -1 || q.indexOf('payment') !== -1 || q.indexOf('checkout') !== -1 || q.indexOf('device') !== -1))) score += 135;
    if (item.id === 'upfront_payment_deposit' && ((q.indexOf('upfront') !== -1 || q.indexOf('pay first') !== -1 || q.indexOf('pay full') !== -1 || q.indexOf('pay both') !== -1 || q.indexOf('total payable') !== -1 || q.indexOf('during checkout') !== -1) && (q.indexOf('deposit') !== -1 || q.indexOf('rental fee') !== -1 || q.indexOf('pay') !== -1))) score += 130;
    if (item.id === 'find_my_not_off' && (q.indexOf('find my') !== -1 || q.indexOf('apple id') !== -1 || q.indexOf('icloud') !== -1) && (q.indexOf('forget') !== -1 || q.indexOf('forgot') !== -1 || q.indexOf('turn off') !== -1 || q.indexOf('sign out') !== -1 || q.indexOf('still') !== -1 || q.indexOf('return') !== -1)) score += 135;
    if (item.id === 'delivery_return_timing_change' && ((q.indexOf('change') !== -1 || q.indexOf('reschedule') !== -1 || q.indexOf('specific') !== -1 || q.indexOf('request') !== -1) && (q.indexOf('delivery') !== -1 || q.indexOf('return') !== -1 || q.indexOf('collection') !== -1 || q.indexOf('slot') !== -1 || q.indexOf('timing') !== -1 || q.indexOf('time') !== -1 || q.indexOf('address') !== -1))) score += 135;

    if (item.id === 'trust_rental_confidence' && (q.indexOf('legit') !== -1 || q.indexOf('trust') !== -1 || q.indexOf('scam') !== -1 || q.indexOf('uen') !== -1 || q.indexOf('registered') !== -1 || q.indexOf('safe to rent') !== -1 || q.indexOf('safe to order') !== -1 || q.indexOf('will you really deliver') !== -1 || q.indexOf('how do i know') !== -1)) score += 140;
    if (item.id === 'software_game_cannot_run' && ((q.indexOf('cannot run') !== -1 || q.indexOf('cant run') !== -1 || q.indexOf('can run') !== -1 || q.indexOf('not compatible') !== -1 || q.indexOf('too slow') !== -1 || q.indexOf('upgrade if') !== -1) && (q.indexOf('software') !== -1 || q.indexOf('app') !== -1 || q.indexOf('game') !== -1 || q.indexOf('program') !== -1 || q.indexOf('laptop') !== -1 || q.indexOf('device') !== -1))) score += 130;
    if (item.id === 'pre_rental_testing' && (q.indexOf('test first') !== -1 || q.indexOf('try first') !== -1 || q.indexOf('trial') !== -1 || q.indexOf('demo') !== -1 || q.indexOf('test before') !== -1 || q.indexOf('inspect before') !== -1)) score += 130;
    if (item.id === 'missed_delivery_return' && ((q.indexOf('miss') !== -1 || q.indexOf('nobody') !== -1 || q.indexOf('no one') !== -1 || q.indexOf('not home') !== -1 || q.indexOf('not around') !== -1 || q.indexOf('redelivery') !== -1 || q.indexOf('cannot receive') !== -1) && (q.indexOf('delivery') !== -1 || q.indexOf('return') !== -1 || q.indexOf('collection') !== -1 || q.indexOf('courier') !== -1 || q.indexOf('driver') !== -1))) score += 140;
    if (item.id === 'device_expectations' && (q.indexOf('new') !== -1 || q.indexOf('used') !== -1 || q.indexOf('pre-owned') !== -1 || q.indexOf('scratch') !== -1 || q.indexOf('condition') !== -1 || q.indexOf('clean') !== -1 || q.indexOf('what is included') !== -1 || q.indexOf('come with charger') !== -1 || q.indexOf('come with bag') !== -1)) score += 120;
    if (item.id === 'data_after_return' && (q.indexOf('data') !== -1 || q.indexOf('files') !== -1 || q.indexOf('format') !== -1 || q.indexOf('wipe') !== -1 || q.indexOf('icloud') !== -1 || q.indexOf('apple id') !== -1 || q.indexOf('find my') !== -1 || q.indexOf('backup') !== -1 || q.indexOf('log out') !== -1)) score += 125;
    if (item.id === 'install_apps_admin' && (q.indexOf('admin') !== -1 || q.indexOf('install') !== -1 || q.indexOf('download') !== -1 || q.indexOf('driver') !== -1 || q.indexOf('vpn') !== -1 || q.indexOf('printer') !== -1)) score += 125;
    if (item.id === 'internet_connectivity' && (q.indexOf('internet') !== -1 || q.indexOf('wifi') !== -1 || q.indexOf('wi fi') !== -1 || q.indexOf('sim') !== -1 || q.indexOf('data') !== -1 || q.indexOf('cellular') !== -1 || q.indexOf('hotspot') !== -1 || q.indexOf('dongle') !== -1 || q.indexOf('router') !== -1)) score += 125;
    if (item.id === 'multiple_device_rental' && ((detectQuantityFromText(q) && /\b(laptop|device|macbook|ipad|unit|units|pcs|pieces)\b/.test(q)) || q.indexOf('multiple device') !== -1 || q.indexOf('many device') !== -1 || q.indexOf('bulk') !== -1 || q.indexOf('event rental') !== -1 || q.indexOf('training rental') !== -1 || q.indexOf('roadshow') !== -1)) score += 135;
    if (item.id === 'someone_else_handover' && ((q.indexOf('someone else') !== -1 || q.indexOf('friend') !== -1 || q.indexOf('family') !== -1 || q.indexOf('staff') !== -1 || q.indexOf('colleague') !== -1 || q.indexOf('parent') !== -1 || q.indexOf('on my behalf') !== -1) && (q.indexOf('receive') !== -1 || q.indexOf('return') !== -1 || q.indexOf('collect') !== -1 || q.indexOf('rent') !== -1 || q.indexOf('documents') !== -1 || q.indexOf('nric') !== -1))) score += 135;

    if (item.id === 'device_damaged' && (q.indexOf('water damage') !== -1 || q.indexOf('liquid') !== -1 || q.indexOf('drop') !== -1 || q.indexOf('dropped') !== -1 || q.indexOf('fall') !== -1 || q.indexOf('dent') !== -1 || q.indexOf('dented') !== -1 || q.indexOf('crack') !== -1 || q.indexOf('cracked') !== -1)) score += 105;
    if (item.id === 'faulty_device_replacement' && (q.indexOf('keyboard') !== -1 || q.indexOf('display') !== -1 || q.indexOf('motherboard') !== -1 || q.indexOf('hardware') !== -1) && (q.indexOf('issue') !== -1 || q.indexOf('fault') !== -1 || q.indexOf('faulty') !== -1 || q.indexOf('spoil') !== -1 || q.indexOf('problem') !== -1)) score += 115;

    return score;
  }

  function findBestAnswer(query) {
    var match = findBestAnswerWithConfidence(query);
    return match && match.bestScore >= 12 ? match.answer : null;
  }

  function findBestAnswerWithConfidence(query) {
    var scored = [];
    for (var i = 0; i < qaBank.length; i += 1) {
      var score = scoreIntent(query, qaBank[i]);
      if (score > 0) scored.push({ item: qaBank[i], score: score });
    }

    scored.sort(function (a, b) { return b.score - a.score; });

    return {
      answer: scored.length ? scored[0].item : null,
      bestScore: scored.length ? scored[0].score : 0,
      second: scored.length > 1 ? scored[1] : null,
      third: scored.length > 2 ? scored[2] : null
    };
  }

  function shouldClarifyAnswerMatch(match, query) {
    if (!match || !match.answer || match.bestScore < 12) return false;
    if (!match.second || match.second.score < 12) return false;
    if (match.answer.id === match.second.item.id) return false;

    var q = normalise(query || '');
    if (match.bestScore >= 80) return false;
    if (match.bestScore - match.second.score > 8) return false;

    // Do not interrupt very clear high-intent flows.
    if (isRentalPriceEstimateQuestion(query) || isAvailabilityQuestion(query) || isCorporateEnquiry(query)) return false;
    if (/\b(how much|price|cost|got stock|available|quotation|invoice)\b/.test(q)) return false;

    return true;
  }


  /* v85 Context and Intent Router
     Broad words identify a topic only. Specific signals choose the exact answer.
     Previous context is used only for true follow-ups, not for strong new topics. */

  function v85HasWord(q, words) {
    q = normalise(q || '');
    for (var i = 0; i < words.length; i += 1) {
      var w = normalise(words[i]);
      if (!w) continue;
      if (q === w || q.indexOf(w) !== -1) return true;
    }
    return false;
  }

  function v85HasAnyRegex(q, regex) {
    q = normalise(q || '');
    return regex.test(q);
  }

  function v85HasFollowUpCue(text) {
    var q = normalise(text || '');
    if (!q) return false;
    return /\b(it|this|that|same one|same laptop|same device|same model|that laptop|the laptop|the device|what about|how about|then|also|and for|for 1 day|for 2 day|for 3 day|for 5 day|for 1 week|for 2 week|for 1 month|for 2 month|for 3 month|for three month|for two month|for one month|for a month)\b/.test(q) ||
      (!!detectDurationFromText(q) && !getCanonicalDeviceLabelFromText(q));
  }

  function v85HasStrongNewTopic(text) {
    var q = normalise(text || '');
    if (!q) return false;
    return /\b(deposit|security deposit|document|documents|nric|proof of address|delivery|deliver|return|late return|early return|invoice|quotation|quote|software|install|admin|internet|wifi|wi fi|sim|mobile data|data|damage|damaged|scratch|scratches|trust|legit|scam|uen|payment|paynow|company|corporate|bulk|availability|available|stock|change|extend|refund|waive|offset|find my|icloud|apple id)\b/.test(q);
  }

  function v85IsPriceTopic(text) {
    var q = normalise(text || '');
    if (!q) return false;
    return /\b(price|pricing|how much to rent|rental fee|rental price|rate|quote for|quotation for|cost to rent)\b/.test(q) ||
      (!!getCanonicalDeviceLabelFromText(q) && /\b(how much|price|cost|fee|rate|1 month|2 month|3 month|1 week|2 week|3 day|5 day)\b/.test(q));
  }

  function v85ShouldExitPriceState(text) {
    var q = normalise(text || '');
    if (!q || !priceState) return false;
    if (isPriceDurationFollowUp(q) || isRentalPriceEstimateQuestion(q) || v85IsPriceTopic(q)) return false;
    if (v85HasStrongNewTopic(q)) return true;
    return false;
  }

  function v85DepositSubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(deposit|security deposit)\b/.test(q)) return '';

    if (/\b(must|required|compulsory|need deposit|need to pay deposit|have deposit|is there deposit|got deposit|deposit required|deposit compulsory)\b/.test(q)) return 'security_deposit_required';
    if (/\b(how much|amount|deposit amount|upfront|pay upfront|total payable)\b/.test(q)) return 'deposit_amount';
    if (/\b(refund|refundable|get back|return deposit|when.*deposit|deposit return)\b/.test(q)) return 'deposit_refundable';
    if (/\b(waive|waived|reduce|discount|no need deposit|without deposit|skip deposit)\b/.test(q)) return 'deposit_waived';
    if (/\b(offset|use deposit|deduct rental|cover rental|deposit as payment)\b/.test(q)) return 'deposit_offset';
    if (/\b(deduct|deduction|minus|cut|forfeit|lose|charged|charge|compensate|compensation|scratch|scratches|cosmetic|dent|damage|damaged|water|liquid|drop|dropped|fall|crack|broken|lost|stolen|missing)\b/.test(q)) return 'deposit_deductions';

    return '';
  }

  function v85ReturnSubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(return|collection|collect back|handover back|self return|drop off|send back|extend|extension)\b/.test(q)) return '';

    if (isEarlyReturnConcern(q)) return 'early_return';
    if (isLateReturnConcern(q)) return 'late_return';
    if (isRentalExtensionConcern(q)) return 'extension';
    if (/\b(self return|self-return|drop off|send back myself|return myself|ownself return)\b/.test(q)) return 'self_return';
    if (/\b(miss return|missed return|miss collection|missed collection|missed return collection|forgot return|not around|nobody|no one)\b/.test(q)) return 'missed_return_collection';
    if (/\b(change|reschedule|specific|request|change return|return timing|return slot|collection timing|return time)\b/.test(q)) return 'delivery_return_timing_change';
    if (/\b(different return|different location|another location|another address|return address)\b/.test(q)) return 'different_return_location';

    return '';
  }

  function v85DeliverySubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(delivery|deliver|send|self collect|pickup|pick up|receive|handover|redelivery|courier|driver|slot|timing)\b/.test(q)) return '';

    if (/\b(self collect|self-collect|pickup|pick up|collect from|ownself collect|collect myself)\b/.test(q)) return 'self_collect';
    if (/\b(free|charge|delivery charge|delivery fee|included|send to me)\b/.test(q)) return 'delivery_free';
    if (/\b(timing|slot|morning|evening|delivery time|time slot|choose time)\b/.test(q)) return 'delivery_timing';
    if (/\b(urgent|priority|asap|today|same day|now|8am|11am|1pm)\b/.test(q)) return 'urgent_delivery_charges';
    if (/\b(tomorrow|next day)\b/.test(q)) return 'deliver_tomorrow';
    if (/\b(miss|missed|nobody|no one|not home|not around|redelivery|cannot receive|courier|driver)\b/.test(q)) return 'missed_delivery_return';
    if (/\b(someone else|friend|family|staff|colleague|parent|on my behalf|receive on behalf)\b/.test(q)) return 'someone_else_handover';
    if (/\b(change|reschedule|specific|request|address|delivery timing|delivery slot|delivery time)\b/.test(q)) return 'delivery_return_timing_change';
    if (/\b(hotel|office|school|venue|islandwide|condo|event)\b/.test(q)) return 'delivery_coverage';

    return '';
  }

  function v85PaymentSubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(pay|payment|price|pricing|how much|cost|fee|rate|total|payable|paynow|card|credit card|grab|atome|damage charge|late fee)\b/.test(q)) return '';

    if (/\b(late return|return late|late fee|late charge|late penalty|overdue)\b/.test(q)) return 'late_return';
    if (/\b(damage|damaged|repair|replacement|deduct|minus|compensation|lost|stolen)\b/.test(q)) return 'damage_payment_amount';
    if (/\b(deposit|security deposit|upfront|pay first|pay full|total payable)\b/.test(q)) return 'upfront_payment_deposit';
    if (/\b(paynow|credit card|card|grab|atome|payment method|how to pay)\b/.test(q)) return 'payment_options';
    if (/\b(rent|rental|laptop|macbook|ipad|gaming|business)\b/.test(q) && /\b(how much|price|pricing|cost|fee|rate|quote)\b/.test(q)) return 'price';

    return '';
  }

  function v85SoftwareSubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(software|app|apps|program|install|download|admin|driver|vpn|printer|adobe|photoshop|illustrator|premiere|python|visual studio|vs code|docker|sql|game|games|can run|cannot run|too slow|compatible|compatibility|support|setup|troubleshoot)\b/.test(q)) return '';

    if (/\b(install|download|admin|administrator|driver|vpn|printer|steam|epic games|own software|company software|exam browser)\b/.test(q)) return 'install_apps_admin';
    if (/\b(cannot run|cant run|can't run|cannot play|too slow|not powerful|not suitable|not compatible|upgrade if|change if|software cannot|app cannot|game cannot)\b/.test(q)) return 'software_game_cannot_run';
    if (/\b(setup|troubleshoot|support|help install|configure|it support)\b/.test(q)) return 'software_support';
    if (/\b(adobe|photoshop|illustrator|premiere|design|video editing)\b/.test(q)) return 'adobe_apps';
    if (/\b(python|visual studio|vs code|coding|programming)\b/.test(q)) return 'coding_apps';
    if (/\b(docker|sql|database|backend)\b/.test(q)) return 'docker_sql';
    if (/\b(ai|chatgpt|copilot|local ai|cloud ai)\b/.test(q)) return 'ai_apps';

    return '';
  }

  function v85DataSubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(data|files|format|wipe|delete|privacy|icloud|apple id|find my|backup|log out|logout|internet|wifi|wi fi|sim|mobile data|cellular|hotspot)\b/.test(q)) return '';

    if (/\b(internet|wifi|wi fi|sim|mobile data|cellular|hotspot|dongle|router|data included|got data)\b/.test(q)) return 'internet_connectivity';
    if (/\b(files|format|wipe|delete|privacy|personal|company files|icloud|apple id|find my|backup|log out|logout|after return|my data|data safe)\b/.test(q)) return 'data_after_return';

    return '';
  }

  function v85ChangeSubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(change|switch|swap|upgrade|reschedule|extend|extension|different)\b/.test(q)) return '';

    if (/\b(upgrade|better model|another model|different model|switch model|swap laptop|change laptop|change device|change model|top up|halfway)\b/.test(q)) return 'change_upgrade_device';
    if (/\b(extend|extension|more days|longer|keep longer|use longer)\b/.test(q)) return 'extension';
    if (/\b(return timing|return slot|collection timing|delivery timing|delivery slot|delivery time|reschedule|change time)\b/.test(q)) return 'delivery_return_timing_change';
    if (/\b(date|start date|rental date|postpone)\b/.test(q)) return 'change_date';
    if (/\b(location|address|return address|delivery address|different return)\b/.test(q)) return 'different_return_location';

    return '';
  }

  function v85AvailabilitySubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(available|availability|stock|got stock|reserve|hold|urgent|today|tomorrow|same day|after order|after payment|unavailable|out of stock)\b/.test(q)) return '';

    if (/\b(unavailable|out of stock|no stock after|after order|after payment|after checkout|cannot fulfil)\b/.test(q)) return 'device_unavailable_after_order';
    if (/\b(urgent|today|same day|now|asap)\b/.test(q)) return 'same_day_urgent_rental';
    if (/\b(tomorrow|next day)\b/.test(q)) return 'deliver_tomorrow';
    if (/\b(reserve|hold)\b/.test(q) && /\b(without payment|before payment|no payment)\b/.test(q)) return 'reserve_without_payment';
    if (/\b(available|availability|stock|got stock)\b/.test(q)) return 'availability_stock';

    return '';
  }

  function v85CompanySubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(company|corporate|bulk|quotation|quote|invoice|receipt|acra|name card|multiple|2 laptop|3 laptop|5 laptop|10 laptop|event|training|roadshow|school|exam)\b/.test(q)) return '';

    if (/\b(invoice|receipt|billing)\b/.test(q)) return 'invoice_receipt';
    if (/\b(quotation|quote|official quote)\b/.test(q)) return 'quotation';
    if (/\b(acra|name card|company document|corporate document)\b/.test(q)) return 'company_documents';
    if (isCorporateEnquiry(q) || /\b(bulk|multiple|event|training|roadshow|school|exam|2 laptop|3 laptop|5 laptop|10 laptop|units|staff|students)\b/.test(q)) return 'multiple_device_rental';

    return '';
  }

  function v85GamingSubIntentId(text) {
    var q = normalise(text || '');
    if (!/\b(gaming|game|games|fps|graphics|gpu|gtx|rtx|roblox|minecraft|fortnite|valorant|dota|league|warzone|gta|counter strike|cs2|apex|palworld|overwatch|genshin|honkai|helldivers|rocket league|mobile legends|pubg|free fire|candy crush)\b/.test(q)) return '';

    if (/\b(mobile legends|pubg mobile|free fire|candy crush|emulator)\b/.test(q)) return 'mobile_games_on_laptop';
    if (/\b(high fps|higher fps|144hz|smooth fps|fps)\b/.test(q)) return 'gaming_higher_fps';
    if (/\b(better graphics|ultra|max settings|high settings|graphics)\b/.test(q)) return 'gaming_better_graphics';
    if (/\b(event|tournament|competition|multiple|10 laptop|5 laptop|roblox event)\b/.test(q)) return 'gaming_event_rental';
    if (isGameRecommendationQuestion(q) || /\b(roblox|minecraft|fortnite|valorant|dota|league|warzone|gta|counter strike|cs2|apex|palworld|overwatch|genshin|honkai|helldivers|rocket league|which laptop for|which device for)\b/.test(q)) return 'gaming_game_recommendation';

    return '';
  }

  function v85GetExactIntentId(text) {
    var q = normalise(text || '');
    if (!q) return '';

    var id = v85DepositSubIntentId(q) || v85ReturnSubIntentId(q) || v85DeliverySubIntentId(q) || v85PaymentSubIntentId(q) || v85DataSubIntentId(q) || v85SoftwareSubIntentId(q) || v85AvailabilitySubIntentId(q) || v85ChangeSubIntentId(q) || v85CompanySubIntentId(q) || v85GamingSubIntentId(q);
    if (id) return id;
    return '';
  }

  function v85GenericTopicClarification(text) {
    var q = normalise(text || '');
    if (!q) return null;

    if (/^(deposit|security deposit|about deposit|security deposit\?)$/.test(q)) {
      return {
        topic: 'security_deposit',
        message: 'Sure. What would you like to know about the security deposit?',
        options: [
          { label: 'Is deposit required?', intent: 'security_deposit_required' },
          { label: 'How much is deposit?', intent: 'deposit_amount' },
          { label: 'When is deposit refunded?', intent: 'deposit_refundable' },
          { label: 'What causes deductions?', intent: 'deposit_deductions' }
        ]
      };
    }

    if (/^(return|can return|return how|how to return|return\?)$/.test(q)) {
      return {
        topic: 'return',
        message: 'Do you mean returning early, returning late, return collection, or changing return timing?',
        options: [
          { label: 'Return early', intent: 'early_return' },
          { label: 'Late return fee', intent: 'late_return' },
          { label: 'Return collection', intent: 'self_return' },
          { label: 'Change return timing', intent: 'delivery_return_timing_change' }
        ]
      };
    }

    if (/^(delivery|deliver|delivery\?|deliver\?)$/.test(q)) {
      return {
        topic: 'delivery',
        message: 'Are you asking about delivery charges, delivery timing, urgent delivery, or missed delivery?',
        options: [
          { label: 'Delivery charges', intent: 'delivery_free' },
          { label: 'Delivery timing', intent: 'delivery_timing' },
          { label: 'Urgent delivery', intent: 'urgent_delivery_charges' },
          { label: 'Missed delivery', intent: 'missed_delivery_return' }
        ]
      };
    }

    if (/^(need pay|how much need pay|how much do i need to pay|payment|pay|pay\?)$/.test(q)) {
      return {
        topic: 'payment',
        message: 'Are you asking about rental price, deposit, payment method, damage charges, or late return fee?',
        options: [
          { label: 'Rental price', action: 'price_flow' },
          { label: 'Deposit upfront', intent: 'upfront_payment_deposit' },
          { label: 'Payment method', intent: 'payment_options' },
          { label: 'Damage charges', intent: 'damage_payment_amount' },
          { label: 'Late return fee', intent: 'late_return' }
        ]
      };
    }

    if (/^(software|software\?|apps|app|can run|compatible|compatibility)$/.test(q)) {
      return {
        topic: 'software',
        message: 'Are you asking whether you can install software, whether a software can run, or whether Playforce provides software support?',
        options: [
          { label: 'Install apps and admin access', intent: 'install_apps_admin' },
          { label: 'Software or game cannot run', intent: 'software_game_cannot_run' },
          { label: 'Software support', intent: 'software_support' },
          { label: 'Compatibility guide', intent: 'device_compatibility_comparison' }
        ]
      };
    }

    if (/^(data|data\?|got data|data included)$/.test(q)) {
      return {
        topic: 'data',
        message: 'Are you asking about personal files after return, or internet and mobile data?',
        options: [
          { label: 'Personal files after return', intent: 'data_after_return' },
          { label: 'Internet and mobile data', intent: 'internet_connectivity' }
        ]
      };
    }

    if (/^(can change|change|change\?|can switch|switch)$/.test(q)) {
      return {
        topic: 'change',
        message: 'Do you mean changing the device, rental date, delivery timing, or return timing?',
        options: [
          { label: 'Change or upgrade device', intent: 'change_upgrade_device' },
          { label: 'Change rental date', intent: 'change_date' },
          { label: 'Change delivery timing', intent: 'delivery_return_timing_change' },
          { label: 'Change return timing', intent: 'delivery_return_timing_change' }
        ]
      };
    }

    if (/^(available|availability|got stock|stock|available\?)$/.test(q)) {
      return {
        topic: 'availability',
        message: 'Are you checking device availability, urgent delivery, or availability after placing an order?',
        options: [
          { label: 'Device availability', intent: 'availability_stock' },
          { label: 'Urgent rental', intent: 'same_day_urgent_rental' },
          { label: 'Unavailable after order', intent: 'device_unavailable_after_order' }
        ]
      };
    }

    if (/^(gaming laptop|gaming|game|games|gaming laptop\?)$/.test(q)) {
      return {
        topic: 'gaming',
        message: 'Are you checking gaming laptop price, game recommendation, GPU options, or gaming event rental?',
        options: [
          { label: 'Game recommendation', intent: 'gaming_game_recommendation' },
          { label: 'Gaming laptop price', action: 'price_flow' },
          { label: 'GPU options', intent: 'gaming_gpu_options' },
          { label: 'Gaming event rental', intent: 'gaming_event_rental' }
        ]
      };
    }

    if (/^(company rental|corporate rental|bulk rental|company|corporate)$/.test(q)) {
      return {
        topic: 'company',
        message: 'Are you asking about multiple-device rental, quotation and invoice, or company documents?',
        options: [
          { label: 'Multiple-device rental', intent: 'multiple_device_rental' },
          { label: 'Quotation and invoice', intent: 'invoice_receipt' },
          { label: 'Company documents', intent: 'company_documents' },
          { label: 'Start corporate enquiry', action: 'start_corporate_enquiry' }
        ]
      };
    }

    return null;
  }

  function maybeShowV85TopicClarification(text) {
    var hub = v85GenericTopicClarification(text);
    if (!hub) return false;
    unresolvedCount = 0;
    setLastAnswerMeta('v85_topic_clarification', 'Topic clarification: ' + hub.topic, 'Clarification', 'clarification');
    trackPlaybotEvent('topic_clarification', { query: text, topic: hub.topic, botOutcome: 'clarification' });
    replyBot(hub.message, function () {
      addClarificationOptions(hub.options);
      addActionRow(['live_agent', 'main_menu']);
    });
    return true;
  }

  function v85UseMemoryForPrice(text) {
    var q = normalise(text || '');
    if (!q) return false;
    if (getCanonicalDeviceLabelFromText(q)) return true;
    if (!conversationContext.device && !conversationContext.confirmedPriceDevice) return false;
    if (v85HasStrongNewTopic(q) && !v85IsPriceTopic(q)) return false;
    if (v101IsGenericPriceRequest(q) && !v101CanUseStoredPriceContext(q)) return false;
    return v85HasFollowUpCue(q) || /\b(how much|price|cost|fee|rate|total|payable|quote)\b/.test(q);
  }




  /* v86 Repeated Question Recovery
     If the customer repeats or rephrases a very similar question after a generic answer,
     Playbot should not repeat the same generic answer. It should run deeper entity and
     specific-intent matching first, then only clarify if still genuinely unclear. */

  function v86RememberUserQuestion(text) {
    var q = String(text || '').trim();
    if (!q) return;
    if (!Array.isArray(lastUserQuestions)) lastUserQuestions = [];
    lastUserQuestions.push(q);
    if (lastUserQuestions.length > 4) lastUserQuestions = lastUserQuestions.slice(lastUserQuestions.length - 4);
  }

  function v86MeaningfulTokens(text) {
    var q = normalise(text || '');
    if (!q) return [];
    q = q.replace(/[^a-z0-9\s]/g, ' ');
    var raw = q.split(/\s+/);
    var stop = {
      'a': true, 'an': true, 'the': true, 'is': true, 'are': true, 'am': true, 'i': true, 'me': true, 'my': true,
      'you': true, 'your': true, 'for': true, 'to': true, 'of': true, 'in': true, 'on': true, 'at': true,
      'and': true, 'or': true, 'it': true, 'this': true, 'that': true, 'can': true, 'do': true, 'does': true,
      'did': true, 'will': true, 'would': true, 'should': true, 'please': true, 'pls': true, 'yup': true,
      'yes': true, 'yeah': true, 'ok': true, 'okay': true, 'hi': true, 'hello': true
    };
    var tokens = [];
    for (var i = 0; i < raw.length; i += 1) {
      var t = raw[i];
      if (!t || stop[t]) continue;
      if (t.length < 2 && !/^\d+$/.test(t)) continue;
      if (tokens.indexOf(t) === -1) tokens.push(t);
    }
    return tokens;
  }

  function v86TokenSimilarity(a, b) {
    var ta = v86MeaningfulTokens(a);
    var tb = v86MeaningfulTokens(b);
    if (!ta.length || !tb.length) return 0;
    var union = ta.slice(0);
    var intersection = 0;
    for (var i = 0; i < tb.length; i += 1) {
      if (union.indexOf(tb[i]) === -1) union.push(tb[i]);
      if (ta.indexOf(tb[i]) !== -1) intersection += 1;
    }
    return union.length ? intersection / union.length : 0;
  }

  function v86IsSimilarToAnyRecentQuestion(text, previousQuestions) {
    if (!Array.isArray(previousQuestions) || !previousQuestions.length) return false;
    var q = normalise(text || '');
    if (!q) return false;
    var currentTokens = v86MeaningfulTokens(q);
    if (currentTokens.length < 2) return false;

    for (var i = previousQuestions.length - 1; i >= 0; i -= 1) {
      var prev = normalise(previousQuestions[i] || '');
      if (!prev || prev === q) continue;
      var prevTokens = v86MeaningfulTokens(prev);
      if (prevTokens.length < 2) continue;
      var sim = v86TokenSimilarity(q, prev);
      if (sim >= 0.42) return true;

      var shorter = q.length <= prev.length ? q : prev;
      var longer = q.length > prev.length ? q : prev;
      if (shorter.length >= 12 && longer.indexOf(shorter) !== -1) return true;

      var sharedImportant = 0;
      for (var j = 0; j < currentTokens.length; j += 1) {
        if (prevTokens.indexOf(currentTokens[j]) !== -1) sharedImportant += 1;
      }
      if (sharedImportant >= 2 && (q.indexOf('which') !== -1 || q.indexOf('how') !== -1 || q.indexOf('can') !== -1 || q.indexOf('need') !== -1 || q.indexOf('must') !== -1 || q.indexOf('return') !== -1 || q.indexOf('deposit') !== -1)) return true;
    }
    return false;
  }

  function v86WasPreviousAnswerGenericOrClarifying() {
    if (!lastAnswerMeta) return false;
    var id = lastAnswerMeta.answerId || '';
    var type = lastAnswerMeta.responseType || '';
    var category = lastAnswerMeta.answerCategory || '';
    if (type === 'clarification' || category === 'Clarification') return true;
    return /^(v85_topic_clarification|confidence_clarification|generic_help_prompt|frustration_recovery|gaming_game_recommendation)$/.test(id);
  }

  function v86IsBroadGenericIntentId(intentId) {
    return /^(gaming_game_recommendation)$/.test(intentId || '');
  }

  function v86ShouldTryRepeatedQuestionRecovery(text, previousQuestions) {
    if (!v86WasPreviousAnswerGenericOrClarifying()) return false;
    if (!v86IsSimilarToAnyRecentQuestion(text, previousQuestions)) return false;
    if (isPoliteAcknowledgement(text) || isGreeting(text)) return false;
    return true;
  }

  function v86ShowSpecificIntent(intentId, rawText) {
    if (!intentId) return false;
    if (intentId === 'price') {
      showRentalPriceEstimate(applyMemoryToText(rawText));
      return true;
    }
    if (intentId === 'gaming_game_recommendation') {
      showGameRecommendationForText(rawText);
      return true;
    }
    if (intentId === 'same_day_urgent_rental') {
      startEnquiryFlow('urgent', rawText);
      return true;
    }
    if (intentId === 'availability_stock') {
      startEnquiryFlow('availability', rawText);
      return true;
    }
    var item = findIntentById(intentId);
    if (item) {
      showAnswer(item);
      return true;
    }
    return false;
  }

  function maybeHandleV86RepeatedQuestionRecovery(text, previousQuestions) {
    if (!v86ShouldTryRepeatedQuestionRecovery(text, previousQuestions)) return false;

    trackPlaybotEvent('repeated_question_recovery', {
      query: text,
      previousQuestions: previousQuestions || [],
      previousAnswerId: lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '',
      previousAnswerTitle: lastAnswerMeta && lastAnswerMeta.answerTitle ? lastAnswerMeta.answerTitle : '',
      botOutcome: 'deep_matching_started'
    });

    logDissatisfactionSignal('repeated_similar_question_after_generic_answer', text, inferPlaybotQuestionTopic(text));

    // 1. Entity-specific game handling. This fixes cases such as:
    // "which device recommended for dota" → generic prompt → "which laptop for dota 2".
    if (findGameRecommendations(text).length) {
      showGameRecommendationForText(text);
      return true;
    }

    // 2. Specific router intent, if it is not merely the same broad generic hub again.
    var exactIntent = v85GetExactIntentId(text);
    if (exactIntent && !v86IsBroadGenericIntentId(exactIntent)) {
      if (v86ShowSpecificIntent(exactIntent, text)) return true;
    }

    // 3. High-confidence direct detectors that do not depend on broad FAQ scoring.
    if (isRentalPriceEstimateQuestion(text) || isContextualPriceQuestion(text)) {
      showRentalPriceEstimate(applyMemoryToText(text));
      return true;
    }
    if (isSmartCompatibilityQuestion(text)) {
      showSmartCompatibilityAnswer(text);
      return true;
    }
    if (isEarlyReturnConcern(text)) {
      showAnswer(findIntentById('early_return'));
      return true;
    }
    if (isLateReturnConcern(text)) {
      showAnswer(findIntentById('late_return'));
      return true;
    }
    if (isDepositDeductionConcern(text)) {
      showAnswer(findIntentById('deposit_deductions'));
      return true;
    }

    // 4. If scoring finds a different answer from the previous one, use it.
    var match = findBestAnswerWithConfidence(text);
    if (match && match.answer && match.bestScore >= 12 && (!lastAnswerMeta || match.answer.id !== lastAnswerMeta.answerId)) {
      showAnswer(match.answer);
      return true;
    }

    // 5. Still unclear: do not repeat the same generic answer. Ask a narrower recovery question.
    setLastAnswerMeta('v86_recovery_clarification', 'Repeated question recovery clarification', 'Clarification', 'clarification');
    replyBot('Sorry, I may have misunderstood your question earlier. Could you choose the closest topic below?', function () {
      addActionRow(['price_flow', 'rental_faq', 'rent_device_flow', 'live_agent', 'main_menu']);
    });
    return true;
  }

  function inferPlaybotQuestionTopic(text) {
    var q = normalise(text || '');
    if (!q) return '';
    try {
      if (v100IsGenericRentalOnly(q)) return 'rental_entry_device';
      if (v100IsDeviceConditionQuestion(q)) return v100DeviceConditionIntentId(q);
      if (v100IsPaymentDeliveryConfirmationQuestion(q)) return 'payment_delivery_confirmation';
      if (v100IsReturnCollectionFeeQuestion(q)) return 'return_collection_fee';
      if (v100FeePolicyIntentId(q)) return v100FeePolicyIntentId(q);
      if (v100IsPriceObjection(q)) return 'price_objection';
      if (v100IsDeviceRecommendationQuestion(q)) return 'device_recommendation';
      if (isRentalProcessQuestion(q)) return 'rental_process';
      if (isTrustQuestion(q)) return 'trust_rental_confidence';
      if (isEarlyReturnConcern(q)) return 'early_return';
      if (isLateReturnConcern(q)) return 'late_return';
      if (isRentalExtensionConcern(q)) return 'extension';
      if (isDepositDeductionConcern(q)) return 'deposit_deductions';
      if (isExistingCosmeticDefectConcern(q)) return 'existing_cosmetic_marks';
      if (isSmallScratchConcern(q)) return 'small_cosmetic_scratches';
      if (isDamagePaymentAmountConcern(q)) return 'damage_payment_amount';
      if (isFaultyDeviceQuestion(q)) return 'faulty_device_replacement';
      if (isInvoiceReceiptQuestion(q)) return 'invoice_receipt';
      if (isCorporateEnquiry(q)) return 'corporate_or_multiple_device';
      if (isUrgentRentalRequest(q)) return 'urgent_rental';
      if (isAvailabilityQuestion(q)) return 'availability';
      if (isRentalPriceEstimateQuestion(q) || isContextualPriceQuestion(q)) return 'price';
      if (isGameRecommendationQuestion(q)) return 'game_recommendation';
      if (isSmartCompatibilityQuestion(q)) return 'software_compatibility';
      if (isLiveAgentRequest(q)) return 'live_agent_request';
      if (isFeedbackRequest(q)) return 'feedback_request';
      var match = findBestAnswerWithConfidence(q);
      if (match && match.answer && match.bestScore >= 12) return match.answer.id || match.answer.category || '';
    } catch (error) {}
    return '';
  }

  function detectAnswerDissatisfactionSignal(text, currentTopic) {
    var q = normalise(text || '');
    if (!q) return null;

    var hasPreviousAnswer = !!(lastAnswerMeta && lastAnswerMeta.answerId);
    var afterRecentAnswer = lastAnswerTimestamp && ((Date.now() - lastAnswerTimestamp) < 8 * 60 * 1000);
    var hasRecentAnswer = hasPreviousAnswer && afterRecentAnswer;

    // These phrases are useful improvement signals even if the customer has not clicked WhatsApp yet.
    // They should be captured immediately so Playforce can see what Playbot is failing to answer clearly.
    if (/\b(wrong|you are wrong|that is wrong|not correct|incorrect|answer wrong|bot wrong|not this|not the answer|not what i mean|not what i asked|misunderstood|you misunderstood|never answer|didnt answer|didn't answer|doesnt answer|doesn't answer|irrelevant|not helpful|useless|bad answer|not really|nope|no this is wrong|no not this)\b/.test(q)) {
      return 'customer_rejected_answer';
    }

    if (/\b(huh|har|alamak|aiyo|what talking|cannot understand|dont understand|don't understand|confusing|unclear|blur|wrong leh|no leh|no lah|lol no|bro no)\b/.test(q)) {
      return 'frustration_language';
    }

    if (/\b(i mean|i meant|i said|i ask|i asked|not asking|i am asking|im asking|i'm asking|you mean|you mean to say)\b/.test(q)) {
      return 'wrong_intent_detected';
    }

    if (/\b(what do you mean|meaning|explain|can explain|so can or cannot|can or not|yes or no|then how|so how|so need pay|need pay or not|so can rent|so can or not)\b/.test(q)) {
      return 'answer_not_clear_enough';
    }

    if (/\b(human|agent|staff|person|real person|talk to someone|speak to someone|call me|whatsapp me|customer service|live agent|someone help)\b/.test(q)) {
      return 'asked_for_human';
    }

    if (/\b(not sure|confused|abit confusing|a bit confusing|why|how come|are you sure|really|confirm|guarantee|sure or not)\b/.test(q)) {
      return 'uncertainty_after_answer';
    }

    if (/\b(exact price|exact model|exact timing|exact amount|confirmed or not|available or not|stock have|got stock|final price|final amount)\b/.test(q)) {
      return 'wanted_more_specific_answer';
    }

    if (lastUserTopic && currentTopic && lastUserTopic === currentTopic && lastUserQuestion && lastUserQuestion !== q && /\b(but|so|still|again|mean|means|will|how|what|can|cannot|need|pay|deduct|minus|return|price|available)\b/.test(q)) {
      // A repeated gaming intent with a new game name is a valid follow-up, not dissatisfaction.
      if (currentTopic === 'game_recommendation' && v100HasNewGameEntity(q, lastUserQuestion || '')) return null;
      return 'repeated_same_intent';
    }

    return null;
  }

  function logDissatisfactionSignal(signal, query, currentTopic) {
    if (!signal) return;
    try {
      lastDissatisfactionSignal = {
        signal: signal,
        query: compactText(query, 500),
        previousQuestion: compactText(lastUserQuestion, 500),
        previousAnswerId: lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '',
        previousAnswerTitle: lastAnswerMeta && lastAnswerMeta.answerTitle ? lastAnswerMeta.answerTitle : '',
        previousAnswerCategory: lastAnswerMeta && lastAnswerMeta.answerCategory ? lastAnswerMeta.answerCategory : '',
        time: new Date().toISOString()
      };

      sendPlaybotLead('possible_bad_answer', {
        query: query,
        signal: signal,
        currentTopic: currentTopic || '',
        previousQuestion: lastUserQuestion || '',
        previousAnswerId: lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '',
        previousAnswerTitle: lastAnswerMeta && lastAnswerMeta.answerTitle ? lastAnswerMeta.answerTitle : '',
        previousAnswerCategory: lastAnswerMeta && lastAnswerMeta.answerCategory ? lastAnswerMeta.answerCategory : '',
        type: 'possible_bad_answer',
        summary: 'Possible answer dissatisfaction detected. Signal: ' + signal,
        allowRepeat: true,
        maxPerReason: 8,
        urgent: true,
        preferBeacon: true,
        flushNow: true
      });
      saveState();
    } catch (error) {}
  }

  function setLastAnswerMeta(answerId, answerTitle, answerCategory, responseType) {
    lastAnswerMeta = {
      answerId: answerId || '',
      answerTitle: answerTitle || '',
      answerCategory: answerCategory || '',
      responseType: responseType || 'answered',
      time: new Date().toISOString()
    };
    lastAnswerTimestamp = Date.now();
  }

  function trackPlaybotEvent(type, payload) {
    try {
      var detail = {
        type: type,
        payload: payload || {},
        context: {
          device: conversationContext.device || '',
          quantity: conversationContext.quantity || '',
          duration: conversationContext.duration || '',
          startDate: conversationContext.startDate || '',
          lastIntent: conversationContext.lastIntent || ''
        }
      };

      if (window && window.dispatchEvent && window.CustomEvent) {
        window.dispatchEvent(new CustomEvent('pf-playbot-event', { detail: detail }));
      }

      if (window && window.console && window.console.debug) {
        window.console.debug('[Playbot]', type, detail);
      }

      if (type === 'message_audit' && playbotFullMessageAuditEnabled) {
        sendPlaybotLead('message_audit', {
          query: payload && payload.query ? payload.query : '',
          customerMessage: payload && payload.query ? payload.query : '',
          detectedTopic: payload && payload.detectedTopic ? payload.detectedTopic : '',
          currentTopic: payload && payload.detectedTopic ? payload.detectedTopic : '',
          previousQuestion: payload && payload.previousQuestion ? payload.previousQuestion : '',
          previousAnswerId: payload && payload.previousAnswerId ? payload.previousAnswerId : '',
          previousAnswerTitle: payload && payload.previousAnswerTitle ? payload.previousAnswerTitle : '',
          answerMatch: payload && payload.answerMatch ? payload.answerMatch : null,
          botOutcome: payload && payload.botOutcome ? payload.botOutcome : 'typed_message_received',
          type: 'message_audit',
          eventType: 'message_audit',
          summary: 'Typed-message audit captured for chatbot improvement.',
          notifyEmail: false,
          sheetOnly: true,
          allowRepeat: true,
          maxPerReason: 120,
          skipDedup: true,
          flushNow: true,
          urgent: false,
          formFallback: true
        });
      }

      if (type === 'fallback_first') {
        lastLowConfidenceQuestion = payload && payload.query ? payload.query : lastLowConfidenceQuestion;
        sendPlaybotLead(playbotWhatsappClicked ? 'low_confidence_followup' : 'low_confidence_question', {
          query: payload && payload.query ? payload.query : '',
          lowConfidenceQuestion: payload && payload.query ? payload.query : '',
          type: type,
          summary: playbotWhatsappClicked ? 'Customer asked a low-confidence question after clicking WhatsApp us.' : 'Customer asked a low-confidence question before WhatsApp handoff.',
          allowRepeat: true,
          maxPerReason: 5,
          urgent: true,
          preferBeacon: true,
          flushNow: true
        });
      }


      if (type === 'fallback_escalated') {
        lastLowConfidenceQuestion = payload && payload.query ? payload.query : lastLowConfidenceQuestion;
        sendPlaybotLead('low_confidence_question', {
          query: payload && payload.query ? payload.query : '',
          lowConfidenceQuestion: payload && payload.query ? payload.query : '',
          type: type,
          summary: 'Customer reached repeated low-confidence answers in Playbot.',
          allowRepeat: true,
          maxPerReason: 5,
          urgent: true,
          preferBeacon: true,
          flushNow: true
        });
      }
    } catch (error) {}
  }

  function addClarificationOptions(options) {
    var card = document.createElement('div');
    card.className = 'pf-playbot-card-grid pf-playbot-card-grid-compact';
    var html = '<div class="pf-playbot-card"><div class="pf-playbot-card-list">';

    for (var i = 0; i < options.length; i += 1) {
      var option = options[i];
      if (option.intent) {
        html += '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-intent="' + escapeHtml(option.intent) + '">' + escapeHtml(option.label) + '</button>';
      } else if (option.priceValue) {
        html += '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-price-value="' + escapeHtml(option.priceValue) + '">' + escapeHtml(option.label) + '</button>';
      } else if (option.action) {
        html += '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-action="' + escapeHtml(option.action) + '">' + escapeHtml(option.label) + '</button>';
      } else if (option.category) {
        html += '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-category="' + escapeHtml(option.category) + '">' + escapeHtml(option.label) + '</button>';
      }
    }

    html += '</div></div>';
    card.innerHTML = html;
    messages.appendChild(card);
    scrollToBottom();
  }

  function showConfidenceClarification(query, match) {
    unresolvedCount = 0;
    trackPlaybotEvent('clarification', {
      query: query,
      best: match && match.answer ? match.answer.id : '',
      bestScore: match ? match.bestScore : 0,
      second: match && match.second && match.second.item ? match.second.item.id : '',
      secondScore: match && match.second ? match.second.score : 0
    });

    var options = [];
    if (match && match.answer) options.push({ label: match.answer.title, intent: match.answer.id });
    if (match && match.second && match.second.item) options.push({ label: match.second.item.title, intent: match.second.item.id });
    if (match && match.third && match.third.item && match.third.score >= 12) options.push({ label: match.third.item.title, intent: match.third.item.id });

    setLastAnswerMeta('confidence_clarification', 'Confidence clarification', 'Clarification', 'clarification');
    replyBot('I want to make sure I answer the right thing. Are you asking about one of these?', function () {
      addClarificationOptions(options);
      addActionRow(['live_agent', 'main_menu']);
      replyBot('Did this help narrow it down?', function () {
        addActionRow(['thumbs_up', 'thumbs_down']);
      });
    });
  }

  function getDirectClarificationOptions(query) {
    var q = normalise(query || '');

    if (/\b(change|switch|swap|upgrade)\b/.test(q) && /\b(laptop|device|rental|model|date|duration|period|location|address)\b/.test(q)) {
      var clearlyUpgrade = /\b(upgrade|better model|another model|different model|switch model|swap laptop|change laptop halfway|halfway)\b/.test(q);
      var clearlyDate = /\b(date|postpone|start date|delivery date)\b/.test(q);
      var clearlyLocation = /\b(location|address|return address|delivery address|different return)\b/.test(q);
      if (!clearlyUpgrade && !clearlyDate && !clearlyLocation) {
        return {
          message: 'Do you mean changing the device or model, changing the rental date, or changing the delivery or return arrangement?',
          options: [
            { label: 'Change or upgrade model', intent: 'change_upgrade_device' },
            { label: 'Change rental date', intent: 'change_date' },
            { label: 'Extend or change duration', intent: 'extension' },
            { label: 'Change return location', intent: 'different_return_location' }
          ]
        };
      }
    }

    if (/^\s*(laptop|device|computer|pc)\s*(how much|price|cost|rate)?\s*\??\s*$/.test(q)) {
      return {
        message: 'Sure. Do you mean Business Laptop, Gaming Laptop, or MacBook?',
        options: [
          { label: 'Business Laptop', priceValue: 'Business Laptop' },
          { label: 'Gaming Laptop', priceValue: 'Gaming Laptop' },
          { label: 'MacBook', priceValue: 'MacBook' }
        ]
      };
    }

    if (/\b(available|availability|stock|got stock|still have)\b/.test(q) && !getCanonicalDeviceLabelFromText(q) && !detectQuantityFromText(q)) {
      return {
        message: 'I can help check availability. I’ll collect the device, quantity, start date, duration, and delivery location before routing this to WhatsApp.',
        options: [
          { label: 'Request availability check', action: 'availability_flow' },
          { label: 'Start rental enquiry', action: 'rent_device_flow' }
        ]
      };
    }

    return null;
  }

  function maybeShowDirectClarification(query) {
    var clarification = getDirectClarificationOptions(query);
    if (!clarification) return false;

    trackPlaybotEvent('direct_clarification', { query: query });
    replyBot(clarification.message, function () {
      addClarificationOptions(clarification.options);
      addActionRow(['live_agent', 'main_menu']);
    });
    return true;
  }

  function startLiveAgent() {
    trackPlaybotEvent('human_handoff_started', { source: conversationContext.lastIntent || 'general' });
    resetQuestionContext();
    feedbackState = null;
    priceState = null;
    confirmState = null;
    chatEnded = false;
    liveState = seedLiveStateFromMemory({
      flow: 'general',
      urgent: false,
      step: 'name',
      name: conversationContext.customerName || '',
      company: '',
      device: '',
      quantity: '',
      duration: '',
      startDate: '',
      location: '',
      special: '',
      question: conversationContext.lastQuestion || ''
    }, conversationContext.lastQuestion || 'general rental enquiry');

    if (liveState.name) {
      replyBot('Sure. I’ll use the rental details shared so far and collect anything missing.', function () {
        askNextLiveEnquiryQuestion();
      });
      return;
    }

    replyBot('Sure. I’ll collect a few details first.\n\nPlease share your name.', function () {
      input.focus();
    });
  }

  function startPriceFlow() {
    resetQuestionContext();
    liveState = null;
    feedbackState = null;
    confirmState = null;
    chatEnded = false;
    v102ClearConfirmedPriceContext('start_price_flow');
    if (conversationContext) conversationContext.recommendedPriceProductKey = '';

    priceState = { raw: 'price' };
    replyBot('Sure. Which device would you like to check the rental price for?', function () {
      addPriceChipRow([
        { label: 'Business Laptop', value: 'Business Laptop' },
        { label: 'Gaming Laptop', value: 'Gaming Laptop' },
        { label: 'MacBook', value: 'MacBook' },
        { label: 'iPad', value: 'iPad' }
      ]);
      input.focus();
    });
  }

  function getCanonicalDeviceLabelFromText(text) {
    var q = normalise(text || '');
    if (!q) return '';

    if (/\b(not sure|unsure|dont know|do not know|not certain|anything)\b/.test(q)) {
      return '';
    }

    // Exact models first. This lets Playbot remember "MacBook Air M1" instead of only "MacBook Air".
    if (/\b(macbook air m1|air m1)\b/.test(q)) return 'MacBook Air M1';
    if (/\b(macbook air m2|air m2)\b/.test(q)) return 'MacBook Air M2';
    if (/\b(macbook air m3|air m3)\b/.test(q)) return 'MacBook Air M3';
    if (/\b(macbook air m4|air m4)\b/.test(q)) return 'MacBook Air M4';
    if (/\b(macbook air m5|air m5)\b/.test(q)) return 'MacBook Air M5';

    if (/\b(imac m1|m1 imac)\b/.test(q)) return 'iMac M1';
    if (/\b(macbook pro m3 max|m3 max macbook pro)\b/.test(q)) return 'MacBook Pro M3 Max';
    if (/\b(macbook pro m1 pro|m1 pro macbook pro)\b/.test(q)) return 'MacBook Pro M1 Pro';
    if (/\b(macbook pro m2 pro|m2 pro macbook pro)\b/.test(q)) return 'MacBook Pro M2 Pro';
    if (/\b(macbook pro m3 pro|m3 pro macbook pro)\b/.test(q)) return 'MacBook Pro M3 Pro';
    if (/\b(macbook pro m4 pro|m4 pro macbook pro)\b/.test(q)) return 'MacBook Pro M4 Pro';
    if (/\b(macbook pro m5 pro|m5 pro macbook pro)\b/.test(q)) return 'MacBook Pro M5 Pro';

    if (/\b(macbook pro m1|pro m1|m1 macbook pro)\b/.test(q)) return 'MacBook Pro M1';
    if (/\b(macbook pro m2|pro m2|m2 macbook pro)\b/.test(q)) return 'MacBook Pro M2';
    if (/\b(macbook pro m3|pro m3|m3 macbook pro)\b/.test(q)) return 'MacBook Pro M3';
    if (/\b(macbook pro m4|pro m4|m4 macbook pro)\b/.test(q)) return 'MacBook Pro M4';
    if (/\b(macbook pro m5|pro m5|m5 macbook pro)\b/.test(q)) return 'MacBook Pro M5';

    if (/\b(rtx 5080|5080)\b/.test(q)) return 'Gaming Laptop RTX 5080';
    if (/\b(rtx 5050|5050)\b/.test(q)) return 'Gaming Laptop RTX 5050';
    if (/\b(rtx 4070|4070)\b/.test(q)) return 'Gaming Laptop RTX 4070';
    if (/\b(rtx 4060|4060)\b/.test(q)) return 'Gaming Laptop RTX 4060';
    if (/\b(rtx 4050|4050)\b/.test(q)) return 'Gaming Laptop RTX 4050';
    if (/\b(rtx 3060|3060)\b/.test(q)) return 'Gaming Laptop RTX 3060';
    if (/\b(rtx 3050|3050)\b/.test(q)) return 'Gaming Laptop RTX 3050';
    if (/\b(rtx 2060|2060)\b/.test(q)) return 'Gaming Laptop RTX 2060';
    if (/\b(gtx 1650|1650)\b/.test(q)) return 'Gaming Laptop GTX 1650';

    if (/\b(ipad pro m2 cellular|pro m2 cellular)\b/.test(q) && /\bipad\b/.test(q)) return 'iPad Pro M2 Cellular';
    if (/\b(ipad pro m2|pro m2)\b/.test(q) && /\bipad\b/.test(q)) return 'iPad Pro M2';
    if (/\b(ipad pro m1 cellular|pro m1 cellular)\b/.test(q) && /\bipad\b/.test(q)) return 'iPad Pro M1 Cellular';
    if (/\b(ipad pro m1|pro m1)\b/.test(q) && /\bipad\b/.test(q)) return 'iPad Pro M1';
    if (/\b(ipad air m4 cellular|air m4 cellular)\b/.test(q)) return 'iPad Air M4 Cellular';
    if (/\b(ipad air m4|air m4)\b/.test(q) && /\bipad\b/.test(q)) return 'iPad Air M4';
    if (/\b(ipad 11th cellular|ipad 11 cellular|11th gen cellular|11th generation cellular)\b/.test(q)) return 'iPad 11th Cellular';
    if (/\b(ipad 11th|ipad 11|11th gen|11th generation)\b/.test(q)) return 'iPad 11th';
    if (/\b(ipad 10th cellular|ipad 10 cellular|10th gen cellular|10th generation cellular)\b/.test(q)) return 'iPad 10th Cellular';
    if (/\b(ipad 10th|ipad 10|10th gen|10th generation)\b/.test(q)) return 'iPad 10th';
    if (/\b(ipad 9th cellular|ipad 9 cellular|9th gen cellular|9th generation cellular)\b/.test(q)) return 'iPad 9th Cellular';
    if (/\b(ipad 9th|ipad 9|9th gen|9th generation)\b/.test(q)) return 'iPad 9th';
    if (/\b(ipad 8th cellular|ipad 8 cellular|8th gen cellular|8th generation cellular)\b/.test(q)) return 'iPad 8th Cellular';
    if (/\b(ipad 8th|ipad 8|8th gen|8th generation)\b/.test(q)) return 'iPad 8th';
    if (/\b(ipad air 5th|ipad air 5|air 5th|air 5)\b/.test(q)) return 'iPad Air 5th';

    if (/\b(ultra 7|intel ultra 7|core ultra 7|ryzen 7 new|ultra 7 ryzen 7 new)\b/.test(q)) return 'Business Laptop Ultra 7 / Ryzen 7 (New)';
    if (/\b(ultra 5|intel ultra 5|core ultra 5|ryzen 5 new|ultra 5 ryzen 5 new)\b/.test(q)) return 'Business Laptop Ultra 5 / Ryzen 5 (New)';
    if (/\b(business laptop i7|business i7|i7|ryzen 7|r7)\b/.test(q)) return 'Business Laptop i7 or Ryzen 7';
    if (/\b(business laptop i5|business i5|i5|ryzen 5|r5)\b/.test(q)) return 'Business Laptop i5 or Ryzen 5';

    // Family/category fallback.
    if (/\bipad\b/.test(q)) return 'iPad';
    if (/\b(gaming laptop|rtx|gtx|gpu|graphics laptop|high performance laptop)\b/.test(q)) return 'Gaming Laptop';
    if (/\bmacbook air\b/.test(q)) return 'MacBook Air';
    if (/\bmacbook pro\b/.test(q)) return 'MacBook Pro';
    if (/\b(macbook|m1|m2|m3|m4|m5)\b/.test(q)) return 'MacBook';
    if (/\b(business laptop|office laptop|work laptop|normal laptop|windows laptop)\b/.test(q)) return 'Business Laptop';

    // Generic "laptop" is intentionally left open because it may mean Business, Gaming, or MacBook.
    return '';
  }

  function wordNumberToInt(word) {
    var map = {
      one: 1, two: 2, three: 3, four: 4, five: 5,
      six: 6, seven: 7, eight: 8, nine: 9, ten: 10,
      eleven: 11, twelve: 12, fifteen: 15, twenty: 20,
      thirty: 30, forty: 40, fifty: 50
    };
    return map[normalise(word || '')] || null;
  }

  function detectQuantityFromText(text) {
    var q = normalise(text || '');
    var match = q.match(/\b(\d{1,3})\s*(units?|pcs?|pieces?|laptops?|notebooks?|devices?|macbooks?|ipads?|tablets?)\b/);
    if (match && parseInt(match[1], 10) > 0) return parseInt(match[1], 10) + ' unit' + (parseInt(match[1], 10) > 1 ? 's' : '');

    match = q.match(/\b(need|want|looking for|require)\s+(\d{1,3})\b/);
    if (match && parseInt(match[2], 10) > 0) return parseInt(match[2], 10) + ' unit' + (parseInt(match[2], 10) > 1 ? 's' : '');

    match = q.match(/\b(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|fifteen|twenty|thirty|forty|fifty)\s*(units?|pcs?|pieces?|laptops?|notebooks?|devices?|macbooks?|ipads?|tablets?)\b/);
    if (match) {
      var value = wordNumberToInt(match[1]);
      if (value) return value + ' unit' + (value > 1 ? 's' : '');
    }
    return '';
  }

  function detectDurationFromText(text) {
    var period = detectRentalPeriod(text || '');
    return period && period.label ? period.label : '';
  }

  function detectStartDateFromText(text) {
    var raw = String(text || '').trim();
    var q = normalise(raw);
    if (/\btoday\b/.test(q)) return 'Today';
    if (/\btomorrow\b/.test(q) || /\bnext day\b/.test(q)) return 'Tomorrow';
    if (/\bnext week\b/.test(q)) return 'Next week';
    if (/\bthis week\b/.test(q)) return 'This week';

    var dateMatch = raw.match(/\b(\d{1,2})(?:st|nd|rd|th)?\s*(jan|january|feb|february|mar|march|apr|april|may|jun|june|jul|july|aug|august|sep|sept|september|oct|october|nov|november|dec|december)\b/i);
    if (dateMatch) return dateMatch[0];

    dateMatch = raw.match(/\b(\d{1,2})[\/-](\d{1,2})(?:[\/-](\d{2,4}))?\b/);
    if (dateMatch) return dateMatch[0];

    dateMatch = raw.match(/\b(mon|monday|tue|tuesday|wed|wednesday|thu|thursday|fri|friday|sat|saturday|sun|sunday)\b/i);
    if (dateMatch && /\b(next|this)\b/.test(q)) return dateMatch[0];

    return '';
  }

  function detectLocationFromText(text) {
    var q = normalise(text || '');
    if (/\b(mbs|marina bay sands)\b/.test(q)) return 'MBS or Marina Bay Sands';
    if (/\b(changi airport|airport)\b/.test(q)) return 'Changi Airport';
    if (/\b(sentosa)\b/.test(q)) return 'Sentosa';
    if (/\b(tuas)\b/.test(q)) return 'Tuas';
    if (/\b(hotel|serviced apartment)\b/.test(q)) return 'Hotel or serviced apartment';
    if (/\b(school|campus|university|poly|ite)\b/.test(q)) return 'School or campus';
    if (/\b(office|company)\b/.test(q)) return 'Office';
    if (/\b(event|venue|roadshow|training)\b/.test(q)) return 'Event venue';
    if (/\b(condo|residential|home|house|hdb)\b/.test(q)) return 'Residential address';
    return '';
  }

  function detectCircularIntent(text) {
    var q = normalise(text || '');
    if (isRentalProcessQuestion(text)) return 'rental_process';
    if (isCorporateEnquiry(text)) return 'corporate';
    if (isUrgentRentalRequest(text) || isSameDayDeliveryQuestion(text)) return 'urgent';
    if (isAvailabilityQuestion(text)) return 'availability';
    if (isEventRentalQuestion(text)) return 'event';
    if (isLateReturnConcern(text) || isRentalExtensionConcern(text)) return 'policy';
    if (isRentalPriceEstimateQuestion(text) || /\b(how much|price|cost|fee|rate|total|payable)\b/.test(q)) return 'price';
    if (isGameRecommendationQuestion(text)) return 'game_recommendation';
    if (isSmartCompatibilityQuestion(text) || /\b(can run|compatible|support|software|app|apps|docker|sql|adobe|premiere|python|coding|visual studio|office|exam browser|lockdown)\b/.test(q)) return 'software';
    if (/\b(deposit|security deposit|documents?|nric|proof of address|delivery|return|payment|paynow|late|damage|cancel|terms)\b/.test(q)) return 'policy';
    if (isRentalStartRequest(text)) return 'rent';
    return '';
  }

  function updateConversationMemory(text, intent) {
    var q = String(text || '').trim();
    if (!q) return;

    var device = getCanonicalDeviceLabelFromText(q);
    var quantity = detectQuantityFromText(q);
    var duration = detectDurationFromText(q);
    var startDate = detectStartDateFromText(q);
    var location = detectLocationFromText(q);

    if (device && v101ShouldStoreDeviceFromMemory(q, intent)) conversationContext.device = device;
    if (quantity) conversationContext.quantity = quantity;
    if (duration) conversationContext.duration = duration;
    if (startDate) conversationContext.startDate = startDate;
    if (location) conversationContext.location = location;
    if (intent) conversationContext.lastIntent = intent;
    conversationContext.lastQuestion = q;

    if (device && v101ShouldStoreDeviceFromMemory(q, intent)) conversationContext.devices = detectCompatibilityDevices(device);
    saveState();
  }

  function applyMemoryToText(text) {
    var q = String(text || '').trim();
    var combined = q;
    var explicitDevice = getCanonicalDeviceLabelFromText(q);

    // v85: use previous device or duration only for true follow-ups.
    // Strong new topics such as deposit, documents, delivery, return, data, or damage should not inherit old price context.
    if (!v85UseMemoryForPrice(q)) return combined;
    if (v101IsGenericPriceRequest(q) && !v101CanUseStoredPriceContext(q)) return combined;

    var memoryDevice = conversationContext.confirmedPriceDevice || (conversationContext.lastIntent === 'price' ? conversationContext.device : '');
    var memoryDuration = conversationContext.confirmedPriceDuration || conversationContext.duration || '';

    if (!explicitDevice && memoryDevice) combined += ' ' + memoryDevice;
    if (!explicitDevice && !detectUnsupportedRentalDuration(q) && !detectDurationFromText(q) && memoryDuration) combined += ' ' + memoryDuration;
    if (!explicitDevice && !detectQuantityFromText(q) && conversationContext.quantity) combined += ' ' + conversationContext.quantity;
    return combined;
  }

  function getRelevantRentalPageActionFromMemory(fallbackText) {
    return getRentalPageActionFromText(conversationContext.device || '', fallbackText || conversationContext.lastQuestion || '');
  }

  function uniqueActions(actions) {
    var out = [];
    for (var i = 0; i < actions.length; i += 1) {
      if (actions[i] && out.indexOf(actions[i]) === -1) out.push(actions[i]);
    }
    return out;
  }

  function getCircularAnswerActions(item) {
    var pageAction = getRelevantRentalPageActionFromMemory((item ? ((item.title || '') + ' ' + (item.answer || '') + ' ' + (item.category || '')) : ''));
    var id = item && item.id ? item.id : '';
    var category = item && item.category ? item.category : '';

    if (category === 'Rental Price' || id === 'check_price' || id === 'quotation' || id === 'bulk_pricing') {
      return uniqueActions([pageAction, 'live_agent', 'rent_device_flow', 'main_menu']);
    }

    if (category === 'Availability and Urgent Rental' || id === 'availability_stock' || id === 'same_day_urgent_rental' || id === 'deliver_tomorrow') {
      return uniqueActions(['availability_flow', 'live_agent', pageAction, 'main_menu']);
    }

    if (category === 'Corporate and Bulk Rental' || id === 'invoice_receipt' || id === 'event_roadshow_rental') {
      return uniqueActions(['corporate_flow', 'live_agent', 'main_menu']);
    }

    if (category === 'Software Compatibility' || /^(adobe_apps|coding_apps|docker_sql|ai_apps|software_support|business_i5_compatibility|business_i7_compatibility|device_compatibility_comparison|gaming_adobe_video|gaming_development_ai|macbook_air_8gb_heavy_apps|macbook_exam_lockdown|macbook_ubuntu_custom_os|ipad_desktop_apps|ipad_exam_browser)$/.test(id)) {
      return uniqueActions([pageAction, 'price_flow', 'rent_device_flow', 'main_menu']);
    }

    if (category === 'Device Selection' || /^(which_device|business_laptop_overview|gaming_laptop_overview|macbook_overview|ipad_overview|gaming_gpu_options|macbook_memory_options|available_rental_devices)$/.test(id)) {
      return uniqueActions([pageAction, 'price_flow', 'availability_flow', 'main_menu']);
    }

    if (category === 'Rental Confidence and Common Concerns') {
      return uniqueActions(['rental_confidence_concerns', 'live_agent', 'main_menu']);
    }

    if (category === 'Security Deposit and Device Care') {
      return uniqueActions(['security_device_care', 'live_agent', 'main_menu']);
    }

    if (category === 'Delivery & Return' || category === 'Security Deposit' || category === 'Required Documents' || category === 'Accessories and Device Condition' || category === 'Rental Period') {
      return uniqueActions(['rent_device_flow', 'price_flow', 'rental_faq', pageAction, 'main_menu']);
    }

    if (category === 'Damage and Late Return' || category === 'Cancellation and Changes') {
      return uniqueActions(['live_agent', 'rental_terms', 'main_menu']);
    }

    return uniqueActions((item && item.actions && item.actions.length ? item.actions : [pageAction]).concat(['main_menu']));
  }

  function isContextualPriceQuestion(text) {
    var q = normalise(text || '');
    if (!/\b(how much|price|cost|fee|rate|total|payable)\b/.test(q)) return false;
    if (getCanonicalDeviceLabelFromText(q)) return true;
    if (/\b(damage|damaged|deposit|security deposit|late return|return late|deduct|minus|document|nric|delivery|internet|data|software|admin|invoice|quotation)\b/.test(q)) return false;
    return !!conversationContext.device && v85UseMemoryForPrice(q);
  }

  function isPriceDurationFollowUp(text) {
    var q = normalise(text || '');
    var hasDuration = !!detectDurationFromText(q);
    var hasPriceWord = /\b(how much|price|cost|fee|rate|total|payable|quote)\b/.test(q);
    var hasRentalQuestionWord = /\b(rent|rental|lease|borrow|hire|book)\b/.test(q);
    var hasDeviceInText = !!getCanonicalDeviceLabelFromText(q);
    var looksLikeDurationOnly = hasDuration && !hasPriceWord && !hasRentalQuestionWord && !hasDeviceInText;

    return looksLikeDurationOnly &&
      conversationContext &&
      conversationContext.device &&
      conversationContext.lastIntent === 'price';
  }

  function seedLiveStateFromMemory(state, originalQuestion) {
    var source = String(originalQuestion || '') + ' ' + (conversationContext.lastQuestion || '');
    state.device = state.device || getCanonicalDeviceLabelFromText(source) || conversationContext.device || '';
    state.quantity = state.quantity || detectQuantityFromText(source) || conversationContext.quantity || '';
    state.duration = state.duration || detectDurationFromText(source) || conversationContext.duration || '';
    state.startDate = state.startDate || detectStartDateFromText(source) || conversationContext.startDate || '';
    state.location = state.location || detectLocationFromText(source) || conversationContext.location || '';
    return state;
  }

  function startEnquiryFlow(flow, originalQuestion) {
    resetQuestionContext();
    feedbackState = null;
    priceState = null;
    confirmState = null;
    chatEnded = false;

    var flowTitle = 'rental enquiry';
    if (flow === 'custom') flowTitle = 'custom rental enquiry';
    if (flow === 'corporate') flowTitle = 'corporate and bulk rental enquiry';
    if (flow === 'urgent') flowTitle = 'urgent rental request';
    if (flow === 'availability') flowTitle = 'availability and urgent rental request';
    if (flow === 'event') flowTitle = 'event and roadshow rental enquiry';
    if (flow === 'issue') flowTitle = 'device issue report';

    updateConversationMemory(originalQuestion || flowTitle, flow || 'general');

    liveState = seedLiveStateFromMemory({
      flow: flow || 'general',
      urgent: flow === 'urgent' || flow === 'availability',
      step: 'name',
      name: conversationContext.customerName || '',
      company: conversationContext.company || '',
      device: getCanonicalDeviceLabelFromText(originalQuestion || '') || '',
      quantity: '',
      duration: '',
      startDate: '',
      location: '',
      special: '',
      question: originalQuestion || flowTitle
    }, originalQuestion || flowTitle);

    if (liveState.name) {
      replyBot('Sure. I’ll use the rental details shared so far and collect anything missing.', function () {
        askNextLiveEnquiryQuestion();
      });
      return;
    }

    replyBot('Sure. I’ll collect a few details for your ' + flowTitle + '.\n\nPlease share your name.', function () {
      input.focus();
    });
  }

  function startRentalGuide(initialText) {
    resetQuestionContext();
    feedbackState = null;
    priceState = null;
    confirmState = null;
    chatEnded = false;

    updateConversationMemory(initialText || 'Rental enquiry', 'rent');
    var detectedDevice = getCanonicalDeviceLabelFromText(initialText || '') || conversationContext.device || '';

    liveState = seedLiveStateFromMemory({
      flow: 'rent_guide',
      step: 'name',
      name: conversationContext.customerName || '',
      company: '',
      device: detectedDevice || '',
      usage: conversationContext.usage || '',
      quantity: '',
      duration: '',
      startDate: '',
      location: '',
      special: '',
      question: 'Rental enquiry'
    }, initialText || 'Rental enquiry');

    if (detectedDevice) {
      conversationContext.devices = detectCompatibilityDevices(detectedDevice);
    }

    if (liveState.name) {
      replyBot('Sure. I’ll use the rental details shared so far and collect anything missing.', function () {
        askNextRentalGuideQuestion();
      });
      return;
    }

    replyBot('Sure. Please share your name.', function () {
      input.focus();
    });
  }

  function shouldAskUsageForRentalGuideDevice(originalValue, canonicalDevice) {
    var q = normalise((originalValue || '') + ' ' + (canonicalDevice || ''));
    if (/\b(not sure|unsure|dont know|do not know|which one|recommend)\b/.test(q)) return true;
    if (!canonicalDevice) return true;
    if (/^\s*(laptop|device|computer|pc)\s*$/.test(q)) return true;
    return false;
  }

  function showDeviceChips() {
    var chips = [
      { id: 'live_device_business', label: 'Business Laptop' },
      { id: 'live_device_gaming', label: 'Gaming Laptop' },
      { id: 'live_device_macbook', label: 'MacBook' },
      { id: 'live_device_ipad', label: 'iPad' },
      { id: 'live_device_not_sure', label: 'Not sure' }
    ];
    addLiveChipRow(chips);
  }

  function showUsageChips() {
    addLiveChipRow([
      { id: 'usage_office', label: 'Office, school or general use' },
      { id: 'usage_exam', label: 'Exam browser' },
      { id: 'usage_adobe', label: 'Adobe and design' },
      { id: 'usage_video', label: 'Video editing' },
      { id: 'usage_coding', label: 'Coding or programming' },
      { id: 'usage_docker', label: 'Docker, SQL and development' },
      { id: 'usage_ai', label: 'AI apps' },
      { id: 'usage_gaming', label: 'Gaming' },
      { id: 'usage_event', label: 'Event or registration' },
      { id: 'usage_notsure', label: 'Not sure' }
    ]);
  }

  function addLiveChipRow(items) {
    var card = document.createElement('div');
    card.className = 'pf-playbot-card-grid pf-playbot-card-grid-compact';
    var html = '<div class="pf-playbot-card"><div class="pf-playbot-card-list">';
    for (var i = 0; i < items.length; i += 1) {
      html += '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-live-value="' + escapeHtml(items[i].label) + '">' + escapeHtml(items[i].label) + '</button>';
    }
    html += '</div></div>';
    card.innerHTML = html;
    messages.appendChild(card);
    scrollToBottom();
  }


  function addPriceChipRow(items) {
    if (!items || !items.length) return;
    var card = document.createElement('div');
    card.className = 'pf-playbot-card-grid pf-playbot-card-grid-compact';
    var html = '<div class="pf-playbot-card"><div class="pf-playbot-card-list">';
    for (var i = 0; i < items.length; i += 1) {
      html += '<button type="button" class="pf-playbot-service-btn" data-pf-playbot-price-value="' + escapeHtml(items[i].value || items[i].label) + '">' + escapeHtml(items[i].label) + '</button>';
    }
    html += '</div></div>';
    card.innerHTML = html;
    messages.appendChild(card);
    scrollToBottom();
  }

  function getPriceModelChipItems(product) {
    if (!product || !product.models) return [];

    if (product.key === 'macbook') {
      return [
        { label: 'MacBook Air M1', value: 'MacBook Air M1' },
        { label: 'MacBook Air M2', value: 'MacBook Air M2' },
        { label: 'MacBook Pro M1', value: 'MacBook Pro M1' },
        { label: 'MacBook Pro M2', value: 'MacBook Pro M2' },
        { label: 'MacBook Pro M1 Pro', value: 'MacBook Pro M1 Pro' },
        { label: 'MacBook Pro M2 Pro', value: 'MacBook Pro M2 Pro' },
        { label: 'MacBook Pro M3 Pro', value: 'MacBook Pro M3 Pro' },
        { label: 'MacBook Pro M4 Pro', value: 'MacBook Pro M4 Pro' }
      ];
    }

    return product.models.map(function (model) {
      return { label: model.label, value: model.label };
    });
  }

  function liveFlowNeedsLocation(flow) {
    return flow === 'corporate' || flow === 'urgent' || flow === 'availability' || flow === 'event';
  }

  function liveFlowNeedsCompany(flow) {
    return flow === 'corporate' || flow === 'event';
  }

  function liveFlowNeedsSpecial(flow) {
    return flow === 'corporate' || flow === 'event';
  }

  function askNextLiveEnquiryQuestion() {
    if (!liveState) return;

    if (liveFlowNeedsCompany(liveState.flow) && !liveState.company) {
      liveState.step = 'company';
      replyBot('Please share your company name. If this is not for a company, you may type “Individual”.', function () { input.focus(); });
      return;
    }

    if (!liveState.device) {
      liveState.step = 'device';
      replyBot(liveState.flow === 'issue' ? 'Which device has the issue?' : 'Which device are you looking to rent?', function () {
        showDeviceChips();
        input.focus();
      });
      return;
    }

    if (liveState.flow === 'issue' && !liveState.question) {
      liveState.step = 'issue';
      replyBot('Please describe the issue.', function () { input.focus(); });
      return;
    }

    if (liveState.flow !== 'issue' && !liveState.quantity) {
      liveState.step = 'quantity';
      replyBot('How many units do you need?', function () { input.focus(); });
      return;
    }

    if (!liveState.startDate) {
      liveState.step = 'startDate';
      replyBot(liveState.flow === 'issue' ? 'Please share your rental start date or order reference, if available.' : 'When is your rental start date?', function () { input.focus(); });
      return;
    }

    if (liveState.flow !== 'issue' && !liveState.duration) {
      liveState.step = 'duration';
      replyBot('What’s the rental duration needed?', function () { input.focus(); });
      return;
    }

    if (liveFlowNeedsLocation(liveState.flow) && !liveState.location) {
      liveState.step = 'location';
      replyBot('Where is the delivery location or event venue?', function () { input.focus(); });
      return;
    }

    if (liveFlowNeedsSpecial(liveState.flow) && !liveState.special) {
      liveState.step = 'special';
      replyBot('Any special requirements? If none, you may type “None”.', function () { input.focus(); });
      return;
    }

    showWhatsappHandover();
  }

  function processLiveInput(text) {
    if (!liveState) return;
    var value = String(text || '').trim();
    if (!value) return;

    if (liveState.flow === 'rent_guide') {
      processRentalGuideInput(value);
      return;
    }

    if (liveState.step === 'name') {
      liveState.name = value;
      conversationContext.customerName = value;
      askNextLiveEnquiryQuestion();
      return;
    }

    if (liveState.step === 'company') {
      liveState.company = value;
      conversationContext.company = value;
      askNextLiveEnquiryQuestion();
      return;
    }

    if (liveState.step === 'device') {
      liveState.device = getCanonicalDeviceLabelFromText(value) || value;
      if (liveState.device) {
        conversationContext.device = liveState.device;
        conversationContext.devices = detectCompatibilityDevices(liveState.device);
      }
      askNextLiveEnquiryQuestion();
      return;
    }

    if (liveState.step === 'issue') {
      liveState.question = value;
      askNextLiveEnquiryQuestion();
      return;
    }

    if (liveState.step === 'quantity') {
      liveState.quantity = detectQuantityFromText(value) || value;
      conversationContext.quantity = liveState.quantity;
      askNextLiveEnquiryQuestion();
      return;
    }

    if (liveState.step === 'startDate') {
      liveState.startDate = detectStartDateFromText(value) || value;
      conversationContext.startDate = liveState.startDate;
      askNextLiveEnquiryQuestion();
      return;
    }

    if (liveState.step === 'duration') {
      var unsupportedLiveDuration = detectUnsupportedRentalDuration(value);
      if (unsupportedLiveDuration) {
        replyBot(buildUnsupportedDurationMessage(unsupportedLiveDuration), function () {
          addLiveChipRow(getAvailablePeriodChipItems());
          addActionRow(['live_agent', 'main_menu']);
          input.focus();
        });
        return;
      }

      liveState.duration = detectDurationFromText(value) || value;
      conversationContext.duration = liveState.duration;
      askNextLiveEnquiryQuestion();
      return;
    }

    if (liveState.step === 'location') {
      liveState.location = detectLocationFromText(value) || value;
      conversationContext.location = liveState.location;
      askNextLiveEnquiryQuestion();
      return;
    }

    if (liveState.step === 'special') {
      liveState.special = value;
      askNextLiveEnquiryQuestion();
      return;
    }
  }

  function askNextRentalGuideQuestion() {
    if (!liveState) return;

    if (!liveState.device) {
      liveState.step = 'device';
      replyBot('Which device are you looking to rent?', function () {
        showDeviceChips();
        input.focus();
      });
      return;
    }

    if (!liveState.usage && shouldAskUsageForRentalGuideDevice(liveState.device, getCanonicalDeviceLabelFromText(liveState.device))) {
      liveState.step = 'usage';
      replyBot('What will you be using it for?', function () {
        showUsageChips();
        input.focus();
      });
      return;
    }

    if (!liveState.startDate) {
      liveState.step = 'startDate';
      replyBot('When is your rental start date?', function () { input.focus(); });
      return;
    }

    if (!liveState.duration) {
      liveState.step = 'duration';
      replyBot('What’s the rental duration needed?', function () { input.focus(); });
      return;
    }

    if (!liveState.quantity) {
      liveState.step = 'quantity';
      replyBot('How many units do you need?', function () { input.focus(); });
      return;
    }

    showRentalGuideHandover();
  }

  function processRentalGuideInput(value) {
    if (liveState.step === 'name') {
      liveState.name = value;
      conversationContext.customerName = value;
      askNextRentalGuideQuestion();
      return;
    }

    if (liveState.step === 'device') {
      var canonicalDevice = getCanonicalDeviceLabelFromText(value);
      liveState.device = canonicalDevice || value;
      conversationContext.device = liveState.device;
      conversationContext.devices = detectCompatibilityDevices(liveState.device);
      askNextRentalGuideQuestion();
      return;
    }

    if (liveState.step === 'usage') {
      liveState.usage = value;
      conversationContext.usage = value;
      askNextRentalGuideQuestion();
      return;
    }

    if (liveState.step === 'startDate') {
      liveState.startDate = detectStartDateFromText(value) || value;
      conversationContext.startDate = liveState.startDate;
      askNextRentalGuideQuestion();
      return;
    }

    if (liveState.step === 'duration') {
      var unsupportedGuideDuration = detectUnsupportedRentalDuration(value);
      if (unsupportedGuideDuration) {
        replyBot(buildUnsupportedDurationMessage(unsupportedGuideDuration), function () {
          addLiveChipRow(getAvailablePeriodChipItems());
          addActionRow(['live_agent', 'main_menu']);
          input.focus();
        });
        return;
      }

      liveState.duration = detectDurationFromText(value) || value;
      conversationContext.duration = liveState.duration;
      askNextRentalGuideQuestion();
      return;
    }

    if (liveState.step === 'quantity') {
      liveState.quantity = detectQuantityFromText(value) || value;
      conversationContext.quantity = liveState.quantity;
      askNextRentalGuideQuestion();
    }
  }

  function getActionLabel(action) {
    var labels = {
      view_rental: 'View rental page',
      view_business: 'View business rental page',
      view_gaming: 'View gaming rental page',
      view_macbook: 'View MacBook rental page',
      view_ipad: 'View iPad rental page',
      main_menu: 'Main menu'
    };
    return labels[action] || labels.view_rental;
  }

  function buildRentalGuideWhatsappUrl(state, recommendationText) {
    var messageText = 'Hi Playforce, I would like to enquire about rental.\n\n' +
      'Name: ' + (state.name || '-') + '\n' +
      'Device: ' + (state.device || '-') + '\n' +
      'Rental start date: ' + (state.startDate || '-') + '\n' +
      'Rental duration: ' + (state.duration || '-') + '\n' +
      'Quantity: ' + (state.quantity || '-') + '\n';

    if (state.usage) {
      messageText += 'Usage: ' + state.usage + '\n';
    }

    if (recommendationText) {
      var firstLine = String(recommendationText).split('\n')[0] || '';
      if (firstLine) messageText += firstLine + '\n';
    }

    messageText += '\nPlease assist. Thanks.';

    return 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(messageText);
  }

  function addRentalGuideActionRow(productPageAction, whatsappUrl) {
    var row = document.createElement('div');
    row.className = 'pf-playbot-action-row';
    row.innerHTML = actionButtonHtml(productPageAction || 'view_rental') +
      '<a class="pf-playbot-link-btn pf-playbot-btn-whatsapp" href="' + whatsappUrl + '" target="_blank" rel="noopener">WhatsApp us</a>' +
      '<button type="button" class="pf-playbot-link-btn pf-playbot-btn-main" data-pf-playbot-action="main_menu">Main menu</button>';
    messages.appendChild(row);
    scrollToBottom();
  }

  function buildRentalGuideFinalReply(state, recommendationText) {
    var reply = 'Thanks. You can view the rental page below, or WhatsApp us with your enquiry details.\n\n' +
      'Device: ' + (state.device || '-') + '\n' +
      'Rental start date: ' + (state.startDate || '-') + '\n' +
      'Rental duration: ' + (state.duration || '-') + '\n' +
      'Quantity: ' + (state.quantity || '-');

    if (state.usage) {
      reply += '\nUsage: ' + state.usage;
    }

    if (recommendationText) {
      var firstLine = String(recommendationText).split('\n')[0] || '';
      if (firstLine) reply += '\n\n' + firstLine;
    }

    return reply;
  }

  function showRentalGuideHandover() {
    if (!liveState) return;

    var state = {
      name: liveState.name || '',
      device: liveState.device || '',
      usage: liveState.usage || '',
      quantity: liveState.quantity || '',
      duration: liveState.duration || '',
      startDate: liveState.startDate || ''
    };

    var recommendationText = '';
    if (state.usage && shouldAskUsageForRentalGuideDevice(state.device, getCanonicalDeviceLabelFromText(state.device))) {
      recommendationText = buildRentalGuideRecommendation(state);
    }

    var productPageAction = getRentalPageActionFromText(state.device, recommendationText);
    var whatsappUrl = buildRentalGuideWhatsappUrl(state, recommendationText);
    var reply = buildRentalGuideFinalReply(state, recommendationText);

    liveState = null;
    replyBot(reply, function () {
      addRentalGuideActionRow(productPageAction, whatsappUrl);
    });
  }

  function detectRentalPageActionFromCanonicalText(q) {
    q = normalise(q || '');
    var candidates = [
      { action: 'view_ipad', terms: ['ipad'] },
      { action: 'view_gaming', terms: ['gaming', 'rtx', 'gtx', 'gpu'] },
      { action: 'view_macbook', terms: ['macbook', 'm1', 'm2', 'm3', 'm4', 'm5'] },
      { action: 'view_business', terms: ['business', 'office', 'i5', 'i7', 'ryzen', 'windows laptop'] }
    ];
    var bestAction = 'view_rental';
    var bestIndex = 999999;

    for (var i = 0; i < candidates.length; i += 1) {
      for (var j = 0; j < candidates[i].terms.length; j += 1) {
        var idx = q.indexOf(candidates[i].terms[j]);
        if (idx !== -1 && idx < bestIndex) {
          bestIndex = idx;
          bestAction = candidates[i].action;
        }
      }
    }

    return bestAction;
  }

  function getRentalPageActionFromText(text, fallbackText) {
    var selectedText = normalise(text || '');
    var selectedAction = detectRentalPageActionFromCanonicalText(selectedText);

    // If the customer already selected a category, keep the CTA aligned to that selected category.
    if (selectedAction !== 'view_rental' && selectedText.indexOf('not sure') === -1) {
      return selectedAction;
    }

    return detectRentalPageActionFromCanonicalText(fallbackText || '');
  }

  function buildRentalGuideRecommendation(state) {
    var device = normalise(state.device || '');
    var usage = normalise(state.usage || '');
    var recommendation = 'Business Laptop or MacBook';
    var reason = 'suitable for office, school, general business use, and common productivity work.';

    if (usage.indexOf('exam') !== -1) {
      recommendation = 'Business Laptop';
      reason = 'usually the safer choice for exam-browser compatibility. MacBook or iPad should only be used if your school or exam provider supports macOS or iPadOS.';
    } else if (usage.indexOf('adobe') !== -1 || usage.indexOf('design') !== -1) {
      recommendation = 'Gaming Laptop or MacBook';
      reason = 'better for Adobe and design use. For heavier files or video editing, choose Gaming Laptop or a 16GB MacBook or higher.';
    } else if (usage.indexOf('video') !== -1) {
      recommendation = 'Gaming Laptop or 16GB+ MacBook';
      reason = 'more suitable for video editing and heavier creative workloads.';
    } else if (usage.indexOf('coding') !== -1 || usage.indexOf('programming') !== -1) {
      recommendation = 'Business Laptop i7 or Ryzen 7, Gaming Laptop, or MacBook';
      reason = 'more suitable for development tools than Business Laptop i5 or Ryzen 5.';
    } else if (usage.indexOf('docker') !== -1 || usage.indexOf('sql') !== -1 || usage.indexOf('development') !== -1) {
      recommendation = 'Business Laptop i7 or Ryzen 7, Gaming Laptop, or 16GB+ MacBook';
      reason = 'better for Docker, SQL, local servers, and heavier development stacks.';
    } else if (usage.indexOf('ai') !== -1) {
      recommendation = 'Business Laptop i7 or Ryzen 7, Gaming Laptop, or 16GB+ MacBook';
      reason = 'better for heavier AI apps and multitasking. Cloud-assisted AI is less demanding.';
    } else if (usage.indexOf('gaming') !== -1) {
      recommendation = 'Gaming Laptop';
      reason = 'required for gaming and GPU-based workloads.';
    } else if (usage.indexOf('event') !== -1 || usage.indexOf('registration') !== -1) {
      recommendation = 'iPad or Business Laptop';
      reason = 'suitable for event check-in, registration, forms, presentations, and portable workflows.';
    }

    if (device.indexOf('macbook') !== -1 && usage.indexOf('office') !== -1) {
      recommendation = 'MacBook';
      reason = 'suitable if you prefer macOS for office, school, or general business use.';
    }

    return 'Recommended category: ' + recommendation + '\n\nWhy: ' + reason + '\n\nQuantity: ' + (state.quantity || '-') + '\nStart date: ' + (state.startDate || '-') + '\nRental period: ' + (state.duration || '-') + '\n\nYou may continue to the relevant rental page to view pricing, available periods, and delivery slots.';
  }

  function showWhatsappHandover() {
    if (!liveState) return;

    trackPlaybotEvent('whatsapp_handoff_ready', {
      flow: liveState.flow || '',
      device: liveState.device || '',
      quantity: liveState.quantity || '',
      duration: liveState.duration || ''
    });

    var title = 'rental enquiry';
    if (liveState.flow === 'custom') title = 'custom rental enquiry';
    if (liveState.flow === 'corporate') title = 'corporate and bulk rental enquiry';
    if (liveState.flow === 'urgent') title = 'urgent rental request';
    if (liveState.flow === 'availability') title = 'availability and urgent rental request';
    if (liveState.flow === 'event') title = 'event and roadshow rental enquiry';
    if (liveState.flow === 'issue') title = 'device issue report';

    var messageText = 'Hi Playforce, I need help with a ' + title + '.\n\n';

    if (liveState.urgent) {
      messageText += 'Urgent request: Yes\n';
    }

    if (liveState.name) {
      messageText += 'Name: ' + liveState.name + '\n';
    }

    if (liveState.company) {
      messageText += 'Company: ' + liveState.company + '\n';
    }

    messageText += 'Device: ' + (liveState.device || '-') + '\n';

    if (liveState.quantity) messageText += 'Quantity: ' + liveState.quantity + '\n';
    if (liveState.startDate) messageText += 'Rental start date or order reference: ' + liveState.startDate + '\n';
    if (liveState.duration) messageText += 'Rental duration: ' + liveState.duration + '\n';
    if (liveState.location) messageText += 'Delivery location or venue: ' + liveState.location + '\n';
    if (liveState.special) messageText += 'Special requirements: ' + liveState.special + '\n';

    messageText += 'Question or request: ' + (liveState.question || title) + '\n\nPlease assist. Thanks.';

    var url = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(messageText);
    var productPageAction = getRentalPageActionFromText(liveState.device || '', liveState.question || '');
    try { lastWhatsappHandoffState = JSON.parse(JSON.stringify(liveState || {})); } catch (error) { lastWhatsappHandoffState = liveState || {}; }

    replyBot('Thanks. Your WhatsApp message is ready.\n\nPlease tap below to continue with Playforce.', function () {
      var row = document.createElement('div');
      row.className = 'pf-playbot-action-row';
      row.innerHTML = actionButtonHtml(productPageAction || 'view_rental') +
        '<a class="pf-playbot-link-btn pf-playbot-link-btn-primary pf-playbot-btn-whatsapp" href="' + url + '" target="_blank" rel="noopener">WhatsApp us</a>' +
        '<button type="button" class="pf-playbot-link-btn pf-playbot-btn-main" data-pf-playbot-action="main_menu">Main menu</button>';
      messages.appendChild(row);
      liveState = null;
      scrollToBottom();
    });
  }

  function startFeedback() {
    priceState = null;
    resetQuestionContext();
    liveState = null;

    if (feedbackProfile && feedbackProfile.name && feedbackProfile.contact) {
      feedbackState = {
        step: 'message',
        name: feedbackProfile.name,
        contact: feedbackProfile.contact,
        message: ''
      };
      replyBot('Sure. Please type your feedback.', function () {
        input.focus();
      });
      return;
    }

    feedbackState = {
      step: 'name',
      name: '',
      contact: '',
      message: ''
    };
    replyBot('Sure. Please share your name.', function () {
      input.focus();
    });
  }

  function processFeedbackInput(text) {
    if (!feedbackState) return;
    var value = String(text || '').trim();
    if (!value) return;

    if (feedbackState.step === 'name') {
      feedbackState.name = value;
      feedbackState.step = 'contact';
      replyBot('Please share your contact number or email.', function () { input.focus(); });
      return;
    }

    if (feedbackState.step === 'contact') {
      feedbackState.contact = value;
      feedbackState.step = 'message';
      replyBot('Please type your feedback.', function () { input.focus(); });
      return;
    }

    if (feedbackState.step === 'message') {
      feedbackState.message = value;
      submitFeedback();
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function submitFeedback() {
    if (!feedbackState) return;
    var currentFeedback = {
      name: feedbackState.name || '',
      contact: feedbackState.contact || '',
      message: feedbackState.message || ''
    };
    feedbackProfile = {
      name: currentFeedback.name,
      contact: currentFeedback.contact
    };
    saveState();

    replyBot('Thank you. I’m submitting your feedback now.', function () {
      var payload = new URLSearchParams();
      payload.append('form_type', 'contact');
      payload.append('utf8', '✓');
      payload.append('contact[name]', currentFeedback.name || 'Playbot User');
      payload.append('contact[email]', isValidEmail(currentFeedback.contact) ? currentFeedback.contact : shopifyContactFallbackEmail);
      payload.append('contact[phone]', currentFeedback.contact || '-');
      payload.append('contact[body]', 'Playforce Rental Assistant Feedback\n\n' +
        'Name: ' + (currentFeedback.name || '-') + '\n' +
        'Contact: ' + (currentFeedback.contact || '-') + '\n\n' +
        'Feedback:\n' + (currentFeedback.message || '-') + '\n\n' +
        'Sent from Playforce Rental Assistant.');

      fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: payload.toString(),
        credentials: 'same-origin'
      }).then(function () {
        feedbackState = null;
        replyBot('Your feedback has been submitted. Thank you for sharing it with us.', function () {
          addActionRow(['main_menu']);
        });
      }).catch(function () {
        feedbackState = null;
        replyBot('Sorry, the feedback could not be submitted automatically. Please try again later or contact us through WhatsApp for urgent rental matters.', function () {
          addActionRow(['main_menu', 'live_agent']);
        });
      });
    });
  }

  function startResetConfirmation() {
    priceState = null;
    liveState = null;
    feedbackState = null;
    pendingRedirectState = null;
    confirmState = 'reset';
    replyBot('Would you like to reset this Playbot conversation?\n\nThis will clear the current chat history and rental details shared so far.', function () {
      addActionRow(['confirm_reset', 'cancel_reset']);
    });
  }

  function startEndChatConfirmation() {
    priceState = null;
    liveState = null;
    feedbackState = null;
    pendingRedirectState = null;
    confirmState = 'end';
    replyBot('Would you like to end this Playbot conversation?', function () {
      addActionRow(['confirm_end', 'cancel_end']);
    });
  }

  function performResetConversation() {
    if (typingTimer) window.clearTimeout(typingTimer);
    typingTimer = null;
    liveState = null;
    feedbackState = null;
    feedbackProfile = null;
    priceState = null;
    confirmState = null;
    pendingRedirectState = null;
    questionContext = null;
    conversationContext = createEmptyConversationContext();
    overallQuestionCount = 0;
    unresolvedCount = 0;
    playbotTranscript = [];
    playbotLeadSentKeys = {};
    playbotLeadSentCounts = {};
    playbotWhatsappClicked = false;
    lastWhatsappHandoffState = null;
    lastLowConfidenceQuestion = '';
    lastUserQuestion = '';
    lastUserQuestions = [];
    chatEnded = false;
    hasStarted = true;
    try { window.sessionStorage.removeItem(storageKey); } catch (error) {}
    try { window.sessionStorage.removeItem('pfPlaybotLeadSessionIdV75'); } catch (error) {}
    try { window.sessionStorage.removeItem('pfPlaybotLeadSessionIdV77'); } catch (error) {}
    playbotSessionId = getOrCreatePlaybotSessionId();
    messages.innerHTML = '';
    addBotMessage('Conversation reset.');
    showMainMenu();
    saveState();
  }

  function performEndConversation() {
    liveState = null;
    feedbackState = null;
    confirmState = null;
    pendingRedirectState = null;
    questionContext = null;
    overallQuestionCount = 0;
    unresolvedCount = 0;
    chatEnded = true;
    replyBot('Conversation ended. You may close Playbot, or type “reset” to start again.', function () {
      saveState();
    });
  }

  function processConfirmInput(text) {
    var q = normalise(text);
    var yes = /^(yes|y|ok|okay|confirm|proceed|reset|end)$/i.test(q);
    var no = /^(no|n|cancel|continue|dont|don t|do not)$/i.test(q);

    if (confirmState === 'reset') {
      if (yes) {
        performResetConversation();
      } else if (no) {
        confirmState = null;
        replyBot('Okay, I’ll keep this conversation.', function () { addActionRow(['main_menu']); });
      } else {
        replyBot('Please choose whether to reset this conversation.', function () {
          addActionRow(['confirm_reset', 'cancel_reset']);
        });
      }
      return;
    }

    if (confirmState === 'end') {
      if (yes) {
        performEndConversation();
      } else if (no) {
        confirmState = null;
        replyBot('Okay, the conversation will continue.', function () { addActionRow(['main_menu']); });
      } else {
        replyBot('Please choose whether to end this conversation.', function () {
          addActionRow(['confirm_end', 'cancel_end']);
        });
      }
      return;
    }

    if (confirmState === 'view_page') {
      if (yes) {
        confirmRentalPageRedirect();
      } else if (no) {
        pendingRedirectState = null;
        confirmState = null;
        replyBot('No problem. You can continue here.', function () { addActionRow(['main_menu']); });
      } else {
        var redirect = pendingRedirectState || getRentalPageInfo('view_rental');
        replyBot('Please choose whether to open the ' + redirect.pageName + '.', function () {
          addActionRow(['confirm_view_page', 'cancel_view_page']);
        });
      }
      return;
    }
  }

  function getPageContextText() {
    var parts = [];
    var path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();

    if (productTitle) parts.push(productTitle);

    if (path.indexOf('business-laptop-rental') !== -1) parts.push('Business Laptop');
    if (path.indexOf('gaming-laptop-rental') !== -1) parts.push('Gaming Laptop');
    if (path.indexOf('macbook-rental') !== -1) parts.push('MacBook');
    if (path.indexOf('ipad-rental') !== -1) parts.push('iPad');

    var checked = document.querySelectorAll('.rental-option-radio:checked');
    for (var i = 0; i < checked.length; i += 1) {
      if (checked[i] && checked[i].value) parts.push(checked[i].value);
    }

    return parts.join(' ');
  }

  function isSmartCompatibilityQuestion(text) {
    var q = normalise(text);
    var appWords = /\b(app|apps|software|compatibility|compatible|handle|run|support|suitable|lockdown|exam|browser|docker|python|coding|visual studio|vs code|sql|database|ubuntu|linux|adobe|photoshop|illustrator|premiere|video editing|office|word|excel|powerpoint|zoom|teams|meet|ai|chatgpt|copilot|canva)\b/.test(q);
    var deviceWords = /\b(business|gaming|macbook|ipad|i5|i7|ryzen 5|ryzen 7|m1|m2|m3|m4|m5|air|pro|gtx|rtx|windows|laptop|this|it)\b/.test(q);
    var compareWords = /\b(vs|versus|compare|comparison|difference|different|better|which)\b/.test(q);
    return (appWords && deviceWords) || (compareWords && deviceWords) || /\b(what about|how about)\b/.test(q) && appWords;
  }

  function detectCompatibilityApps(text) {
    var q = normalise(text);
    var apps = [];
    function add(id) { if (apps.indexOf(id) === -1) apps.push(id); }

    if (/\b(lockdown|exam browser|respondus|safe exam|exam)\b/.test(q)) add('exam');
    if (/\bdocker|container|containers|wsl\b/.test(q)) add('docker');
    if (/\bpython|coding|programming|jupyter|pycharm|anaconda\b/.test(q)) add('python');
    if (/\bvisual studio|vs code|vscode|\.net|c#\b/.test(q)) add('visual-studio');
    if (/\bsql|database|mysql|postgres|postgresql|dbeaver|sqlite|ssms\b/.test(q)) add('sql');
    if (/\bubuntu|linux|custom os|dual boot\b/.test(q)) add('ubuntu');
    if (/\badobe|photoshop|illustrator|lightroom|premiere|indesign|design|video editing|video edit\b/.test(q)) add('adobe');
    if (/\boffice|microsoft office|word|excel|powerpoint|outlook|onenote\b/.test(q)) add('office');
    if (/\bzoom|teams|meet|webex|video call|video meeting|webinar\b/.test(q)) add('video');
    if (/\bbrowser|chrome|edge|firefox|web app|web-based|website\b/.test(q)) add('browser');
    if (/\bcloud ai|cloud-assisted|chatgpt|gemini|copilot|canva|notion ai\b/.test(q)) add('cloud-ai');
    if (/\bapplication-based ai|ai app|local ai|lm studio|ollama|installed ai\b/.test(q)) add('application-ai');
    if (/\bai\b/.test(q) && apps.indexOf('cloud-ai') === -1 && apps.indexOf('application-ai') === -1) {
      add('cloud-ai');
      add('application-ai');
    }

    return apps;
  }

  function detectCompatibilityDevices(text) {
    var q = normalise(text);
    var devices = [];

    function add(id) { if (devices.indexOf(id) === -1) devices.push(id); }

    if (/\bbusiness\b/.test(q) || /\bi5\b/.test(q) || /\bryzen 5\b/.test(q) || /\bi7\b/.test(q) || /\bryzen 7\b/.test(q)) {
      if (/\bi7\b/.test(q) || /\bryzen 7\b/.test(q)) add('business_i7');
      if (/\bi5\b/.test(q) || /\bryzen 5\b/.test(q)) add('business_i5');
      if (devices.indexOf('business_i5') === -1 && devices.indexOf('business_i7') === -1) add('business_general');
    }

    if (/\bgaming\b/.test(q) || /\brtx\b/.test(q) || /\bgtx\b/.test(q)) add('gaming');

    if (/\bmacbook\b|\bmac\b|\bm1\b|\bm2\b|\bm3\b|\bm4\b|\bm5\b/.test(q)) {
      if (/\bair\b/.test(q) || /\bmacbook air\b/.test(q)) {
        if (/\bm1\b|\bm2\b/.test(q)) add('macbook_air_m1_m2');
        else if (/\bm3\b|\bm4\b/.test(q)) add('macbook_air_m3_m4');
        else if (/\bm5\b/.test(q)) add('macbook_air_m5');
        else add('macbook_air');
      }

      if (/\bpro\b/.test(q) || /\bmacbook pro\b/.test(q)) {
        if (/\bm1 pro\b|\bm2 pro\b/.test(q)) add('macbook_pro_m1_m2_pro');
        else if (/\bm3 pro\b/.test(q)) add('macbook_pro_m3_pro');
        else if (/\bm4 pro\b|\bm5 pro\b/.test(q)) add('macbook_pro_m4_m5_pro');
        else if (/\bm3 max\b/.test(q)) add('macbook_pro_m3_max');
        else if (/\bm1\b|\bm2\b/.test(q)) add('macbook_pro_m1_m2');
        else if (/\bm3\b/.test(q)) add('macbook_pro_m3');
        else if (/\bm4\b|\bm5\b/.test(q)) add('macbook_pro_m4_m5');
        else add('macbook_pro');
      }

      if (!devices.some(function (device) { return device.indexOf('macbook') === 0; })) add('macbook_general');
    }

    if (/\bipad\b/.test(q)) add('ipad');

    return devices;
  }

  function appLabel(app) {
    var labels = {
      exam: 'Exam Browser & LockDown',
      docker: 'Docker',
      python: 'Python and coding',
      'visual-studio': 'Visual Studio or VS Code',
      sql: 'SQL and database tools',
      ubuntu: 'Ubuntu or Custom OS',
      adobe: 'Adobe and design apps',
      office: 'Microsoft Office',
      video: 'Zoom, Teams or Meet',
      browser: 'Web Browsers',
      'cloud-ai': 'Cloud-Assisted AI Apps',
      'application-ai': 'Application-Based AI Apps'
    };
    return labels[app] || app;
  }

  function deviceLabel(device) {
    var labels = {
      business_i5: 'Business Laptop i5 or Ryzen 5',
      business_i7: 'Business Laptop i7 or Ryzen 7',
      business_general: 'Business Laptop',
      gaming: 'Gaming Laptop',
      macbook_air_m1_m2: 'MacBook Air M1 or M2',
      macbook_air_m3_m4: 'MacBook Air M3 or M4',
      macbook_air_m5: 'MacBook Air M5',
      macbook_air: 'MacBook Air',
      macbook_pro_m1_m2: 'MacBook Pro M1 or M2',
      macbook_pro_m1_m2_pro: 'MacBook Pro M1 Pro or M2 Pro',
      macbook_pro_m3: 'MacBook Pro M3',
      macbook_pro_m3_pro: 'MacBook Pro M3 Pro',
      macbook_pro_m4_m5: 'MacBook Pro M4 or M5',
      macbook_pro_m4_m5_pro: 'MacBook Pro M4 Pro or M5 Pro',
      macbook_pro_m3_max: 'MacBook Pro M3 Max',
      macbook_pro: 'MacBook Pro',
      macbook_general: 'MacBook',
      ipad: 'iPad'
    };
    return labels[device] || device;
  }

  function deviceMemoryNote(device) {
    var notes = {
      business_i5: 'Windows 11, 16GB, 512GB',
      business_i7: 'Windows 11, 16GB, 512GB',
      gaming: 'Windows 11, 16GB, 512GB with dedicated GTX or RTX graphics',
      macbook_air_m1_m2: 'macOS, 8GB, 256GB',
      macbook_air_m3_m4: 'macOS, 16GB, 256GB',
      macbook_air_m5: 'macOS, 16GB, 512GB',
      macbook_pro_m1_m2: 'macOS, 8GB, 256GB',
      macbook_pro_m1_m2_pro: 'macOS, 16GB, 512GB',
      macbook_pro_m3: 'macOS, 8GB, 512GB',
      macbook_pro_m3_pro: 'macOS, 18GB, 512GB',
      macbook_pro_m4_m5: 'macOS, 16GB, 512GB',
      macbook_pro_m4_m5_pro: 'macOS, 24GB, 512GB or higher',
      macbook_pro_m3_max: 'macOS, 48GB, 1TB'
    };
    return notes[device] || '';
  }

  function appSuitabilityForDevice(device, app) {
    var result = {
      status: 'Suitable',
      why: 'Suitable for common use.',
      recommended: '',
      note: ''
    };

    if (device === 'ipad') {
      if (['docker', 'python', 'visual-studio', 'sql', 'ubuntu', 'adobe'].indexOf(app) !== -1) {
        result.status = 'Not recommended';
        result.why = 'iPad is not recommended for desktop laptop software or development tools.';
        result.recommended = 'Choose a Windows laptop or MacBook instead.';
        return result;
      }
      if (app === 'exam') {
        result.status = 'Check first';
        result.why = 'Only suitable if your school or exam provider supports iPadOS.';
        result.recommended = 'Business Laptop is usually safer for exam-browser compatibility.';
        return result;
      }
      result.why = 'Suitable for portable, browser-based, presentation, registration, and supported iPad app use.';
      return result;
    }

    if (device === 'business_i5') {
      if (['python', 'visual-studio', 'docker', 'sql', 'ubuntu'].indexOf(app) !== -1) {
        result.status = 'Not recommended';
        result.why = 'This is not recommended for Business Laptop i5 or Ryzen 5 because it is more demanding than general office or browser-based use.';
        result.recommended = 'Choose Business Laptop i7 or Ryzen 7, Gaming Laptop, or a suitable MacBook.';
        return result;
      }
      result.why = 'This is suitable for Business Laptop i5 or Ryzen 5 for common use.';
      if (app === 'adobe') result.recommended = 'For Premiere Pro, large design files, or video editing, choose Gaming Laptop or a suitable MacBook.';
      return result;
    }

    if (device === 'business_i7') {
      result.why = 'Suitable for broader general use, including productivity, coding, Visual Studio or VS Code, Docker, SQL, Ubuntu or Custom OS, and browser-based workloads.';
      if (['adobe', 'application-ai'].indexOf(app) !== -1) result.recommended = 'For heavier graphics, video editing, gaming, or demanding AI workloads, Gaming Laptop may be more suitable.';
      return result;
    }

    if (device === 'gaming') {
      result.why = 'Usually the strongest Windows rental option for heavier workloads, GPU-based tasks, Adobe and design, video editing, coding, Docker, SQL, and application-based AI apps.';
      result.note = 'Actual performance still depends on the selected GPU tier and software workload.';
      return result;
    }

    if (device.indexOf('macbook') === 0) {
      if (app === 'ubuntu') {
        result.status = 'Not recommended';
        result.why = 'Ubuntu or Custom OS installation is not recommended for MacBook rentals.';
        result.recommended = 'Choose a suitable Windows laptop if Ubuntu or custom OS is required.';
        result.note = 'The MacBook must be returned with the original macOS intact.';
        return result;
      }

      if (app === 'exam') {
        result.status = 'Check first';
        result.why = 'MacBook is suitable for common online exam browsers, but support depends on your school or exam provider.';
        result.recommended = 'Confirm macOS support with your school or exam provider before booking.';
        return result;
      }

      if (['macbook_air_m1_m2', 'macbook_pro_m1_m2', 'macbook_pro_m3'].indexOf(device) !== -1) {
        result.why = 'Suitable for common macOS use. For heavier multitasking or larger projects, a 16GB MacBook or higher is recommended.';
        if (['docker', 'python', 'visual-studio', 'sql', 'adobe', 'application-ai'].indexOf(app) !== -1) {
          result.recommended = 'For heavier projects, multiple tools, large design files, local AI, or multiple Docker containers, choose a 16GB MacBook or higher, such as MacBook Pro M1 Pro and above.';
        }
        return result;
      }

      result.why = 'Suitable for common macOS use and heavier workloads than the 8GB MacBook options.';
      if (['docker', 'python', 'visual-studio', 'sql', 'adobe', 'application-ai'].indexOf(app) !== -1) {
        result.recommended = 'For very heavy workloads, choose the higher-memory MacBook Pro options where available.';
      }
      return result;
    }

    if (device === 'business_general') {
      result.status = 'Check first';
      result.why = 'Business Laptop suitability depends on whether you select i5 or Ryzen 5 or i7 or Ryzen 7.';
      result.recommended = 'i5 or Ryzen 5 is better for lighter general use. i7 or Ryzen 7 is better for development tools and heavier multitasking.';
      return result;
    }

    return result;
  }

  function formatSuitabilityAnswer(device, app) {
    var memory = deviceMemoryNote(device);
    var result = appSuitabilityForDevice(device, app);
    var lines = [];
    lines.push(deviceLabel(device) + (memory ? ' (' + memory + ')' : ''));
    lines.push('');
    lines.push('Suitability: ' + result.status);
    lines.push('Why: ' + result.why);
    if (result.recommended) lines.push('Recommended option: ' + result.recommended);
    lines.push('Note: Applications are not provided unless stated. This is general suitability guidance only; final compatibility still depends on the software’s own requirements.');
    if (result.note) lines.push(result.note);
    return lines.join('\n');
  }

  function updateConversationContext(devices, apps) {
    if (devices && devices.length) conversationContext.devices = devices.slice(0);
    if (apps && apps.length) conversationContext.apps = apps.slice(0);
    saveState();
  }

  function buildSmartCompatibilityAnswer(query) {
    var devices = detectCompatibilityDevices(query);
    var apps = detectCompatibilityApps(query);
    var q = normalise(query);
    var pageDevices = detectCompatibilityDevices(getPageContextText());

    if (!devices.length && /\b(this|it|here|current|selected)\b/.test(q) && pageDevices.length) {
      devices = pageDevices;
    }

    if (!devices.length && conversationContext.devices && conversationContext.devices.length) {
      devices = conversationContext.devices.slice(0);
    }

    if (!apps.length && conversationContext.apps && conversationContext.apps.length && /\b(what about|how about|same|this|it)\b/.test(q)) {
      apps = conversationContext.apps.slice(0);
    }

    if (!devices.length && /\bi5\b|\bryzen 5\b/.test(q)) devices.push('business_i5');
    if (!devices.length && /\bi7\b|\bryzen 7\b/.test(q)) devices.push('business_i7');

    if (!devices.length && apps.length) {
      updateConversationContext(devices, apps);
      return 'Please let me know which rental category you are considering — Business Laptop, Gaming Laptop, MacBook, or iPad — so I can advise the app suitability more accurately.';
    }

    if (!apps.length && devices.length) {
      updateConversationContext(devices, apps);
      if (devices.length >= 2 || /\b(vs|versus|compare|comparison|difference|different|better|which)\b/.test(q)) {
        return buildDeviceComparisonAnswer(devices);
      }
      return buildDeviceGeneralAnswer(devices[0]);
    }

    if (devices.length >= 2 && apps.length === 0) {
      updateConversationContext(devices, apps);
      return buildDeviceComparisonAnswer(devices);
    }

    updateConversationContext(devices, apps);

    var lines = [];
    for (var i = 0; i < devices.length; i += 1) {
      for (var j = 0; j < apps.length; j += 1) {
        if (lines.length) lines.push('\n---\n');
        lines.push(formatSuitabilityAnswer(devices[i], apps[j]));
      }
    }

    return lines.join('\n');
  }

  function buildDeviceGeneralAnswer(device) {
    var memory = deviceMemoryNote(device);
    if (device === 'business_i5') {
      return 'Business Laptop i5 or Ryzen 5' + (memory ? ' (' + memory + ')' : '') + '\n\nSuitable for: Office, browsers, video calls, cloud-assisted AI, common AI apps, Adobe and design apps, and exam browsers.\n\nNot recommended for: Python and coding, Visual Studio or VS Code, Docker, SQL and database tools, and Ubuntu or Custom OS.';
    }
    if (device === 'business_i7') {
      return 'Business Laptop i7 or Ryzen 7' + (memory ? ' (' + memory + ')' : '') + '\n\nSuitable for: Office, browsers, video calls, common coding, Visual Studio or VS Code, Docker, SQL and database tools, Ubuntu or Custom OS, and heavier general multitasking.\n\nRecommended upgrade: Gaming Laptop for heavy Adobe, video editing, gaming, or demanding AI workloads.';
    }
    if (device === 'gaming') {
      return 'Gaming Laptop' + (memory ? ' (' + memory + ')' : '') + '\n\nSuitable for: Office, browsers, video calls, Adobe and design, video editing, gaming, coding, Visual Studio or VS Code, Docker, SQL, Ubuntu or Custom OS, and heavier AI and app workloads.\n\nNote: Actual performance depends on the selected GPU tier and workload.';
    }
    if (device.indexOf('macbook') === 0) {
      return deviceLabel(device) + (memory ? ' (' + memory + ')' : '') + '\n\nSuitable for: common macOS use, Office, browsers, video calls, Adobe and design, coding, Docker, SQL, and exam browsers.\n\nRecommended: choose 16GB MacBook or higher for heavier projects, multiple tools, large design files, local AI, or multiple Docker containers.\n\nNot recommended: Ubuntu or Custom OS on MacBook rentals.';
    }
    if (device === 'ipad') {
      return 'iPad rental\n\nSuitable for: events, registration, presentations, browsing, supported iPad apps, and portable workflows.\n\nNot recommended for: Docker, Visual Studio, SQL tools, Ubuntu, full desktop Adobe workflows, or desktop laptop software.';
    }
    return 'Please select a rental category and app requirement so I can advise more accurately.';
  }

  function buildDeviceComparisonAnswer(devices) {
    if (!devices.length) {
      return 'Please let me know the rental categories you want to compare.';
    }

    if (devices.indexOf('business_i5') !== -1 && devices.indexOf('business_i7') !== -1) {
      return 'Business Laptop i5 or Ryzen 5 vs i7 or Ryzen 7\n\n• i5 or Ryzen 5: suitable for lighter general use such as Office, browsers, video calls, cloud-assisted AI apps, common productivity work, light design work, and exam browsers.\n\n• i7 or Ryzen 7: better for multitasking, coding, Visual Studio or VS Code, Docker, SQL and database tools, Ubuntu or Custom OS, and heavier business use.\n\nFor Adobe video editing, gaming, graphics work, or demanding AI workloads, Gaming Laptop may still be more suitable.';
    }

    if (devices.indexOf('business_i5') !== -1 && devices.some(function (d) { return d.indexOf('macbook_pro_m1_m2_pro') === 0 || d.indexOf('macbook_pro') === 0; })) {
      return 'Business Laptop i5 or Ryzen 5 vs MacBook Pro M1 Pro\n\n• Business Laptop i5 or Ryzen 5: suitable for basic Windows office, browser, video-call, light design, and general productivity use. Not recommended for Docker, SQL, Visual Studio or VS Code, Python and coding, or Ubuntu.\n\n• MacBook Pro M1 Pro: more suitable for macOS users who need coding, Docker, SQL, Adobe and design, and heavier multitasking. Ubuntu or Custom OS is still not recommended on MacBook rentals.\n\nChoose Business i5 for simpler Windows work. Choose MacBook Pro M1 Pro for stronger macOS compatibility and heavier creative or development use.';
    }

    var parts = [];
    for (var i = 0; i < devices.length; i += 1) {
      parts.push(buildDeviceGeneralAnswer(devices[i]));
    }
    return parts.join('\n\n');
  }

  function showSmartCompatibilityAnswer(query) {
    unresolvedCount = 0;
    setLastAnswerMeta('smart_compatibility', 'Smart compatibility answer', 'Software Compatibility', 'answered');
    var shouldAskForRating = updateQuestionContext({ category: 'Software Compatibility' });
    replyBot(buildSmartCompatibilityAnswer(query), function () {
      addActionRow(['main_menu']);
      if (shouldAskForRating) {
        replyBot('Did this answer your question?', function () {
          addActionRow(['thumbs_up', 'thumbs_down']);
        });
      }
    });
  }

  function handleUserInput(text) {
    var clean = String(text || '').trim();
    if (!clean) return;
    addUserMessage(clean);

    if (isResetRequest(clean)) {
      performResetConversation();
      return;
    }

    if (isEndChatRequest(clean)) {
      startEndChatConfirmation();
      return;
    }

    if (isPoliteAcknowledgement(clean)) {
      unresolvedCount = 0;
      setLastAnswerMeta('polite_acknowledgement', 'Polite acknowledgement', 'Support', 'answered');
      replyBot(getPoliteAcknowledgementReply(clean), function () {
        if (isSimpleAcknowledgement(clean)) {
          addActionRow(['main_menu', 'live_agent']);
        } else {
          addActionRow(['rent_device_flow', 'price_flow', 'live_agent', 'main_menu']);
        }
      });
      return;
    }

    var previousUserQuestionsForRecovery = Array.isArray(lastUserQuestions) ? lastUserQuestions.slice(0) : (lastUserQuestion ? [lastUserQuestion] : []);

    var circularIntent = detectCircularIntent(clean);
    updateConversationMemory(clean, circularIntent);

    var currentQuestionTopic = inferPlaybotQuestionTopic(clean) || circularIntent || '';
    var auditAnswerMatch = findBestAnswerWithConfidence(clean);
    trackPlaybotEvent('message_audit', {
      query: clean,
      detectedTopic: currentQuestionTopic,
      previousQuestion: lastUserQuestion || '',
      previousAnswerId: lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '',
      previousAnswerTitle: lastAnswerMeta && lastAnswerMeta.answerTitle ? lastAnswerMeta.answerTitle : '',
      answerMatch: auditAnswerMatch,
      botOutcome: 'typed_message_received'
    });
    var dissatisfactionSignal = detectAnswerDissatisfactionSignal(clean, currentQuestionTopic);
    if (dissatisfactionSignal) {
      logDissatisfactionSignal(dissatisfactionSignal, clean, currentQuestionTopic);
    }
    lastUserQuestion = clean;
    v86RememberUserQuestion(clean);
    lastUserTopic = currentQuestionTopic || lastUserTopic || '';

    /*
      v58 regression prompts to test after every code change:
      - MacBook Air M1 1 month how much?
      - 4 days?
      - Gaming laptop how much? → MacBook Pro M1 Pro how much?
      - Need 20 laptops
      - Got stock tomorrow?
      - Can issue quotation and invoice?
      - What if the laptop spoilt?
      - Can change laptop?
      - Can upgrade halfway?
      - Does Windows laptop come with charger and bag?
      - Which device for Dota 2?
      - Can it run Valorant high FPS?
      - Need 10 laptops for Roblox event
      - Can I play Mobile Legends on laptop?
      - Can I return earlier?
      - How much to pay for late return?
      - I cannot return today
      - Can I extend my rental instead?
      - How does rental work?
      - Can I order online or WhatsApp?
      - What happens after payment?
      - Will you deliver and collect?
      - Is this a scam?
      - Can I trust Playforce?
      - ok thanks
      - noted
      - reset
    */

    if (confirmState) {
      processConfirmInput(clean);
      return;
    }

    if (chatEnded) {
      replyBot('This conversation has ended. Type “reset” to start again.', function () {});
      return;
    }

    if (liveState) {
      processLiveInput(clean);
      return;
    }

    if (feedbackState) {
      processFeedbackInput(clean);
      return;
    }

    if (v102HandlePriceDeviceSwitch(clean)) {
      return;
    }

    if (v102IsLiveCatalogueQuestion(clean)) {
      if (priceState) priceState = null;
      showV102LiveCatalogueAnswer(clean);
      return;
    }

    if (v103MaybeHandleStandaloneCatalogueEntity(clean)) {
      if (priceState) priceState = null;
      return;
    }

    if (maybeHandleV100PriorityIntent(clean)) {
      if (priceState) {
        priceState = null;
        trackPlaybotEvent('topic_switch', { query: clean, from: 'price_flow', botOutcome: 'v100_priority_intent' });
      }
      return;
    }

    if (priceState && v85ShouldExitPriceState(clean)) {
      priceState = null;
      trackPlaybotEvent('topic_switch', { query: clean, from: 'price_flow', botOutcome: 'price_state_cleared' });
    }

    if (priceState) {
      processPriceInput(clean);
      return;
    }

    if (showV87RentalEntryForText(clean)) {
      return;
    }

    if (maybeHandleV86RepeatedQuestionRecovery(clean, previousUserQuestionsForRecovery)) {
      return;
    }

    if (maybeShowDirectClarification(clean)) {
      return;
    }

    var v85ExactIntent = v85GetExactIntentId(clean);
    if (v85ExactIntent) {
      if (v85ExactIntent === 'price') {
        if (v105MaybeHandleContextualGenericPriceRequest(clean)) return;
        showRentalPriceEstimate(applyMemoryToText(clean));
      } else if (v85ExactIntent === 'gaming_game_recommendation') {
        showGameRecommendationForText(clean);
      } else {
        var v85Answer = findIntentById(v85ExactIntent);
        if (v85Answer) showAnswer(v85Answer);
        else startEnquiryFlow('custom', clean);
      }
      return;
    }

    if (maybeShowV85TopicClarification(clean)) {
      return;
    }

    if (isRentalProcessQuestion(clean)) {
      showRentalSteps();
      return;
    }

    var unsupportedDurationFollowUp = detectUnsupportedRentalDuration(clean);
    if (unsupportedDurationFollowUp && conversationContext && conversationContext.lastIntent === 'price') {
      showUnsupportedDurationPrompt(unsupportedDurationFollowUp, clean);
      return;
    }

    if (isPriceDurationFollowUp(clean)) {
      showRentalPriceEstimate(applyMemoryToText('price ' + clean));
      return;
    }

    if (isAvailableDevicesQuestion(clean)) {
      showAnswer(findIntentById('available_rental_devices'));
      return;
    }

    if (isDeviceUpgradeQuestion(clean)) {
      showAnswer(findIntentById('change_upgrade_device'));
      return;
    }

    if (isEarlyReturnConcern(clean)) {
      showAnswer(findIntentById('early_return'));
      return;
    }

    if (isLateReturnConcern(clean)) {
      showAnswer(findIntentById('late_return'));
      return;
    }

    if (isRentalExtensionConcern(clean)) {
      showAnswer(findIntentById('extension'));
      return;
    }

    if (isExistingCosmeticDefectConcern(clean)) {
      showAnswer(findIntentById('existing_cosmetic_marks'));
      return;
    }

    if (isSmallScratchConcern(clean)) {
      showAnswer(findIntentById('small_cosmetic_scratches'));
      return;
    }

    if (isDamagePaymentAmountConcern(clean)) {
      showAnswer(findIntentById('damage_payment_amount'));
      return;
    }

    if (isDepositDeductionConcern(clean)) {
      showAnswer(findIntentById('deposit_deductions'));
      return;
    }

    if (isFaultyDeviceQuestion(clean)) {
      showAnswer(findIntentById('faulty_device_replacement'));
      return;
    }

    if (isAccessoryLostQuestion(clean)) {
      showAnswer(findIntentById('lost_accessories'));
      return;
    }

    if (isInvoiceReceiptQuestion(clean)) {
      showAnswer(findIntentById('invoice_receipt'));
      return;
    }

    if (isCorporateEnquiry(clean)) {
      startEnquiryFlow('corporate', clean);
      return;
    }

    if (isUrgentRentalRequest(clean)) {
      startEnquiryFlow('urgent', clean);
      return;
    }

    if (isAvailabilityQuestion(clean)) {
      startEnquiryFlow('availability', clean);
      return;
    }

    if (isEventRentalQuestion(clean)) {
      startEnquiryFlow('event', clean);
      return;
    }

    if (isCustomRentalEnquiry(clean)) {
      startEnquiryFlow('custom', clean);
      return;
    }

    if (isRentalPriceEstimateQuestion(clean) || isContextualPriceQuestion(clean)) {
      showRentalPriceEstimate(applyMemoryToText(clean));
      return;
    }

    if (isGameRecommendationQuestion(clean)) {
      showGameRecommendationForText(clean);
      return;
    }

    if (isSmartCompatibilityQuestion(clean)) {
      showSmartCompatibilityAnswer(clean);
      return;
    }

    if (isGreeting(clean)) {
      unresolvedCount = 0;
      replyBot('Hello. I can help with rental pricing, device selection, delivery, documents, rental terms, and software suitability.', function () {
        addActionRow(['rent_device_flow', 'price_flow', 'availability_flow', 'main_menu']);
      });
      return;
    }

    if (isLiveAgentRequest(clean)) {
      startLiveAgent();
      return;
    }

    if (isFeedbackRequest(clean)) {
      startFeedback();
      return;
    }

    if (isFrustration(clean)) {
      unresolvedCount += 1;
      logDissatisfactionSignal('frustration_language', clean, currentQuestionTopic);
      setLastAnswerMeta('frustration_recovery', 'Frustration recovery answer', 'Support', 'clarification');
      replyBot('Sorry, I may not have answered that clearly.\n\nYou can choose a topic below, or WhatsApp us for help.', function () {
        addActionRow(['live_agent', 'continue_chat', 'feedback']);
      });
      return;
    }

    if (isSameDayDeliveryQuestion(clean)) {
      startEnquiryFlow('urgent', clean);
      return;
    }

    if (isDamageStatement(clean)) {
      showAnswer(findIntentById('device_damaged'));
      return;
    }

    if (isLostStatement(clean)) {
      showAnswer(findIntentById('device_lost'));
      return;
    }

    if (isTrustQuestion(clean)) {
      unresolvedCount = 0;
      showAnswer(findIntentById('trust_rental_confidence'));
      return;
    }

    if (isGenericHelpRequest(clean)) {
      unresolvedCount += 1;
      setLastAnswerMeta('generic_help_prompt', 'Generic help prompt', 'Support', 'clarification');
      replyBot('Sure. What do you need help with?', function () {
        addActionRow(['rent_device_flow', 'price_flow', 'availability_flow', 'main_menu']);
      });
      return;
    }

    var answerMatch = findBestAnswerWithConfidence(clean);
    if (answerMatch && answerMatch.answer && answerMatch.bestScore >= 12) {
      if (answerMatch.answer.id === 'gaming_game_recommendation' && findGameRecommendations(clean).length) {
        showGameRecommendationForText(clean);
        return;
      }
      if (shouldClarifyAnswerMatch(answerMatch, clean)) {
        showConfidenceClarification(clean, answerMatch);
      } else {
        showAnswer(answerMatch.answer);
      }
      return;
    }

    if (isRentalStartRequest(clean)) {
      startRentalGuide(clean);
      return;
    }

    unresolvedCount += 1;
    resetQuestionContext();
    if (unresolvedCount >= 2) {
      trackPlaybotEvent('fallback_escalated', { query: clean, unresolvedCount: unresolvedCount });
      replyBot('Sorry, I may not be able to answer that clearly here.\n\nPlease WhatsApp us and our team can assist you directly.', function () {
        addActionRow(['live_agent', 'rent_device_flow', 'main_menu']);
      });
    } else {
      trackPlaybotEvent('fallback_first', { query: clean, unresolvedCount: unresolvedCount });
      replyBot('I may not have the exact fixed answer for that.\n\nAre you trying to check price, availability, device suitability, rental FAQs, or contact Playforce?', function () {
        addActionRow(['price_flow', 'availability_flow', 'rent_device_flow', 'rental_faq', 'live_agent', 'main_menu']);
      });
    }
  }

  function scrollToCompatibility() {
    var target = document.querySelector('.rental-compatibility-panel') || document.querySelector('[data-rental-compatibility]');
    if (target) {
      closePanel();
      window.setTimeout(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 250);
    } else {
      window.location.href = rentalLinks.rental;
    }
  }

  function openPanel(event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    root.style.display = '';
    root.classList.add('is-open');
    if (!toggle.checked) toggle.checked = true;
    launcher.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    panel.style.transform = 'translateX(0)';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    lockPageScroll();
    removeTypingIndicators();
    flushPlaybotLogQueue({ limit: 8 });
    if (!hasStarted || !messages.innerHTML.trim()) {
      hasStarted = true;
      showMainMenu();
    }
    updatePlaybotKeyboardViewport('open');
    saveState();
    if (!isPlaybotMobileBrowser() && !isPlaybotIOSLikeBrowser()) {
      window.setTimeout(function () { input.focus(); }, 180);
    } else {
      window.setTimeout(function () { updatePlaybotKeyboardViewport('open-mobile'); scrollMessagesToBottomNow(); }, 180);
    }
  }

  function closePanel(event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    root.classList.remove('is-open');
    if (toggle.checked) toggle.checked = false;
    launcher.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    panel.style.transform = '';
    overlay.style.opacity = '';
    overlay.style.pointerEvents = '';
    resetPlaybotKeyboardViewport();
    unlockPageScroll();
    saveState();
  }

  root.__pfPlaybotOpen = openPanel;
  root.__pfPlaybotClose = closePanel;

  toggle.addEventListener('change', function (event) {
    if (toggle.checked) {
      openPanel(event);
    } else {
      closePanel(event);
    }
  });

  launcher.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openPanel(event);
    }
  });

  launcher.addEventListener('click', function () {
    window.setTimeout(function () { if (toggle.checked) openPanel(); }, 0);
  }, true);
  closeBtn.addEventListener('click', closePanel, true);
  overlay.addEventListener('click', function () {
    window.setTimeout(function () { if (!toggle.checked) closePanel(); }, 0);
  }, true);

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest && event.target.closest('[data-pf-playbot-open]');
    if (openButton && root.contains(openButton)) {
      openPanel(event);
    }
  }, true);

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var text = input.value;
    input.value = '';
    handleUserInput(text);
  });

  function focusPlaybotInputFromUserTap() {
    if (!root.classList.contains('is-open')) return;
    if (!shouldManagePlaybotKeyboardViewport()) return;
    updatePlaybotKeyboardViewport('before-focus');
    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      try { input.focus(); } catch (focusError) {}
    }
    scheduleInputVisibleAfterKeyboard('input-tap');
  }

  // iOS Safari sometimes consumes the first tap inside a fixed chat panel after the panel or page overlay has been touched.
  // Keep input-touch handling separate from Playbot's delegated button-click handling so the first tap opens the keyboard.
  function protectPlaybotInputTap(event) {
    if (!event) return;
    if (event.stopPropagation) event.stopPropagation();
  }

  input.addEventListener('touchstart', protectPlaybotInputTap, true);
  input.addEventListener('touchend', function (event) {
    protectPlaybotInputTap(event);
    if (shouldManagePlaybotKeyboardViewport()) focusPlaybotInputFromUserTap();
  }, true);
  input.addEventListener('pointerdown', function (event) {
    protectPlaybotInputTap(event);
    if (shouldManagePlaybotKeyboardViewport()) focusPlaybotInputFromUserTap();
  }, true);
  input.addEventListener('mousedown', protectPlaybotInputTap, true);
  input.addEventListener('click', function (event) {
    protectPlaybotInputTap(event);
    if (shouldManagePlaybotKeyboardViewport()) focusPlaybotInputFromUserTap();
  }, true);

  input.addEventListener('focus', function () {
    if (shouldManagePlaybotKeyboardViewport()) {
      scheduleInputVisibleAfterKeyboard('focus');
    } else {
      scrollMessagesToBottomNow();
    }
  }, true);

  input.addEventListener('blur', function () {
    window.setTimeout(function () {
      if (document.activeElement !== input && shouldManagePlaybotKeyboardViewport()) {
        updatePlaybotKeyboardViewport('blur');
      }
    }, 180);
  }, true);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      if (root.classList.contains('is-open') && shouldManagePlaybotKeyboardViewport()) schedulePlaybotKeyboardViewportUpdate('visualViewport-resize', 20);
    });
    window.visualViewport.addEventListener('scroll', function () {
      if (root.classList.contains('is-open') && shouldManagePlaybotKeyboardViewport()) schedulePlaybotKeyboardViewportUpdate('visualViewport-scroll', 20);
    });
  }

  window.addEventListener('resize', function () {
    if (root.classList.contains('is-open') && shouldManagePlaybotKeyboardViewport()) {
      schedulePlaybotKeyboardViewportUpdate('window-resize', 40);
    }
  });

  window.addEventListener('orientationchange', function () {
    if (!root.classList.contains('is-open')) return;
    resetPlaybotKeyboardViewport();
    if (shouldManagePlaybotKeyboardViewport()) {
      window.setTimeout(function () { updatePlaybotKeyboardViewport('orientationchange'); scrollMessagesToBottomNow(); }, 350);
    }
  });

  // Mobile-safe WhatsApp logging: preflight runs before Safari or Chrome can switch to the WhatsApp app.
  root.addEventListener('touchstart', handleWhatsappLinkPreflight, true);
  root.addEventListener('pointerdown', handleWhatsappLinkPreflight, true);




  function isPlaybotMobileBrowser() {
    try {
      var ua = navigator && navigator.userAgent ? navigator.userAgent : '';
      return /iphone|ipad|ipod|android/i.test(ua) || (('ontouchstart' in window) && window.innerWidth <= 900);
    } catch (error) {
      return false;
    }
  }

  function buildWhatsappClickLoggingExtra(eventId) {
    return {
      eventId: eventId || createPlaybotEventId(),
      whatsappClicked: true,
      handoff: lastWhatsappHandoffState || {},
      previousQuestion: lastUserQuestion || '',
      previousAnswerId: lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '',
      previousAnswerTitle: lastAnswerMeta && lastAnswerMeta.answerTitle ? lastAnswerMeta.answerTitle : '',
      summary: 'Customer clicked WhatsApp us from Playbot.' + (lastAnswerMeta && lastAnswerMeta.answerId ? '\nPrevious answer before WhatsApp: ' + lastAnswerMeta.answerId : ''),
      urgent: true,
      preferBeacon: true,
      flushNow: true,
      allowRepeat: true,
      maxPerReason: 3
    };
  }

  function logWhatsappClickBeforeNavigation(link) {
    try {
      if (!link) return;
      var now = Date.now();
      var href = link.href || link.getAttribute('href') || '';
      var lastLoggedAt = parseInt(link.getAttribute('data-pf-playbot-whatsapp-logged-at') || '0', 10) || 0;

      // Mobile browsers can fire touchstart, pointerdown and click for the same tap.
      // Treat them as one WhatsApp click so the tracking sheet receives one row only.
      if (lastLoggedAt && now - lastLoggedAt < 8000) return;
      if (playbotLastWhatsappClickAt && now - playbotLastWhatsappClickAt < 8000 && href === playbotLastWhatsappClickHref) return;

      var eventId = createPlaybotEventId();
      link.setAttribute('data-pf-playbot-whatsapp-logged-at', String(now));
      link.setAttribute('data-pf-playbot-whatsapp-event-id', eventId);
      playbotLastWhatsappClickAt = now;
      playbotLastWhatsappClickHref = href;
      playbotLastWhatsappClickEventId = eventId;
      playbotWhatsappClicked = true;
      sendPlaybotLead('whatsapp_clicked', buildWhatsappClickLoggingExtra(eventId));
      flushPlaybotLogQueue({ preferBeacon: true, limit: 8 });
      saveState();
    } catch (error) {}
  }

  function openWhatsappAfterMobileSafeLog(link) {
    if (!link || !link.href || playbotWhatsappNavigationLock) return;
    playbotWhatsappNavigationLock = true;
    var href = link.href;
    var delay = isPlaybotMobileBrowser() ? 320 : 120;
    flushPlaybotLogQueue({ preferBeacon: true, limit: 8 });
    window.setTimeout(function () {
      try {
        if (!isPlaybotMobileBrowser() && link.getAttribute('target') === '_blank') {
          window.open(href, '_blank', 'noopener');
        } else {
          window.location.href = href;
        }
      } catch (error) {
        window.location.href = href;
      }
      window.setTimeout(function () { playbotWhatsappNavigationLock = false; }, 900);
    }, delay);
  }

  function handleWhatsappLinkPreflight(event) {
    try {
      var link = event && event.target && event.target.closest ? event.target.closest('a.pf-playbot-btn-whatsapp[href]') : null;
      if (!link || !root.contains(link)) return;
      logWhatsappClickBeforeNavigation(link);
    } catch (error) {}
  }

  function handleWhatsappLinkActivation(event, link) {
    if (!link) return false;
    markPlaybotClickHandled(event);
    logWhatsappClickBeforeNavigation(link);
    openWhatsappAfterMobileSafeLog(link);
    return true;
  }

  function getRentalPageInfo(action) {
    var map = {
      view_rental: { label: 'View Rental Page', pageName: 'rental page', href: rentalLinks.rental },
      view_business: { label: 'View Business Rental Page', pageName: 'Business rental page', href: rentalLinks.business },
      view_gaming: { label: 'View Gaming Rental Page', pageName: 'Gaming rental page', href: rentalLinks.gaming },
      view_macbook: { label: 'View MacBook Rental Page', pageName: 'MacBook rental page', href: rentalLinks.macbook },
      view_ipad: { label: 'View iPad Rental Page', pageName: 'iPad rental page', href: rentalLinks.ipad }
    };
    return map[action] || map.view_rental;
  }

  function isRentalPageAction(action) {
    return action === 'view_rental' || action === 'view_business' || action === 'view_gaming' || action === 'view_macbook' || action === 'view_ipad';
  }

  function startRentalPageRedirectConfirmation(action) {
    var info = getRentalPageInfo(action);
    pendingRedirectState = {
      action: action,
      label: info.label,
      pageName: info.pageName,
      href: info.href
    };
    confirmState = 'view_page';
    replyBot('I’ll open the ' + info.pageName + ' and close Playbot. Continue?', function () {
      addActionRow(['confirm_view_page', 'cancel_view_page']);
    });
    saveState();
  }

  function confirmRentalPageRedirect() {
    var redirect = pendingRedirectState || getRentalPageInfo('view_rental');
    pendingRedirectState = null;
    confirmState = null;
    closePanel();
    window.setTimeout(function () {
      window.location.href = redirect.href || rentalLinks.rental;
    }, 120);
  }


  function isPlaybotFeedbackActionLocked(key, windowMs) {
    var now = Date.now();
    var existing = playbotFeedbackActionLocks[key] || 0;
    if (existing && now - existing < (windowMs || 8000)) return true;
    playbotFeedbackActionLocks[key] = now;
    return false;
  }

  function dispatchPlaybotAction(action, event) {
    if (!action) return false;

    if (action === 'live_agent') {
      addUserMessage('Contact Playforce');
      startLiveAgent();
      return true;
    }
    if (action === 'main_menu') {
      addUserMessage('Main menu');
      chatEnded = false;
      confirmState = null;
      showMainMenu();
      return true;
    }
    if (action === 'feedback') {
      addUserMessage('Submit feedback');
      startFeedback();
      return true;
    }
    if (action === 'continue_chat') {
      addUserMessage('Continue chatting');
      replyBot('Sure. Please continue asking your rental question anytime.', function () {
        addActionRow(['main_menu']);
      });
      return true;
    }
    if (action === 'v87_rent_business') {
      addUserMessage('Business Laptop');
      showV87BusinessRentalOptions('Business Laptop');
      return true;
    }
    if (action === 'v87_rent_gaming') {
      addUserMessage('Gaming Laptop');
      showV87GamingRentalOptions('Gaming Laptop');
      return true;
    }
    if (action === 'v87_rent_macbook') {
      addUserMessage('MacBook');
      showV87MacbookRentalOptions('MacBook');
      return true;
    }
    if (action === 'v87_rent_ipad') {
      addUserMessage('iPad');
      showV87IpadRentalOptions('iPad');
      return true;
    }
    if (action === 'rent_device_flow') {
      addUserMessage('Start rental enquiry');
      startRentalGuide();
      return true;
    }
    if (action === 'price_flow') {
      addUserMessage('Check rental price');
      if (v105MaybeStartContextualPriceFlowFromAction()) return true;
      startPriceFlow();
      return true;
    }
    if (action === 'availability_flow') {
      addUserMessage('Request availability check');
      showAvailabilityHub();
      return true;
    }
    if (action === 'start_availability_enquiry') {
      addUserMessage('Start availability request');
      startEnquiryFlow('availability', 'Availability and urgent rental request');
      return true;
    }
    if (action === 'corporate_flow') {
      addUserMessage('Corporate and bulk rental');
      showCorporateBulkHub();
      return true;
    }
    if (action === 'start_corporate_enquiry') {
      addUserMessage('Start corporate enquiry');
      startEnquiryFlow('corporate', 'Corporate and bulk rental enquiry');
      return true;
    }
    if (action === 'rental_related') {
      addUserMessage('Delivery, deposit & documents');
      showRentalRelatedCategories();
      return true;
    }
    if (action === 'rental_confidence_concerns') {
      addUserMessage('Rental Confidence and Common Concerns');
      showRentalConfidenceConcernsHub();
      return true;
    }
    if (action === 'security_device_care') {
      addUserMessage('Security Deposit and Device Care');
      showSecurityDeviceCareHub();
      return true;
    }
    if (action === 'rental_product') {
      addUserMessage('Help me choose a device');
      showRentalProductCategories();
      return true;
    }
    if (action === 'game_recommendation') {
      addUserMessage('Game Recommendation');
      showGameRecommendationHub();
      return true;
    }
    if (action === 'rental_software') {
      addUserMessage('Software & app compatibility');
      showSoftwareCompatibilityCategories();
      return true;
    }
    if (action === 'rental_tnc') {
      addUserMessage('Rental terms');
      showRentalTncCategories();
      return true;
    }
    if (action === 'contact_menu') {
      addUserMessage('Contact Playforce');
      showContactCategories();
      return true;
    }
    if (action === 'rental_faq') {
      addUserMessage('Rental FAQs');
      showRentalFaqMenu();
      return true;
    }
    if (action === 'rental_steps') {
      addUserMessage('How does rental work?');
      showRentalSteps();
      return true;
    }
    if (action === 'rental_terms') {
      addUserMessage('Rental T&C');
      showRentalTerms();
      return true;
    }
    if (action === 'payment_options') {
      addUserMessage('Payment options');
      showPaymentOptions();
      return true;
    }
    if (action === 'issue_flow') {
      addUserMessage('Report device issue');
      startEnquiryFlow('issue', 'Device issue report');
      return true;
    }
    if (action === 'back_main') {
      addUserMessage('Back');
      showMainMenu();
      return true;
    }
    if (action === 'back_product') {
      addUserMessage('Back');
      showRentalProductCategories();
      return true;
    }
    if (action === 'thumbs_up') {
      var thumbsUpLockKey = 'thumbs_up|' + (lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '') + '|' + compactText(lastUserQuestion || '', 120);
      if (isPlaybotFeedbackActionLocked(thumbsUpLockKey, 8000)) return true;
      addUserMessage('👍🏻 Yes');
      unresolvedCount = 0;
      questionContext = null;
      overallQuestionCount = 0;
      replyBot('Glad it helped. You may continue asking any rental question.', function () {
        addActionRow(['continue_chat', 'main_menu']);
      });
      return true;
    }
    if (action === 'thumbs_down') {
      var thumbsDownLockKey = 'thumbs_down|' + (lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '') + '|' + compactText(lastUserQuestion || '', 120);
      if (isPlaybotFeedbackActionLocked(thumbsDownLockKey, 8000)) return true;
      addUserMessage('👎🏻 No');
      sendPlaybotLead('negative_feedback', {
        previousQuestion: lastUserQuestion || '',
        previousAnswerId: lastAnswerMeta && lastAnswerMeta.answerId ? lastAnswerMeta.answerId : '',
        previousAnswerTitle: lastAnswerMeta && lastAnswerMeta.answerTitle ? lastAnswerMeta.answerTitle : '',
        summary: 'Customer selected thumbs down on Playbot answer.'
      });
      questionContext = null;
      overallQuestionCount = 0;
      replyBot('Sorry about that.\n\nYou can WhatsApp us for a clearer answer.', function () {
        addActionRow(['live_agent', 'continue_chat', 'feedback']);
      });
      return true;
    }
    if (action === 'compatibility') {
      scrollToCompatibility();
      return true;
    }
    if (isRentalPageAction(action)) {
      var pageInfo = getRentalPageInfo(action);
      addUserMessage(pageInfo.label);
      startRentalPageRedirectConfirmation(action);
      return true;
    }
    if (handleProductQuestionAction(action, event)) {
      return true;
    }
    if (action === 'confirm_view_page') {
      addUserMessage('Yes, open page');
      confirmRentalPageRedirect();
      return true;
    }
    if (action === 'cancel_view_page') {
      addUserMessage('No, stay here');
      pendingRedirectState = null;
      confirmState = null;
      replyBot('No problem. You can continue here.', function () { addActionRow(['main_menu']); });
      return true;
    }
    if (action === 'confirm_reset') {
      addUserMessage('Yes, reset');
      performResetConversation();
      return true;
    }
    if (action === 'cancel_reset') {
      addUserMessage('No, continue');
      confirmState = null;
      replyBot('Okay, I’ll keep this conversation.', function () { addActionRow(['main_menu']); });
      return true;
    }
    if (action === 'confirm_end') {
      addUserMessage('Yes, end chat');
      performEndConversation();
      return true;
    }
    if (action === 'cancel_end') {
      addUserMessage('No, continue');
      confirmState = null;
      replyBot('Okay, the conversation will continue.', function () { addActionRow(['main_menu']); });
      return true;
    }
    return false;
  }

  function markPlaybotClickHandled(event) {
    if (!event) return;
    event.__pfPlaybotHandled = true;
    if (event.preventDefault) event.preventDefault();
    if (event.stopPropagation) event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function handlePlaybotButtonClick(event) {
    if (!event || event.__pfPlaybotHandled || !event.target || !root.contains(event.target)) return false;

    var whatsappLink = event.target.closest && event.target.closest('a.pf-playbot-btn-whatsapp[href]');
    if (whatsappLink && root.contains(whatsappLink)) {
      return handleWhatsappLinkActivation(event, whatsappLink);
    }

    var recommendUsageButton = event.target.closest && event.target.closest('[data-pf-playbot-recommend-usage]');
    if (recommendUsageButton && root.contains(recommendUsageButton)) {
      markPlaybotClickHandled(event);
      var usage = recommendUsageButton.getAttribute('data-pf-playbot-recommend-usage') || recommendUsageButton.textContent;
      addUserMessage(recommendUsageButton.textContent || usage);
      showV100UsageRecommendation(usage);
      return true;
    }

    var intentButton = event.target.closest && event.target.closest('[data-pf-playbot-intent]');
    if (intentButton && root.contains(intentButton)) {
      var item = findIntentById(intentButton.getAttribute('data-pf-playbot-intent'));
      if (item) {
        markPlaybotClickHandled(event);
        addUserMessage(intentButton.textContent || item.title);
        showAnswer(item);
        return true;
      }
    }

    var categoryButton = event.target.closest && event.target.closest('[data-pf-playbot-category]');
    if (categoryButton && root.contains(categoryButton)) {
      markPlaybotClickHandled(event);
      var category = categoryButton.getAttribute('data-pf-playbot-category');
      addUserMessage(categoryButton.textContent || category);
      showCategory(category);
      return true;
    }

    var liveValueButton = event.target.closest && event.target.closest('[data-pf-playbot-live-value]');
    if (liveValueButton && root.contains(liveValueButton)) {
      markPlaybotClickHandled(event);
      var value = liveValueButton.getAttribute('data-pf-playbot-live-value') || liveValueButton.textContent;
      addUserMessage(value);
      processLiveInput(value);
      return true;
    }

    var rentalEntryValueButton = event.target.closest && event.target.closest('[data-pf-playbot-rental-entry-value]');
    if (rentalEntryValueButton && root.contains(rentalEntryValueButton)) {
      markPlaybotClickHandled(event);
      var rentalEntryValue = rentalEntryValueButton.getAttribute('data-pf-playbot-rental-entry-value') || rentalEntryValueButton.textContent;
      addUserMessage(rentalEntryValue);
      startV87RentalEntryValue(rentalEntryValue);
      return true;
    }

    var priceValueButton = event.target.closest && event.target.closest('[data-pf-playbot-price-value]');
    if (priceValueButton && root.contains(priceValueButton)) {
      markPlaybotClickHandled(event);
      var priceValue = priceValueButton.getAttribute('data-pf-playbot-price-value') || priceValueButton.textContent;
      addUserMessage(priceValue);
      processPriceInput(priceValue);
      return true;
    }

    var actionButton = event.target.closest && event.target.closest('[data-pf-playbot-action]');
    if (actionButton && root.contains(actionButton)) {
      var action = actionButton.getAttribute('data-pf-playbot-action');
      markPlaybotClickHandled(event);
      if (dispatchPlaybotAction(action, event)) {
        return true;
      }
      return true;
    }

    return false;
  }

  root.addEventListener('click', function (event) {
    handlePlaybotButtonClick(event);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) {
      closePanel();
    }
  });

  // Retry any mobile logging events that were queued before the browser switched apps or went into background.
  flushPlaybotLogQueue({ limit: 8 });
  window.addEventListener('online', function () { flushPlaybotLogQueue({ limit: 8 }); });
  window.addEventListener('focus', function () { flushPlaybotLogQueue({ limit: 8 }); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      flushPlaybotLogQueue({ preferBeacon: true, beaconOnly: true, limit: 10 });
    } else {
      flushPlaybotLogQueue({ limit: 8 });
    }
  });
  window.addEventListener('pagehide', function () {
    flushPlaybotLogQueue({ preferBeacon: true, beaconOnly: true, limit: 10 });
  });

  restoreState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPlaybot);
  } else {
    bootPlaybot();
  }

  window.addEventListener('load', bootPlaybot);
  window.setTimeout(bootPlaybot, 250);
  window.setTimeout(bootPlaybot, 500);
  window.setTimeout(bootPlaybot, 1200);
  window.setTimeout(bootPlaybot, 2200);

  // Global delegated opener: protects the main rentals page from theme/page scripts that may attach late or interrupt direct button listeners.
  document.addEventListener('click', function (event) {
    var target = event.target;
    var openButton = target && target.closest && target.closest('.pf-playbot-launcher, [data-pf-playbot-open]');
    if (!openButton) return;
    var root = document.getElementById('pf-playbot-root');
    if (root) root.style.display = '';
    if (root && typeof root.__pfPlaybotOpen === 'function') {
      root.__pfPlaybotOpen(event);
    } else {
      bootPlaybot();
      window.setTimeout(function () {
        var retryRoot = document.getElementById('pf-playbot-root');
        if (retryRoot && typeof retryRoot.__pfPlaybotOpen === 'function') {
          retryRoot.__pfPlaybotOpen(event);
        }
      }, 50);
    }
  }, true);
}());
